// ***********************************
// Batch.vue
// ***********************************
<template>
  <div id="app">
    <div class="container-fluid">
      <div v-if="this.batch_id.charAt(0)=='C'">
        <router-link :to="{ name: 'Main'}">List</router-link> | 
        <router-link :to="{ name: 'Add'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> |
        <router-link :to="{ name: 'Shapes' }">ShapeBrowser</router-link> |
        <router-link :to="{ name: 'API' }">API</router-link> 
      </div>
      <div v-else>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> |
        <router-link :to="{ name: 'Shapes' }">ShapeBrowser</router-link> |
        <router-link :to="{ name: 'API' }">API</router-link>
      </div>
      
      <br/>
      
      <b-form @reset="onReset">
      <b-card header="Auto-Right-Sizer (EXPERIMENTAL)">
        
  <a href="#databases" class="card-link"><b>Click here to jump to Databases ( {{ batchItemsOrigLength==0 ? 'loading' : batchItemsOrigLength }} ).</b></a>

  <a v-if="batchItemsOrigLength > 0 && scenarioCount == 0" href="#" class="card-link" @click.prevent="createNewScenario($event); $nextTick(() => { $el.querySelector('#databases').scrollIntoView(); })"><b>Click here to create a Base scenario.</b></a>
  <br/>
      
  <b-button v-b-toggle.morehelp variant="link"><b>Click here to see instructions for this page.</b></b-button>
  
  <br/>
  <b-collapse id="morehelp">
    <b-card           border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
>
    <div id="morehelptext" class="mt-3 text-left">
Start with the <b>Algorithm Choices</b> section of the page, which provides a set of selectable algorithms and preferences for you to tell DBCSI how to review your data and pick target values for the key sizing dimensions.  For instance, the CPU Algorithm drop-down provides various choices for how DBCSI
picks the CPU Target Value based on the real-world performance metrics.  Some of the options have additional help text which you can see via hovering over the option until the tooltip appears.
<br/><br/>
Once you are happy with your selections for the algorithms and preferences, go to the <b>Scenario Controls</b> section, where you can click on the Create New Scenario button.  At this point, DBCSI will use your algorithms to read through all the raw performance metrics data and apply them.  
<br/><br/>
When the scenario is finished calculating, you can see the results in the <b>Databases</b> section. You will see the Target Values columns (VCPU, Memory, IOPS, IO Throughput, Disk Space) updated in the table.  You will also see a corresponding RDS configuration that fits the calculated target values.
<br/><br/>
A few things to note:
<br/>
1. For some databases, there may not be a matching RDS configuration.  One example could be a database that need more IO Throughput than RDS can offer today.  
<br/>
2. If you don't like the target values that DBCSI calculated, you can change the corresponding algorithm/preferences and then click on one of the Scenario Control buttons to use the new algorithm/preference choices.
<br/>
3. Or, you can manually change the calculated target values of a scenario (using the Manually Edit Target Values button in the Scenario Controls section).
<br/><br/>
A useful feature in the Databases section is the "Show Config" button.  If you click on this, you will get a report showing the configuration, the target values, and graphs of the key performance metrics.  Pro tip: you can print the report using the Print button at the bottom of the report and then use the "Save as PDF" or "Print to PDF" feature of your print dialog to create a PDF report for sharing.
<br/><br/>

Another useful feature is the the Download CSV button.  This creates a spreadsheet of useful configuration details which you can use for further manipulation or incorporation into other documents.
<br/><br/>
Besides being able to calculate RDS-Oracle configurations, you can also ask DBCSI to help with some additional types of sizing exercises.  
For instance, you can use the <b>Include RDS Consolidation Alternative?</b> algorithm to ask DBCSI to also calculate a multi-tenant RDS-Oracle consolidation outcome, which will display in a "Consolidated RDS Instances" section.  In the Algorithm Choices section, you can find several other alternative outcomes you can choose, such as Aurora PostgreSQL and Oracle Database@AWS.

    </div>
        
    </b-card>

  </b-collapse>  
      
      <br/>
        
        <b-list-group>
          <b-list-group-item variant="light">




              <b-card 
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
                <template #header>
                  <div @click="algorithmsCollapsed = !algorithmsCollapsed" style="cursor: pointer;">
                    Algorithm Choices
                    <span class="float-right">{{ algorithmsCollapsed ? '▶' : '▼' }}</span>
                  </div>
                </template>
                <b-collapse :visible="!algorithmsCollapsed">


            <div>
              <p/>
              Choose the algorithms you want to use to calculate target values for the key sizing metrics (VCPU, Memory, IOPS, IO Throughput, and Disk Space).
              <p/>
              <b-form-group label="CPU Algorithm:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'You can use this control to tell DBCSI how to calculate the target value for CPU threads based on the collected metrics for your database'">
                <b-form-select v-model="form.cpu_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="cpu1">P99 of the averages</option>
                  <option value="cpu1_plus10">P99 of the averages, plus 10%</option>
                  <option value="cpu5">P75 of the averages</option>
                  <option value="cpu5_plus10">P75 of the averages, plus 10%</option>
                  <option value="cpu2">P90 of the peaks</option>
                  <option value="cpu2_plus10">P90 of the peaks, plus 10%</option>
                  <option value="cpu3">Larger of the P99 of the averages OR the P90 of the peaks</option>
                  <option value="cpu3_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                  <option value="cpu4">Larger of the P99 of the averages OR the P97 of the peaks</option>
                  <option value="cpu4_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                </b-form-select>
              </b-form-group>
              <b-alert :show="showAlertNonX86" variant="warning">{{alertTextNonX86}}</b-alert>
              <b-form-group v-if="showAlertNonX86" label="CPU Thread Mapping Ratio:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'The Thread Mapping Ratio is the number of source system threads that are equivalent to 1 Intel thread.  For instance, for a SPARC T4, you might enter 5.  You can use industry benchmarks such as SPECINT to compare thread-to-thread performance for different chipsets to derive the ratio to use.'">
                <b-form-input @change="triggerFullRecalculate"
                      v-model="form.cpu_thread_ratio" size="sm" type="number"
                      step="0.01"
                      :placeholder="`Ratio to map ${this.NonX86Platform} threads to Intel threads`">
                </b-form-input>
              </b-form-group>
              <b-form-group v-if="showAIX" label="AIX Power CPU Usage Time Adjustment:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'The AIX Power SMT CPU Time Adjustment tries to normalize AIX CPU metrics to what Oracle reports on non-AIX platforms.  This adjustment accounts for so-called missing time for Oracle usage on Power7 and newer AIX hardware.  Refer to https://ardentperf.com/2016/07/01/understanding-cpu-on-aix-power-smt-systems/ for additional reading.'">
                <b-form-select v-model="form.aix_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="old">Multiply the measured CPU usage of AIX by 8 for SMT-8 and by 4 for SMT-4 (previous default algorithm but we now think this was too extreme)</option>
                  <option value="new">Multiply the measured CPU usage of AIX by 4 for SMT-8 and by 2.5 for SMT-4</option>
                  <option value="new2">Multiply the measured CPU usage of AIX by 2.0 for SMT-8 and by 1.8 for SMT-4</option>
                  <option value="none">Do not try to adjust for AIX SMT CPU time reporting (good for Power6 and earlier hardware)</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Memory Algorithm:" label-cols="3" label-size="sm"
                 v-b-popover.hover.top="'Adjusted for RAC means that each additional RAC instance adds 50% (not 100%) of its SGA+PGA to the target memory value.  The idea is that in a RAC environment, the same blocks are kept in multiple RAC instances block buffers, so it is not as if you were getting 100% benefit of the aggregate total amount of memory.'">
                <b-form-select v-model="form.memory_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="mem1">sum(SGA+PGA)</option>
                  <option value="mem1_plus20_2">sum(SGA+PGA), plus greater of 2GB or 20%</option>
                  <option value="mem2">sum(SGA+PGA) adjusted for RAC</option>
                  <option value="mem2_plus20_2">sum(SGA+PGA) adjusted for RAC, plus greater of 2GB or 20%</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="IO Throughput Algorithm:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'You can use this control to tell DBCSI how to calculate the target value for IO Throughput based on the collected metrics for your database'">
                <b-form-select v-model="form.iomb_algo" size="sm" @change="triggerFullRecalculate">
                  <!--<option value="iomb1">AVERAGE of the peaks</option>-->
                  <!--<option value="iomb1_plus10">AVERAGE of the peaks, plus 10%</option>-->
                  <option value="iomb2">P99 of the averages</option>
                  <option value="iomb2_plus10">P99 of the averages, plus 10%</option>
                  <option value="iomb3">P90 of the peaks</option>
                  <option value="iomb3_plus10">P90 of the peaks, plus 10%</option>
                  <option value="iomb5">Larger of the P99 of the averages OR the P50 of the peaks</option>
                  <option value="iomb5_plus10">Larger of the P99 of the averages OR the P50 of the peaks, plus 10%</option>
                  <option value="iomb4">Larger of the P99 of the averages OR the P90 of the peaks</option>
                  <option value="iomb4_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                  <option value="iomb6">Larger of the P99 of the averages OR the P97 of the peaks</option>
                  <option value="iomb6_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="IOPS Algorithm:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'You can use this control to tell DBCSI how to calculate the target value for IOPS based on the collected metrics for your database'">
                <b-form-select v-model="form.iops_algo" size="sm" @change="triggerFullRecalculate">
                  <!--<option value="iops1">AVERAGE of the peaks</option>-->
                  <!--<option value="iops1_plus10">AVERAGE of the peaks, plus 10%</option>-->
                  <option value="iops2">P99 of the averages</option>
                  <option value="iops2_plus10">P99 of the averages, plus 10%</option>
                  <option value="iops3">P90 of the peaks</option>
                  <option value="iops3_plus10">P90 of the peaks, plus 10%</option>
                  <option value="iops5">Larger of the P99 of the averages OR the P50 of the peaks</option>
                  <option value="iops5_plus10">Larger of the P99 of the averages OR the P50 of the peaks, plus 10%</option>
                  <option value="iops4">Larger of the P99 of the averages OR the P90 of the peaks</option>
                  <option value="iops4_plus10">Larger of the P99 of the averages OR the P90 of the peaks, plus 10%</option>
                  <option value="iops6">Larger of the P99 of the averages OR the P97 of the peaks</option>
                  <option value="iops6_plus10">Larger of the P99 of the averages OR the P97 of the peaks, plus 10%</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Disk Space Algorithm:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'You can use this control to tell DBCSI how to calculate the target value for Disk Space based on the collected metrics for your database'">
                <b-form-select v-model="form.diskspace_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="disk1">Total DB Size</option>
                  <option value="disk1_plus15">Total DB Size, plus 15%</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="IS_EXADATA" label-cols="3" label-size="sm" v-b-popover.hover.top="'One or more of these databases run on Exadata.  Exadata can favor the use of I/O intensive SmartScans in lieu of more I/O-friendly techniques such as index lookups.  Some customers will take the time/effort to do some post-Exadata tuning to convert their heaviest SQL queries from SmartScans(Full-Table Scans) to indexes or materialized views because the benefits (smaller configurations and more managable I/O demands) outweigh the effort of tuning.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="20px" ></img>
                  Assume post-Exadata tuning?:
                </template>
                <b-form-select v-model="form.smartscan_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="ss1">No - assume no ex-SmartScan adjustments (such as query tuning, indexes, materialized views, ...)</option>
                  <option value="ss2a" >Yes(Light) - assume some light tuning to reduce I/O Throughput</option>
                  <option value="ss2" >Yes(Moderate) - assume some moderate tuning to reduce I/O Throughput</option>
                  <option value="ss3" >Yes(Heavy) - assume some heavy tuning to reduce I/O Throughput</option>
                  <option value="ss4" >Yes(Very Heavy) - assume some very heavy tuning to reduce I/O Throughput</option>
                </b-form-select>
              </b-form-group>

              <hr style="margin: 0.5rem 0; border-top: 1px solid #dee2e6;">

              <p/>
              Choose the target RDS-Oracle preference for the right-sizing and decide how to optimize shape selection between AWS cost and Oracle Licensing.
              <p/>
              
            <b-form-group label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI if you want to size for RDS-Oracle Enterprise Edition (BYOL) or RDS-Oracle Standard Edition2 (License Included)'">
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="20px" ></img>
                  RDS-Oracle Preference:
                </template>
                <b-form-select v-model="form.rds_algo" size="sm" @change="triggerFullRecalculate">
                  <option v-if="false" value="none"> </option>
                  <option value="ee">Use EE BYOL</option>
                  <option value="se">Use SE2 License Included</option>
                  <option v-if="showBeta && false" value="custom">Use RDS Custom for Oracle (BYOL)</option>
                  <option v-if="showRAC && showBeta" value="rac">Use RDS Custom for Oracle Real Application Clusters (BYOL) - PREVIEW</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.rds_algo!='se'" label="Optimization Goal:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'You can use this control to tell DBCSI your optimization preference in terms of License versus Cost'">
                <template slot="label">
                  <img src="@/assets/Dollar.png" height="20px" ></img>
                  Optimization Goal:
                </template>
                <b-form-select v-model="form.optgoal_algo" size="sm" @change="triggerFullRecalculate">
                  
                  <option value="min_license">Minimize Licensing (look for the shape with the fewest VCPU)</option>
                  <option value="min_cost">Minimize Cost of RDS shape (estimated Oracle license quantity does not matter- good for Oracle ULAs)</option>
                  <option v-if="showOptCPU" value="Y">Use OptimizeCPU (consult with your license experts to decide if OptimizeCPU is a fit for your license/contract)</option>

                </b-form-select>
              </b-form-group>

              <hr style="margin: 0.5rem 0; border-top: 1px solid #dee2e6;">

              <p/>
              Include optional additional right-sizing targets and choose other preferences.
              <p/>

              <b-form-group label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI if it should add a Replica to the RDS-Oracle configuration.'">
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="20px" ></img>
                  RDS-Oracle Replica Preference:
                </template>
                <b-form-select v-model="form.readreplica_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">Do not add Replicas to the configuration</option>
                  <option value="Y">Add Replicas to the configuration</option>
                  <option v-if="false" value="auto">Add a Replica to the configuration where Data Guard is used</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.readreplica_algo=='Y' || form.readreplica_algo=='auto'" label="Replica Sizing Algorithm:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI the algorithm to use to size the Replica.'">
                <b-form-select v-model="form.readreplica_size_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="rr100">Size Replica instance equivalent to primary</option>
                  <option value="rr50">Size Replica instance at 50% of primary</option>
                  <option value="rr25">Size Replica instance at 25% of primary</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.readreplica_algo=='Y' || form.readreplica_algo=='auto'" label="Replica MultiAZ Algorithm:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This controls whether the Replica should always be SingleAZ or match the MultiAZ setting of the primary.'">
                <b-form-select v-model="form.readreplica_maz_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="single">Always SingleAZ for Replica</option>
                  <option value="match">Match primary database's MultiAZ setting</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.readreplica_algo=='Y' || form.readreplica_algo=='auto'" label="Replica DB_NAME Filter:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'Optional Regular Expression to filter which databases get Replicas. Only databases where DB_NAME matches this pattern will have Replicas created. Supports glob patterns like *QA or PROD* which are automatically converted to regex.'">
                <b-form-input v-model="form.readreplica_db_name_match_expr" size="sm" @change="triggerFullRecalculate" 
                  placeholder="Optional pattern.  e.g., *PR*, PROD*, ^PROD.*, (PR|QA) " />
              </b-form-group>





              <b-form-group label="Include RDS Consolidation Alternative?:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI if it should try to create a consolidated RDS alternative.'"
                >
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="24px" ></img><img src="@/assets/Dollar.png" height="24px" ></img>
                  Include RDS Consolidation Alternative?:
                </template>
                <b-form-select v-model="form.rdsConsolidation_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No</option>
                  <option v-if="false && (this.showBeta)" value="Y1">Yes- try to merge instances together using existing shape selection</option>
                  <option value="Y2">Yes- try to merge instances together and consider other shapes with same VCPU</option>
                  <option v-if="false && (this.showBeta)" value="Y3">Yes- try to merge instances together and consider other shapes with more VCPU</option>
                  <option value="baremetal">Yes- use only RDS-Oracle bare metal shapes to consolidate databases</option>
                </b-form-select>
              </b-form-group>
 
              <b-form-group v-if="this.form.rdsConsolidation_algo=='baremetal'" label="Preferred Bare Metal Shape:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'Select the preferred bare metal shape for consolidation. Other shapes will only be used if a single database exceeds the preferred shape capacity or if the preferred shape cannot accommodate the combined requirements.'"
                >
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="24px" ></img><img src="@/assets/Dollar.png" height="24px" ></img>
                  Preferred Bare Metal Shape for consolidation:
                </template>
                <b-form-select v-model="form.rdsConsolidation_baremetalShape" size="sm" @change="triggerFullRecalculate">
                  <option value="x2iezn.metal">x2iezn.metal (48 VCPU, 1536 GB)</option>
                  <option value="m7i.metal-24xl">m7i.metal-24xl (96 VCPU, 384 GB)</option>
                  <option value="r7i.metal-24xl">r7i.metal-24xl (96 VCPU, 768 GB)</option>
                  <option value="m6i.metal">m6i.metal (128 VCPU, 512 GB)</option>
                  <option value="r6i.metal">r6i.metal (128 VCPU, 1024 GB)</option>
                </b-form-select>
              </b-form-group>

 
              <b-form-group v-if="this.form.rdsConsolidation_algo!='N'" label="Maximum PDBs per CDB:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'The maximum number of PDBs per CDB.  Choose this based on both technical and license considerations.'"
                >
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="24px" ></img><img src="@/assets/Dollar.png" height="24px" ></img>
                  Max PDBs per CDB for consolidation:
                </template>
                <b-form-select v-model="form.rdsConsolidation_maxPDBcount" size="sm" @change="triggerFullRecalculate">
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </b-form-select>
              </b-form-group>


              <b-form-group v-if="this.form.rdsConsolidation_algo!='N'" label="Group by Version:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'When enabled, databases will be grouped by Oracle version before attempting consolidation. This ensures only databases with the same version are consolidated together.'"
                >
                <template slot="label">
                  <img src="@/assets/Oracle.png" height="24px" ></img><img src="@/assets/Dollar.png" height="24px" ></img>
                  Group by Version for consolidation:
                </template>
                <b-form-select v-model="form.rdsConsolidation_groupbyversion" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No - consolidate databases regardless of version</option>
                  <option value="Y">Yes - only consolidate databases with the same version</option>
                </b-form-select>
              </b-form-group>


              <b-form-group v-if="this.form.optgoal_algo=='min_license'"   label-cols="3" label-size="sm" 
                v-b-popover.hover.top="{content:`This tells DBCSI how to consider Bare Metal shapes when choosing RDS shapes. <a href='https://aws.amazon.com/about-aws/whats-new/2025/09/amazon-rds-oracle-bare-metal-instances/' target='_blank'>(whats new)</a> <a href='https://aws.amazon.com/blogs/database/getting-started-with-amazon-ec2-bare-metal-instances-for-amazon-rds-for-oracle-and-amazon-rds-custom-for-oracle/' target='_blank'>(blog)</a> <a href='https://houseofbrick.com/blog/oracle-licensing-efficiency-with-dedicated-hosts/' target='_blank'>(3rdParty blog)</a>`, html: true}"
                >
                <template slot="label">
                  <img src="@/assets/BareMetalPossibility.png" height="20px" ></img>
                  RDS Bare Metal Evaluation Preference?:
                </template>
                <b-form-select v-model="form.rds_baremetal_ranking" size="sm" @change="triggerFullRecalculate">
                  <option value="never">Offer RDS bare metal shape suggestions where appropriate but don't assume core factor</option>
                  <option value="always">Only pick bare metal shapes for RDS</option>
                  <option v-if="false" value="considerVCPU">Consider bare metal shapes for RDS as just another cloud shape</option>
                  <option value="consider0.5">Consider bare metal shapes for RDS and assume 0.5 core factor with bare metal shapes</option>
                  <option value="consider1.0">Consider bare metal shapes for RDS and assume 1.0 core factor with bare metal shapes</option>
                </b-form-select>
              </b-form-group>


             



 
              

             <b-form-group label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI to make some assumptions about the benefits and sizing adjustments by adding ElastiCache.'">
                <template slot="label">
                  <img src="@/assets/Elasticache.png" height="20px" ></img>
                  Include ElastiCache?:
                </template>
                <b-form-select v-model="form.caching_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No</option>
                  <option value="ec25">Yes- add ElastiCache and reduce RDS requirements by 25%.  Size ElastiCache based on 1:3 ratio to SGA reduction.</option>
                  <option value="ec50">Yes- add ElastiCache and reduce RDS requirements by 50%.  Size ElastiCache based on 1:3 ratio to SGA reduction.</option>
                  <option value="ec65">Yes- add ElastiCache and reduce RDS requirements by 65%.  Size ElastiCache based on 1:3 ratio to SGA reduction.</option>
                </b-form-select>
              </b-form-group>
              
              
                <b-form-group label-cols="3" label-size="sm"
                  v-b-popover.hover.top="'Use this control to tell DBCSI to also include a rough estimate of an Aurora PostgreSQL sizing.  This will be a very ballpark sizing based on some broad assumptions.'">
                  <template slot="label">
                  <img src="@/assets/Aurora.png" height="20px" ></img>
                  Include Aurora Alternative?:
                </template>
                  <b-form-select v-model="form.aurora_algo" size="sm" @change="triggerFullRecalculate">
                    <option value="auro1">No</option>
                    <option value="auro5" >Yes- use the Aurora IO-Optimized mode (no need to estimate number of storage IOs)</option>
                    <option value="auro2" >Yes- estimate Storage IO costs as 25% of the on-demand cost of the compute shape</option>
                    <!--<option value="auro3" disabled>Yes- estimate Storage IO costs as 35% of the on-demand cost of the compute shape</option>-->
                    <option value="auro4" >Yes- estimate Storage IO costs based on estimated IOs derived from target IO Throughput metric, adjusted by internal ratios</option>
                    
                  </b-form-select>
                </b-form-group>


              <b-form-group  label="Include EC2 + FSx-OnTap Alternative?:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'This tells DBCSI if it should add an alternate customer-managed EC2 with FSx-OnTap configuration.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  Include EC2 + FSx-OnTap Alternative?:
                </template>
                <b-form-select v-model="form.ec2fsxn_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No</option>
                  <option value="Y">Yes- add an alternate customer-managed EC2 with FSx-OnTap configuration</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'This tells DBCSI which EC2 shapes to consider. EC2 Bare Metal only, or any EC2 shape (regular or Bare Metal). Regular EC2 requires Bring-Your-Own-License Oracle and is vCPU-licensed (2 vCPU = 1 Oracle processor license with hyperthreading; 1 vCPU = 1 Oracle processor license for shapes without hyperthreading, such as m7a, r7a and r8a). Graviton (ARM) shapes are never considered because Oracle DB is not supported on Graviton.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  EC2 Shape Scope?:
                </template>
                <b-form-select v-model="form.ec2fsxn_shape_scope" size="sm" @change="triggerFullRecalculate">
                  <option value="baremetal">EC2 Bare Metal shapes only</option>
                  <option value="all">Any EC2 shape (regular or Bare Metal)</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'This tells DBCSI which generation of FSx-OnTap file system to size and price. Gen1 (Single-AZ 1 / Multi-AZ 1) uses one HA pair with 128 - 4096 MB/s of throughput capacity and is typically less expensive. Gen2 (Single-AZ 2 / Multi-AZ 2) offers 384 - 6144 MB/s and up to 200,000 SSD IOPS per HA pair, much higher burst rates on its smaller sizes, and Single-AZ 2 can scale out to 12 HA pairs; it costs more per MB/s and is not available in every region. Auto prices both and uses the less expensive one.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  FSx-OnTap Generation?:
                </template>
                <b-form-select v-model="form.ec2fsxn_fsxn_generation" size="sm" @change="triggerFullRecalculate">
                  <option value="Gen1">Gen1 - first-generation FSx-OnTap (typically less expensive)</option>
                  <option value="Gen2">Gen2 - second-generation FSx-OnTap (higher per-HA-pair limits and bursts; Single-AZ scale-out)</option>
                  <option value="auto">Auto - price both Gen1 and Gen2 and use the less expensive one</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'This tells DBCSI the most FSx-OnTap file systems it may use to lower cost. DBCSI first finds the fewest file systems that meet your targets, then uses more (up to this limit) only when that saves at least 20% per month, e.g. 2 x 2048 MB/s instead of 1 x 4096 MB/s (which requires 160,000 provisioned SSD IOPS). Multiple file systems mean striping the database (e.g. Oracle ASM) across them, and snapshots/replication are per file system. Gen2 Single-AZ scales out with HA pairs inside one file system instead. DBCSI still uses more file systems than this limit if fewer cannot meet your targets.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  FSx-OnTap Maximum File Systems?:
                </template>
                <b-form-select v-model="form.ec2fsxn_fsxn_max_filesystems" size="sm" @change="triggerFullRecalculate">
                  <option value="1">1 - only use more file systems when one cannot meet the targets</option>
                  <option value="2">Up to 2 file systems</option>
                  <option value="4">Up to 4 file systems</option>
                  <option value="8">Up to 8 file systems</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to pick an EC2 shape when multiple shapes match your target requirements.  When customers want to be frugal with their Oracle Database Licenses, they may choose something other than lowest AWS hourly cost.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  EC2 Shape Selection Preference?:
                </template>
                <b-form-select v-model="form.ec2fsxn_baremetal_ranking" size="sm" @change="triggerFullRecalculate">
                  <option value="fastestCore">Pick EC2 shape with the fastest cores</option>
                  <option value="minimumCores">Pick EC2 shape with the least quantity of total cores</option>
                  <option value="minimumCost">Pick EC2 shape with the lowest AWS hourly cost</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group v-if="this.form.ec2fsxn_algo=='Y' && this.form.ec2fsxn_baremetal_ranking!='minimumCost'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This preference tells DBCSI how you want to incorporate Core Factor logic into the selection criteria when multiple EC2 Bare Metal shapes meet your target requirements.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  EC2 Bare Metal Core Factor?:
                </template>
                <b-form-select v-model="form.ec2fsxn_corefactor" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No - do not include Core Factor in criteria</option>
                  <option value="positiveguess">Yes - guess Core Factor and treat ambiguity positively (i.e. 8259CL is the same as 82XX)</option>
                  <option value="negativeguess">Yes - guess Core Factor and treat ambiguity negatively (i.e. 8259CL is NOT the same as 82XX)</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group v-if="this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to estimate MultiAZ for the EC2 instance.  Given that FSx-OnTap\'s MultiAZ File System storage replication does not require you to run an EC2 instance in the secondary AZ, some customers with longer RTO requirements choose to not continually run an EC2 instance in the secondary AZ.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  EC2 MultiAZ Style?:
                </template>
                <b-form-select v-model="form.ec2fsxn_baremetal_HA" size="sm" @change="triggerFullRecalculate">
                  <option value="single">Frugal (Longer RTO) - MultiAZ Estimates only include an EC2 instance in the primary AZ</option>
                  <option value="Y">Shorter RTO - MultiAZ Estimates should include EC2 instance in both AZs</option>
                </b-form-select>
              </b-form-group>
              

              <b-form-group v-if="false && this.form.ec2fsxn_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how if you want to show both the RDS configuration and the EC2 Bare Metal configuration in the Show Config report, or if you only want to show the EC2 Bare Metal configuration.  If you show both, the charts in the report will use the RDS configuration as the reference for the available resources.'">
                <template slot="label">
                  <img src="@/assets/EC2FSxN.png" height="24px" ></img>
                  EC2 Bare Metal Show Config Style?:
                </template>
                <b-form-select v-model="form.ec2fsxn_baremetal_showdetail" size="sm" @change="triggerFullRecalculate">
                  <option value="alternate">Display both the RDS and the EC2 Bare Metal configuration in the Show Config report </option>
                  <option value="ec2only">Only show the EC2 Bare Metal configuration in the Show Config report</option>
                </b-form-select>
              </b-form-group>


              <b-form-group v-if="this.showEC2" label="Include EC2 Alternative?:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI if it should add an alternate customer-managed EC2 (non-bare metal) configuration.'">
                <template slot="label">
                  <img src="@/assets/EC2new.png" height="24px" ></img>
                  Include EC2 Alternative?:
                </template>
                <b-form-select v-model="form.ec2_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No</option>
                  <option value="Y">Yes- add an alternate customer-managed EC2 configuration</option>
                </b-form-select>
              </b-form-group>




              <b-form-group v-if="this.showODBAWS && !isChinaRegion" label="Include Oracle Database@AWS (Marketplace) Alternative?:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI if it should add an alternate Oracle Database@AWS marketplace configuration.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  Include Oracle Database@AWS (Marketplace) Alternative?:
                </template>
                <b-form-select v-model="form.odbAWS_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="N">No</option>
                  <option value="Y">Yes- add an alternative Oracle Database@AWS configuration</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.odbAWS_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI what Oracle Service to estimate.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  OCI Service:
                </template>
                <b-form-select v-model="form.odbAWS_service" size="sm" @change="changeODBRecalculate">
                  <option value="exacs">Exadata Database on Dedicated Infrastructure</option>
                  <option value="exascale">Exadata Database on ExaScale Infrastructure</option>
                  <option value="adb">Autonomous Database on Dedicated Infrastructure</option>
                  <option value="adbs-tp">Autonomous Database Serverless</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.odbAWS_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to estimate license/Usage charges.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  License Model?:
                </template>
                <b-form-select v-model="form.odbAWS_Licensing" size="sm" @change="triggerFullRecalculate">
                  <option value="BYOL">Use Bring Your Own Licensing (BYOL) Usage pricing</option>
                  <option value="LI">Use License Included Usage pricing</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.odbAWS_algo=='Y' && this.form.odbAWS_service!='adbs-tp' && this.form.odbAWS_service!='exascale'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI what hardware model to use for the estimate.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  Model:
                </template>
                <b-form-select v-model="form.odbAWS_model" size="sm" @change="triggerFullRecalculate">
                  <!-- X9M-2 is no longer offered for ODB@AWS; X11M is the only model -->
                  <!--<option v-if="(this.form.odbAWS_service=='exacs')" value="X9M-2">X9M-2</option>-->
                  <option value="X11M">X11M</option>
                </b-form-select>
              </b-form-group>

 
              <b-form-group v-if="this.form.odbAWS_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to configure MultiAZ for the Exadata infrastructure.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  MultiAZ?:
                </template>
                <b-form-select v-model="form.odbAWS_HA" size="sm" @change="triggerFullRecalculate">
                  <option value="single">Use a single AZ</option>
                  <option v-if="(this.form.odbAWS_service!='adbs-tp')" value="Y">Deploy Exadata infrastructure in two AZs in the region, with full-scale Usage sizing for the 2nd AZ</option>
                  <option v-if="(this.form.odbAWS_service=='adbs-tp')" value="Y">Always deploy a Local Peer for HA (Autonomous Data Guard)</option>
                  <option v-if="(this.form.odbAWS_service=='adbs-tp')" value="UseMAZ">When RDS-Oracle is set for MultiAZ, then deploy a Local Peer for HA</option>
                  <option v-if="(this.form.odbAWS_service=='exacs') || (this.form.odbAWS_service=='exascale')" value="Y20">(Pilot Light MAZ) - Deploy Exadata infrastructure in two AZs in the region, with 20% Usage sizing for the 2nd AZ</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="this.form.odbAWS_algo=='Y'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to configure DR for the Exadata infrastructure.  Because of the calendar time needed to purchase new infrastructure, it is strongly recommended to have your DR infrastructure pre-acquired and provisioned.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  DR?:
                </template>
                <b-form-select v-model="form.odbAWS_DR" size="sm" @change="triggerFullRecalculate">
                  <option v-if="(this.form.odbAWS_service!='adbs-tp')" value="N">Do not deploy DR infrastructure (WARNING- Not Suggested)</option>
                  <option v-if="(this.form.odbAWS_service=='adbs-tp')" value="N">Do not deploy Cross-Region Peer (Autonomous Data Guard) for DR</option>
                  <option v-if="(this.form.odbAWS_service!='adbs-tp')" value="Y">Deploy SingleAZ Exadata infrastructure in a 2nd region, with full-scale Usage sizing for the 2nd region</option>
                  <option v-if="(this.form.odbAWS_service=='adbs-tp')" value="Y">Deploy Cross-Region Peer (Autonomous Data Guard) for DR</option>
                  <option v-if="(this.form.odbAWS_service=='exacs') || (this.form.odbAWS_service=='exascale')" value="Y20">(Pilot Light DR) - Deploy SingleAZ Exadata infrastructure in a 2nd region, with 20% Usage sizing for the 2nd region</option>
                  <option v-if="((this.form.odbAWS_service=='exacs') || (this.form.odbAWS_service=='exascale')) && ( (this.form.odbAWS_HA=='Y') || (this.form.odbAWS_HA=='Y20') )" value="YMA">Deploy MultiAZ Exadata infrastructure in a 2nd region, with full-scale Usage sizing for the 2nd region primary</option>
                  <option v-if="((this.form.odbAWS_service=='exacs') || (this.form.odbAWS_service=='exascale')) && ( (this.form.odbAWS_HA=='Y') || (this.form.odbAWS_HA=='Y20') )" value="YMA20">(Pilot Light DR w/ MAZ) - Deploy MultiAZ Exadata infrastructure in a 2nd region, with 20% Usage sizing for the 2nd region</option>
                </b-form-select>
              </b-form-group>
 
              <b-form-group v-if="this.form.odbAWS_algo=='Y' && this.form.odbAWS_service!='adbs-tp' && this.form.odbAWS_service!='exascale'" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how to allocate storage.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  Storage Allocation?:
                </template>
                <b-form-select v-model="form.odbAWS_StorageStyle" size="sm" @change="triggerFullRecalculate">
                  <option value="default">Do not store backups on Exadata Storage nor create a SPARSE disk group</option>
                  <option value="BACKUP">Store backups on Exadata Storage (but do not create a SPARSE disk group)</option>
                  <option v-if="(this.form.odbAWS_service=='exacs')" value="SPARSE">Create a SPARSE disk group (but do not store Backups on Exadata Storage)</option>
                  <option v-if="(this.form.odbAWS_service=='exacs')" value="BOTH">Store backup on Exadata Storage and create a SPARSE disk group</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(this.form.odbAWS_algo=='Y') && (this.form.odbAWS_service=='adb')" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI how much additional CPU to reserve when calculating the number of database servers needed.  This is only for Autonomous Database'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="24px" ></img>
                  ADB Node Failover?:
                </template>
                <b-form-select v-model="form.odbAWS_adb_nodereserve" size="sm" @change="triggerFullRecalculate">
                  <option value="0">Do not reserve any additional CPU for node failures</option>
                  <option value="25">Reserve 25% additional CPU</option>
                  <option value="50">Reserve 50% additional CPU</option>
                </b-form-select>
              </b-form-group>
 
 
              

              
          <div>
            <b-button @click="addlControlsCollapsed = !addlControlsCollapsed" variant="secondary">
              More Preferences/Controls &nbsp;
              <span class="float-right">{{ addlControlsCollapsed ? '▶' : '▼' }}</span>
            </b-button>
            <b-collapse :visible="!addlControlsCollapsed" id="collapse-1" class="mt-2">
              <b-card>
                <p class="card-text">Additional Preferences</p>


              <b-form-group label="AWS Pricing Preference:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'You can use this control to tell DBCSI your preference for pricing AWS compute instances'">
                <b-form-select v-model="form.useRI_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="RI+SP">Use 1yr No-Upfront Reserved Instance pricing or 1yr No-Upfront Database Savings Plans pricing if available</option>
                  <option value="SP-Only">Use only 1yr No-Upfront Database Savings Plans pricing</option>
                  <option v-if="false" value="RI">Use 1yr No-Upfront Reserved Instance pricing if available</option>
                  <option value="OD">Use On-Demand pricing</option>
                </b-form-select>
              </b-form-group>

              

              <b-form-group v-if="form.caching_algo && form.caching_algo!='N'" label="ElastiCache DB Memory Minimum:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This is the minimum target memory size (in GB) needed before DBCSI will try to add ElastiCache to the configuration.'">
                <template slot="label">
                  <img src="@/assets/Elasticache.png" height="20px" ></img>
                  ElastiCache DB Memory Minimum:
                </template>
                <b-form-input @change="triggerFullRecalculate"
                      v-model="form.caching_minmem" size="sm" type="number"
                      step="1"
                      :placeholder="`minimum database Memory size (GB) needed before adding ElastiCache`">
                </b-form-input>
              </b-form-group>


              <b-form-group v-if="IS_EXADATA" label="post-Exadata tuning IO Throughput minimum threshold (MB/s):" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'This is the minimum IO Throughput needed to apply the post-Exadata tuning assumptions.  Databases with a smaller IO throughput will be ignored/skipped when applying the tuning assumptions.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="20px" ></img>
                  post-Exadata tuning IO Throughput minimum threshold (MB/s):
                </template>
                <b-form-input @change="triggerFullRecalculate"
                      v-model="form.smartscan_minimum" size="sm" type="number"
                      step="1"
                      :placeholder="`minimum IO throughput (MB/s) before applying tuning assumption`">
                </b-form-input>
              </b-form-group>
              
              <b-form-group v-if="IS_EXADATA" label="Boost post-Exadata Memory target?:" label-cols="3" label-size="sm" v-b-popover.hover.top="'When moving away from Exadata, a common technique is to increasing the memory allocation for the buffer cache.'">
                <template slot="label">
                  <img src="@/assets/Exadata.png" height="20px" ></img>
                  Boost post-Exadata Memory target?:
                </template>
                <b-form-select v-model="form.exa_memory_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="em0">No - leave Memory target alone</option>
                  <option value="em1" >Yes - favor a bigger Memory target to ease post-Exadata transition</option>
                </b-form-select>
              </b-form-group>
  
              <b-form-group v-if="IS_PDB" label="PDB Metric Data Source:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'You can use this control to tell DBCSI what Oracle AWR data source to use for PDB-level metrics.  In some cases, Oracle AWR seems to mis-report PDB-level metrics (such as surprisingly low or high values) and you can tell DBCSI to use data from the other AWR table to work-around this AWR problem.'">
                <b-form-select v-model="form.pdb_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="pdb1">Use Oracle's DBA_HIST_CON_SYSMETRIC_SUMM table for PDB-level CPU and IO Throughput</option>
                  <option value="pdb2">Use Oracle's DBA_HIST_RSRC_PDB_METRIC table for PDB-level CPU and IO Throughput</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.rds_algo=='rac'" label="RAC Minimum Node Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI the minimum number of Real Application Cluster Nodes to use.  DBCSI may choose to use more nodes if needed to meet your target values.  The Buffer setting increases the target values before sizing for when you might want to account for scaling overhead with the RAC clustering for your workload.'">
                <b-form-select v-model="form.rac_min_node_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="2">2 Nodes</option>
                  <option value="3">3 Nodes</option>
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="form.rds_algo=='rac'" label="RAC Buffer Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'The Buffer setting optionally increases the target values before sizing for when you might want to account for potential scaling overhead with the RAC clustering for your workload.'">
                <b-form-select v-model="form.rac_buffer_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="0">No added target value buffer</option>
                  <option value="10">Add a target value of buffer of 10% when calculating requirements</option>
                 </b-form-select>
              </b-form-group>

              <b-form-group label="MultiAZ Preference:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI when to configure MultiAZ.'">
                <b-form-select v-model="form.multiAZ_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="auto">Configure MultiAZ when source database uses RAC</option>
                  <option value="Y">Always configure using MultiAZ</option>
                  <option value="N">Never configure using MultiAZ</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group label="EBS Preference:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI what kind of storage to provision for RDS.  The Prefer gp2/gp3 option will try to use gp2/gp3 unless it finds it needs to move to io1/io2 to meet one of the IO target values'">
                <b-form-select v-model="form.ebs_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="p-gp">Prefer gp2/gp3</option>
                  <option value="gp2">Always use gp2</option>
                  <option value="gp3">Always use gp3</option>
                  <option value="io1">Always use io1</option>
                  <option value="io2">Always use io2</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group label="Additional Storage Volume Consideration(GB):" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI the minimum overall database storage size (in GB) before it starts to consider Additional Storage Volumes for RDS-Oracle.  If empty, DBCSI will not consider ASVs.  If you provide a value, it should be in the range of 400 to 64000.'">
                <b-form-input v-model="form.asv_min_storage" size="sm" @change="triggerFullRecalculate" 
                  placeholder="If empty, DBCSI will not consider ASVs.  If you provide a value, it should be in the range of 400 to 64000." />
              </b-form-group>

              <b-form-group label="Local Storage Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI if you want to only consider Shapes with local storage.  Some customers prefer to have local storage for temporary tablespace usage or for the Database Flash Cache feature.'">
                <b-form-select v-model="form.nvme_shape_algo" size="sm" @change="triggerFullRecalculate">
                  <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                  <option value="Y">Only consider shapes with local storage (e.g. r5d,m5d,r6id,...)</option>
                  <option value="N">Consider any shape</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="T-Shape Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI if you want to consider T-shapes with burstable CPU.  Some customers prefer to avoid T-shapes with burstable CPU when they are bringing expensive per-CPU Oracle licenses '">
                <b-form-select v-model="form.tshape_algo" size="sm" @change="triggerFullRecalculate">
                  <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                  <option value="Y">Consider T-shapes (burstable CPU)</option>
                  <option value="N">Do not consider T-shapes (burstable CPU)</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Extended Memory Shape Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI if you want to consider RDS extended memory shapes like r5.xlarge.tpc2.mem2x'">
                <b-form-select v-model="form.extMemShape_algo" size="sm" @change="triggerFullRecalculate">
                  <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                  <option value="Y">Consider RDS extended memory shapes like r5.xlarge.tpc2.mem2x</option>
                  <option value="N">Do not consider RDS extended memory shapes</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Skip Shape Filter:" label-cols="3" label-size="sm"
                v-b-popover.hover.top="'Optional Regular Expression to filter out certain shapes when picking RDS-Oracle, Aurora PostgreSQL, EC2, and EC2 + FSxN configurations. Shapes with names that match this pattern will not be picked. For example, the filter 5 will filter out the various r5, r5b, and m5 shapes.  Supports glob patterns like *r5* which are automatically converted to regex.'">
                <b-form-select v-model="skipShapePreset" size="sm">
                  <option v-for="p in skipShapePresets" :key="p.key" :value="p.key">{{ p.text }}</option>
                  <option value="custom">Custom pattern...</option>
                </b-form-select>
              </b-form-group>
              <b-form-group v-if="skipShapePreset=='custom'" label="Custom Skip Shape Pattern:" label-cols="3" label-size="sm">
                <b-form-input v-model="form.rdsSkipShape_expr" size="sm" @change="triggerFullRecalculate"
                  placeholder="Optional pattern.  e.g., z1d,  5, 5\., (z1d|5\.) " />
                <b-form-text>
                  Shapes whose name (e.g. <code>r5.xlarge</code>, <code>r6i.2xlarge</code>, <code>x2iedn.4xlarge</code>) matches this regular expression anywhere will NOT be picked. Leave blank to consider all shapes.
                  <ul class="mb-0 pl-3">
                    <li><code>z1d</code> &mdash; skip the z1d family</li>
                    <li><code>5</code> &mdash; skip any shape whose name contains a 5 (r5, r5b, m5, c5, ...)</li>
                    <li><code>^r5</code> &mdash; skip shapes starting with r5 (r5, r5b, r5d, r5dn)</li>
                    <li><code>^r5\.</code> &mdash; skip only the plain r5 family (a literal dot is <code>\.</code>)</li>
                    <li><code>(z1d|^r5\.)</code> &mdash; use <code>|</code> to combine several patterns</li>
                    <li><code>^[a-z]+[1-5]</code> &mdash; skip families whose name digit is 1-5 (note: unlike the generation presets above, this also skips i4i, t4g, and x2iedn, which are really 6th generation)</li>
                    <li><code>metal</code> &mdash; skip bare metal shapes</li>
                    <li><code>*r5*</code> &mdash; simple glob patterns are converted to regex (<code>*</code> becomes <code>.*</code>)</li>
                  </ul>
                  <span v-if="skipShapePatternError" class="text-danger">{{ skipShapePatternError }}</span>
                </b-form-text>
              </b-form-group>
              
              <b-form-group label="Bursting IO Preference:" label-cols="3" label-size="sm" 
              v-b-popover.hover.top="'This tells DBCSI if you want to consider bursting IO characteristics of the compute shape (and, for EC2 + FSx-OnTap, the EC2 network bandwidth and the FSx-OnTap throughput tier) as a way to meet IO target values. Burst rates only last for short periods, so DBCSI only relies on FSx-OnTap bursting for targets up to 2x the baseline.'">
                <b-form-select v-model="form.bursting_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="Y">Consider burstable IO performance for compute shapes and FSx-OnTap storage</option>
                  <option value="N">Evaluate compute shapes and FSx-OnTap storage only on their baseline IO performance</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group label="PDB and CDB Overlap Preference:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI what to do when you have a child PDB and its parent CDB in the same set.'">
                <b-form-select v-model="form.pdb_and_cdb_exclude_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="none">Treat PDBs and CDBs as separate independent databases and include both</option>
                  <option value="excludePDB">Exclude the PDB from totals and CSV downloads if the CDB is also in the batch</option>
                  <option value="excludeCDB">Exclude the CDB from totals and CSV downloads if the PDB is also in the batch</option>
                </b-form-select>
              </b-form-group>
              
              <b-form-group label="Duplicate Database Preference:" label-cols="3" label-size="sm" 
                v-b-popover.hover.top="'This tells DBCSI what to do when duplicate databases (same DBID, DBNAME, and hostnames) appear in the same batch.'">
                <b-form-select v-model="form.duplicate_database_exclude_algo" size="sm" @change="triggerFullRecalculate">
                  <option value="none">Include all databases, even duplicates</option>
                  <option value="excludeDuplicates">Exclude duplicate databases from totals and CSV downloads</option>
                </b-form-select>
              </b-form-group>
              


              </b-card>
            </b-collapse>
          </div>
          
            <p/>

              <hr style="margin: 0.5rem 0; border-top: 1px solid #dee2e6;">

              <p/>
              Choose the target AWS region.  The following control will take effect immediately and will be applied to all scenarios.
              <p/>
          
                
                <b-form-group label="AWS Region for Pricing:" label-cols="3" label-size="sm">
                  <b-form-select v-model="regionCode" size="sm" @change="changeRegion" :options="region_lov"/>
                </b-form-group>
                
                <b-alert :show="isChinaRegion" variant="warning">
                  <strong>Note:</strong> Prices are in Chinese Yuan, not US dollars.
                </b-alert>
                <b-alert :show="isChinaRegion" variant="warning">
                  <strong>Beta:</strong> DBCSI support for pricing for the Chinese AWS regions is beta and experimental. You should manually reconfirm pricing outside of DBCSI.
                </b-alert>

                <b-form-group v-if="form.readreplica_algo=='Y' || form.readreplica_algo=='auto'" label="AWS Region for Replica:" label-cols="3" label-size="sm"
                  v-b-popover.hover.top="'For a cross-region Replica (which can be used for low RPO Disaster Recovery), pick the AWS Region to use for pricing.'" >
                  <b-form-select v-model="form.readreplica_region" size="sm" @change="changeDRRegionLOV" :options="region_lov"/>
                </b-form-group>
                

              <p/>

 
              <p/>
            </div>

              </b-collapse>
              </b-card>

          </b-list-group-item>  






          <b-list-group-item variant="light">

              <b-card 
          
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
                <template #header>
                  <div @click="scenariosCollapsed = !scenariosCollapsed" style="cursor: pointer;">
                    Scenario Controls
                    <span class="float-right">{{ scenariosCollapsed ? '▶' : '▼' }}</span>
                  </div>
                </template>
                <b-collapse :visible="!scenariosCollapsed">
                  
                  <p/>
                  
              <b-alert :show="triggerFullRecalculateFlag" variant="danger">{{ (this.scenarioCount==0) ? "To get started: choose your algorithms, name your scenario, and click the Create New Scenario button" : "The algorithm selections have been changed. To apply your new choices, choose to either create a new a scenario or replace an existing one." }}</b-alert>

              <b-card bg-variant="light">
                <b-form-group
                  label-cols-lg="3"
                  label="Create New Scenario"
                  label-size="lg"
                  label-class="font-weight-bold pt-0"
                  class="mb-0"
                  v-b-popover.hover.top="`You can use the scenario feature to compare different algorithms or different preferences.  For example, you can compare the default algorithm choices against a more conservative set of choices, or compare the different Optimization Goal preferences against each other.`" title="Scenario Ideas"
                >
                  <b-form-group label="Scenario Name:" label-cols="3" label-size="sm">
                    <b-form-input 
                          v-model="scenarioName" size="sm" 
                          :placeholder="`Scenario ${this.scenarioCount+1}`">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group label="" label-cols="3" label-size="sm">
                    <b-button
                      v-on:click="createNewScenario"
                      type="button"
                      block
                      variant="primary"
                      :disabled="this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || this.batchItems[0].row=='Error Loading??' || !triggerFullRecalculateFlag || this.disableScenarioButton"
                    >Create New Scenario{{(scenarioCount>0) && (!triggerFullRecalculateFlag) ? ' - disabled until you change an algorithm' : ''}}</b-button>
                  </b-form-group>

                </b-form-group>
              </b-card>
 
              <b-card bg-variant="light" v-if="this.scenarioCount>0">
                <b-form-group
                  label-cols-lg="3"
                  label="Replace Existing Scenario"
                  label-size="lg"
                  label-class="font-weight-bold pt-0"
                  class="mb-0"
                >
                  <b-form-group label="Existing Scenario:" label-cols="3" label-size="sm">
                    <b-form-select v-model="scenarioSelected" :options="scenarios" size="sm"></b-form-select>
                  </b-form-group>
                  <b-form-group label="" label-cols="3" label-size="sm">
                    
                    <b-button
                      v-on:click="replaceExistingScenario"
                      type="button"
                      block
                      variant="primary"
                      :disabled="(this.scenarioCount==0) || this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || !triggerFullRecalculateFlag || this.disableScenarioButton"
                    >Replace Existing Scenario{{(scenarioCount==0) ? ' - disabled until you create a scenario' : (!triggerFullRecalculateFlag) ? ' - disabled until you change an algorithm' : ''}}</b-button>
                  </b-form-group>
                  
                </b-form-group>
              </b-card>

              <b-card bg-variant="light" v-if="this.scenarioCount>0">
                <b-form-group
                  label-cols-lg="3"
                  label="Manually Edit Target Values"
                  label-size="lg"
                  label-class="font-weight-bold pt-0"
                  class="mb-0"
                  v-b-popover.hover.top="`You can manually edit the target values for a scenario.  This method will make a copy of the specified scenario and then allow you to hand-edit its target values as needed.`" title="Manually Edit Values"
                >
                  
                  <b-form-group label="Existing Scenario:" label-cols="3" label-size="sm">
                    <b-form-select v-model="scenarioSelected" :options="scenarios" size="sm"></b-form-select>
                  </b-form-group>
                  <b-form-group label="" label-cols="3" label-size="sm">
                    
                    <b-button
                      v-on:click="manualEditScenario"
                      type="button"
                      block
                      variant="primary"
                      :disabled="(this.scenarioCount==0) || this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || this.disableScenarioButton"
                    >Manually Edit Target Values{{(scenarioCount==0) ? ' - disabled until you create a scenario' : ''}}</b-button>
                  </b-form-group>
                  
                </b-form-group>
              </b-card>                  
                  
              <p/>

              </b-collapse>
              </b-card>
            
          </b-list-group-item>  




          <b-list-group-item variant="light" v-if="this.singleDB">
            


              <b-card 
          class="mb-1"
          border-variant="success"
          header-bg-variant="success"
          header-text-variant="white"
        >
                <template #header>
                  <div @click="databaseDetailsCollapsed = !databaseDetailsCollapsed" style="cursor: pointer;">
                    Database Details
                    <span class="float-right">{{ databaseDetailsCollapsed ? '▶' : '▼' }}</span>
                  </div>
                </template>
                <b-collapse :visible="!databaseDetailsCollapsed">
              
              <div>

              
              <div id="dbOverview">
                <!-- COPIED FROM Metrics.vue line 29 -->
                <b-alert :show="shareMode" variant="info">This database has been shared with you via URL.  Please save the URL if you want to continue to view it later.</b-alert>
                
                <img v-if="(this.batchItems[0].AWR_MINER_VER != undefined && !( this.batchItems[0].AWR_MINER_VER.includes('aws') || this.batchItems[0].AWR_MINER_VER.includes('statspack') ) )" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic non-DBCSI AWR Miner script was used to collect metrics.  DBCSI works best if you use the DBCSI-specific data collection script downloadable from the DBCSI Add page.  Some DBCSI functionality will be missing."></img>
                
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='AIX-Based_Systems_(64-bit)')" src="@/assets/AIX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='Solaris[tm]_OE_(64-bit)')" src="@/assets/SPARC.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='HP-UX_IA_(64-bit)')" src="@/assets/HPUX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='IBM_zSeries_Based_Linux')" src="@/assets/zSeries.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${this.batchItems[0].PLATFORM_NAME}]`" title="not x86"></img>
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='Microsoft_Windows_x86_64-bit')" src="@/assets/WIN.png" height="16px" ></img>
                <img v-if="(this.batchItems[0].PLATFORM_NAME=='Solaris_Operating_System_(x86-64)')" src="@/assets/SolarisX86.png" height="16px" ></img>
                
                
                    <img v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId==undefined) && (this.batchItems[0].cdb_target_comments==undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.`" title="PDB" src="@/assets/PDB.png" height="20px" ></img>
                    <img v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId==undefined) && (this.batchItems[0].cdb_target_comments!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(this.batchItems[0].cdb_target_comments==undefined) ? '' : this.batchItems[0].cdb_target_comments}`" title="PDB" src="@/assets/PDB_NOCDB.png" height="20px" ></img>
                    <a v-if="(this.batchItems[0].IS_PDB=='YES') && (this.batchItems[0].CDB_collectionId!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(this.batchItems[0].cdb_target_comments==undefined) ? '' : this.batchItems[0].cdb_target_comments}`" title="PDB - Click on the PDB icon to view the CDB" :href="`/batch/C${this.batchItems[0].CDB_collectionId}`" target="_blank"><img src="@/assets/PDB_CDB.png" height="20px" ></img></a>  
                
                
                <img v-if="!(this.batchItems[0].AWR_MINER_VER != undefined && !(this.batchItems[0].AWR_MINER_VER.includes('aws') || this.batchItems[0].AWR_MINER_VER.includes('statspack'))) && (this.batchItems[0].COUNT_LINES_PLSQL*1<20000)" src="@/assets/Postgres.png" height="20px" v-b-popover.hover="`Not much PLSQL (${this.batchItems[0].COUNT_LINES_PLSQL} lines). Consider migrating to PostgreSQL.`" title="PostgreSQL"></img>
                <img v-if="(this.batchItems[0].rds_type!='custom')&&(this.batchItems[0].VERSION !== undefined && this.batchItems[0].VERSION.substr(0,2)!=='21')&&(this.batchItems[0].VERSION !== undefined && this.batchItems[0].VERSION.substr(0,2)!=='19')" src="@/assets/Upgrade.png" height="20px" v-b-popover.hover="`This is an old version [${this.batchItems[0].VERSION}] of Oracle.  Expect to upgrade it for RDS-Oracle.`" title="old Oracle version"></img>
                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible==undefined)" src="@/assets/Exadata.png" height="20px" v-b-popover.hover="`This database runs on Exadata.`" title="Exadata"></img>
 
                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible==0)" src="@/assets/Exadata0.png" height="20px" v-b-popover.hover="`This database used to run on Exadata, but may not anymore. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - ZERO SmartScan Offload"></img>

                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>0)&&(this.batchItems[0].SmartScanEligible<=500)" src="@/assets/Exadata1.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Minimal SmartScan Offload"></img>
                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>500)&&  (this.batchItems[0].SmartScanEligible<2000)" src="@/assets/Exadata2.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Moderate SmartScan Offload"></img>
                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>2000)&&  (this.batchItems[0].SmartScanEligible<8000)" src="@/assets/Exadata3.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Medium SmartScan Offload"></img>
                <img v-if="(this.batchItems[0].Exadata=='Yes')&&(this.batchItems[0].SmartScanEligible!=undefined)&&(this.batchItems[0].SmartScanEligible>8000)" src="@/assets/Exadata4.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+this.batchItems[0].SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+this.batchItems[0].StorageIndexSavings.toFixed(0)+'MB/s'}  ${(this.batchItems[0].ExadataAdjustmentText==undefined) ? '' : this.batchItems[0].ExadataAdjustmentText}`" title="Exadata - Heavy SmartScan Offload"></img>
                <img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 30)" src="@/assets/OLTP1.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                <img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 30) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 120)" src="@/assets/OLTP2.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                <img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 120) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 <= 400)" src="@/assets/OLTP3.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting mixed and/or DW workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                <img v-if="(this.batchItems[0].IOPS*1>0) && (this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024 > 400)" src="@/assets/OLTP4.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(this.batchItems[0].Throughput/this.batchItems[0].IOPS*1024)} KB, which makes this database appear to be supporting DW-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                <img v-if="(this.batchItems[0].considerSE2=='Yes') || (this.batchItems[0].considerSE2==undefined && !(this.batchItems[0].AWR_MINER_VER != undefined && !(this.batchItems[0].AWR_MINER_VER.includes('aws') || this.batchItems[0].AWR_MINER_VER.includes('statspack')) ) && this.batchItems[0].SE2=='Yes')" src="@/assets/SE2.png" height="20px" v-b-popover.hover="`Consider evaluating this database for Oracle Standard Edition2.  At first glance, DBCSI did not find too many different types of EE features such as Partitioning, Bitmap Indexes, Parallel Query, and VPD/ FGA/ Data Redaction. ${this.batchItems[0].SE2_Comments}`" title="Standard Edition2"></img>
                
                <b-alert :show="showPDBalert" variant="warning">Warning: This is a PDB.  PDB support for DBCSI is still evolving.  We encourage you to also collect data from the CDB database to help DBCSI sanity-check the PDB-level metrics.</b-alert>
             
                
                <b-table striped hover bordered fixed small sticky-header head-variant="light" :items="genItems" class="table-sm text-xsmall">
                  <template v-slot:cell(value)="row">
                    <div v-if="(row.item.name == 'SE2_ANALYSIS')">{{batchItems[0].SE2_Comments}}</div>
                    <div v-if="!( row.item.name == 'SE2_ANALYSIS')">{{row.item.value}}
                      <img v-if="row.item.name == 'NUM_CPUS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'NUM_CPU_CORES'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle on a single node.  Source: DBA_HIST_OSSTAT or STATS$OSSTAT"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of operating system CPUs (aka threads) seen by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'GLOBAL_CPU_CORE_COUNT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the number of hardware cores detected by Oracle across all nodes.  Source: DBA_CPU_USAGE _STATISTICS"></img>
                      <img v-if="row.item.name == 'TOTAL_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files and temp files.  Source: DBA_DATA_FILES and DBA_TEMP_FILES"></img>
                      <img v-if="row.item.name == 'TOTAL_DATAFILE_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all data files.  Source: DBA_DATA_FILES"></img>
                      <img v-if="row.item.name == 'USED_DB_SIZE_GB'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="This is the total size of all segments.  Source: DBA_SEGMENTS"></img>
                      <img v-if="row.item.name == 'HOSTS'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: DBA_HIST_ DATABASE_INSTANCE or STATS$ DATABASE_INSTANCE"></img>
                      <img v-if="row.item.name == 'HOSTS_CURRENT'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Source: GV$INSTANCE"></img>
                      <img v-if="row.item.name == 'HOST_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The host of the database instance used to collect data."></img>
                      <img v-if="row.item.name == 'INSTANCE#_CONNECTED'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="The database instance number used to collect data.  DBCSI pulls data from all instances in a RAC Cluster, but it can sometimes be helpful to know which instance was used to collect data."></img>
                      <!--<img v-if="(row.item.name == 'AWR_MINER_VER' && row.item.value.includes('aws'))" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Reminder: best practice is to always download the latest version of the DBCSI data collection script from the DBCSI Add page."></img>-->
                      <img v-if="(row.item.name == 'AWR_MINER_VER' && !( row.item.value.includes('aws') || row.item.value.includes('statspack') ) )" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic AWR Miner script output.  DBCSI works best if you use the DBCSI-specific data collection script from the DBCSI Add page."></img>
                      <img v-if="row.item.name == 'STATSPACK_MINER_VER'" src="@/assets/info.png" height="20px" v-b-tooltip.hover title="Warning: when using STATSPACK data, some features of DBCSI will be limited."></img>
                      
                    </div>

                  </template>
                </b-table>
              </div>

            </div>
              
              </b-collapse>
              </b-card>
            
          </b-list-group-item>  





          <b-list-group-item variant="light">

              
              <div id="databases">
              <b-alert :show="showAlertRecalc" :variant="alertStyleRecalc">{{alertTextRecalc}}</b-alert>
                
               <b-card 
                    class="mb-1"
                    border-variant="success"
                    header-bg-variant="success"
                    header-text-variant="white"
                  >

                <template #header>
                  <div @click="databasesCollapsed = !databasesCollapsed" style="cursor: pointer;">
                    Databases ( {{ batchItemsOrigLength==0 ? 'loading' : batchItemsOrigLength }} )
                    <span class="float-right">{{ databasesCollapsed ? '▶' : '▼' }}</span>
                  </div>
                </template>

                <a id="Databases"></a>
                 <span v-if="(this.scenarioCount>0)"> <p/>
                                <span style="font-size:14px" title="Source Environment Analysis" v-b-popover.hover="`The source environment totals attempt to unravel scenarios where multiple databases run on the same hostname as well as scenarios where both a CDB and some of its PDBs are included.  Total Apparent VCPU is simply the sum of NUM_CPUS across all of the instances.  Total Distinct VCPU (which is likely more useful) attempts to avoid duplicate counting of VCPUs when instances share the same hostname.  Understand that the totals are based on the data that DBCSI is provided and can be misleading when you have not been provided data for all of the databases in the environment or in cases where different VMs are actually colocated on the same physical server.  And also be careful how you use and compare these VCPU quantities when the source platform is not X86.`">Source Environment:  Databases = {{this.totals[0].totalSourceDBCount}}.  Instances = {{this.totals[0].totalSourceInstanceCount}}.  Distinct Hostnames = {{this.totals[0].totalSourceDistinctServerCount}}. Total Apparent VCPU = {{this.totals[0].totalSourceVCPU}}.  Total Distinct VCPU = {{this.totals[0].totalSourceDistinctServerVCPUs}}.   
                                  <span v-if="(this.totals[0].sourceWarning)"><br/>(Note: {{this.totals[0].sourceWarning}})</span>
                                </span><br/>
                   <hr style="border-top: 1px solid #ddd; margin: 5px 20px;"/>
                   <span style="font-size:14px" v-for="(total, index) in this.totals" :key="total.scenarioName">
                                <span>RDS-Oracle Totals for: <b>{{ total.scenarioName }}</b>.  Databases = {{total.totalRDSCount}}.  Instances = {{total.totalRDSInstanceCount}}.  Total VCPU = {{total.totalRDSVCPU}}.   Total Monthly Estimate = $ {{total.totalRDScost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                  <span v-if="(total.totalUnshapedRDS>0)"><br/>(Note: there are {{total.totalUnshapedRDS}} databases that were not sized for RDS-Oracle and are not included in the above line's totals)</span>
                                </span>
                                <b-button v-if="showDBC" size="sm" variant="outline-info" v-b-modal="`mDBC${index}`" class="ml-2">TCO</b-button>
                                <b-modal :id="`mDBC${index}`" :title="`Total Cost of Ownership / Business Case (${total.totalRDSCount} databases, ${total.totalSourceUsableDiskSpace} GB storage)`" scrollable ok-only size="xl">
                                  <dbcmodal :totals="totals" :scenarioIndex="index" :batchItems="batchItems" :batchId="batch_id"></dbcmodal>
                                </b-modal>
                                <br/>
                                <span v-if="(total.totalAuroracost>0 || total.totalUnshapedAurora>0)">Aurora Totals for: <b>{{ total.scenarioName }}</b>.  Databases = {{total.totalAuroraCount}}.  Instances = {{total.totalAuroraInstanceCount}}.  Total Monthly Estimate = $ {{total.totalAuroracost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                  <span v-if="(total.totalUnshapedAurora>0)"><br/>(Note: there are {{total.totalUnshapedAurora}} databases that were not sized for Aurora and are not included in the above line's totals)</span>
                                  <br/>
                                </span>
                                <span v-if="(total.totalADBSCost>0 || total.totalUnshapedADBS>0)">Autonomous Database Serverless Totals for: <b>{{ total.scenarioName }}</b>.  Databases = {{total.totalADBSCount}}.  Total ECPUs = {{total.totalADBSEcpus}}.  Total Monthly Estimate = $ {{total.totalADBSCost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} 
                                  <span v-if="(total.totalUnshapedADBS>0)"><br/>(Note: there are {{total.totalUnshapedADBS}} databases that were not sized for ADBS and are not included in the above line's totals)</span><br/>
                                </span>
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludePDB')">(Note: PDBs which overlap with a CDB in this batch are excluded from the above line's totals)<br/></span>   
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludeCDB')">(Note: CDBs which overlap with a PDB in this batch are excluded from the above line's totals)<br/></span>   
                               <span style="font-size:14px" v-if="duplicate_databases_in_batch && (total.duplicate_database_exclude_algo == 'excludeDuplicates')">(Note: Duplicated databases in this batch are excluded from the above line's totals)<br/></span>   
                               <hr style="border-top: 1px solid #ddd; margin: 5px 20px;"/>
                   </span>
                   <span v-if="showDBC && totals.length > 1">
                     <b-button size="sm" variant="outline-info" v-b-modal="'mDBCall'" class="ml-2">TCO for all scenarios</b-button>
                     <b-modal id="mDBCall" title="Total Cost of Ownership / Business Case — All Scenarios" scrollable ok-only size="xl">
                       <dbcmodal :totals="totals" :batchItems="batchItems" :batchId="batch_id"></dbcmodal>
                     </b-modal>
                   </span>
                 </span>
                 
                <b-collapse :visible="!databasesCollapsed">
              <p/>
              <span style="font-size:14px">The table below shows the target values and configurations calculated by your algorithms.  You can manually edit a scenario to adjust these target values by hand if desired.</span>
              <p/>
              
              <!-- Filter Controls -->
              <b-row class="mb-3">
                <b-col  md="6">
                  
                    <b-form-select v-if="totals.length>1" v-model="selectedScenarioFilter" size="sm">
                      <option value="">Show All Scenarios</option>
                      <option v-for="total in this.totals" :key="total.scenarioName" :value="total.scenarioName">{{ total.scenarioName }}</option>
                    </b-form-select>
                  
                </b-col>
                <b-col md="6">
                  
                    <b-form-checkbox v-if="duplicate_databases_in_batch || pdb_and_cdb_pairs_in_batch" v-model="hideDuplicates" size="sm">
                      Hide overlapping/duplicated databases
                    </b-form-checkbox>
                  
                </b-col>
              </b-row>
              
                <b-pagination
                  :total-rows="filteredBatchItems.length"
                  :per-page="perPage"
                  v-model="currentInputPage"
                  size="sm"
                  align="center"
                />
                <b-table
                  :per-page="perPage"
                  :current-page="currentInputPage"
                  striped
                  hover
                  responsive
                  bordered
                  small
                  :items="filteredBatchItems"
                  :fields="inputFields"
                  :sort-by.sync="inputSortBy"
                >
                  <template v-slot:head(selected)>
                    <b-checkbox :checked="allSelected" @change="toggleAllSelection"></b-checkbox>
                  </template>
                  <template v-slot:cell(selected)="{ item, field: { key } }" >
                    <b-checkbox :checked="item[key]" @change="toggleItemSelection(item, key, $event)"></b-checkbox>
                  </template>

                  <template  #cell(consolidation_server)="row">
                    <span v-if="row.item.consolidation_server!=undefined"  :title="`${row.item.consolidation_server}`" v-b-popover.hover="`${row.item.consolidation_server_summary}`" >
                      {{ row.item.consolidation_server }}
                      <span style="font-size:12px" >
                        <br/><br/>
                        {{ row.item.consolidation_summary }}
                        <br/><br/>
                        [Databases: {{ row.item.consolidation_databases }}]
                        
                        </span>
                    </span>
                  </template> 
                  

                    
                  
                  <template  #cell(odb_prorated_monthly_estimate)="row">
                    <span v-if="row.item.odb_shape!=undefined && row.item.odb_total_monthly_estimate!=0" 
                      v-b-popover.hover="{title:`Pro-Rated Cost Split/Allocation`, content:`This is the total cost of the ODB@AWS Infrastructure and Usage split (pro-rated) across each individual database.  This is for comparison purposes on a database-by-database level, but you should realize that this projected per-database cost is only valid if you bring all the databases in the set to ODB@AWS.  The split is based on allocating the Usage costs by relative VCPU share, the DB Server costs by relative Memory share, and the Storage Server costs by relative Disk Space share. <br/><br/> ${row.item.odb_prorated_comments}`, html: true}">
                    
                      {{ row.item.odb_prorated_monthly_estimate }}
                      <br/><br/>
                      (This is a share of the overall ODB@AWS total of {{ row.item.odb_total_monthly_estimate }})
                    </span>                  
                    <span v-if="row.item.odb_shape!=undefined && row.item.odb_total_monthly_estimate==0" 
                      v-b-popover.hover="{title:`Not included in Cost Split/Allocation`, content:`${row.item.odb_prorated_comments}`, html: true}">
                      N/A 
                    </span>                  
                  </template>

                  <template  #cell(odb_shape)="row">
                     <span v-if="row.item.odb_shape!=undefined" >
                        <span v-if="row.item.odb_shape!='N/A'"  v-b-popover.hover="{title:`Oracle Database@AWS`, content:`Specifications: ${row.item.odb_specifications}.  <br/><br/> `, html: true}">{{ row.item.odb_shape }}
                        <br/><br/><img src="@/assets/Exadata.png" height="30px" ></img></span>
                    </span>
                  </template>
                  
                  <template v-slot:cell(VCPU)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                      <b-form-input v-model="row.item.VCPU" size="sm" @change="manualEditReconfig"/>
                    </template>
                    <template v-else>
                      {{ row.item.VCPU }}
                      <span v-if="((row.item.AdjustedVCPU) )" v-b-popover.hover="`This is projected value with caching assumptions applied`" title="With Caching Assumptions"><br/>[{{ Math.round(row.item.AdjustedVCPU*10)/10 }}=w/Cache]</span>
                    </template>
                    <br/>
                      <b-button
                        type="button"
                        size="sm"
                        variant="link"
                        v-b-modal="`mCPU${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                         :disabled="row.item.collectionID==undefined"
                      >...</b-button>
                      <img v-if="row.item.vcpu_cost_optimization_text" src="@/assets/CostSaving.png" height="20px" v-b-popover.hover="row.item.vcpu_cost_optimization_text" title="Cost-Optimization Oppty?"></img>                      
                      <img v-if="row.item.vcpu_warnings && row.item.vcpu_warnings.alert" src="@/assets/warning.png" height="20px" v-b-popover.hover="row.item.vcpu_warnings.alert" title="Alerts"></img>
                      <img v-if="row.item.vcpu_warnings && row.item.vcpu_warnings.burst" src="@/assets/burst.png" height="20px" v-b-popover.hover="row.item.vcpu_warnings.burst" title="Alerts"></img>
                      <img v-if="row.item.vcpu_warnings && row.item.vcpu_warnings.info" src="@/assets/info.png" height="20px" v-b-popover.hover="row.item.vcpu_warnings.info" title="Adjustments"></img>
                      <b-modal :id="`mCPU${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" title="VCPU Details" ok-only size="xl">
                          <div>
                            
                          <div style="margin: 25px">
                              <p style="font-size:14px">{{ ((row.item.IS_PDB=='YES')) ? "This shows the average # of CPU threads used by the PDB during each snapshot time period using the Oracle metric: (CPU Usage Per Sec from DBA_HIST_CON_SYSMETRIC_SUMM) along with the alternate metric: (CPU_CONSUMED_TIME from DBA_HIST_RSRC_PDB_METRIC).  Values at the PDB-level are sanity-checked against the CDB (if found in DBCSI) or against typical thresholds, and outliers are not shown.  The value can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  Use this chart to help identify a target baseline of CPU threads needed for this database." :  "This shows the average and peak # of CPU threads used by the database during each snapshot time period using the Oracle metric: (CPU Usage Per Sec).  The value can be greater than 1 when multiple CPU threads at active at the same time.  For a RAC cluster, this chart aggregates the usage across all instances.  Use this chart to help identify a target baseline of CPU threads needed for this database." }}</p>
                           
                            <span style="font-size:14px" v-if="(row.item.AIX_CPU_ADJUSTMENT_USED*1>0)">The following chart has been adjusted for AIX CPU Usage timekeeping by using an AIX Power SMT CPU Time Adjustment multiplier of {{row.item.AIX_CPU_ADJUSTMENT_USED}}.   </span>                  
                            <span style="font-size:14px" v-if="(row.item.PLATFORM_NAME!=undefined && !row.item.PLATFORM_NAME.includes('x86'))">The Average and Peak CPU Usage lines have been adjusted from the source system's threads ({{ row.item.PLATFORM_NAME }}) to x86 VCPUs using the CPU Thread Ratio of {{row.item.cpu_thread_ratio ?? form.cpu_thread_ratio}}.</span>
                          </div>
                          <timechart2container
                            v-bind="getCPUChartConfig(row.item)"
                            :user="user"
                          ></timechart2container>
                  
                          <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; margin: 25px; font-size:14px">[For the Replica, the Target value has been sized as 
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr100') ? '100%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr50') ? '50%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr25') ? '25%' : ''}} of the primary]<br/></span>
                          
                          <div style="margin: 25px" v-if="row.item.ExadataVCPUAdjustmentText!=undefined">
                              <p style="font-size:14px">{{ row.item.ExadataVCPUAdjustmentText }}</p>
                          </div>
                          </div>

                          <div>
                          <div v-if="((row.item.NUM_INSTANCES*1>1))" style="margin: 25px">
                              <p style="font-size:14px">And the below chart is the breakout of the Average DB CPU Usage by RAC Instance.  This chart can show you how the workload is spread across the different RAC nodes.</p>
                          </div>  
                          <div v-if="((row.item.CONSOLIDATED_DATABASES*1>1))" style="margin: 25px">
                              <p style="font-size:14px">And the below chart is the breakout of the Average DB CPU Usage by child database.  This chart can show you how the workload is spread across the different child databases being consolidated together.  This is a stacked chart.</p>
                          </div>  
                            <timechartRACcontainer v-if="( (row.item.NUM_INSTANCES*1>1) || (row.item.CONSOLIDATED_DATABASES*1>1) )"
                            :collection_id="`${row.item.collectionID}`"
                            collection_type="ora_v1"
                            :user="user"
                            label="node"
                            :chart_id="`${(((row.item.IS_PDB=='YES')&&(row.item.pdb_algo=='pdb2'))) ? 'MAIN_METRICS~PDB_CPU_USAGE_PER_S' : 'MAIN_METRICS~cpu_per_s'}`"
                            reflines="false"
                            stacked=false
                            :num_instances="`${row.item.NUM_INSTANCES}`"
                            :consolidated_databases_num="`${row.item.CONSOLIDATED_DATABASES}`"
                            :consolidated_databases_list="`${row.item.database}`"
                            :instancenum_list="`${row.item.INSTANCENUMS}`"
                            :filter="`${(row.item.IS_PDB=='YES') ? row.item.CDB_VCPU*2 : 0}`"
                            :adjustment="`${(!row.item.PLATFORM_NAME.includes('x86'))? (row.item.AIX_CPU_ADJUSTMENT_USED*1>0 ? (row.item.cpu_thread_ratio ?? form.cpu_thread_ratio)*1 / row.item.AIX_CPU_ADJUSTMENT_USED : (row.item.cpu_thread_ratio ?? form.cpu_thread_ratio)) : '1.0'}`"
                          ></timechartRACcontainer>
                          </div>
                          
                      </b-modal>
  
                  </template>
                  
                  <template v-slot:cell(Throughput)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                      <b-form-input v-model="row.item.Throughput" size="sm" @change="manualEditReconfig"/>
                      
                      <!--<b-form-select v-if="row.item.Exadata=='Yes'" v-model="row.item.frozen_prefs.smartscan_algo" size="sm" @change="manualEditRecalc">-->
                      <!--  <option value="ss1">No - assume no ex-SmartScan adjustments (such as query tuning, indexes, materialized views, ...)</option>-->
                      <!--  <option value="ss2a" >Yes(Light) - assume some light tuning to reduce I/O Throughput</option>-->
                      <!--  <option value="ss2" >Yes(Moderate) - assume some moderate tuning to reduce I/O Throughput</option>-->
                      <!--  <option value="ss3" >Yes(Heavy) - assume some heavy tuning to reduce I/O Throughput</option>-->
                      <!--  <option value="ss4" >Yes(Very Heavy) - assume some very heavy tuning to reduce I/O Throughput</option>-->
                      <!--</b-form-select>-->
                    
                    </template>
                    <template v-else>
                      <span v-if="(row.item.Throughput) && ( (row.item.Exadata!='Yes') || (row.item.frozen_prefs.smartscan_algo==='ss1') || (row.item.Throughput==row.item.OrigThroughput) )">{{ row.item.Throughput }} MB/s</span>
                      <span v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.Throughput!=undefined) && (row.item.Throughput!=row.item.OrigThroughput) )" v-b-popover.hover="`This is the original metric as seen on the Exadata`" title="Original">[{{ row.item.OrigThroughput }}=Exadata]<br/></span>
                      <span v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.Throughput!=undefined) && (row.item.Throughput!=row.item.OrigThroughput) )" v-b-popover.hover="`This is an adjusted number based on your Post-Exadata SmartScan Tuning assumption`" title="Adjustments">{{ row.item.Throughput }} MB/s w/tuning</span>
                      <span v-if="((row.item.AdjustedThroughput) )" v-b-popover.hover="`This is projected value with caching assumptions applied`" title="With Caching Assumptions"><br/>[{{ Math.round(row.item.AdjustedThroughput) }}=w/Cache]</span>
                    </template>
                    <br/>
                      <b-button
                        type="button"
                        size="sm"
                        variant="link"
                        v-b-modal="`mThru${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                         :disabled="row.item.collectionID==undefined"
                      >...</b-button>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.gap_throughput!=undefined)&&(row.item.targetconfig_rds.gap_throughput!='')" src="@/assets/CostSaving.png" height="20px" v-b-popover.hover="`Consider if you can reduce the Throughput from ${((row.item.AdjustedThroughput) ? row.item.AdjustedThroughput : row.item.Throughput)} MB/s to ${((row.item.AdjustedThroughput) ? row.item.AdjustedThroughput : row.item.Throughput)*1-row.item.targetconfig_rds.gap_throughput} MB/s to use a smaller shape.  [ ${row.item.targetconfig_rds.closeness_string} ]`" title="Cost-Optimization Oppty?"></img>
                      <img v-if="( (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_alert!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_alert!='') )" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${(row.item.targetconfig_rds.iomb_warnings_alert!=undefined) ? row.item.targetconfig_rds.iomb_warnings_alert : ''}`" title="Alert"></img>
                      <img v-if="( (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_burst!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_burst!='') )" src="@/assets/burst.png" height="20px" v-b-popover.hover="`${(row.item.targetconfig_rds.iomb_warnings_burst!=undefined) ? row.item.targetconfig_rds.iomb_warnings_burst : ''}`" title="Bursting"></img>
                      <img v-if="( (row.item.iomb_target_comments!=undefined)&&(row.item.iomb_target_comments!='') ) || ( (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_info!=undefined)&&(row.item.targetconfig_rds.iomb_warnings_info!='') )" src="@/assets/info.png" height="20px" v-b-popover.hover="`${(row.item.iomb_target_comments!=undefined) ? row.item.iomb_target_comments : ''} ${(row.item.targetconfig_rds.iomb_warnings_info!=undefined) ? row.item.targetconfig_rds.iomb_warnings_info : ''}`" title="Adjustments"></img>

                      <b-modal :id="`mThru${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" title="Throughput Details" ok-only size="xl">
                          <div><div style="margin: 25px">
                              <p style="font-size:14px">{{ ((row.item.IS_PDB=='YES')) ? "This shows the average IO throughput rate (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec from DBA_HIST_CON_SYSMETRIC_SUMM) along with the alternate metric: (IOMBPS from DBA_HIST_RSRC_PDB_METRIC).  Values at the PDB-level are sanity-checked against the CDB (if found in DBCSI) or against typical thresholds, and outliers are not shown.  For a RAC Cluster, the chart aggregates the metrics across all the instances. For an Exadata system, this does include I/O from the storage cells even I/O avoided via storage index use. Use this chart to help select a target baseline for Throughput for this database." : "This shows the average and peak IO throughput rate (MB/s) during each snapshot time period using the Oracle metrics: (Physical Read Total Bytes Per Sec, Physical Write Total Bytes Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances. For an Exadata system, this does include I/O from the storage cells even I/O avoided via storage index use. Use this chart to help select a target baseline for Throughput for this database." }}</p>
                            </div>
                          <timechart2container
                            v-bind="getThroughputChartConfig(row.item, false)"
                            :user="user"
                          ></timechart2container>
                          </div>
                          
                          <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; margin: 25px; font-size:14px">[For the Replica, the Target value has been sized as 
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr100') ? '100%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr50') ? '50%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr25') ? '25%' : ''}} of the primary]<br/></span>
                          
                          <div v-if="((row.item.CONSOLIDATED_DATABASES*1>1))" style="margin: 25px">
                              <p style="font-size:14px">The below chart is the breakout of the Average Throughput by child database.  This chart can show you how the workload is spread across the different child databases being consolidated together.  This is a stacked chart.</p>
                          </div>  
                            <timechartRACcontainer v-if="(  (row.item.CONSOLIDATED_DATABASES*1>1) )"
                            :collection_id="`${row.item.collectionID}`"
                            collection_type="ora_v1"
                            :user="user"
                            label="node"
                            :chart_id="`${(((row.item.IS_PDB=='YES')&&(row.item.pdb_algo=='pdb2'))) ? 'MAIN_METRICS~PDB_CPU_USAGE_PER_S' : 'IO_MBS_AVGCOMBINED'}`"
                            reflines="false"
                            stacked=false
                            :num_instances="`${row.item.NUM_INSTANCES}`"
                            :consolidated_databases_num="`${row.item.CONSOLIDATED_DATABASES}`"
                            :consolidated_databases_list="`${row.item.database}`"
                            :instancenum_list="`${row.item.INSTANCENUMS}`"
                            :filter="`${(row.item.IS_PDB=='YES') ? row.item.CDB_IOMB*2 : 0}`"
                            filter_prompt="(twice the p99 of Average CDB Throughput)"
                            :adjustment="1.0"
                          ></timechartRACcontainer>
                          
                          

                          <div><div style="margin: 25px" v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.Throughput!=undefined) && (row.item.Throughput!=row.item.OrigThroughput) )">
                              <p style="font-size:14px">The below chart shows the estimated I/O Throughput after adjusting for post-Exadata tuning activities {{row.item.ExadataAdjustmentText}}.</p>
                            </div>
                          <timechart2container v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.Throughput!=undefined) && (row.item.Throughput!=row.item.OrigThroughput) )"
                            v-bind="getThroughputChartConfig(row.item, true)"
                            :user="user"
                          ></timechart2container>

                            <div style="margin: 25px" v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.SmartScanEligible!=undefined) && (row.item.Throughput!=row.item.OrigThroughput) )">
                              <p style="font-size:14px">The adjustment logic is to start with the target value for I/O throughput as seen on the source Exadata ({{row.item.OrigThroughput}} MB/s).  The {{(row.item.frozen_prefs.smartscan_algo=='ss2') ? 'MODERATE' : ((row.item.frozen_prefs.smartscan_algo=='ss3') ? 'HEAVY' : ((row.item.frozen_prefs.smartscan_algo=='ss4') ? 'VERY HEAVY' : 'LIGHT'))}} tuning assumption assumes that I/O Throughput can be reduced by a factor of {{(row.item.frozen_prefs.smartscan_algo=='ss2') ? '3' : ((row.item.frozen_prefs.smartscan_algo=='ss3') ? '5' : ((row.item.frozen_prefs.smartscan_algo=='ss4') ? '10' : '2') )}}.  More discussion available internally <a href="https://broadcast.amazon.com/videos/441676" target="_blank">here</a>.</p>
                             

                            </div></div>

                             <br/><br/>
                            <b-card v-if="(row.item.Exadata=='Yes')">
                              
                                  <b>Exadata Observations:</b>
                               
                              <exadataobservations
                                v-if="(row.item.Exadata=='Yes')"
                                :param_collection_id="`${row.item.metricsURL}`"
                                :param_item="`${JSON.stringify(row.item)}`"
                                collection_type="ora_v1"
                                :user="user"
                              ></exadataobservations>
                            </b-card>

                      </b-modal>

                  </template>

                  <template v-slot:cell(IOPS)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                      <b-form-input v-model="row.item.IOPS" size="sm" @change="manualEditReconfig"/>
                    </template>
                    <template v-else>
                      <span v-if="(row.item.Exadata!='Yes') || (row.item.frozen_prefs.smartscan_algo==='ss1') || (row.item.IOPS==row.item.OrigIOPS)">{{ row.item.IOPS }}</span>
                      <span v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.IOPS!=undefined) && (row.item.IOPS!=row.item.OrigIOPS))" v-b-popover.hover="`This is the original metric as seen on the Exadata`" title="Original">[{{ row.item.OrigIOPS }}=Exadata]<br/></span>
                      <span v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.IOPS!=undefined) && (row.item.IOPS!=row.item.OrigIOPS) )" v-b-popover.hover="`This is an adjusted number based on your Post-Exadata SmartScan Tuning assumption`" title="Adjustments">{{ row.item.IOPS }} w/tuning</span>
                      <span v-if="((row.item.AdjustedIOPS) )" v-b-popover.hover="`This is projected value with caching assumptions applied`" title="With Caching Assumptions"><br/>[{{ Math.round(row.item.AdjustedIOPS) }}=w/Cache]</span>
                    </template>    
                      <br/>
                      <b-button
                        type="button"
                        size="sm"
                        variant="link"
                        v-b-modal="`mIOPS${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                         :disabled="row.item.collectionID==undefined"
                      >...</b-button>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.gap_iops!=undefined)&&(row.item.targetconfig_rds.gap_iops!='')" src="@/assets/CostSaving.png" height="20px" v-b-popover.hover="`Consider if you can reduce the IOPS from ${((row.item.AdjustedIOPS) ? row.item.AdjustedIOPS : row.item.IOPS)} to ${((row.item.AdjustedIOPS) ? row.item.AdjustedIOPS : row.item.IOPS)*1-row.item.targetconfig_rds.gap_iops} IOPS to use a smaller shape.  [ ${row.item.targetconfig_rds.closeness_string} ]`" title="Cost-Optimization Oppty?"></img>
                      <img v-if=" (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iops_warnings_alert!=undefined)&&(row.item.targetconfig_rds.iops_warnings_alert!='') " src="@/assets/warning.png" height="20px" v-b-popover.hover="`${(row.item.targetconfig_rds.iops_warnings_alert!=undefined) ? row.item.targetconfig_rds.iops_warnings_alert : ''}`" title="Alerts"></img>
                      <img v-if=" (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iops_warnings_burst!=undefined)&&(row.item.targetconfig_rds.iops_warnings_burst!='') " src="@/assets/burst.png" height="20px" v-b-popover.hover="`${(row.item.targetconfig_rds.iops_warnings_burst!=undefined) ? row.item.targetconfig_rds.iops_warnings_burst : ''}`" title="Bursting"></img>
                      <img v-if="( (row.item.iops_target_comments!=undefined)&&(row.item.iops_target_comments!='') ) || ( (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.iops_warnings_info!=undefined)&&(row.item.targetconfig_rds.iops_warnings_info!='') )" src="@/assets/info.png" height="20px" v-b-popover.hover="`${(row.item.iops_target_comments!=undefined) ? row.item.iops_target_comments : ''} ${(row.item.targetconfig_rds.iops_warnings_info!=undefined) ? row.item.targetconfig_rds.iops_warnings_info : ''}`" title="Adjustments"></img>
                      <b-modal :id="`mIOPS${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" title="IOPS Details" ok-only size="xl">
                          

                          <div><div style="margin: 25px" v-if="(row.item.IS_PDB=='YES')">
                              <p style="font-size:14px">This shows the average IOPS during each snapshot time period using the Oracle metric: (IOPS from DBA_HIST_RSRC_PDB_METRIC).  This is a PDB-specific metric and may not include some IOPS that happen at the CDB-level.  For a RAC Cluster, the chart aggregates the metrics across all the instances.  Use this chart to help select a target baseline for IOPS for this database.</p>
                            </div>
                          <div style="margin: 25px" v-else>
                              <p style="font-size:14px">This shows the average and peak rate (Database IO Requests/second) during each snapshot time period using the Oracle metrics: (Physical Read Total IO Requests Per Sec, Physical Write Total IO Requests Per Sec).  For a RAC Cluster, the chart aggregates the metrics across all the instances.  Use this chart to help select a target baseline for IOPS for this database.</p>
                            </div>
                          <timechart2container
                            v-bind="getIOPSChartConfig(row.item, false)"
                            :user="user"
                          ></timechart2container>
                          </div>
                          
                          <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; margin: 25px; font-size:14px">[For the Replica, the Target value has been sized as 
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr100') ? '100%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr50') ? '50%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr25') ? '25%' : ''}} of the primary]<br/></span>

                          <div v-if="((row.item.CONSOLIDATED_DATABASES*1>1))" style="margin: 25px">
                              <p style="font-size:14px">The below chart is the breakout of the Average IOPS by child database.  This chart can show you how the workload is spread across the different child databases being consolidated together.  This is a stacked chart.</p>
                          </div>  
                            <timechartRACcontainer v-if="(  (row.item.CONSOLIDATED_DATABASES*1>1) )"
                            :collection_id="`${row.item.collectionID}`"
                            collection_type="ora_v1"
                            :user="user"
                            label="node"
                            :chart_id="`${(((row.item.IS_PDB=='YES')&&(row.item.pdb_algo=='pdb2'))) ? 'PDB_IOPS' : 'IOPS_AVGCOMBINED'}`"
                            reflines="false"
                            stacked=false
                            :num_instances="`${row.item.NUM_INSTANCES}`"
                            :consolidated_databases_num="`${row.item.CONSOLIDATED_DATABASES}`"
                            :consolidated_databases_list="`${row.item.database}`"
                            :instancenum_list="`${row.item.INSTANCENUMS}`"
                            :filter="`${(row.item.IS_PDB=='YES') ? row.item.CDB_IOPS*2 : 0}`"
                            filter_prompt="(twice the p99 of Average CDB IOPS)"
                            :adjustment="1.0"
                          ></timechartRACcontainer>
                          
                          


                          <div><div style="margin: 25px" v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.IOPS!=undefined) && (row.item.IOPS!=row.item.OrigIOPS) )">
                              <p style="font-size:14px">The below chart shows the estimated IOPS after adjusting for post-Exadata tuning activities {{row.item.ExadataAdjustmentText}}.</p>
                            </div>
                          <timechart2container v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.IOPS!=undefined) && (row.item.IOPS!=row.item.OrigIOPS) )"
                            v-bind="getIOPSChartConfig(row.item, true)"
                            :user="user"
                          ></timechart2container>
                            <div style="margin: 25px" v-if="((row.item.Exadata=='Yes')&&((row.item.frozen_prefs.smartscan_algo??'ss000')!='ss1')&&(row.item.SmartScanEligible!=undefined) && (row.item.IOPS!=row.item.OrigIOPS) )">
                              <p style="font-size:14px">The adjustment logic is to start with the target value for IOPS as seen on the source Exadata ({{row.item.OrigIOPS}}).  The {{(row.item.frozen_prefs.smartscan_algo=='ss2') ? 'MODERATE' : ((row.item.frozen_prefs.smartscan_algo=='ss3') ? 'HEAVY' : ((row.item.frozen_prefs.smartscan_algo=='ss4') ? 'VERY HEAVY' : 'LIGHT'))}} tuning assumption assumes that IOPS can be reduced by a factor of {{(row.item.frozen_prefs.smartscan_algo=='ss2') ? '3' : ((row.item.frozen_prefs.smartscan_algo=='ss3') ? '5' : ((row.item.frozen_prefs.smartscan_algo=='ss4') ? '10' : '2') )}}.  More discussion available internally <a href="https://broadcast.amazon.com/videos/441676" target="_blank">here</a>.</p>

                            </div>
                            </div>
                      </b-modal>

                  </template>

                  <template v-slot:cell(Memory)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                      <b-form-input v-model="row.item.Memory" size="sm" @change="manualEditReconfig"/>
                    </template>
                    <template v-else>
                      <span v-if="((row.item.Memory) )">{{ row.item.Memory }} GB</span>
                      <span v-if="((row.item.AdjustedMemory) )" v-b-popover.hover="`This is projected value with caching assumptions applied`" title="With Caching Assumptions"><br/>[{{ Math.round(row.item.AdjustedMemory) }}=w/Cache]</span>
                    </template>
                    <br/>
                      <b-button
                        type="button"
                        size="sm"
                        variant="link"
                        v-b-modal="`mMem${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                         :disabled="row.item.collectionID==undefined"
                      >...</b-button>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.gap_memory!=undefined)&&(row.item.targetconfig_rds.gap_memory!='')" src="@/assets/CostSaving.png" height="20px" v-b-popover.hover="`Consider if you can reduce the Memory from ${((row.item.AdjustedMemory) ? row.item.AdjustedMemory : row.item.Memory)} GB to ${((row.item.AdjustedMemory) ? row.item.AdjustedMemory : row.item.Memory)*1-row.item.targetconfig_rds.gap_memory} GB to use a smaller shape.  [ ${row.item.targetconfig_rds.closeness_string} ]`" title="Cost-Optimization Oppty?"></img>
                      <img v-if=" (row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.memory_warnings_alert!=undefined)&&(row.item.targetconfig_rds.memory_warnings_alert!='') " src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_rds.memory_warnings_alert}`" title="Alerts"></img>
                      <img v-if="(row.item.memory_target_comments!=undefined)&&(row.item.memory_target_comments!='') " src="@/assets/info.png" height="20px" v-b-popover.hover="`${row.item.memory_target_comments}`" title="Adjustments"></img>
                      <b-modal :id="`mMem${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" title="Memory Details" ok-only size="xl">
                          <div style="margin: 25px">
                              <p style="font-size:14px">This shows the combined allocated size in GB of the SGA and PGA.  For Oracle RAC clusters, the sizes are the aggregate across all instances.  Use this chart to help select a target memory configuration for this database (be sure to allow for some additional memory for the operating system).  This is a stacked chart.</p>
                            </div>
                          <timechart2container
                            v-bind="getMemoryChartConfig(row.item)"
                            :user="user"
                          ></timechart2container>
                           <!-- :compare_collection_id="`${row.item.CDB_collectionId}`" -->
                            <!--compare_ctrl_text="Compare to CDB Metrics"-->
                            <!--compare_label="CDB SGA:CDB PGA"-->
                            <!--compare_chart_id="MEMORY"-->
                          
                          <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; margin: 25px; font-size:14px">[For the Replica, the Target value has been sized as 
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr100') ? '100%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr50') ? '50%' : ''}}
                            {{(row.item.frozen_prefs.readreplica_size_algo=='rr25') ? '25%' : ''}} of the primary]<br/></span>

                          <div v-if="((row.item.CONSOLIDATED_DATABASES*1>1))" style="margin: 25px">
                              <p style="font-size:14px">The below chart is the breakout of the combined SGA+PGA by child database.  This chart can show you how the workload is spread across the different child databases being consolidated together.  This is a stacked chart.</p>
                          </div>  
                            <timechartRACcontainer v-if="(  (row.item.CONSOLIDATED_DATABASES*1>1) )"
                            :collection_id="`${row.item.collectionID}`"
                            collection_type="ora_v1"
                            :user="user"
                            label="node"
                            :chart_id="`${(((row.item.IS_PDB=='YES')&&(row.item.pdb_algo=='pdb2'))) ? 'MEMORYPDBCOMBINED' : 'MEMORYCOMBINED'}`"
                            reflines="false"
                            stacked=false
                            :num_instances="`${row.item.NUM_INSTANCES}`"
                            :consolidated_databases_num="`${row.item.CONSOLIDATED_DATABASES}`"
                            :consolidated_databases_list="`${row.item.database}`"
                            :instancenum_list="`${row.item.INSTANCENUMS}`"
                            :adjustment="1.0"
                          ></timechartRACcontainer>
                          
                          

                      </b-modal>

                  </template>


                  <template v-slot:cell(DiskSpace)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                    <b-form-input v-model="row.item.DiskSpace" size="sm" @change="manualEditReconfig"/>
                    </template>
                    <template v-else>
                      {{ row.item.DiskSpace }}
                    </template>
                    <br/>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.diskspace_warnings!=undefined)&&(row.item.targetconfig_rds.diskspace_warnings!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_rds.diskspace_warnings}`" title="Alerts"></img>
                      
                      <span v-if="(row.item.COUNT_PDBS*1==0) && row.item.NUM_PDBS && (row.item.NUM_PDBS*1==0)" style="font-size:10px"><img src="@/assets/CDBalert2.png" height="10px" ></img> (missing PDB storage)</span>
                      
                       <span style="font-size:14px" 
                          v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.AddlStorageVolumes!=undefined)&&(row.item.targetconfig_rds.AddlStorageVolumes>0)"
                          v-b-popover.hover="`${row.item.targetconfig_rds.ebsvol_warnings}`" title="Additional Storage Volumes">
                         <img src="@/assets/info.png" height="20px"></img>
                         ASVs({{row.item.targetconfig_rds.AddlStorageVolumes}})
                       </span>
                  </template>  


                  <template v-slot:cell(VolumeType)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                    <b-form-select v-model="row.item.VolumeType" size="sm" @change="manualEditReconfig">
                      <option v-if="row.item.rds_type!='rac'" value="gp2">gp2</option>
                      <option v-if="row.item.rds_type!='rac'" value="gp3">gp3</option>
                      <option v-if="row.item.rds_type!='rac'" value="io1">io1</option>
                      <option value="io2">io2</option>
                    </b-form-select>
                    </template>
                    <template v-else>
                      {{ row.item.VolumeType }}                    
                    </template>
                      <br/>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.ebsvol_warnings!=undefined)&&(row.item.targetconfig_rds.ebsvol_warnings!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_rds.ebsvol_warnings}`" title="Adjustments"></img>

                  </template>  


                  <template v-slot:cell(UseMAZ)="row">
                    <template v-if="row.item.manual!=undefined && row.item.manual=='YES' ">
                    <b-form-select v-model="row.item.UseMAZ" size="sm" @change="manualEditReconfig">
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </b-form-select>
                    </template>
                    <template v-else>
                      {{ row.item.UseMAZ }}
                    </template>  
                  </template>


                  <template  v-slot:cell(UseSE2)="row">
             
                      <img v-if="!( (row.item.AWR_MINER_VER != undefined && ! (row.item.AWR_MINER_VER.includes('aws') || row.item.AWR_MINER_VER.includes('statspack')) )  ) && (row.item.SE2_Comments!=undefined)&&(row.item.SE2_Comments!='')" src="@/assets/info.png" height="20px" v-b-popover.hover="`${row.item.SE2_Comments}`" title="EE to SE2 Feature Usages"></img>
                      <img v-if="(row.item.AWR_MINER_VER != undefined && !(row.item.AWR_MINER_VER.includes('aws') || row.item.AWR_MINER_VER.includes('statspack')))  " src="@/assets/warning.png" height="20px" v-b-popover.hover="`EE to SE2 Feature analysis not available if you used the generic non-DBCSI AWR Miner script to collect data`" title="EE to SE2 Feature Usages"></img>
                      
                  </template>  


                  

                  <template #cell(show_adhoc)="row">
                   
                    <a v-b-popover.hover="`Click here to view/chart additional metrics`" :title="`${row.item.database}`" :href="`/charts/${row.item.metricsURL}`" target="_blank">AdhocCharts</a>
                    <br/><br/>
                    <a v-b-popover.hover="`Click here to browse compute shapes`" :title="`Browse Shapes`" :href="`/shapes/${regionCode}:RDS:${row.item.VCPU}:${row.item.Memory}:${row.item.Throughput}:${row.item.IOPS}`" target="_blank">ShapeBrowser</a>
                  </template>

                  <template #cell(row)="row">
                    {{row.item.row}}
                    <span v-if="row.item.scenarioName!=undefined" v-b-popover.hover="{title:`Scenario: ${escapeHtml(row.item.scenarioName)}`, content:`${row.item.assumptionsString}`, html: true}"><br/>({{row.item.scenarioName}})</span>
                    <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; font-weight: bold; margin-left: 5px;"><br/><br/>[Replica in {{row.item.ReadReplicaRegion}}]</span>
                    
                    <span v-if="row.item.manual!=undefined && row.item.manual=='YES'"><br/>[Manual Edit]</span>
                  </template>  
                  
                  <template #cell(database)="row">
                   
                    <a v-b-popover.hover="{title:`${row.item.user_DB_NAME}`, content:`${row.item.description}  <br/><br/>(host: ${row.item.hostname})`, html: true}"  :href="`/metrics/${row.item.metricsURL}/ora_v1${ (row.item.VCPU) ? '/' + regionCode + ':RDS:' + row.item.VCPU + ':' + row.item.Memory + ':' + row.item.Throughput + ':' + row.item.IOPS + ':' + row.item.DiskSpace + ':' + row.item.VolumeType + ':' + row.item.UseMAZ : '' }`" target="_blank">{{ row.item.database }}</a>
                    
                    
                    <br/>
                    <img v-if="(row.item.PLATFORM_NAME=='AIX-Based_Systems_(64-bit)')" src="@/assets/AIX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${row.item.PLATFORM_NAME}]`" title="not x86"></img>
                    <img v-if="(row.item.PLATFORM_NAME=='Solaris[tm]_OE_(64-bit)')" src="@/assets/SPARC.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${row.item.PLATFORM_NAME}]`" title="not x86"></img>
                    <img v-if="(row.item.PLATFORM_NAME=='HP-UX_IA_(64-bit)')" src="@/assets/HPUX.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${row.item.PLATFORM_NAME}]`" title="not x86"></img>
                    <img v-if="(row.item.PLATFORM_NAME=='IBM_zSeries_Based_Linux')" src="@/assets/zSeries.png" height="16px" v-b-popover.hover="`Be sure to adjust the CPU Thread Mapping Ratio to adjust to x86 threads [${row.item.PLATFORM_NAME}]`" title="not x86"></img>
                    <img v-if="(row.item.PLATFORM_NAME=='Microsoft_Windows_x86_64-bit')" src="@/assets/WIN.png" height="16px" ></img>
                    <img v-if="(row.item.PLATFORM_NAME=='Solaris_Operating_System_(x86-64)')" src="@/assets/SolarisX86.png" height="16px" ></img>

                    <img v-if="(row.item.COUNT_PDBS*1>=1) && (row.item.COUNT_PDBS*1<=3)" v-b-popover.hover="`This is a CDB database (${row.item.COUNT_PDBS} PDBs).`" title="CDB" src="@/assets/CDB.png" height="10px" ></img>
                    <span v-if="(row.item.COUNT_PDBS*1>=4)" style="font-size:10px" v-b-popover.hover="`This is a CDB database (${row.item.COUNT_PDBS} PDBs).  Note: Recent Oracle licensing documents suggest an Oracle-dictated licensing limit of 3 PDBs per CDB in the cloud (the technical RDS-Oracle maximum is 30 PDBs per CDB).  Your contract may pre-date this policy or have other terms that apply, so consult your legal/procurement office and/or a third-party Oracle licensing advisor to determine your maximum PDBs per CDB quantity.`" title="CDB"><img v-if="(row.item.COUNT_PDBS*1>=4)"  src="@/assets/CDBalert2.png" height="10px" ></img> ({{row.item.COUNT_PDBS}} pdbs)</span>
                    
                    <img v-if="(row.item.IS_PDB=='YES') && (row.item.CDB_collectionId==undefined) && (row.item.cdb_target_comments==undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.`" title="PDB" src="@/assets/PDB.png" height="20px" ></img>
                    <img v-if="(row.item.IS_PDB=='YES') && (row.item.CDB_collectionId==undefined) && (row.item.cdb_target_comments!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(row.item.cdb_target_comments==undefined) ? '' : row.item.cdb_target_comments}`" title="PDB" src="@/assets/PDB_NOCDB.png" height="20px" ></img>
                    <a v-if="(row.item.IS_PDB=='YES') && (row.item.CDB_collectionId!=undefined)" v-b-popover.hover="`This is a PDB database.  Collecting PDB-level IO metrics is problematic and we have seen data issues in Oracle's AWR tables.  ${(row.item.cdb_target_comments==undefined) ? '' : row.item.cdb_target_comments}`" title="PDB - Click on the PDB icon to view the CDB" :href="`/batch/C${row.item.CDB_collectionId}`" target="_blank"><img src="@/assets/PDB_CDB.png" height="20px" ></img></a>  
                    
                    

                    <img v-if="(row.item.AWR_MINER_VER != undefined && row.item.AWR_MINER_VER.includes('statspack')) " src="@/assets/statspack.png" height="20px" v-b-popover.hover="`Data was collected using STATSPACK.  Some information and features, such as individual snapshot Peak values, will not be available.`" title="STATSPACK"></img> 
                    <img v-if="(row.item.BANNER != undefined && row.item.BANNER.includes('Standard Edition')) " src="@/assets/SE2a.png" height="14px" v-b-popover.hover="`This appears to be a Standard Edition database: ${row.item.BANNER}`" title="Standard Edition"></img>
                    <img v-if="(row.item.IS_RDS != undefined && row.item.IS_RDS=='YES') " src="@/assets/rds.png" height="20px" v-b-popover.hover="`This appears to be a RDS database. ${(row.item.RDS_SHAPE!=undefined) ? row.item.RDS_SHAPE : ''}`" title="RDS"></img>
                    <img v-if="(row.item.IS_EBIZ != undefined && row.item.IS_EBIZ!='') " src="@/assets/ebizsuite.png" height="20px" v-b-popover.hover="`This appears to be an E-Business Suite database, version ${row.item.IS_EBIZ}.`" title="E-Business Suite"></img>
                    <img v-if="(row.item.DATABASE_ROLE != undefined && row.item.DATABASE_ROLE!='PRIMARY') " src="@/assets/standby.png" height="20px" v-b-popover.hover="`This appears to be a ${row.item.DATABASE_ROLE.toLowerCase()} database.  Note: DBCSI collects previously captured data from the AWR or STATSPACK tables.  Essentially that means that even though you collected data from a Standby database, the metrics you are viewing were captured on the Primary database and may not be of much value trying to separately size standby replica instances.`" title="Standby Database"></img>

                    <img v-if="!(row.item.AWR_MINER_VER != undefined && !(row.item.AWR_MINER_VER.includes('aws') || row.item.AWR_MINER_VER.includes('statspack'))) && (row.item.COUNT_LINES_PLSQL*1<20000)" src="@/assets/Postgres.png" height="20px" v-b-popover.hover="`Not much PLSQL (${row.item.COUNT_LINES_PLSQL} lines). Consider migrating to PostgreSQL.`" title="PostgreSQL"></img>
                    <img v-if="(row.item.considerSE2=='Yes') || (row.item.considerSE2==undefined && !(row.item.AWR_MINER_VER != undefined && !(row.item.AWR_MINER_VER.includes('aws') || row.item.AWR_MINER_VER.includes('statspack')) ) && row.item.SE2=='Yes')" src="@/assets/SE2.png" height="20px" v-b-popover.hover="`Consider evaluating this database for Oracle Standard Edition2.  At first glance, DBCSI did not find too many different types of EE features such as Partitioning, Bitmap Indexes, Parallel Query, and VPD/ FGA/ Data Redaction. ${row.item.SE2_Comments}`" title="Standard Edition2"></img>
                    <img v-if="(row.item.rds_type!='custom')&&(row.item.VERSION!==undefined && row.item.VERSION.substr(0,2)!='21')&&(row.item.VERSION!==undefined && row.item.VERSION.substr(0,2)!='19')" src="@/assets/Upgrade.png" height="20px" v-b-popover.hover="`This is an old version [${row.item.VERSION}] of Oracle.  Expect to upgrade it for RDS-Oracle.`" title="old Oracle version"></img>
                    <br/>
                    <img v-if="(row.item.CONSOLIDATED_DATABASES*1>1)" src="@/assets/Consolidated.png" height="20px" v-b-popover.hover="`This is a tentative new Consolidated Database containing ${row.item.CONSOLIDATED_DATABASES} other individual databases.`" title="Consolidated"></img>
                    <img v-if="(row.item.NUM_INSTANCES*1>1)" src="@/assets/RAC.png" height="20px" v-b-popover.hover="`This database currently uses Real Application Clusters with ${row.item.NUM_INSTANCES} instances.`" title="RAC"></img>
                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible==undefined)" src="@/assets/Exadata.png" height="20px" v-b-popover.hover="`This database runs on Exadata. Click Create New Scenario button to load more details.`" title="Exadata"></img>
                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible==0)" src="@/assets/Exadata0.png" height="20px" v-b-popover.hover="`This database used to run on Exadata, but may not anymore. ${'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(row.item.ExadataAdjustmentText==undefined) ? '' : row.item.ExadataAdjustmentText}`" title="Exadata - ZERO SmartScan Offload"></img>

                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>0)&&  (row.item.SmartScanEligible<500)" src="@/assets/Exadata1.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(row.item.ExadataAdjustmentText==undefined) ? '' : row.item.ExadataAdjustmentText}`" title="Exadata - Minimal SmartScan Offload"></img>
                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>500)&&  (row.item.SmartScanEligible<2000)" src="@/assets/Exadata2.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(row.item.ExadataAdjustmentText==undefined) ? '' : row.item.ExadataAdjustmentText}`" title="Exadata - Moderate SmartScan Offload"></img>
                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>2000)&&  (row.item.SmartScanEligible<8000)" src="@/assets/Exadata3.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(row.item.ExadataAdjustmentText==undefined) ? '' : row.item.ExadataAdjustmentText}`" title="Exadata - Medium SmartScan Offload"></img>
                    <img v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>8000)" src="@/assets/Exadata4.png" height="20px" v-b-popover.hover="`This database runs on Exadata. ${'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s'}  ${(row.item.ExadataAdjustmentText==undefined) ? '' : row.item.ExadataAdjustmentText}`" title="Exadata - Heavy SmartScan Offload"></img>
                    <img v-if="(row.item.IOPS*1>0) && (row.item.Throughput/row.item.IOPS*1024 <= 30)" src="@/assets/OLTP1.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(row.item.Throughput/row.item.IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                    <img v-if="(row.item.IOPS*1>0) && (row.item.Throughput/row.item.IOPS*1024 > 30) && (row.item.Throughput/row.item.IOPS*1024 <= 120)" src="@/assets/OLTP2.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(row.item.Throughput/row.item.IOPS*1024)} KB, which makes this database appear to be supporting OLTP-style workloads with some mixed workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                    <img v-if="(row.item.IOPS*1>0) && (row.item.Throughput/row.item.IOPS*1024 > 120) && (row.item.Throughput/row.item.IOPS*1024 <= 400)" src="@/assets/OLTP3.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(row.item.Throughput/row.item.IOPS*1024)} KB, which makes this database appear to be supporting mixed and/or DW workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                    <img v-if="(row.item.IOPS*1>0) && (row.item.Throughput/row.item.IOPS*1024 > 400)" src="@/assets/OLTP4.png" height="20px" v-b-popover.hover="`The estimated typical IO request size is ${Math.round(row.item.Throughput/row.item.IOPS*1024)} KB, which makes this database appear to be supporting DW-style workloads.`" title="OLTP-DW Spectrum Estimation"></img>
                    <img v-if="(row.item.AWR_MINER_VER != undefined && !(row.item.AWR_MINER_VER.includes('aws') || row.item.AWR_MINER_VER.includes('statspack') ) )" src="@/assets/warning.png" height="20px" v-b-tooltip.hover title="Warning: This looks like the generic non-DBCSI AWR Miner script was used to collect metrics.  DBCSI works best if you use the DBCSI-specific data collection script downloadable from the DBCSI Add page.  Some DBCSI functionality will be missing."></img>
                      <b-button
                        type="button"
                        size="sm"
                        variant="link"
                        v-b-modal="`mGenInfo${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                         :disabled="row.item.metricsURL==undefined"
                      >...</b-button>
                      <span v-if="(row.item.Exadata=='Yes')" style="font-size:8px">
                        <a href="https://docs.aws.amazon.com/prescriptive-guidance/latest/oracle-exadata-blueprint/introduction.html" target="_blank" v-b-popover.hover="{title:`Exadata Migration`, content:`This is a link to AWS Prescriptive Guidance for migrating Exadata to AWS.`, html: true}"  >Exadata_Blueprint</a><br/>
                      </span>
                      <span v-if="currentEmployee && (row.item.Exadata=='Yes')" style="font-size:8px">
                        <a href="https://aws.highspot.com/items/64efb7cffe3f3d432778dd14" target="_blank" v-b-popover.hover="{title:`Exadata Runbook`, content:`This is a link to an AWS internal runbook on how to handle Exadata opportunities.  This link does not appear for partners or customer users.`, html: true}"  >Exadata_Runbook</a>
                      </span>
                      <b-modal :id="`mGenInfo${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" scrollable title="Database Details" ok-only size="xl">
                          
                          <generalinfomodal 
                            :param_collection_id="`${row.item.metricsURL}`"
                            :param_item="`${JSON.stringify(row.item)}`"
                            collection_type="ora_v1"
                            :user="user"
                          ></generalinfomodal>
                      </b-modal>    
                   </template>








                  <template  #cell(targetconfig_rds.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A'" title="RDS Estimate" v-b-popover.hover="`${row.item.targetconfig_rds.summaryText}`" >{{ row.item.targetconfig_rds.monthly_estimate }}
                      <br/><br/>
                      {{ (row.item.targetconfig_rds.RIused=="RI" ? "1yrNURI" : (row.item.targetconfig_rds.RIused=="SP" ? "SavingsPlan" : "OnDemand") ) }}
                      <br/><br/>
                    </span>
                    
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && !row.item.targetconfig_elasticache && (row.item.cachingSavingsText)" v-b-popover.hover="{title:`Caching Conversation Starter: Save $${row.item.cachingSavings} per month?`, content:`${row.item.cachingSavingsText}<br/><br/><a href='https://docs.aws.amazon.com/pdfs/whitepapers/latest/database-caching-strategies-using-redis/database-caching-strategies-using-redis.pdf' target='_blank'>[AWS White Paper] Database Caching Strategies</a> <br/><a href='https://aws.amazon.com/blogs/database/optimize-cost-and-boost-performance-of-rds-for-mysql-using-amazon-elasticache-for-redis/' target='_blank'>[AWS Blog] ElastiCache with RDS</a>`, html: true}" >
                      <img  src="@/assets/Elasticache.png" height="20px"></img>?
                    </span>
                    
                    <span v-if="showAsk && row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A'" v-b-popover.hover="{title:`Ask an AWS Database Advisor`, content:`Connect with an AWS Database Advisor and ask a question about your database or sizing`, html: true}" >
                      
                      <b-button v-if="true"
                            type="button"
                            variant="link"
                            size="sm"
                            v-b-modal="`mAsk${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                          >Question?</b-button>
                    </span>
                    
                    
                    <span v-if="showAsk && row.item.targetconfig_rds!=undefined   && row.item.rds_shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an ${row.item.targetconfig_rds.rds_type_desc} configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_rds.closeness_string} ]`, html: true}" > 
                          <b-button v-if="true"
                            type="button"
                            block
                            variant="link"
                            size="sm"
                            v-b-modal="`mAsk${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                          >Unable to size RDS. Click to ask an AWS Database Advisor</b-button>
                    </span>                     
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-select v-model="row.item.UseRI" size="sm" @change="manualEditReconfig">
                        <option value="SP">SP - 1yr No-Upfront Database Savings Plans (if available)</option>
                        <option value="RI">RI - 1yr NoUpfront Reserved Instance (if available)</option>
                        <option value="OD">OD - On-Demand</option>
                      </b-form-select>
                    </span>
                    
                    
                    <b-modal :id="`mAsk${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`" title="Ask an AWS Database Advisor" ok-only ok-title="Done" size="xl" v-if="showAsk && row.item.targetconfig_rds!=undefined">
                          <div style="margin: 15px">
                            

                            <b-form>
                              
                              <!--<b-form-group label="Type of Question:" >-->
                              <!--  <b-form-radio v-model="ask_querytype" value="q1">I have a question about how DBCSI collected performance data from my source database</b-form-radio>-->
                              <!--  <b-form-radio v-model="ask_querytype" value="q2">I have a question about how DBCSI mapped performance data to minimum target values for VCPU, Memory, IO</b-form-radio>-->
                              <!--  <b-form-radio v-model="ask_querytype" value="q3">I have a question about how DBCSI selected an AWS configuration based on the calculated minimum target values</b-form-radio>-->
                              <!--  <b-form-radio v-model="ask_querytype" value="q4">I have a different type of question</b-form-radio>-->
                              <!--</b-form-group>-->
                              
                              <b-form-group
                                id="exampleInputGroup0"
                                label="Email:"
                                label-for="email"
                                description="Your email.  We will use this email address to contact you."
                              >
                                <b-form-input
                                  id="email"
                                  type="text"
                                  v-model="email"
                                  required
                                  disabled
                                  placeholder="Enter your email address"
                                ></b-form-input>
                              </b-form-group>
                              
                              <b-form-group
                                id="exampleInputGroup1"
                                label="Company:"
                                label-for="company"
                                description="The company name of the customer.  If you are working for a partner, you can use the partner name if you prefer."
                                v-if="(lastQuestion!=row.item.collectionID)"
                              >
                                <b-form-input
                                  id="company"
                                  type="text"
                                  v-model="company"
                                  required
                                  placeholder="Enter the company name"
                                ></b-form-input>
                              </b-form-group>
                              
    
                              <!--<b-form-select v-model="ask_querytype" class="mb-3">-->
                              <!--  <option value="empty">Please select your type of question to continue...</option>-->
                              <!--  <option value="q1">I have a question about how DBCSI collected performance data from my source database</option>-->
                              <!--  <option value="q2">I have a question about how DBCSI mapped performance data to minimum target values for VCPU, Memory, IO</option>-->
                              <!--  <option value="q3">I have a question about how DBCSI selected an AWS configuration based on the calculated minimum target values</option>-->
                              <!--  <option value="q4">I have a question specific to my workload/database</option>-->
                              <!--  <option value="q5">I have a different type of question</option>-->
                              <!--</b-form-select>-->


                              <b-form-group id="exampleInputGroup4" label="Your Question:" label-for="question" v-if="(lastQuestion!=row.item.collectionID)" description="Your question (minimum 40 characters).  Please be as detailed as possible in your question.  You can use this space to provide any additional information as well.">
                                <b-form-textarea
                                  id="question"
                                  v-model="question"
                                  required
                                  placeholder="Enter your question (minimum 40 characters).  Also use this space to provide any additional information."
                                  
                                  :rows="6"
                                  :max-rows="10"
                                ></b-form-textarea>
                              </b-form-group>

                            
            
                              <b-button v-if="(lastQuestion!=row.item.collectionID) && ( (question.length<40) || (company.length==0) )" disabled variant="outline-danger">Enter your Company and Question (minimum 40 characters) to continue</b-button>
                              <b-button @click="submitQuestion(row.item)" v-if="(lastQuestion!=row.item.collectionID) &&  (question.length>=40) && (company.length>0) " variant="primary">Submit your question</b-button>
                              <b-button v-if="(lastQuestion==row.item.collectionID)"  disabled variant="outline-success">Thank you for your question</b-button>
                              
                              <p style="font-size:14px"><b>Disclaimer:</b>  This is not a way to ask support-type questions.  This should be used for sizing and architectural types of questions.  This Ask a Database Advisor service is a new informal experimental offering and the individuals involved will make a best-effort to respond, so please be patient and understanding.</p>
                            </b-form>
                            <br/><br/>
                            <p style="font-size:14px">Context for this question (details will be shared with the AWS Database Advisor to help them answer your question):</p>

                            <b-card>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Database Name:</b>
                                </b-col>
                                <b-col>{{ row.item.database }}</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Description:</b>
                                </b-col>
                                <b-col>{{ row.item.description }}</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Version:</b>
                                </b-col>
                                <b-col>{{ row.item.VERSION }}</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Platform:</b>
                                </b-col>
                                <b-col>{{ row.item.PLATFORM_NAME }}</b-col>
                              </b-row>
                              <b-row v-if="(row.item.IS_PDB=='YES')" class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>PDB?:</b>
                                </b-col>
                                <b-col>This is a Pluggable Database.  {{ (row.item.cdb_target_comments==undefined) ? '' : row.item.cdb_target_comments }}</b-col>
                              </b-row>
                              <b-row v-if="(row.item.Exadata=='Yes')" class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Exadata?:</b>
                                </b-col>
                                <b-col v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible==0)">
                                  <img  src="@/assets/Exadata0.png" height="20px"></img>  ZERO SmartScan Offload. {{ 'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s' }}</b-col>
                                <b-col v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>0)&&(row.item.SmartScanEligible<=500)">
                                  <img  src="@/assets/Exadata1.png" height="20px"></img>  Minimal SmartScan Offload. {{ 'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s' }}</b-col>
                                <b-col v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>500)&&  (row.item.SmartScanEligible<2000)">
                                  <img  src="@/assets/Exadata2.png" height="20px"></img>  Moderate SmartScan Offload. {{ 'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s' }}</b-col>
                                <b-col v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>2000)&&  (row.item.SmartScanEligible<8000)">
                                  <img  src="@/assets/Exadata3.png" height="20px"></img>  Medium SmartScan Offload. {{ 'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s' }}</b-col>
                                <b-col v-if="(row.item.Exadata=='Yes')&&(row.item.SmartScanEligible!=undefined)&&(row.item.SmartScanEligible>8000)">
                                  <img  src="@/assets/Exadata4.png" height="20px"></img>  Heavy SmartScan Offload. {{ 'Smart Scan Eligible= '+row.item.SmartScanEligible.toFixed(0)+'MB/s Storage Index Savings= '+row.item.StorageIndexSavings.toFixed(0)+'MB/s' }}</b-col>
                              </b-row>
                              
                              
      

                              
                              <b-row class="mb-2" >
                                <b-col sm="3" class="text-sm-right">
                                  <b>DB CSI url:</b>
                                </b-col>
                                <b-col><a :href="`/batch/${row.item.batchURL}`" target="_blank">https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/batch/{{ row.item.batchURL }}</a></b-col>
                              </b-row>
                              <b-row class="mb-2" v-if="(row.item.considerSE2=='Yes') || (row.item.considerSE2==undefined && row.item.SE2=='Yes')">
                                <b-col sm="3" class="text-sm-right">
                                  <b>SE2 Potential:</b>
                                </b-col>
                                <b-col>Suggestion: Consider evaluating this database for <a :href="`https://aws.amazon.com/blogs/database/rethink-oracle-standard-edition-two-on-amazon-rds-for-oracle/`" target="_blank">Oracle Standard Edition2</a> as it may be a good fit.<br/>{{ row.item.SE2_Comments }}<br/><a :href="`https://docs.aws.amazon.com/prescriptive-guidance/latest/evaluate-downgrading-oracle-edition/welcome.html`" target="_blank">[Additional Reading]</a></b-col>
                              </b-row>
                              <b-row class="mb-2" v-if="row.item.extraInfo != ''">
                                <b-col sm="3" class="text-sm-right">
                                  <b>DB Freedom Potential:</b>
                                </b-col>
                                <b-col>{{ row.item.extraInfo }}</b-col>
                              </b-row>
                              
                              
                            </b-card>
                             
                             
                             
                             
                            <b-card>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Target VCPU:</b>
                                </b-col>
                                <b-col>{{ row.item.VCPU }}
                                </b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Target Memory:</b>
                                </b-col>
                                <b-col>{{ row.item.Memory }} GB</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Target Throughput:</b>
                                </b-col>
                                <b-col>{{ row.item.Throughput }} MB/s</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Target IOPS:</b>
                                </b-col>
                                <b-col>{{ row.item.IOPS }}</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Target Disk Space:</b>
                                </b-col>
                                <b-col>{{ row.item.DiskSpace }} GB</b-col>
                              </b-row>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>Algorithms Used:</b>
                                </b-col>
                                <b-col><span v-html="row.item.assumptionsString"></span></b-col>
                              </b-row>

                              
                            </b-card>

                             
                            <b-card>
                              <b-row class="mb-2">
                                <b-col sm="3" class="text-sm-right">
                                  <b>RDS-Oracle Summary:</b>
                                </b-col>
                                <b-col>{{ row.item.targetconfig_rds.summaryText }}</b-col>
                              </b-row>
                              <b-row class="mb-2" v-if="row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!=''">
                                <b-col sm="3" class="text-sm-right">
                                  <b>RDS-Oracle Cluster:</b>
                                </b-col>
                                <b-col>{{row.item.targetconfig_rds.rac_nodes}} Node Cluster of {{row.item.rds_shape}}</b-col>
                              </b-row>
                              
                              
                            </b-card>
                          
                            
                            
                        
                          </div>      
                    </b-modal>      
                    
                    
                    
                    
                    
                    
                    
                 </template>



                  <template  #cell(targetconfig_adbs.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_adbs!=undefined  && row.item.targetconfig_adbs.shape!='null'" title="Autonomous Database Serverless Estimate" v-b-popover.hover="`${row.item.targetconfig_adbs.summaryText}.  [Breakout: Storage cost=$${row.item.targetconfig_adbs.storage_cost}.  ECPU cost=$${row.item.targetconfig_adbs.ecpu_cost}]`" >{{ row.item.targetconfig_adbs.monthly_estimate }}
                      <br/><br/>
                      
                     
                  </span>
                 
                  </template>


                  <template  #cell(targetconfig_adbs.shape)="row">
                     <span v-if="row.item.targetconfig_adbs!=undefined" >
                        <span v-if="row.item.targetconfig_adbs.shape!='N/A'"  v-b-popover.hover="{title:`${row.item.targetconfig_adbs.shape}`, content:`<b>Specifications:</b><br/><b>ECPUs requested:</b> ${row.item.targetconfig_adbs.ecpu_requested}  <br/>
                          <b>ECPUs billed (accounts for peers):</b> ${row.item.targetconfig_adbs.ecpu_billed}  <br/>
                          ${row.item.targetconfig_adbs.ecpu_warnings} <br/><br/>
                          <b>Storage requested:</b> ${row.item.targetconfig_adbs.storage_requested}  <br/>
                          <b>Storage billed (accounts for peers):</b> ${row.item.targetconfig_adbs.storage_billed}  <br/>
                          ${row.item.targetconfig_adbs.storage_warnings} `, html: true}">{{ row.item.targetconfig_adbs.shape }}</span>

                        
                        <span v-if="row.item.targetconfig_adbs!=undefined   && row.item.targetconfig_adbs.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an Autonomous Database Serverless configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_adbs.ecpu_warnings}  ${row.item.targetconfig_adbs.storage_warnings} ]`, html: true}" > (Contact your AWS Database Specialist)</span> 
                       </span>
                  </template>






                  <template  #cell(targetconfig_aurora.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_aurora!=undefined  && row.item.targetconfig_aurora.shape!='N/A'" title="Aurora Estimate" v-b-popover.hover="`${row.item.targetconfig_aurora.summaryText}`" >{{ row.item.targetconfig_aurora.monthly_estimate }}
                      <br/><br/>
                      {{ (row.item.targetconfig_aurora.RIused=="RI" ? "1yrNURI" : (row.item.targetconfig_aurora.RIused=="SP" ? "SavingsPlan" : "OnDemand") ) }}
                      
                      <br/><br/><img src="@/assets/Aurora.png" height="30px" ></img>
                     
                  </span>
                  <span v-if="showAsk && row.item.targetconfig_aurora!=undefined   && row.item.targetconfig_aurora.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an Aurora configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_aurora.closeness_string} ]`, html: true}" > 
                          <b-button v-if="true"
                            type="button"
                            block
                            variant="link"
                            size="sm"
                            v-b-modal="`mAsk${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                          >Unable to size Aurora. Click to ask an AWS Database Advisor</b-button>
                    </span>
                  </template>


                  <template  #cell(aurora_shape)="row">
                     <span v-if="row.item.targetconfig_aurora!=undefined" >
                        <span v-if="row.item.aurora_shape!='N/A'"  v-b-popover.hover="{title:`${row.item.aurora_shape}`, content:`Specifications: ${row.item.targetconfig_aurora.match_string}.  <br/><br/>${row.item.targetconfig_aurora.closeness_string =='' ? '' : '[ '+row.item.targetconfig_aurora.closeness_string+' ]'} `, html: true}">{{ row.item.aurora_shape }}</span>

                        <span v-if="row.item.targetconfig_aurora!=undefined  && row.item.aurora_shape!='N/A' && row.item.UseMAZ=='Yes' "> (2Instances)</span> 
                        
                        <span v-if="row.item.targetconfig_aurora!=undefined   && row.item.aurora_shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an Aurora configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_aurora.closeness_string} ]`, html: true}" > (Contact your AWS Database Specialist)</span> 
                       </span>
                  </template>


                  <template  #cell(targetconfig_elasticache.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_elasticache!=undefined " title="Elasticache Estimate" v-b-popover.hover="`${row.item.targetconfig_elasticache.summaryText}`" >{{ row.item.targetconfig_elasticache.monthly_estimate }}
                      <br/><br/>
                      {{ (row.item.targetconfig_elasticache.RIused=="RI" ? "1yrNURI" : "OnDemand") }}
                      <br/><br/><img src="@/assets/Elasticache.png" height="30px" ></img>
                      </span>
                      
                      <span v-if="row.item.targetconfig_elasticache && (row.item.cachingSavingsText)" v-b-popover.hover="{title:`Caching Conversation Starter: Save $${row.item.cachingSavings} per month?`, content:`${row.item.cachingSavingsText}<br/><br/><a href='https://docs.aws.amazon.com/pdfs/whitepapers/latest/database-caching-strategies-using-redis/database-caching-strategies-using-redis.pdf' target='_blank'>[AWS White Paper] Database Caching Strategies</a> <br/><a href='https://aws.amazon.com/blogs/database/optimize-cost-and-boost-performance-of-rds-for-mysql-using-amazon-elasticache-for-redis/' target='_blank'>[AWS Blog] ElastiCache with RDS</a>`, html: true}" >
                      <br/><br/>save ${{ row.item.cachingSavings }}?
                    </span>

                  
                  </template>


                  <template  #cell(targetconfig_elasticache.shape)="row">
                     
                     <span v-if="row.item.targetconfig_elasticache!=undefined" >
                        
                        <span v-if="row.item.targetconfig_elasticache.shape!='N/A'"  v-b-popover.hover="{title:`cache.${row.item.targetconfig_elasticache.shape}`, content:`Specifications: ${row.item.targetconfig_elasticache.match_string}.  <br/><br/>${row.item.targetconfig_elasticache.closeness_string =='' ? '' : '[ '+row.item.targetconfig_elasticache.closeness_string+' ]'} `, html: true}">cache.{{ row.item.targetconfig_elasticache.shape }}</span>

                        <span v-if="row.item.targetconfig_elasticache!=undefined  && row.item.UseMAZ=='Yes' "> (2Instances)</span> 
                        
                        <br/><br/><span>Sized for {{ Math.round(row.item.targetconfig_elasticache.requested_memory*1*10)/10 }}GB</span>
                        
                        <span v-if="row.item.targetconfig_elasticache!=undefined   && row.item.targetconfig_elasticache.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an Elasticache configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_elasticache.closeness_string} ]`, html: true}" ><br/> (Contact your AWS Database Specialist)</span> 
                         
                    </span>
                  </template>


                  <template  #cell(targetconfig_ec2fsxn.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_ec2fsxn!=undefined &&  row.item.targetconfig_ec2fsxn.shape!='N/A'" :title="(row.item.targetconfig_ec2fsxn.shapeIsMetal ? 'EC2 Bare Metal' : 'EC2') + ' and FSx-OnTap Estimate'" v-b-popover.hover="`${row.item.targetconfig_ec2fsxn.summaryText}`" >{{ row.item.targetconfig_ec2fsxn.monthly_estimate }}
                      <br/><br/>
                      {{ (row.item.targetconfig_ec2fsxn.RIused=="RI" ? "1yrNURI" : "OnDemand") }}
                      <br/>
                      </span>

                      
                      <span v-if="row.item.targetconfig_ec2fsxn!=undefined &&  row.item.targetconfig_ec2fsxn.shape!='N/A'" v-b-popover.hover="{title:(row.item.targetconfig_ec2fsxn.shapeIsMetal ? `EC2 Bare Metal Configuration` : `EC2 Configuration`), content:(row.item.targetconfig_ec2fsxn.shapeIsMetal ? `This is a customer-managed EC2 Bare Metal configuration which can be useful for those customers who wish to use the Oracle Linux VM Hypervisor.  See this <a href='https://docs.aws.amazon.com/whitepapers/latest/running-oracle-hypervisors-ec2-bare-metal/running-oracle-hypervisors-ec2-bare-metal.html' target='_blank'>white paper</a> for a discussion.` : `This is a customer-managed EC2 configuration running Oracle Database on EC2 with FSx for NetApp ONTAP storage.  Regular EC2 requires Bring-Your-Own-License Oracle and is vCPU-licensed (2 vCPU = 1 Oracle processor license).`), html: true}">
                        <br/><img v-if="row.item.targetconfig_ec2fsxn.shape!='N/A'" src="@/assets/EC2FSxN.png" height="30px" ></img><br/>
                      </span>
                      
                      <span v-if="showAsk && row.item.targetconfig_ec2fsxn!=undefined   && row.item.targetconfig_ec2fsxn.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find a EC2 + FSxN configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_ec2fsxn.closeness_string} ]`, html: true}" >
                          <b-button v-if="true"
                            type="button"
                            block
                            variant="link"
                            size="sm"
                            v-b-modal="`mAsk${row.item.collectionID}${row.item.scenario}${row.item.manual}${row.item.ReadReplica}`"
                          >Unable to size EC2 + FSxN. Click to ask an AWS Database Advisor</b-button>
                    </span>
                    
                      <img v-if="row.item.targetconfig_ec2fsxn!=undefined && row.item.targetconfig_ec2fsxn.fsxn_warnings &&  row.item.targetconfig_ec2fsxn.fsxn_warning!=''" src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`FSx-OnTap Comments`, content:`${row.item.targetconfig_ec2fsxn.fsxn_warnings}`, html: false}"></img>
                      <img v-if="row.item.targetconfig_ec2fsxn!=undefined && ( (row.item.targetconfig_ec2fsxn.iomb_warnings_burst!=undefined && row.item.targetconfig_ec2fsxn.iomb_warnings_burst!='') || (row.item.targetconfig_ec2fsxn.iops_warnings_burst!=undefined && row.item.targetconfig_ec2fsxn.iops_warnings_burst!='') )" src="@/assets/burst.png" height="20px" v-b-popover.hover="{title:`Bursting`, content:`${row.item.targetconfig_ec2fsxn.iomb_warnings_burst || ''} ${row.item.targetconfig_ec2fsxn.iops_warnings_burst || ''}`, html: false}"></img>
                  </template>


                  <template  #cell(targetconfig_ec2fsxn.shape)="row">
                     
                     <span v-if="row.item.targetconfig_ec2fsxn!=undefined" >
                        
                        <span v-if="row.item.targetconfig_ec2fsxn.shape!='N/A'"  v-b-popover.hover="{title:`${row.item.targetconfig_ec2fsxn.shape}`, content:`Specifications: ${row.item.targetconfig_ec2fsxn.match_string}.  <br/><br/>${row.item.targetconfig_ec2fsxn.closeness_string =='' ? '' : '[ '+row.item.targetconfig_ec2fsxn.closeness_string+' ]'} `, html: true}">{{ row.item.targetconfig_ec2fsxn.shape }}</span>
                        <span v-if="row.item.targetconfig_ec2fsxn!=undefined   && row.item.targetconfig_ec2fsxn.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find a EC2 + FSxN configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_ec2fsxn.closeness_string} ]`, html: true}" >(Contact your AWS Database Specialist)</span>
                        
                        <span v-if="row.item.targetconfig_ec2fsxn!=undefined  && row.item.targetconfig_ec2fsxn.shape!='N/A' &&  row.item.UseMAZ=='Yes' && row.item.frozen_prefs.ec2fsxn_baremetal_HA=='Y'"> (2Instances) </span> 
                        <br/>
                        
                      
                        
                        
                       
                        
                        <span style="font-size:14px" v-if="row.item.targetconfig_ec2fsxn.shape!='N/A' && row.item.targetconfig_ec2fsxn.shapeIsMetal"
                          v-b-popover.hover="{title:`Cores Suggested`, content:`Each ${row.item.targetconfig_ec2fsxn.shape} has ${row.item.targetconfig_ec2fsxn.shape_cores_available} total cores (${row.item.targetconfig_ec2fsxn.shape_cores_available*(row.item.targetconfig_ec2fsxn.shape_vcpus_per_core || 2)} VCPUs).  Your choice of algorithms suggests that you can run with ${row.item.targetconfig_ec2fsxn.shape_cores_needed} cores.  <br/><br/>Some customers may consider the use of Oracle Core Factor licensing.  Your customer should review <a href='https://www.oracle.com/assets/processor-core-factor-table-070634.pdf' target='_blank'>https://www.oracle.com/assets/processor-core-factor-table-070634.pdf</a> and decide if the ${row.item.targetconfig_ec2fsxn.Processor} CPU does or does not match ${row.item.targetconfig_ec2fsxn.OracleCoreFactorString? 'what the document lists as: ' + row.item.targetconfig_ec2fsxn.OracleCoreFactorString : 'the CPUs listed in the document.'}<br/><br/>Some customers may consider the use of Oracle Linux VM Hypervisor's Hard Partitioning to only utilize a specific quantity of cores (see <a href='https://docs.aws.amazon.com/whitepapers/latest/running-oracle-hypervisors-ec2-bare-metal/running-oracle-hypervisors-ec2-bare-metal.html' target='_blank'>white paper</a>).`, html: true}" >
                          <br/>
                          {{ "(" +
                             row.item.targetconfig_ec2fsxn.shape_cores_needed + " Cores Suggested, " +
                             row.item.targetconfig_ec2fsxn.shape_cores_available + " Cores Total per instance" +
                             ") "  }}
                         </span>

                        <span style="font-size:14px" v-if="row.item.targetconfig_ec2fsxn.shape!='N/A' && !row.item.targetconfig_ec2fsxn.shapeIsMetal"
                          title="VCPU" v-b-popover.hover="`Regular EC2 requires Bring-Your-Own-License Oracle and is vCPU-licensed (${(row.item.targetconfig_ec2fsxn.shape_vcpus_per_core || 2)==1 ? '1 vCPU = 1 Oracle processor license, because this shape does not use hyperthreading' : '2 vCPU = 1 Oracle processor license'}). The ${row.item.targetconfig_ec2fsxn.shape} has ${row.item.targetconfig_ec2fsxn.shape_max_vcpu} VCPU (${Math.ceil(row.item.targetconfig_ec2fsxn.shape_max_vcpu / (row.item.targetconfig_ec2fsxn.shape_vcpus_per_core || 2))} Oracle processor license${Math.ceil(row.item.targetconfig_ec2fsxn.shape_max_vcpu / (row.item.targetconfig_ec2fsxn.shape_vcpus_per_core || 2))==1 ? '' : 's'}). ${(row.item.UseMAZ=='Yes' && row.item.frozen_prefs.ec2fsxn_baremetal_HA=='Y') ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + (2 * row.item.targetconfig_ec2fsxn.shape_max_vcpu) + ' VCPU).' : ''}`" >
                          <br/>
                          {{ "(" + row.item.targetconfig_ec2fsxn.shape_max_vcpu + " VCPU" + ((row.item.UseMAZ=='Yes' && row.item.frozen_prefs.ec2fsxn_baremetal_HA=='Y') ? '*' : '') + ") " }}
                         </span>


                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-checkbox
                        v-model="row.item.UseManualShape"
                        size="sm"
                        value="Y"
                        unchecked-value="N"
                        @input="manualEditReconfig"
                      >
                        Manually pick shape
                      </b-form-checkbox>
                  <!--    <b-form-select v-model="row.item.UseManualShape" size="sm" @change="manualEditReconfig">-->
                  <!--<option value="N">Let the system pick the best RDS shape</option>-->
                  <!--<option value="Y">Let me pick the RDS shape</option>-->
                  <!--    </b-form-select>-->
                    </span>
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.targetconfig_ec2fsxn.shape" size="sm" @change="manualEditReconfig" :options="ec2BMShapes_lov"/>
                    </span>  
                    
                    <img v-if="(row.item.targetconfig_ec2fsxn.warnings!=undefined)&&(row.item.targetconfig_ec2fsxn.warnings!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_ec2fsxn.warnings}`" title="Alerts"></img>
                    
                    </span>
                  </template>

                  
                  <template  #cell(targetconfig_ec2.monthly_estimate)="row">
                    <span v-if="row.item.targetconfig_ec2!=undefined &&  row.item.targetconfig_ec2.shape!='N/A'" title="EC2 and EBS Estimate" v-b-popover.hover="`${row.item.targetconfig_ec2.summaryText}`" >{{ row.item.targetconfig_ec2.monthly_estimate }}
                      <br/><br/>
                      {{ (row.item.targetconfig_ec2.RIused=="RI" ? "1yrNURI" : "OnDemand") }}
                      <br/>
                      </span>

                      
                      <span v-if="row.item.targetconfig_ec2!=undefined &&  row.item.targetconfig_ec2.shape!='N/A'" v-b-popover.hover="{title:`EC2 Configuration`, content:`This is a customer-managed EC2 configuration.`, html: true}">
                        <br/><img v-if="row.item.targetconfig_ec2.shape!='N/A'" src="@/assets/EC2new.png" height="30px" ></img><br/>
                      </span>
                      
                      <span v-if="showAsk && row.item.targetconfig_ec2!=undefined   && row.item.targetconfig_ec2.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find a EC2 configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_ec2.closeness_string} ]`, html: true}" > 
                          <b-button v-if="true"
                            type="button"
                            size="sm"
                            variant="outline-primary"
                            @click="showConfigurationDetailsModal(row.item)"
                          >
                            Ask AWS
                          </b-button>
                    </span>
                    
                      <img v-if="row.item.targetconfig_ec2!=undefined && row.item.targetconfig_ec2.warnings &&  row.item.targetconfig_ec2.warnings!=''" src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`EC2 Comments`, content:`${row.item.targetconfig_ec2.warnings}`, html: false}"></img>
                  </template>


                  <template  #cell(targetconfig_ec2.shape)="row">
                     
                     <span v-if="row.item.targetconfig_ec2!=undefined" >
                        
                        <span v-if="row.item.targetconfig_ec2.shape!='N/A'"  v-b-popover.hover="{title:`${row.item.targetconfig_ec2.shape}`, content:`Specifications: ${row.item.targetconfig_ec2.match_string}.  <br/><br/>${row.item.targetconfig_ec2.closeness_string =='' ? '' : '[ '+row.item.targetconfig_ec2.closeness_string+' ]'} `, html: true}">{{ row.item.targetconfig_ec2.shape }}</span>
                        <span v-if="row.item.targetconfig_ec2!=undefined   && row.item.targetconfig_ec2.shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find a EC2 configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_ec2.closeness_string} ]`, html: true}" >(Contact your AWS Database Specialist)</span> 
                        
                        <span v-if="row.item.targetconfig_ec2!=undefined  && row.item.targetconfig_ec2.shape!='N/A' &&  row.item.UseMAZ=='Yes'"> (2Instances) </span> 
                        <br/>
                        
                    <span v-if="row.item.targetconfig_ec2!=undefined && row.item.targetconfig_ec2.shape!='N/A' && row.item.optgoal_choice=='min_license'" title="Minimize Licensing" v-b-popover.hover="`Pick the shape that minimizes the number of VCPUs used in the configuration. ${row.item.UseMAZ=='Yes' && row.item.targetconfig_ec2.shape!='N/A'  ? '*This is a 2 instance HA configuration, so plan on licenses for both instances of the HA (' + (  2 * row.item.targetconfig_ec2.shape_max_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize Licensing (" + 
                         ( row.item.targetconfig_ec2.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.targetconfig_ec2.shape!='N/A'  ) ? '*' : '' ) + ")"  }}
                     </span>    
                     
                    <span v-if="row.item.targetconfig_ec2!=undefined && row.item.targetconfig_ec2.shape!='N/A' && row.item.optgoal_choice=='min_cost'" title="Minimize AWS Spend" v-b-popover.hover="`Pick the shape that minimizes the AWS Spend even if it has more VCPUs than other shapes.  This is good for when you have an Unlimited License Agreement or you have a large pool of available licenses. ${row.item.UseMAZ=='Yes' && row.item.targetconfig_ec2.shape!='N/A'   ? '*This is a 2 instance HA configuration, so plan on licenses for both instances of the HA (' + (  2 * row.item.targetconfig_ec2.shape_max_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize AWS Cost (" + 
                         (  row.item.targetconfig_ec2.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.targetconfig_ec2.shape!='N/A'  ) ? '*' : '' ) + ")"  }}
                    </span>
                     
                        
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-checkbox
                        v-model="row.item.UseManualShape"
                        size="sm"
                        value="Y"
                        unchecked-value="N"
                        @input="manualEditReconfig"
                      >
                        Manually pick shape
                      </b-form-checkbox>
                  <!--    <b-form-select v-model="row.item.UseManualShape" size="sm" @change="manualEditReconfig">-->
                  <!--<option value="N">Let the system pick the best RDS shape</option>-->
                  <!--<option value="Y">Let me pick the RDS shape</option>-->
                  <!--    </b-form-select>-->
                    </span>
                    
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.targetconfig_ec2.shape" size="sm" @change="manualEditReconfig" :options="ec2Shapes_lov"/>
                    </span>  
                    
                    <img v-if="(row.item.targetconfig_ec2.warnings!=undefined)&&(row.item.targetconfig_ec2.warnings!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_ec2.warnings}`" title="Alerts"></img>
                    
                    </span>
                  </template>

                  
                  <template  #cell(rds_shape)="row">
                     <span v-if="row.item.targetconfig_rds!=undefined" >
                        <img v-if="(row.item.Comments!=undefined)&&(row.item.Comments!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.Comments}`" title="Alerts"></img>
                        <span v-if="(row.item.Comments!=undefined)&&( (row.item.Comments=='[Setting target to EC2 when disk space is > 64000 GB] ') )" > <b>Disk Space ({{row.item.DiskSpace}} GB) more than 64TB.</b> </span>
                        <span v-if="(row.item.Comments!=undefined)&&(  (row.item.Comments=='[Setting target to EC2 when disk space is > 256000 GB] '))" > <b>Disk Space ({{row.item.DiskSpace}} GB) more than 256TB.</b> </span>
                        <span v-if="((row.item.Comments==undefined) || (row.item.Comments=='') )&&( row.item.targetconfig_rds!=undefined   && row.item.rds_shape=='N/A')" > <b>Could not find shape.</b> </span>
                        <span v-if="row.item.rds_shape!='N/A' && row.item.rds_type!='rac'"  v-b-popover.hover="{title:`${row.item.rds_shape}`, content:`Specifications: ${row.item.targetconfig_rds.match_string}.  <br/><br/>${row.item.targetconfig_rds.closeness_string =='' ? '' : '[ '+row.item.targetconfig_rds.closeness_string+' ]'} `, html: true}">{{ row.item.rds_shape }}</span>
                        <span v-if="row.item.rds_shape!='N/A' && row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='' && row.item.targetconfig_rds.rac_nodes!=undefined"  v-b-popover.hover="{title:`${row.item.targetconfig_rds.rac_nodes} Node Cluster of ${row.item.rds_shape}`, content:`${row.item.targetconfig_rds.rac_nodes} Node Cluster.<br/>Individual Node Specifications: ${row.item.targetconfig_rds.match_string}.  <br/><br/>${row.item.targetconfig_rds.closeness_string =='' ? '' : '[ '+row.item.targetconfig_rds.closeness_string+' ]'} `, html: true}">{{ row.item.rds_shape }} ({{ row.item.targetconfig_rds.rac_nodes }} nodes)</span>

                        
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' && row.item.rds_type!='custom'"> (MultiAZ)</span>
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type=='custom'" title="MultiAZ for RDS Custom" v-b-popover.hover="`This configuration is targetting a MultiAZ deployment.  For RDS Custom, it does not currently offer a managed MultiAZ topology so we are modeling a Data Guard Replica setup using 2 instances.  Therefore, the pricing shown reflects the cost of 2 identical instances (in other words, it is doubled).`"> (MultiAZ*)</span>
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.rds_shape!='N/A' && row.item.targetconfig_rds.shape_max_vcpu != row.item.targetconfig_rds.shape_optimize_vcpu" size="sm" :title="`OptimizeCPU`" v-b-popover.hover="`OptimizeCPU feature considered when selecting the shape.  If you wish to ignore OptimizeCPU, use the Optimization Goal Preference drop-down to pick a different algorithm.`"> (OptimizeCPU: {{ row.item.targetconfig_rds.shape_max_vcpu }} to {{ row.item.targetconfig_rds.shape_optimize_vcpu }})</span> 
                        <span v-if="row.item.targetconfig_rds!=undefined   && row.item.rds_shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an ${row.item.targetconfig_rds.rds_type_desc} configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_rds.closeness_string} ]`, html: true}" > 
                          <br/>
                          {{row.item.rds_type=="se" && (row.item.SE2_Comments!=undefined) && (row.item.SE2_Comments.indexOf("[SE2-LI ruled out")>0 ) ? row.item.SE2_Comments.substring( row.item.SE2_Comments.indexOf("[SE2-LI ruled out") ) :
                            "(Consider EC2 or ODB@AWS)" }}
                            
                        </span> 
                        <br/>
                        
                       <img v-if="(row.item.rds_type=='se')" src="@/assets/SE2LI.png" height="12px"></img>
                       <img v-if="(row.item.rds_type=='custom')" src="@/assets/RDSCustom.png" height="12px"></img>
                       <img v-if="(row.item.rds_type=='rac')" src="@/assets/RDSCustomRAC.png" height="12px"></img>
                       </span>


                    <span style="font-size:10px" v-if="(row.item.targetconfig_rds!=undefined && row.item.targetconfig_rds.BareMetalPossibilityComments)" v-b-popover.hover="{title:`Bare Metal Instance Suggestion`, content:`${row.item.targetconfig_rds.BareMetalPossibilityComments}<br/><br/>Refer to Oracle Cloud Policy and Oracle Core Factor Table, and consult your licensing partner to determine if you can reduce license and support costs. <a href='https://aws.amazon.com/blogs/database/getting-started-with-amazon-ec2-bare-metal-instances-for-amazon-rds-for-oracle-and-amazon-rds-custom-for-oracle/' target='_blank'>(blog)</a> <a href='https://houseofbrick.com/blog/oracle-licensing-efficiency-with-dedicated-hosts/' target='_blank'>(3rdParty blog)</a>`, html: true}" >
                      <br/><img  src="@/assets/BareMetalPossibility.png" height="18px"></img></br>
                    </span>
                   
                    <span style="font-size:10px" v-if="(row.item.targetconfig_rds!=undefined && row.item.targetconfig_rds.BareMetalProcessor)" v-b-popover.hover="{title:`Bare Metal Instance`, content:`This is a bare metal instance using the ${row.item.targetconfig_rds.BareMetalProcessor}<br/><br/>Refer to Oracle Cloud Policy and Oracle Core Factor Table, and consult your licensing partner to determine if you can reduce license and support costs. <a href='https://aws.amazon.com/blogs/database/getting-started-with-amazon-ec2-bare-metal-instances-for-amazon-rds-for-oracle-and-amazon-rds-custom-for-oracle/' target='_blank'>(blog)</a>`, html: true}" >
                      <br/><img  src="@/assets/BareMetal.png" height="18px"></img></br>
                    </span>
                    
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-select v-model="row.item.rds_type" size="sm" @change="manualEditReconfig" :disabled="(row.item.UseManualShape=='Y')">
                        <!--<option value="se_prefer" disabled>Prefer SE2 License Included</option>-->
                        <option value="ee">EE BYOL</option>
                        <option value="se">SE2 License Included</option>
                        <option v-if="showBeta && false" value="custom">Custom - RDS Custom for Oracle (BYOL)</option>
                        <option v-if="showRAC" value="rac">RAC - RDS Custom for Oracle Real Application Clusters (BYOL) - PREVIEW</option>
                      </b-form-select>
                    </span>  
                    
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && !(row.item.targetconfig_rds.BareMetalProcessor) && row.item.optgoal_choice=='min_license'" title="Minimize Licensing" v-b-popover.hover="`Pick the shape that minimizes the number of VCPUs used in the configuration. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_max_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize Licensing (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span>

                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A'  && (row.item.targetconfig_rds.BareMetalProcessor) && row.item.optgoal_choice=='min_license'" title="Minimize Licensing" v-b-popover.hover="`Pick the shape that minimizes the number of Cores used in the configuration. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes /2 : 2 * row.item.targetconfig_rds.shape_max_vcpu/2  ) + ' Cores).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize Licensing (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes / 2: row.item.targetconfig_rds.shape_max_vcpu/2  ) +
                         " Core" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span>

                     
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && row.item.optgoal_choice=='min_cost'" title="Minimize AWS Spend" v-b-popover.hover="`Pick the shape that minimizes the AWS Spend even if it has more VCPUs than other shapes.  This is good for when you have an Unlimited License Agreement or you have a large pool of available licenses. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_optimize_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize AWS Cost (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                    </span>
                     
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && row.item.optgoal_choice=='Y'" title="OptimizeCPU" v-b-popover.hover="`Use OptimizeCPU feature when picking RDS shape to minimize cost and provisioned VCPU.  Please consult with your license experts to decide if OptimizeCPU is a fit for your license/contract.  ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_optimize_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: OptimizeCPU (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_optimize_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span> 

                    <span v-if="(row.item.optimizationGoalSuggestion)" v-b-popover.hover="{title:`Optimization Goal Consideration?`, content:`${row.item.optimizationGoalSuggestion}`, html: true}" >
                      <br/><img  src="@/assets/Dollar.png" height="18px"></img>
                    </span>
 
                      
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-select v-model="row.item.optgoal_choice" size="sm" @change="manualEditReconfig">
                        <option value="min_license">Minimize Licensing (look for the shape with the fewest VCPU) - Ignores OptimizeCPU</option>
                        <option value="min_cost">Minimize Cost of RDS shape (estimated Oracle license quantity does not matter- good for Oracle ULAs) - Ignores OptimizeCPU</option>
                        <option v-if="row.item.rds_type=='ee'" value="Y">Use OptimizeCPU (consult with your license experts to decide if OptimizeCPU is a fit for your license/contract)</option>
                      </b-form-select>
                    </span>
                    
                    <span v-if="(row.item.manual!=undefined && row.item.manual=='YES' )">
                      <b-form-checkbox
                        v-model="row.item.UseManualShape"
                        size="sm"
                        value="Y"
                        unchecked-value="N"
                        @input="manualEditReconfig"
                      >
                        Manually pick shape
                      </b-form-checkbox>
                  <!--    <b-form-select v-model="row.item.UseManualShape" size="sm" @change="manualEditReconfig">-->
                  <!--<option value="N">Let the system pick the best RDS shape</option>-->
                  <!--<option value="Y">Let me pick the RDS shape</option>-->
                  <!--    </b-form-select>-->
                    </span>
                    <span v-if="row.item.rds_type=='ee' && (row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.rds_shape" size="sm" @change="manualEditReconfig" :options="rdsShapesEE_lov"/>
                    </span>  
                    <span v-if="row.item.rds_type=='se' && (row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.rds_shape" size="sm" @change="manualEditReconfig" :options="rdsShapesSE_lov"/>
                    </span>  
                    <span v-if="row.item.rds_type=='custom' && (row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.rds_shape" size="sm" @change="manualEditReconfig" :options="rdsShapesCustom_lov"/>
                    </span>  
                    <span v-if="row.item.rds_type=='rac' && (row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.rds_shape" size="sm" @change="manualEditReconfig" :options="rdsShapesRAC_lov"/>
                    </span>  
                    <span v-if="row.item.rds_type=='rac' && (row.item.manual!=undefined && row.item.manual=='YES' ) && row.item.UseManualShape=='Y'">
                      <b-form-select v-model="row.item.rac_nodes" size="sm" @change="manualEditReconfig" >
                        <option value="2">2 nodes</option>
                        <option value="3">3 nodes</option>
                        <option value="4">4 nodes</option>
                        <option value="5">5 nodes</option>
                        <option value="6">6 nodes</option>
                        <option value="7">7 nodes</option>
                        <option value="8">8 nodes</option>
                        <option value="9">9 nodes</option>
                        <option value="10">10 nodes</option>
                        <option value="11">11 nodes</option>
                        <option value="12">12 nodes</option>
                        <option value="13">13 nodes</option>
                        <option value="14">14 nodes</option>
                        <option value="15">15 nodes</option>
                        <option value="16">16 nodes</option>
                      </b-form-select>
                    </span>  
                    
                              

                    <span style="font-size:14px" v-if="row.item.PDBandCDBmatch!=undefined && row.item.frozen_prefs.pdb_and_cdb_exclude_algo == 'excludePDB' && row.item.PDBandCDBmatch == 'PDBwithParent'">
                      <br/> <br/>[This PDB overlaps with a CDB in the batch]
                    </span>
                    <span style="font-size:14px" v-if="row.item.PDBandCDBmatch!=undefined && row.item.frozen_prefs.pdb_and_cdb_exclude_algo == 'excludeCDB' && row.item.PDBandCDBmatch == 'CDBwithChild'">
                      <br/> <br/>[This CDB overlaps with a PDB in the batch]
                    </span>
                    <span style="font-size:14px" v-if="row.item.DuplicateMatch!=undefined && row.item.frozen_prefs.duplicate_database_exclude_algo == 'excludeDuplicates' && row.item.DuplicateMatch != 'OriginalDatabase'">
                      <br/> <br/>[This is a duplicate database of row {{row.item.DuplicateMatch}}]
                    </span>

                  </template>




                  
                  <template  v-slot:cell(show_config)="row">
                    <template v-if="row.item.targetconfig_rds==undefined">
                      
                    </template>
                    <template v-else>
                      
                    
                          <b-button v-if="row.item.rds_shape=='N/A' "
                            type="button"
                            block
                            size="sm"
                            v-b-modal="`mConfig${row.item.collectionID}${row.item.scenario}${row.item.row}${row.item.manual}`"
                          >Show Metrics</b-button>
                          <b-button v-if="row.item.rds_shape!='N/A'  "
                            type="button"
                            block
                            size="sm"
                            v-b-modal="`mConfig${row.item.collectionID}${row.item.scenario}${row.item.row}${row.item.manual}`"
                          >Show Config</b-button>
                          
<!-- HERE IS WHERE THE MODAL STARTS


-->
                          <b-modal :id="`mConfig${row.item.collectionID}${row.item.scenario}${row.item.row}${row.item.manual}`" title="Configuration Details" scrollable ok-only size="xl">
                            <div :id="`mConfigDiv${row.item.collectionID}${row.item.scenario}${row.item.row}${row.item.manual}`">

                          <configurationdetailsmodal
                            :item="row.item"
                            :genItems="genItems"
                            :disclaimerLists="disclaimerLists"
                            :singleDB="singleDB"
                            :showAlertPrint="showAlertPrint"
                            :alertStylePrint="alertStylePrint"
                            :alertTextPrint="alertTextPrint"
                            :user="user"
                          >
                          </configurationdetailsmodal>
                            </div>

                            
                          </b-modal>
                          
                        </template>
                  </template>


                </b-table>
                
                <br/>
                
                
                
                <!--https://www.npmjs.com/package/vue-json-csv-->
                <div>
                  <b-alert :show="shareMode" variant="info">These databases have been shared with you via URL.  Please save the URL if you want to continue to view them later.</b-alert>
                  <b-button v-if="!this.shareMode && !( this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || this.batchItems[0].row=='Error Loading??' || this.disableScenarioButton) && ('0123456789C'.indexOf(this.batch_id.substring(0,1) ) >= 0 ) " block variant="outline-primary" v-b-modal="`mShare`">Share these databases via URL</b-button>
                  
                  
                  <b-button :disabled="(this.scenarioCount<1)" block variant="outline-primary" v-b-modal="`mCSV`">Download CSV{{ this.scenarioCount<1 ? ' [Create a Scenario first]' : '' }}</b-button>
                  
                  <b-button :disabled="(this.scenarioCount<1)" block variant="outline-primary" v-b-modal="`mPPTX`">Create Powerpoint (work-in-progress){{ this.scenarioCount<1 ? ' [Create a Scenario first]' : '' }}</b-button>

                  <b-button v-if="showATX" :disabled="!(this.scenarioCount > 0)" block variant="outline-primary" v-b-modal="`mATX`">Generate AWS Transform JSON files{{ this.scenarioCount > 0 ? '' : ' [Create a Scenario first]' }}</b-button>
                  
                  
                  <!--<download-csv-->
                  <!--	class   = "btn btn-outline-primary btn-block"-->
                  <!--	:data   = "flatItems"-->
                  <!--	:fields = "csvFields"-->
                  <!--	:labels = "csvLabels"-->
                  <!--	:name    = "`dbcsi_sizing_${this.batch_id}.csv`">-->
                  <!--	Download CSV-->
                  <!--</download-csv>-->
                  <!--<download-csv v-if="this.countSelected > 0"-->
                  <!--	class   = "btn btn-outline-primary btn-block"-->
                  <!--	:data   = "selectedFlatItems"-->
                  	
                  <!--	:fields = "csvFields"-->
                  <!--	:labels = "csvLabels"-->
                  <!--	:name    = "`dbcsi_sizing_${this.batch_id}_selected.csv`">-->
                  <!--	Download CSV for {{this.countSelected}} Selected Databases-->
                  <!--</download-csv>-->
                  <b-button v-if="!this.shareMode" :disabled="! ( !this.shareMode && !( this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || this.batchItems[0].row=='Error Loading??' || this.disableScenarioButton) && (this.countSelected > 0) )" block variant="outline-primary" v-b-modal="`mBatch`">Create a new batch for {{this.countSelected}} Selected Databases {{ this.countSelected<1 ? '[Select at least 1 database]' : '' }}</b-button>
                  <b-button v-if="false && currentEmployee" :disabled="! ( this.currentEmployee && !this.shareMode && !( this.batchItems.length==0 || this.batchItems[0].row=='Loading...' || this.batchItems[0].row=='Error Loading??' || this.disableScenarioButton) && (this.countSelected > 1) )" block variant="outline-primary" v-b-modal="`mConsolidate`">Consolidate {{this.countSelected}} Selected Databases (ALPHA PREVIEW) {{ this.countSelected<2 ? '[Select at least 2 databases]' : '' }}</b-button>
                  
                    <b-modal :id="`mShare`" title="Share Databases via URL" ok-only ok-title="Finished" size="xl" >
                          <div style="margin: 15px">
                            <p style="font-size:14px">This feature lets you share your DBCSI databases via generated obscure URLs, similar to how you share in the AWS Pricing Calculator.  The other users who wish to use your generated sharing URL will need to be DBCSI users as well. The generated URL does not copy over your algorithm choices or any manually entered target values.  To continue, please read and acknowledge the following:</p>
                            <br/><br/>
                            <p style="font-size:14px"><b>Sharing Acknowledgement:</b>  Any DBCSI user who has been given the generated sharing URL will be able to see the DBCSI information for these databases.</p>
                            

                            <b-form>
                              
                                   
                              <b-form-group
                                id="exampleInputGroup0"
                                label="Generated Sharing URL:"
                                label-for="genURL"
                                description="Please copy the above URL and distribute it for sharing these databases with other DBCSI users."
                                v-if="generatedSharingURL !=''"
                              >
                                <b-form-input
                                  id="genURL"
                                  type="text"
                                  v-model="generatedSharingURL"
                                  required
                                  disabled
                                  placeholder="generated URL for sharing these databases"
                                ></b-form-input>
                              </b-form-group>
                              
                              <b-button @click="shareDatabases(0)" v-if="(generatedSharingURL=='')" variant="success">Acknowledge and Continue</b-button>
                            </b-form>
                            <br/><br/>
                      </div>  
                    </b-modal>      

                    <b-modal :id="`mCSV`" title="Download CSV" ok-only ok-title="Finished" size="xl" @show="onCSVModalShow" >
                          <div style="margin: 15px">
                            <p style="font-size:14px">This feature lets you download DBCSI data into a CSV.  There are multiple formats to choose from.  The DETAIL format is the primary choice and is also the right choice for uploading into the Directional Business Case (DBC) tool.  The ALTERNATE-1 format is a reduced set of columns.<span v-if="currentEmployee">  The MAT format is a prototype export for the <a href="https://web.app.mat.pace.aws.dev/" target="_blank" rel="noopener noreferrer">Migrations Acceleration Toolkit (MAT)</a> and has one row per database; columns DBCSI does not collect yet are left empty.</span></p>
                            <br/>
                            

                            <b-form>
                              
                              <!--<b>This set of databases contains both CDB and PDBs.  You may be double-counting if you include both the PDB and its CDB parent.  Do you want to include only CDBs, only PDBs, or everything?</b>-->
                              
                              <!--<br/>-->
                              
                              <b-form-group
                                id="exampleInputGroup0"
                                label="CSV Format:"
                                label-for="genURL"
                                description="Please choose the CSV format to use for the download."
                              >
                                <b-form-select v-model="csv_format" size="sm" :options="csvFormatOptions" @change="onCSVFormatChange"/>
                              </b-form-group>
                              
                             <span visible="false" v-if="this.pdb_and_cdb_pairs_in_batch">Note: This batch contains PDBs which overlap with CDBs in this batch.  You may want to exclude them from your CSV to avoid confusion or over-counting.<br/><br/></span>   
                             <span visible="false" v-if="this.duplicate_databases_in_batch">Note: This batch contains databases which are duplicates of others in this batch.  You may want to exclude them from your CSV to avoid confusion or over-counting.<br/><br/></span>

                              
                              
                              <br/>
                              <div  class="mt-4 mb-2">
                                  <b>Databases</b>
                                  <div v-if="csv_format == 'mat' && matLoading"><b-spinner small></b-spinner> Loading database details for the MAT format...</div>
                                  <div v-else>
                                  <download-csv
                                  	class   = "btn btn-outline-primary btn-block"
                                  	:data   = "(csv_format == 'mat') ? matFlatItems : flatItems"
                                  	:fields = "csvFields"
                                  	:labels = "csvLabels"
                                  	:name    = "`dbcsi_sizing_${this.csv_format}_${this.batch_id}.csv`">
                                  	Download CSV in {{this.csv_format}} format
                                  </download-csv>
                                  <download-csv v-if="this.pdb_and_cdb_pairs_in_batch || this.duplicate_databases_in_batch"
                                  	class   = "btn btn-outline-primary btn-block"
                                  	:data   = "(csv_format == 'mat') ? matFilteredFlatItems : filteredFlatItems"
                                  	:fields = "csvFields"
                                  	:labels = "csvLabels"
                                  	:name    = "`dbcsi_sizing_${this.csv_format}_${this.batch_id}.csv`">
                                  	Download CSV in {{this.csv_format}} format excluding overlapping PDBs/CDBs or duplicated databases as per scenario preference
                                  </download-csv>
                                  <download-csv v-if="this.countSelected > 0"
                                  	class   = "btn btn-outline-primary btn-block"
                                  	:data   = "(csv_format == 'mat') ? matSelectedFlatItems : selectedFlatItems"
                                  	:fields = "csvFields"
                                  	:labels = "csvLabels"
                                  	:name    = "`dbcsi_sizing_${this.csv_format}_${this.batch_id}_selected.csv`">
                                  	Download CSV in {{this.csv_format}} for {{this.countSelected}} Selected Databases
                                  </download-csv>
                                  </div>
                              </div>
                              
                              <div v-if="this.showODBAWS && (this.infrastructure.length > 0) " class="mt-4 mb-2">
                                  <b>ODB@AWS Infrastructure</b>
                                  <!-- New infrastructure CSV download buttons -->
                                  <download-csv
                                    class="btn btn-outline-primary btn-block"
                                    :data="flatInfrastructure"
                                    :fields="infrastructureFields"
                                    :labels="infrastructureLabels"
                                    :name="`dbcsi_ODBatAWS_${this.batch_id}.csv`">
                                    Download CSV for ODB@AWS Infrastructure Details
                                  </download-csv>
            
                              </div>
            
                              <div v-if="this.showRDSConsolidationFields && (this.consolidatedServers.length > 0) " class="mt-4 mb-2">
                                  <b>RDS on Consolidated Servers</b>
                                  <download-csv
                                    class="btn btn-outline-primary btn-block"
                                    :data="flatConsolidatedServers"
                                    :fields="consolidatedServerFields"
                                    :labels="consolidatedServerLabels"
                                    :name="`dbcsi_RDSConsolidated_${this.batch_id}.csv`">
                                    Download CSV for RDS Consolidated Servers
                                  </download-csv>
            
                              </div>

                              
                              
                            </b-form>
                            <br/><br/>
                      </div>  
                    </b-modal>      

                    <b-modal :id="`mATX`" title="Generate AWS Transform JSON files (prototype)" ok-only ok-title="Close" size="lg" @show="initATXModal">
                      <div style="margin: 15px">
                        <p style="font-size:14px">This prototype exports a scenario's databases in the AWS Transform (ATX) migration inventory format: a database_instance JSON file (one record per database) and a server JSON file (one record per host).  It follows the hybrid schema proposal in ATX/proposal.</p>
                        <b-form-group label="Select your Auto-Right-Sizer Scenario:" label-for="atxScenario">
                          <b-form-select id="atxScenario" v-model="selectedATXScenario" size="sm">
                            <option v-for="total in this.totals" :key="total.scenarioName" :value="total.scenarioName">{{ total.scenarioName }}</option>
                          </b-form-select>
                        </b-form-group>
                        <b-form-checkbox v-if="this.pdb_and_cdb_pairs_in_batch || this.duplicate_databases_in_batch" v-model="atxExcludeOverlaps" class="mb-3">
                          Exclude overlapping PDBs/CDBs and duplicated databases as per scenario preference
                        </b-form-checkbox>
                        <div v-if="matLoading"><b-spinner small></b-spinner> Loading database details...</div>
                        <div v-else-if="selectedATXScenario">
                          <p>{{ atxRecords.databaseInstances.length }} database_instance records and {{ atxRecords.servers.length }} server records.</p>
                          <b-button class="btn-block" variant="outline-primary" @click="downloadATXJSON('database_instance')" :disabled="atxRecords.databaseInstances.length == 0">
                            Download database_instance JSON
                          </b-button>
                          <b-button class="btn-block" variant="outline-primary" @click="downloadATXJSON('server')" :disabled="atxRecords.servers.length == 0">
                            Download server JSON
                          </b-button>
                        </div>
                      </div>
                    </b-modal>

                    <b-modal :id="`mPPTX`" title="Create Powerpoint (work-in-progress)" ok-only ok-title="Close" size="xl" @show="initPPTXModal" @hidden="cleanupPPTX">
                      <div style="margin: 15px">
                  
                      <b-list-group>
                        <b-list-group-item>
                          <div> 
                            
                            <b-card bg-variant="light" class="text-left" >

                              <b>DBCSI can merge your auto-right-sizer scenario data into a 'template' PowerPoint to quickly create custom output.</b>
                              <p class="mt-2">Choose how you want to generate it:</p>

                              <b-form-radio-group v-model="pptxMode" stacked :disabled="generatingPPTX">
                                <b-form-radio value="server">
                                  <b>Generate on the server (recommended)</b> — DBCSI builds the PowerPoint and downloads it to you. No setup required.
                                </b-form-radio>
                                <b-form-radio value="client" class="mt-2">
                                  <b>Advanced: generate it yourself (command-line)</b> — download the scenario JSON and run the python merge tool locally.
                                </b-form-radio>
                              </b-form-radio-group>

                              <p class="mt-3">
                              This is a work-in-progress. More features will be coming soon.
                              <b>Please send ideas and feedback to dbayard@amazon.com</b>
                              </p>
                            </b-card>
                           </div>
                        </b-list-group-item>
              
                        <b-list-group-item v-if="pptxMode === 'server'">
                          <div>
                            <b>Generate your PowerPoint:</b>
                            <b-card bg-variant="light" class="text-left" >
                              <b-form>
                                <b-form-group
                                  label="Select your Auto-Right-Sizer Scenario:"
                                  label-for="pptxScenarioGen"
                                  description="Choose the scenario to include in the PowerPoint."
                                >
                                  <b-form-select id="pptxScenarioGen" v-model="selectedPPTXScenario" size="sm" :disabled="generatingPPTX">
                                    <option v-for="total in this.totals" :key="total.scenarioName" :value="total.scenarioName">{{ total.scenarioName }}</option>
                                  </b-form-select>
                                </b-form-group>

                                <b-form-checkbox v-model="pptxNoCharts" :disabled="generatingPPTX" class="mb-2">
                                  Skip charts (faster)
                                </b-form-checkbox>

                                <div v-if="pptxShowTimeEstimate && !generatingPPTX" class="text-muted small mb-2">
                                  With charts, this scenario ({{ pptxDbCount }} databases) may take about
                                  {{ pptxEstimateMinutes }} minute{{ pptxEstimateMinutes === 1 ? '' : 's' }} to generate on the server.
                                </div>

                                <b-alert :show="pptxTimeoutWarning && !generatingPPTX" variant="warning" class="mb-2">
                                  This scenario has {{ pptxDbCount }} databases with charts enabled. Server-side generation
                                  may exceed the Lambda 15-minute limit and fail. Consider enabling “Skip charts (faster)”
                                  above, or use the client-side option below. You can still try.
                                </b-alert>

                                <b-button class="btn-block" variant="primary" @click="generatePPTX" :disabled="generatingPPTX || !selectedPPTXScenario">
                                  <b-spinner small v-if="generatingPPTX"></b-spinner>
                                  <span v-if="generatingPPTX && pptxShowTimeEstimate"> Generating PowerPoint… this may take {{ pptxEstimateMinutes }} minute{{ pptxEstimateMinutes === 1 ? '' : 's' }} or so</span>
                                  <span v-else-if="generatingPPTX"> Generating PowerPoint… this can take a minute</span>
                                  <span v-else>Generate PowerPoint for {{ selectedPPTXScenario }}</span>
                                </b-button>

                                <b-alert :show="pptxStatus === 'ready'" variant="success" class="mt-3">
                                  Your PowerPoint is ready — the download should have started automatically.
                                  <span v-if="pptxDownloadUrl">If it did not, <a :href="pptxDownloadUrl" target="_blank">click here to download</a>.</span>
                                </b-alert>
                                <b-alert :show="pptxChartsDisabled" variant="warning" class="mt-3">
                                  Note: charts were skipped because your account has no DBCSI API key. Set one up
                                  <a href="/api" target="_blank">here</a> to include charts.
                                </b-alert>
                                <b-alert :show="pptxStatus === 'failed'" variant="danger" class="mt-3">
                                  PowerPoint generation failed: {{ pptxError }}
                                </b-alert>
                              </b-form>
                            </b-card>
                          </div>
                        </b-list-group-item>

                        <b-list-group-item v-if="pptxMode === 'client'">
                          <div>
                            <b>Download your JSON scenario file to run the python merge tool yourself...</b>
                            <b-card bg-variant="light" class="text-left" >
                              
                                
                                 <b-form>
                                  <b-form-group
                                    label="Select your Auto-Right-Sizer Scenario:"
                                    label-for="pptxScenario"
                                    description="Choose the scenario to export."
                                  >
                                    
                                    <b-form-select v-model="selectedPPTXScenario" size="sm">
                                      <option v-for="total in this.totals" :key="total.scenarioName" :value="total.scenarioName">{{ total.scenarioName }}</option>
                                    </b-form-select>
                                    
                                  </b-form-group>
                                  
                                  <br/>
                                  <div class="mt-4 mb-2">
                                    Download your Scenario Data:
                                    <b-button class="btn-block" variant="outline-primary" @click="downloadPPTXJSON" :disabled="downloadingPPTXJSON">
                                      <span v-if="downloadingPPTXJSON">Fetching data... please wait</span>
                                      <span v-else>Download JSON scenario file for {{ selectedPPTXScenario }}</span>
                                    </b-button>
                                  </div>
                                </b-form>
              
                            </b-card>     
                                    
              
                          </div>
                        </b-list-group-item>
              
                        <b-list-group-item v-if="pptxMode === 'client'">
                          <div>
                            <b>To generate your DBCSI Powerpoint...</b>
                            <b-card bg-variant="light" class="text-left" >
                              <p>There are some one-time setup steps that need to be completed first:</p>
                              <p>1. Setup the DBCSI API (including requesting your dbcsi_userkey and setting environment variables) following the instructions <a
                                href="/api" target="_blank"
                              >here</a></p>
                              <p>2. Download this python3 file (hint: you can re-download it to get the most recent version): <a
                                href="/dbcsi_pptx_merge.py" target="_blank"
                              >dbcsi_pptx_merge.py</a></p>
                              <p>3. Install the necessary python3 dependencies:</p>
                              <pre>
              pip3 install python-pptx requests
</pre>
                              
                              <p>4. Download the sample pptx_template.pptx file: <a
                                href="/sample_pptx_template.pptx" target="_blank"
                              >sample_pptx_template.pptx</a></p>
                              <p>(hint: Open up the pptx_template file in Powerpoint to see how the DBCSI mail-merge placeholders are used)</p>
                              <p/>
                            </b-card>
                            <b-card bg-variant="light" class="text-left" >
                              <p>And these are the recurring steps to follow when you want to create a powerpoint:</p>
                              
                              <p>5. Set the following environment variables (see the API page from step1 for help on the actual values):</p>
                              <pre>
              dbcsi_username
              dbcsi_userkey
              API_GW_KEY
              API_GW_URL                  
                              </pre>
                              <p>6. Download the JSON scenario file for your scenario using the above Scenario Selection LOV and Download JSON button on this page.</p>
                              <p>(hint: Open up your downloaded scenario JSON file in a text editor to better understand the structure and attribute names available to be used as mail-merge placeholders)</p>
                              <p>7. Invoke the dbcsi_pptx_merge.py file to merge the scenario data with your template pptx (in the example below replace ~/Downloads/dbcsi_pptx_{{batch_id}}_{{ selectedPPTXScenario }}.json with the actual filename of your downloaded scenario JSON file):</p>
                              <pre style="white-space: pre; overflow-x: auto; max-width: 100%; font-size: 10px; background: #f5f5f5; padding: 8px; border-radius: 4px;">
    python3 dbcsi_pptx_merge.py --pptx_template sample_pptx_template.pptx --output_pptx output_{{batch_id}}.pptx --scenario_json ~/Downloads/dbcsi_pptx_{{batch_id}}_{{ selectedPPTXScenario }}.json                  
                              </pre>
                              <p>8. Open up the generated output_test.pptx and review.</p>
                              <p>9. Make changes to your pptx template file and repeat steps 7-9.</p>
                            </b-card>
                          </div>
                        </b-list-group-item>
                        <b-list-group-item v-if="pptxMode === 'client'">
                          <div>

                            <p>Here is some quick reference information about usage. (reach out to dbayard@amazon.com if you have requests for additional syntax or scenario data attributes):</p>
                            <b-card bg-variant="light" class="text-left" >
                              

                              <pre>
DBCSI PowerPoint Mail-Merge Generator
Uses mail-merge style placeholders (~~FIELDNAME~~) to populate PowerPoint slides

REQUIRED ENVIRONMENT VARIABLES:
    API_GW_KEY          - API Gateway key for DBCSI
    API_GW_URL          - API Gateway URL for DBCSI
    dbcsi_username      - DBCSI username (get from DBCSI web application)
    dbcsi_userkey       - DBCSI user key (get from DBCSI web application)

COMMAND-LINE ARGUMENTS:
    --scenario_json     Path to scenario JSON file (required)
    --pptx_template     Path to PowerPoint template file (required)
    --output_pptx       Path for output PowerPoint file (required)
    --noCharts          Skip adding charts to slides (optional)
    --verbose           Enable detailed logging output (optional)

TEMPLATE PLACEHOLDER SYNTAX:
    All placeholders must be wrapped in double tildes: ~~PLACEHOLDER~~

    1. Scenario Data Fields:
       ~~S.fieldname~~                    - Access top-level scenario field
       ~~S.nested.field~~                 - Access nested field using dot notation
       ~~S.totals.totalODBcost~~          - Example: access totals.totalODBcost

    2. Array Items (with slide replication):
       ~~S.items[N].database~~            - Replicates slide for each item in items[] array
       ~~S.infrastructure[N].hostname~~   - Replicates slide for each item in infrastructure[] array
       ~~S.consolidatedServers[N].name~~  - Replicates slide for each item in consolidatedServers[] array
       
       Note: [N] indicates current item during replication. Slides containing [N] patterns
             will be automatically duplicated once per array item.

    3. Specific Array Index:
       ~~S.items[0].database~~            - Access first item in items[] array
       ~~S.items[1].database~~            - Access second item in items[] array

    4. Table Replication:
       ~~S.items[N].assumptionsArray[TABLE].category~~
       
       Tables containing [TABLE] pattern will replicate rows for each item in the array.
       Use [TABLE] to reference the current array index during row replication.

    5. Charts:
       ~~CHART[N].CPU~~                   - Insert CPU chart for current item
       ~~CHART[N].Memory~~                - Insert Memory chart for current item
       ~~CHART[N].Throughput~~            - Insert Throughput chart for current item
       ~~CHART[N].IOPS~~                  - Insert IOPS chart for current item
       
       Chart parameters (optional, in any order inside {}):
         adjusted=true|false              - Use adjusted metrics (default: false)
         annotation=none|targetOnly|full  - Annotation level (default: full)
       
       Examples:
         ~~CHART[N].Throughput{adjusted=true}~~
         ~~CHART[N].IOPS{annotation=none}~~
         ~~CHART[N].Throughput{annotation=targetOnly, adjusted=true}~~
       
       Charts are generated via DBCSI API in parallel and inserted at placeholder location.
       Use --noCharts flag to skip chart generation.

    6. Special Patterns:
       ~~DATE~~                           - Insert current date (format: Month DD, YYYY)

    7. Conditional Slides:
       ~~IF(S.infrastructure[])~~         - Delete slide if infrastructure[] is empty,
                                            otherwise remove this placeholder shape
       ~~IF(S.consolidatedServers[])~~    - Delete slide if consolidatedServers[] is empty
       ~~IF(S.items[])~~                  - Delete slide if items[] is empty
       ~~IF(S.items[0].targetconfig_elasticache)~~ - Delete slide if items[0].targetconfig_elasticache is missing
       
       Note: Field existence checks work with any field path and any array index ([0], [1], [N], etc.)

EXAMPLES:
    # Basic usage
    python dbcsi_pptx_merge.py \\
        --scenario_json scenario_123.json \\
        --pptx_template template.pptx \\
        --output_pptx output.pptx

    # Skip charts
    python dbcsi_pptx_merge.py \\
        --scenario_json scenario_123.json \\
        --pptx_template template.pptx \\
        --output_pptx output.pptx \\
        --noCharts
                              </pre>
                           </b-card>
                          </div>
                        </b-list-group-item>                        
                      </b-list-group>
                            
                      </div>  
                    </b-modal>


                    <b-modal :id="`mBatch`" title="Create a new batch for selected databases" ok-only ok-title="Close Window" size="xl" @show="resetBatchModal">
                          <div style="margin: 15px">
                            <p style="font-size:14px">This feature lets you create a new Batch containing the {{this.countSelected}} databases you selected.</p>
                            <br/><br/>

                            <b-form>
                              

                             <div>
                                <b>Provide some details about this batch.</b>
                                <b-card bg-variant="light" class="text-left">
                  
                                    <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                                      <b-form-input
                                        id="customer"
                                        type="text"
                                        v-model="batchAdd.customer"
                                        required
                                        placeholder="Enter customer name."
                                        >
                                      </b-form-input>
                                    </b-form-group>
                  
                                    <b-form-group id="exampleInputGroup3" label="Batch Name:" label-for="batchname">
                                      <b-form-input
                                        id="batchname"
                                        type="text"
                                        v-model="batchAdd.batchname"
                                        required
                                        placeholder="Enter batch name."
                                      ></b-form-input>
                                    </b-form-group>
                  
                                   <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                                      <b-form-textarea
                                        id="descr"
                                        v-model="batchAdd.descr"
                                        required
                                        placeholder="Enter a description for this batch of databases."
                                        :rows="3"
                                        :max-rows="6"
                                      ></b-form-textarea>
                                    </b-form-group>
                              
                                </b-card>
                              </div>

                              <b-button :disabled="(this.batchAdd.customer=='') || (this.batchAdd.batchname=='')" v-if="(this.createBatchID=='') && (this.createBatchMessage=='')" @click="createBatch" variant="success">Create Batch</b-button>

                            </b-form>
                            <br/><br/>
                            {{this.createBatchMessage}}
                            <span v-if="this.createBatchID!=''">Batch created successfully.  &nbsp;
                              <a :href="`/batch/${this.createBatchID}`" target="_blank">Open your new batch in a new tab.</a>
                            </span>  
                      </div>  
                    </b-modal>   
                    
                    <b-modal :id="`mConsolidate`" title="Consolidate selected databases" ok-only ok-title="Close Window" size="xl" >
                          <div style="margin: 15px">
                            
                            <consolidatemodal 
                            :param_items="`${JSON.stringify(this.selectedItems)}`"
                            :user="user"
                          ></consolidatemodal>
                            <br/><br/>

                              
                      </div>  
                    </b-modal>  
                   
                  <br/><br/>
              
                  <span style="font-size:12px" v-for="(list, index) in disclaimerLists" :key="list">
                    <span>{{ list }}</span><br/>
                  </span>

                </div>
                
                </b-collapse>
                
                </b-card>
                  
              </div>

          </b-list-group-item>  






          <b-list-group-item variant="light" v-if="this.showRDSConsolidationFields && this.consolidatedServers.length > 0">

              <b-card v-if="this.showRDSConsolidationFields && this.consolidatedServers.length > 0"
          class="mb-1"
          border-variant="success"
          header-bg-variant="success"
          header-text-variant="white"
        >
                <template #header>
                  <div @click="rdsConsolidationCollapsed = !rdsConsolidationCollapsed" style="cursor: pointer;">
                    Consolidated RDS Instances (PREVIEW DBCSI FUNCTIONALITY)
                    <span class="float-right">{{ rdsConsolidationCollapsed ? '▶' : '▼' }}</span>
                  </div>
                </template>

                 <span v-if="(this.scenarioCount>0)"> <p/>
                   <span style="font-size:14px" v-for="(total, index) in this.totals" :key="total.scenarioName">
                          <span v-if="total.totalRDSConsolidatedCount*1>0">RDS Consolidation Totals for: <b>{{ total.scenarioName }}</b>.  Total Servers = {{total.totalRDSConsolidatedCount}} (was {{total.totalRDSCount}}).   Total VCPU = {{total.totalRDSConsolidatedVCPU}} (was {{total.totalRDSVCPU}}).   Total Monthly Estimate = $ {{total.totalRDSConsolidatedcost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}} (was $ {{total.totalRDScost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}})
                                  <span v-if="(total.totalUnshapedRDS>0)"><br/>(Note: there are {{total.totalUnshapedRDS}} databases that were not sized for RDS-Oracle and are not included in the above line's totals)</span>
                                <b-button v-if="showDBC" size="sm" variant="outline-info" v-b-modal="`mDBC${index}`" class="ml-2">TCO</b-button>
                                <br/>
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludePDB')">(Note: PDBs which overlap with a CDB in this batch are excluded from the above line's totals)<br/></span>   
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludeCDB')">(Note: CDBs which overlap with a PDB in this batch are excluded from the above line's totals)<br/></span>   
                               <hr style="border-top: 1px solid #ddd; margin: 5px 20px;"/>
                          </span>     
                   </span>            

                 </span>

                <b-collapse :visible="!rdsConsolidationCollapsed">
                <p/>
                <span style="font-size:14px">The table below shows the consolidated RDS instances.</span>
                <p/>   
                <div>  
                <b-pagination
                  :total-rows="consolidatedServers.length"
                  :per-page="perPage"
                  v-model="currentRDSConsolidationPage"
                  size="sm"
                  align="center"
                />
                <b-table
                  v-if="this.consolidatedServers.length > 0"
                  :per-page="perPage"
                  :current-page="currentRDSConsolidationPage"
                  striped
                  hover
                  responsive
                  bordered
                  small
                  :items="consolidatedServers"
                  :fields="consolidatedFields"
                  :sort-by.sync="consolidatedSortBy"
                >
                  <template #cell(scenarioName)="row">
                    <span v-if="row.item.scenarioName!=undefined" v-b-popover.hover="{title:`Scenario: ${escapeHtml(row.item.scenarioName)}`, content:`${row.item.assumptionsString}`, html: true}"><br/>({{row.item.scenarioName}})</span>
                    <span v-if="row.item.ReadReplica === 'Y'" style="color: blue; font-weight: bold; margin-left: 5px;"><br/><br/>[Replica in {{row.item.ReadReplicaRegion}}]</span>
                    
                    <span v-if="row.item.manual!=undefined && row.item.manual=='YES'"><br/>[Manual Edit]</span>
                  </template>  

                  <template  #cell(targetconfig_rds.monthly_estimate)="row">
                    <span  title="RDS Estimate" v-b-popover.hover="`${row.item.targetconfig_rds.summaryText}`" >{{ row.item.targetconfig_rds.monthly_estimate }}
                    </span>
                  </template> 
                  
                  <template  #cell(databases)="row">
                    <!--<span  title="Databases" v-b-popover.hover="`${row.item.databasesLong}`" >{{ row.item.databases }}-->
                    <!--</span>-->
                    <div v-for="item0 in row.item.databasesArray" :key="item0.row">
                      <!--<span  :title="item0.database" v-b-popover.hover="`${item0.target_vcpu} out of ${item0.shape_max_vcpu} VCPU used on a ${item0.shape}. [row ${item0.row}]`" >-->
                      <!--  {{ item0.database }}-->
                      <!--</span>-->
                      <span v-b-popover.hover="{title:`${item0.database}`, content:`${item0.description} <br/><br/>(host: ${item0.hostname}) <br/><br/>${item0.target_vcpu} out of ${item0.shape_max_vcpu} VCPU used on a ${item0.shape}. <br/><br/>${((item0.COUNT_PDBS==0) ? '' : ' PDBs='+item0.COUNT_PDBS+'<br/><br/>')} [row ${item0.row}]`, html: true}"  >{{ item0.database }}</span>
                      <br/><br/>
                    </div>   
                    <span v-if="row.item.COUNT_PDBS*1<=row.item.frozen_prefs.rdsConsolidation_maxPDBcount*1">PDBs={{row.item.COUNT_PDBS}}</span>
                    <span v-if="row.item.COUNT_PDBS*1>row.item.frozen_prefs.rdsConsolidation_maxPDBcount*1" v-b-popover.hover="`This server has ${row.item.COUNT_PDBS} PDBs, which is more than you requested.`" title="CDB"><img src="@/assets/warning.png" height="10px"></img> PDBs={{row.item.COUNT_PDBS}}</span>
                  </template> 
                  
                  
                  
                  <template  #cell(targetconfig_rds.shape)="row">
                     <span v-if="row.item.targetconfig_rds!=undefined" >
                        <img v-if="(row.item.Comments!=undefined)&&(row.item.Comments!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.Comments}`" title="Alerts"></img>
                        <span v-if="(row.item.Comments!=undefined)&&( (row.item.Comments=='[Setting target to EC2 when disk space is > 64000 GB] ') )" > <b>Disk Space ({{row.item.DiskSpace}} GB) more than 64TB.</b> </span>
                        <span v-if="(row.item.Comments!=undefined)&&(  (row.item.Comments=='[Setting target to EC2 when disk space is > 256000 GB] '))" > <b>Disk Space ({{row.item.DiskSpace}} GB) more than 256TB.</b> </span>
                        <span v-if="row.item.rds_shape!='N/A' && row.item.rds_type!='rac'"  v-b-popover.hover="{title:`${row.item.rds_shape}`, content:`Specifications: ${row.item.targetconfig_rds.match_string}.  <br/><br/>${row.item.targetconfig_rds.closeness_string =='' ? '' : '[ '+row.item.targetconfig_rds.closeness_string+' ]'} `, html: true}">{{ row.item.rds_shape }}</span>
                        <span v-if="row.item.rds_shape!='N/A' && row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='' && row.item.targetconfig_rds.rac_nodes!=undefined"  v-b-popover.hover="{title:`${row.item.targetconfig_rds.rac_nodes} Node Cluster of ${row.item.rds_shape}`, content:`${row.item.targetconfig_rds.rac_nodes} Node Cluster.<br/>Individual Node Specifications: ${row.item.targetconfig_rds.match_string}.  <br/><br/>${row.item.targetconfig_rds.closeness_string =='' ? '' : '[ '+row.item.targetconfig_rds.closeness_string+' ]'} `, html: true}">{{ row.item.rds_shape }} ({{ row.item.targetconfig_rds.rac_nodes }} nodes)</span>

                        
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' && row.item.rds_type!='custom'"> (MultiAZ)</span>
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type=='custom'" title="MultiAZ for RDS Custom" v-b-popover.hover="`This configuration is targetting a MultiAZ deployment.  For RDS Custom, it does not currently offer a managed MultiAZ topology so we are modeling a Data Guard Replica setup using 2 instances.  Therefore, the pricing shown reflects the cost of 2 identical instances (in other words, it is doubled).`"> (MultiAZ*)</span>
                        <span v-if="row.item.targetconfig_rds!=undefined  && row.item.rds_shape!='N/A' && row.item.targetconfig_rds.shape_max_vcpu != row.item.targetconfig_rds.shape_optimize_vcpu" size="sm" :title="`OptimizeCPU`" v-b-popover.hover="`OptimizeCPU feature considered when selecting the shape.  If you wish to ignore OptimizeCPU, use the Optimization Goal Preference drop-down to pick a different algorithm.`"> (OptimizeCPU: {{ row.item.targetconfig_rds.shape_max_vcpu }} to {{ row.item.targetconfig_rds.shape_optimize_vcpu }})</span> 
                        <span v-if="row.item.targetconfig_rds!=undefined   && row.item.rds_shape=='N/A'" v-b-popover.hover="{title:`Unable to Auto-Right-Size`, content:`Sorry, could not find an ${row.item.targetconfig_rds.rds_type_desc} configuration that meets all of your specifications.  <br/><br/>[ ${row.item.targetconfig_rds.closeness_string} ]`, html: true}" > 
                          <br/>
                          {{row.item.rds_type=="se" && (row.item.SE2_Comments!=undefined) && (row.item.SE2_Comments.indexOf("[SE2-LI ruled out")>0 ) ? row.item.SE2_Comments.substring( row.item.SE2_Comments.indexOf("[SE2-LI ruled out") ) :
                            "(Consider EC2 or ODB@AWS)" }}
                            
                        </span> 
                        <br/>
                        
                       <img v-if="(row.item.rds_type=='se')" src="@/assets/SE2LI.png" height="12px"></img>
                       <img v-if="(row.item.rds_type=='custom')" src="@/assets/RDSCustom.png" height="12px"></img>
                       <img v-if="(row.item.rds_type=='rac')" src="@/assets/RDSCustomRAC.png" height="12px"></img>
                       </span>



                    <span style="font-size:10px" v-if="(row.item.targetconfig_rds!=undefined && row.item.targetconfig_rds.BareMetalPossibilityComments)" v-b-popover.hover="{title:`Bare Metal Instance Possibility?`, content:`${row.item.targetconfig_rds.BareMetalPossibilityComments}<br/><br/>Refer to Oracle Cloud Policy and Oracle Core Factor Table, and consult your licensing partner to determine if you can reduce license and support costs. <a href='https://aws.amazon.com/blogs/database/getting-started-with-amazon-ec2-bare-metal-instances-for-amazon-rds-for-oracle-and-amazon-rds-custom-for-oracle/' target='_blank'>(blog)</a>`, html: true}" >
                      <br/><img  src="@/assets/BareMetalPossibility.png" height="18px"></img></br>
                    </span>
                   
                    <span style="font-size:10px" v-if="(row.item.targetconfig_rds!=undefined && row.item.targetconfig_rds.BareMetalProcessor)" v-b-popover.hover="{title:`Bare Metal Instance`, content:`This is a bare metal instance using the ${row.item.targetconfig_rds.BareMetalProcessor}<br/><br/>Refer to Oracle Cloud Policy and Oracle Core Factor Table, and consult your licensing partner to determine if you can reduce license and support costs. <a href='https://aws.amazon.com/blogs/database/getting-started-with-amazon-ec2-bare-metal-instances-for-amazon-rds-for-oracle-and-amazon-rds-custom-for-oracle/' target='_blank'>(blog)</a>`, html: true}" >
                      <br/><img  src="@/assets/BareMetal.png" height="18px"></img></br>
                    </span>


                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && !(row.item.targetconfig_rds.BareMetalProcessor) && row.item.optgoal_choice=='min_license'" title="Minimize Licensing" v-b-popover.hover="`Pick the shape that minimizes the number of VCPUs used in the configuration. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_max_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize Licensing (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span>

                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A'  && (row.item.targetconfig_rds.BareMetalProcessor) && row.item.optgoal_choice=='min_license'" title="Minimize Licensing" v-b-popover.hover="`Pick the shape that minimizes the number of Cores used in the configuration. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes /2 : 2 * row.item.targetconfig_rds.shape_max_vcpu/2  ) + ' Cores).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize Licensing (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes / 2: row.item.targetconfig_rds.shape_max_vcpu/2  ) +
                         " Core" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span>

                     
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && row.item.optgoal_choice=='min_cost'" title="Minimize AWS Spend" v-b-popover.hover="`Pick the shape that minimizes the AWS Spend even if it has more VCPUs than other shapes.  This is good for when you have an Unlimited License Agreement or you have a large pool of available licenses. ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_optimize_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: Minimize AWS Cost (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_max_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                    </span>
                     
                    <span v-if="row.item.targetconfig_rds!=undefined && row.item.rds_shape!='N/A' && row.item.optgoal_choice=='Y'" title="OptimizeCPU" v-b-popover.hover="`Use OptimizeCPU feature when picking RDS shape to minimize cost and provisioned VCPU.  Please consult with your license experts to decide if OptimizeCPU is a fit for your license/contract.  ${row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac'  ? '*This is a Multi-AZ configuration, so plan on licenses for both sides of the MultiAZ (' + ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? 2 * row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : 2 * row.item.targetconfig_rds.shape_optimize_vcpu  ) + ' VCPU).': ''}`" >
                      <br/>
                      {{ "Goal: OptimizeCPU (" + 
                         ( (row.item.rds_type=='rac' && row.item.targetconfig_rds.rac_nodes!='') ? row.item.targetconfig_rds.shape_max_vcpu * row.item.targetconfig_rds.rac_nodes : row.item.targetconfig_rds.shape_optimize_vcpu  ) +
                         " VCPU" + ( (row.item.UseMAZ=='Yes' && row.item.rds_shape!='N/A' && row.item.rds_type!='rac' ) ? '*' : '' ) + ")"  }}
                     </span> 

                  </template>
                  
                  
                  <template v-slot:cell(DiskSpace)="row">
                      {{ row.item.DiskSpace }}
                    <br/>
                      <img v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.diskspace_warnings!=undefined)&&(row.item.targetconfig_rds.diskspace_warnings!='')" src="@/assets/warning.png" height="20px" v-b-popover.hover="`${row.item.targetconfig_rds.diskspace_warnings}`" title="Alerts"></img>
                       <span style="font-size:14px" 
                          v-if="(row.item.targetconfig_rds!=undefined)&&(row.item.targetconfig_rds.AddlStorageVolumes!=undefined)&&(row.item.targetconfig_rds.AddlStorageVolumes>0)"
                          v-b-popover.hover="`${row.item.targetconfig_rds.ebsvol_warnings}`" title="Additional Storage Volumes">
                         <img src="@/assets/info.png" height="20px"></img>
                         ASVs({{row.item.targetconfig_rds.AddlStorageVolumes}})
                       </span>
                  </template>  


                </b-table>  
                
                <span style="font-size:12px" v-for="(list, index) in consolidatedServersDisclaimerLists" :key="list">
                                <span>{{ list }}</span><br/>
                
                  </span>

                </div>
                </b-collapse>
              </b-card>
              
              
          </b-list-group-item>  



          <b-list-group-item variant="light" v-if="this.showODBAWS && (this.infrastructure.length > 0) ">
             <div>              
                  

              <b-card v-if="this.showODBAWS && (this.infrastructure.length > 0) "
                  class="mb-1"
                  border-variant="success"
                  header-bg-variant="success"
                  header-text-variant="white"
                >
              
                <template #header>
                  <div @click="odbAwsCollapsed = !odbAwsCollapsed" style="cursor: pointer;">
                    Oracle Database@AWS Infrastructure
                    <span class="float-right">{{ odbAwsCollapsed ? '▶' : '▼' }}</span>
                    
                  </div>
                </template>

                 <span v-if="(this.scenarioCount>0)"> <p/>
                   <span style="font-size:14px" v-for="(total, index) in this.totals" :key="total.scenarioName">
                          <span v-if="total.totalODBUsage*1>0">ODB@AWS Totals for: <b>{{ total.scenarioName }}</b>.  Total {{total.totalODBUsageUnits}} = {{total.totalODBUsage}}.   Total Monthly Estimate = $ {{total.totalODBcost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                <b-button v-if="showDBC" size="sm" variant="outline-info" v-b-modal="`mDBC${index}`" class="ml-2">TCO</b-button>
                                <br/>
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludePDB')">(Note: PDBs which overlap with a CDB in this batch are excluded from the above line's totals)<br/></span>   
                               <span style="font-size:14px" v-if="pdb_and_cdb_pairs_in_batch && (total.pdb_and_cdb_algo == 'excludeCDB')">(Note: CDBs which overlap with a PDB in this batch are excluded from the above line's totals)<br/></span>   
                               <span style="font-size:14px" v-if="(total.readreplica_algo == 'Y')">(Note: RDS-Oracle Replicas added to this batch are excluded from the above line's totals)<br/></span>
                               <hr style="border-top: 1px solid #ddd; margin: 5px 20px;"/>
                          </span>     
                   </span>            

                 </span>

                <b-collapse :visible="!odbAwsCollapsed">
              <p/>
              <span style="font-size:14px">The table below shows the Oracle Database@AWS Infrastructure estimated by your algorithms.</span>
              <p/>   
                <div >  
                <b-table
                  v-if="this.showODBAWS && (this.infrastructure.length > 0) && (this.form.odbAWS_algo=='Y')"
                  striped
                  hover
                  responsive
                  bordered
                  small
                  :items="infrastructure"
                  :fields="infraFields"
                  :sort-by.sync="infraSortBy"
                >
                  <template #cell(row)="row">
                    <span v-b-popover.hover="{title:`Scenario: ${escapeHtml(row.item.scenarioName)}`, content:`${row.item.assumptionsString}`, html: true}">
                      {{row.item.row}}</span>
                    <span v-if="row.item.manual!=undefined && row.item.manual=='YES'"><br/>[Manual Edit]</span>
                    <span v-b-popover.hover="{title:`In-Region MultiAZ Role`, content:`This row represents the Dedicated Infrastructure for the ${row.item.role} AZ`, html: true}"><br/><br/>Role: {{row.item.role}}</span>
                  </template>  

                  <template #cell(service)="row">
                    <span v-if="row.item.service=='exacs-dedicated'" >
                      Exadata Database Service on Dedicated Infrastructure</span>
                    <span v-if="row.item.service=='adb-dedicated'" >
                      Autonomous Database on Dedicated Infrastructure</span>  
                    <span v-if="row.item.service=='exadb-xs'" >
                      Exadata Database Service on ExaScale Infrastructure</span>  
                      <br/>
                      <span style="font-size:8px">
                        <a href="https://www.oracle.com/cloud/aws/" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to Oracle's landing page for ODB@AWS.  You can find sub-pages for pricing, documentation, tutorials, etc.`, html: true}"  >Oracle's_Page</a>. 
                        <a v-if="row.item.service=='exacs-dedicated'" href="https://docs.oracle.com/en-us/iaas/exadatacloud/index.html" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to the Exadata Database Service - Dedicated documentations.`, html: true}"  >ExaCS-D_Docs</a>
                        <a v-if="row.item.service=='adb-dedicated'" href="https://docs.oracle.com/en/cloud/paas/autonomous-database/dedicated/adbaa/index.html" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to the Autonomous Database Service - Dedicated documentations.`, html: true}"  >ADB-D_Docs</a>
                        <a v-if="row.item.service=='exadb-xs'" href="https://docs.oracle.com/en-us/iaas/exadb-xs/index.html" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to the Exadata Database Service on ExaScale Infrastructure documentation.`, html: true}"  >ExaScale_Docs</a>
                        <br/>
                      </span>
                      <span style="font-size:8px">
                        <a href="https://docs.aws.amazon.com/odb/" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to AWS's documentation for the ODB@AWS offering.`, html: true}"  >AWS's_Docs</a><br/>
                      </span>
                      <span v-if="currentEmployee" style="font-size:8px">
                        <a href="https://aws.highspot.com/items/66db5049cab07d4364f3d794?lfrm=isd.9" target="_blank" v-b-popover.hover="{title:`ODB@AWS`, content:`This is a link to an AWS internal highspot page for the ODB@AWS offering.  This link does not appear for partners or customer users.`, html: true}"  >Internal_Page</a>
                      </span>                      
                  </template>  
                  
                  <template  #cell(monthly_estimate)="row">
                    <span  title="ODB@AWS Estimate" v-b-popover.hover="`${row.item.summaryText}`" >{{ row.item.monthly_estimate }}
                      <br/><br/>
                      {{ row.item.UsageUnits_billed }} {{ row.item.Usage_units }}<br/>{{ (row.item.licenseType=="BYOL" ? "BYOL" : "License Included") }}
                      <br/><br/>
                    </span>
                  </template> 

                  <template  #cell(dbservers)="row">
                    <span v-if="row.item.service!='exadb-xs'" >
                      {{ row.item.dbservers}}<br/>
                      <img src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`Totals across ${row.item.dbservers} nodes`, content:`${row.item.Usage_units}: ${row.item.UsageUnits_provisioned} provisioned out of ${row.item.UsageUnits_available} available. ${row.item.UsageUnits_billed} billable.<br/>Memory: ${row.item.Memory_target} GB provisioned out of ${row.item.Memory_available} available.<br/><br/>${row.item.Usage_comments}`, html: true}"></img>
                      <br/><br/>
                      {{ row.item.model }}
                    </span>
                    <span v-if="row.item.service=='exadb-xs'" >
                      {{ row.item.num_vms}} VMs ({{ row.item.ecpus_reserved_total }} ECPUs)<br/>
                      <img src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`ExaScale: ${row.item.num_vms} VMs x ${row.item.ecpus_per_vm} ECPUs/VM enabled`, content:`Total ECPUs: ${row.item.ecpus_reserved_total} reserved, ${row.item.ecpus_enabled_total} enabled (${row.item.UsageUnits_billed} billable).<br/>Memory: ${row.item.memory_total_gb} GB (${row.item.memory_per_vm_gb} GB/VM at 2.75 GB per reserved ECPU).<br/>VM Filesystem: ${row.item.vm_filesystem_per_vm_gb} GB/VM.<br/><br/>${row.item.Usage_comments}`, html: true}"></img>
                      <br/><br/>
                      {{ row.item.model }}
                    </span>
                  </template> 

                  <template  #cell(storageservers)="row">
                    <span v-if="row.item.service!='exadb-xs'" >
                      {{ row.item.storageservers}}<br/>
                      <img src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`Totals across ${row.item.storageservers} storage servers`, content:`Total Storage: ${row.item.storage_total_available} TB. <br/>DATA disk group: ${row.item.storage_data_dg} TB (${row.item.storage_target} GB needed/target). <br/>RECO disk group: ${row.item.storage_reco_dg} TB.<br/> SPARSE disk group: ${row.item.storage_sparse_dg} TB.<br/> <br/>${row.item.storage_comments}`, html: true}"></img>
                      <br/><br/>
                      
                      {{ row.item.model }}
                    </span>
                    <span v-if="row.item.service=='exadb-xs'" >
                      Vault<br/>
                      <img src="@/assets/info.png" height="20px" v-b-popover.hover="{title:`ExaScale Storage Vault`, content:`Database Storage: ${row.item.database_storage_gb} GB (target: ${row.item.storage_target} GB).<br/>Additional Flash Cache: ${row.item.additional_flash_cache_gb} GB.<br/><br/>${row.item.storage_comments}`, html: true}"></img>
                      <br/><br/>
                      {{ row.item.database_storage_gb }} GB
                    </span>
                  </template> 
                  
                  <template  #cell(UsageUnits_target)="row">
                    <span  >
                      {{ row.item.UsageUnits_target}} {{ row.item.Usage_units}}<br/>
                      <img v-if=" (row.item.Usage_comments!=undefined)&&(row.item.Usage_comments!='') " src="@/assets/info.png" height="20px" v-b-popover.hover="`${row.item.Usage_comments}`" title="Usage Comments"></img>
                    </span>
                  </template> 
                  
                  <template  #cell(Memory_target)="row">
                    <span  >
                      {{ row.item.Memory_target}}<br/>
                      <img v-if=" (row.item.Memory_comments!=undefined)&&(row.item.Memory_comments!='') " src="@/assets/info.png" height="20px" v-b-popover.hover="`${row.item.Memory_comments}`" title="Memory Comments"></img>
                    </span>
                  </template> 
                                    
                </b-table>  
                
                <span style="font-size:12px" v-for="(list, index) in infraDisclaimerLists" :key="list">
                                <span>{{ list }}</span><br/>
                </span>
                </div>
                </b-collapse>
              </b-card>


              </div>

          </b-list-group-item>  

            


        </b-list-group>
      </b-card>


      </b-form>
    </div>
  </div>
</template>

<script>
import { API, Auth } from "aws-amplify";
import axios from "axios";
import flatten from "flat";
import TimeChartContainer from "./TimeChartContainer.vue";
import TimeChartRACContainer from "./TimeChartRACContainer.vue";
import TimeChart2Container from "./TimeChart2Container.vue";
import TimeChart4Container from "./TimeChart4Container.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import GeneralInfoModal from "./GeneralInfoModal.vue";
import ConsolidateModal from "./ConsolidateModal.vue";
import ConfigurationDetailsModal from "./ConfigurationDetailsModal.vue";
import DBCModal from "./DBC_modal.vue";
import ExadataObservations from "./ExadataObservations.vue";
import {get_default_prefs} from "./dbcsi_external.js";
import {calculate_target_values} from "./dbcsi_external.js";
import {disclaimers} from "./dbcsi_external.js";
import {enrichBatchItemWithPopoverText} from "./dbcsi_external.js";
import {get_skip_shape_presets,resolve_skip_shape_filter,get_skip_shape_regex} from "./dbcsi_external.js";
import {calculate_ec2_config,pick_ec2_shape} from "./dbcsi_ec2.js";
import {calculate_rds_config,pick_rds_shape,pick_rac_shape} from "./dbcsi_rds.js";
import {calculate_consolidated_config} from "./dbcsi_rds_consolidation.js";
import {aggregate_database_targets,pick_exadata_shape,calculate_exadata_config,calculate_adbs_config,pick_exascale_shape,calculate_exascale_config} from "./dbcsi_exadata.js";
import {calculate_aurora_config,pick_aurora_shape} from "./dbcsi_aurora.js";
import {calculate_elasticache_config,pick_elasticache_shape} from "./dbcsi_elasticache.js";
import {calculate_ec2fsxn_config,pick_ec2fsxn_shape} from "./dbcsi_ec2fsxn.js";
import {calculateTotals} from "./dbcsi_sizing.js";
import {calculateDBC} from "./dbcsi_dbc.js";
import {MAT_FIELDS, build_mat_row} from "./dbcsi_mat_export.js";
import {build_atx_records} from "./dbcsi_atx_export.js";
import {getChartTag, getChartConfig} from "./chart_config.js";

export default {
  name: "app",
  components: {
    timechartcontainer: TimeChartContainer,
    timechartRACcontainer: TimeChartRACContainer,
    timechart2container: TimeChart2Container,
    timechart4container: TimeChart4Container,
    timebarchartncontainer: TimeBarChartNContainer,
    exadataobservations: ExadataObservations,
    generalinfomodal: GeneralInfoModal,
    consolidatemodal: ConsolidateModal,
    configurationdetailsmodal: ConfigurationDetailsModal,
    dbcmodal: DBCModal
  },
  async created() {    
  
    // get default prefs
    this.form = get_default_prefs();
    
    // make a copy of form as standard_form
    this.standard_form = JSON.parse(JSON.stringify(this.form));
    this.standard_form.rds_baremetal_ranking = "consider0.5";

    // is this shareMode?
    if ( (this.batch_id.substring(0,2)=="SD")  || (this.batch_id.substring(0,2)=="SB")) {
      console.log("shareMode");
      this.shareMode=true;
    }
    
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    this.email = name.attributes.email;
    this.company = this.email.split('@').pop();
    var mydomains = ["gmail.com","hotmail.com","outlook.com","amazon.com","yahoo.com"];
    if (mydomains.includes(this.company.toLowerCase() ) ) {
      this.company = ''; 
    }
    // how do I get the domain name from an email string
    
    
    // console.log("authenticated", this.user, name);
    //if we need email, it can be found at name.attributes.email
    
    await API.get(
        "dbcsiAPI",
        `/dbcsi/permissions`
      )
        .then(response => {
          if (response.data.racOK=="Y") {
            console.log("Authorized for RAC.");      
            // this.showRAC = true;
          }
          if (response.data.currentEmployee=="Y") {
            console.log("Current Employee.");      
            this.currentEmployee = true;
            this.showODBAWS = true;
            this.showDBC = true;
          }
          if (response.data.odbawsOK=="Y") {
            console.log("Authorized for ODB@AWS.");      
            this.showODBAWS = true;
          }
          if (response.data.dbcOK=="Y") {
            console.log("Authorized for DBC.");      
            this.showDBC = true;
          }
        })
        .catch(error => {
          console.log("Batch-permissions Error:", error);
        });

    if ( (["dbayardAWS","amzn~dbayard"].includes(this.user))  ) {
      // this.showRAC = true;
      this.showAsk = true;
      this.showBeta = true;
      this.showATX = true;
      this.showODBAWS = true;
      this.showDBC = true;
      this.showEC2 = false;
    }
    
    if ( (this.user=="sample")  ) {
      // this.showRAC = true;
      this.showAsk = false;
      // this.showODBAWS = false;
    }
    

    if (this.query!=undefined) {
      console.log("query", this.query);
      if ( (this.query.toLowerCase().indexOf("show_rac")>=0) || (this.query.toLowerCase().indexOf("showrac")>=0) ) {
        console.log("showRAC enabled");
        this.showRAC = true;
      }
      if ( (this.query.toLowerCase().indexOf("show_optcpu")>=0) || (this.query.toLowerCase().indexOf("showoptcpu")>=0) ) {
        console.log("showoptCPU enabled");
        this.showOptCPU = true;
      }
      if ( (this.query.toLowerCase().indexOf("show_beta")>=0) || (this.query.toLowerCase().indexOf("showbeta")>=0) ) {
        console.log("showBETA enabled");
        this.showBeta = true;
        this.showODBAWS = true;
        // Add Chinese regions to the region LOV when beta mode is enabled
        this.region_lov.push({ value: 'cn-north-1', text: 'cn-north-1 Beijing (Beta)' });
        this.region_lov.push({ value: 'cn-northwest-1', text: 'cn-northwest-1 Ningxia (Beta)' });
      }
      if ( (this.query.toLowerCase().indexOf("show_odb")>=0) || (this.query.toLowerCase().indexOf("showodb")>=0) ) {
        console.log("showODBAWS enabled");
        this.showODBAWS = true;
      }
      if ( (this.query.toLowerCase().indexOf("show_64tb")>=0) || (this.query.toLowerCase().indexOf("show64tb")>=0) ) {
        console.log("allow_big_storage enabled");
        this.form.asv_min_storage = 400;
      }
      if ( (this.query.toLowerCase().indexOf("show_ec2")>=0) || (this.query.toLowerCase().indexOf("showec2")>=0) ) {
        console.log("showEC2 enabled");
        this.showEC2 = true;
      }
      
    } 
    
    
    var tries = 3;
    let success=false;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/batch/${this.batch_id}`
      )
        .then(response => {
				// 	console.log("get batch success "+response.success, response.data, response.data[0].INSTANCENUMS);
				// 	console.log(JSON.stringify(response.data, null, 2));
					if (response.success) {
          this.batchItems = response.data;
          
          // Enrich batch items with popover text
          for (let i = 0; i < this.batchItems.length; i++) {
            this.batchItems[i] = enrichBatchItemWithPopoverText(this.batchItems[i], this.form);
            this.batchItems[i].frozen_prefs= this.form;
          }
          
          //if no rows, then not authorized
          if (this.batchItems.length==0) {
            console.log("Sorry, not authorized to view this batch/collection.  Routing back to main page.",this.batch_id);      
            this.$router.push('/');
          } 
          
          this.batchItemsOrigLength = this.batchItems.length;
 
          let AIXmsg=false;
          let SPARCmsg=false;
          let HPUXmsg=false;
          
          //are any of these batchItems non X86?
          for (var i of this.batchItems) {
            
            if (i.PLATFORM_NAME==undefined) {
              console.log("bad PLATFORM_NAME",i);
            }
            if (i.PLATFORM_NAME!=undefined && i.PLATFORM_NAME.includes('None')) {
              // console.log("assume PLATFORM_NAME of None is x86",i.collectionID);
              // i.PLATFORM_NAME = "Assume x86";
              this.showAlertNonX86 = true;
              this.alertTextNonX86 = "Warning: It is unknown if this is a X86 platform (for example, 10g databases do not report the platform).  If this is not X86, then please enter a CPU thread mapping ratio value.  " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
              this.NonX86Platform = "unknown platform";
            }   
            if (i.PLATFORM_NAME!=undefined && !i.PLATFORM_NAME.includes('x86') && !i.PLATFORM_NAME.includes('None')) {
              this.showAlertNonX86 = true;
              this.alertTextNonX86 = "Warning: Your batch contains non-x86 platforms.  Please enter a CPU thread mapping ratio value.  " + (this.currentEmployee ? "AWS Employees can watch https://broadcast.amazon.com/videos/398430 (internal) for more details." : "You can watch https://www.youtube.com/watch?v=fA8rKA1Sggs for more details.");
              this.NonX86Platform = i.PLATFORM_NAME;

              if (i.PLATFORM_NAME=="Solaris[tm]_OE_(64-bit)") {
                SPARCmsg=true;
              }

              if (i.PLATFORM_NAME=="AIX-Based_Systems_(64-bit)") {
                AIXmsg=true;
                this.showAIX = true;
                i.AIX_CPU_ADJUSTMENT_USED =i.AIX_CPU_ADJUSTMENT*1; 
                if (this.form.aix_algo=="old") {
                  i.AIX_CPU_ADJUSTMENT_USED =i.AIX_CPU_ADJUSTMENT*1; 
                } else if (this.form.aix_algo=="new") {
                  i.AIX_CPU_ADJUSTMENT_USED = (i.AIX_CPU_ADJUSTMENT*1) == 8 ? 4 : 2.5;
                } else if (this.form.aix_algo=="new2") {
                  i.AIX_CPU_ADJUSTMENT_USED =(i.AIX_CPU_ADJUSTMENT*1) == 8 ? 2.0 : 1.8;
                }   
              }              

              if (i.PLATFORM_NAME=="HP-UX_IA_(64-bit)") {
                HPUXmsg=true;
              }              
              //break;
            }
            if (i.Exadata=="Yes") {
              // ADP and ADW hide the fact that they are exadata!
              // so, we need to also check this after we get additional data points too
              this.IS_EXADATA = true;
              //break;
            }
            if (i.IS_PDB=="YES") {
              this.IS_PDB = true;
              this.showPDBalert = true;
              //break;
            }
            
            if (i.COUNT_PDBS*1<0) {
              i.COUNT_PDBS=0;
            }
            
            if (i.CONSOLIDATED_DATABASES*1>0) {
              i.CONSOLIDATED = "YES - contains " + i.CONSOLIDATED_DATABASES + " DBs";
            }
            
            // set batchURL and metricsURL variables
            i.batchURL = 'C' + i.collectionID;
            i.metricsURL = i.collectionID;
            
            if (this.shareMode) {
              i.batchURL = this.batch_id.substring(0,2) + this.batch_id.substring(2).split('-')[0] +'-' + i.collectionID;
              i.metricsURL = this.batch_id.substring(0,2) + this.batch_id.substring(2).split('-')[0] + '-' + i.collectionID;
            }
            
          }  //end for
          
          if (AIXmsg) {
            this.alertTextNonX86 += `  This batch contains one or more AIX platforms.  To account for differences in how AIX tracks CPU time (see https://ardentperf.com/2016/07/01/understanding-cpu-on-aix-power-smt-systems/), we will adjust the CPU Usage metric by an AIX Power SMT CPU Time Adjustment factor.  You should also enter a x86 CPU Thread Mapping Ratio value to account for relative performance between an AIX thread and an x86 thread.  Some suggested ratios values are Power6=1.6, Power7=2.1, Power8=2.5, Power9=1.8, Power10=1.3, Power11=1.15.`;
              this.form.cpu_thread_ratio = 2.5;
          }
          if (SPARCmsg) {
                this.alertTextNonX86 += `  This batch contains one or more SPARC platforms.  You should enter a x86 CPU Thread Mapping Ratio value to account for relative performance between a SPARC thread and an x86 thread.  Some suggested ratios values are T3=16.7, T5=5.9, M7=4.9, VII=3.7, X=1.8, XII=2.4.`;
                this.form.cpu_thread_ratio = 4.9;
          }
          if (HPUXmsg) {
                this.alertTextNonX86 += `  This batch contains one or more HPUX platforms.  You should enter a x86 CPU Thread Mapping Ratio value to account for relative performance between an Itanium thread and an x86 thread.  Some suggested ratios values are Itanium 2(9050)=3.4, Itanium (9140M)=2.8.`;
                this.form.cpu_thread_ratio = 3.4;
          }
          
          success=true;
          
					tries = 0;
					// console.log("get batch set batchItems:"+this.batchItems.length);
					}
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Batch-batchItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
      tries -= 1;
		}
		if (!success) {
		  this.batchItems[0].row='Error Loading??';
		}

    // is this a single database
    // singleDB = true;
    if ( (this.batchItems.length==1) && (this.batchItems[0].row!='Loading...') && (this.batchItems[0].row!='Error Loading??') ){
      this.singleDB = true;
          // fetch genItems
          
      tries = 2;
      while (tries > 0) {
        await API.get(
          "dbcsiAPI",
          `/dbcsi/${this.batchItems[0].collectionID}/ora_v1`
        )
          .then(response => {
            
            this.genItems = response.data;
            
            
            for (var ii = 0; ii < this.genItems.length; ii++) {
               
              //hide socket values
              if ((this.genItems[ii].name == "!CPU_SOCKET_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_SOCKET_COUNT") ||(this.genItems[ii].name == "NUM_CPU_SOCKETS")  ) {
                this.genItems.splice(ii,1);
                ii--;
              } else if ( this.genItems[ii].name.startsWith("DEBUG")  ) {
                this.genItems.splice(ii,1);
                ii--;
              } else if ( this.genItems[ii].name.startsWith("DB_") && this.genItems[ii].name!="DB_NAME"  ) {
                this.genItems.splice(ii,1);
                ii--;
              }
            
            }
            
  
            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("Batch-GeneralItems Error:", error);
            console.log("Will retry.  Attempts Left:", (tries-1));
          });
  
        tries -= 1;
      }
      
          // add row for SE2_ANALYSIS
          this.genItems.push({name: "SE2_ANALYSIS", value: ""});

          
          
          
    } else {
      this.singleDB = false;
    }

    
    

    // now load Region info
    await axios
      .get("/db-us-east-1.json")
      .then(response => {
        // console.log("I am here4");
        this.regionInfo = response.data;
      })
      .catch(error => {
        console.log("Batch-Load regionInfo data Error:", error);
      });
      
    // now load Region info
    await axios
      .get("/db-us-west-2.json")
      .then(response => {
        // console.log("I am here4");
        this.DRregionInfo = response.data;
      })
      .catch(error => {
        console.log("Batch-Load DRregionInfo data Error:", error);
      });
      
    // populate shape LOVs
    this.populateShapeLovs("ee");
    this.populateShapeLovs("se");
    this.populateShapeLovs("custom");
    this.populateShapeLovs("rac");
    this.populateShapeLovs("ec2BM");
    this.populateShapeLovs("ec2");

    // console.log("I am here4");
  },
  props: ["batch_id", "query"],
  data() {
    return {
      downloadingPPTXJSON: false,
      // Server-side PowerPoint generation (dbcsiPPTXlambda) state
      pptxMode: 'server',      // 'server' | 'client'
      generatingPPTX: false,
      pptxNoCharts: false,
      pptxStatus: null,        // null | 'running' | 'ready' | 'failed'
      pptxError: null,
      pptxDownloadUrl: null,
      pptxChartsDisabled: false,
      pptxPollTimer: null,
      generatedSharingURL: '',
      user: '',
      email: '',
      company: '',
      question: '',
      lastQuestion: '',
      disclaimerLists: [],
      infraDisclaimerLists: [],
      consolidatedServersDisclaimerLists: [],
      singleDB: false,
      rdsShapesEE_lov: [
{ value: 'r6i.large', text: 'db.r6i.large' },
        ],
      rdsShapesSE_lov: [
{ value: 'r6i.large', text: 'db.r6i.large' },
        ],
      rdsShapesCustom_lov: [
{ value: 'r6i.large', text: 'db.r6i.large' },
        ],
      rdsShapesRAC_lov: [
{ value: 'r6i.large', text: 'db.r6i.large' },
        ],
      ec2BMShapes_lov: [
{ value: 'r6i.metal', text: 'r6i.metal' },
        ],  
      ec2Shapes_lov: [
{ value: 'r6i.large', text: 'r6i.large' },
        ],  
      csv_format: "detail",  
      csv_lov: [
{ value: 'detail', text: 'DETAIL format - includes full set of columns.  Also use this for input to the DBC tool.' },
{ value: 'alt-1', text: 'ALTERNATE-1 format - smaller set of columns.'  },
{ value: 'mat', text: 'Migrations Acceleration Toolkit (MAT) CSV format - one row per database. Data DBCSI does not collect is left empty.'  }
],
      matGenInfo: {},
      matLoading: false,
      showATX: false,
      selectedATXScenario: null,
      atxExcludeOverlaps: true,
      selectedPPTXScenario: null,
      regionCode: "us-east-1",
      DRregionCode: "us-west-2",
      region_lov: [
{ value: 'af-south-1', text: 'af-south-1 Cape Town' },
{ value: 'ap-east-1', text: 'ap-east-1 Hong Kong'  },
{ value: 'ap-east-2', text: 'ap-east-1 Taipei'  },
{ value: 'ap-northeast-1', text: 'ap-northeast-1 Tokyo'  },
{ value: 'ap-northeast-2', text: 'ap-northeast-2 Seoul'  },
{ value: 'ap-northeast-3', text: 'ap-northeast-3 Osaka'  },
{ value: 'ap-south-1', text: 'ap-south-1 Mumbai'  },
{ value: 'ap-south-2', text: 'ap-south-2 Hyderabad'  },
{ value: 'ap-southeast-1', text: 'ap-southeast-1 Singapore'  },
{ value: 'ap-southeast-2', text: 'ap-southeast-2 Sydney'  },
{ value: 'ap-southeast-3', text: 'ap-southeast-3 Jakarta'  },
{ value: 'ap-southeast-4', text: 'ap-southeast-4 Melbourne'  },
{ value: 'ap-southeast-5', text: 'ap-southeast-5 Malaysia'  },
{ value: 'ap-southeast-6', text: 'ap-southeast-6 New Zealand'  },
{ value: 'ap-southeast-7', text: 'ap-southeast-7 Thailand'  },
{ value: 'ca-central-1', text: 'ca-central-1 Canada' },
{ value: 'ca-west-1', text: 'ca-west-1 Calgary' },
{ value: 'eu-central-1', text: 'eu-central-1 Frankfurt'  },
{ value: 'eu-central-2', text: 'eu-central-2 Zurich'  },
{ value: 'eu-north-1', text: 'eu-north-1 Stockholm'  },
{ value: 'eu-south-1', text: 'eu-south-1 Milan'  },
{ value: 'eu-south-2', text: 'eu-south-2 Spain'  },
{ value: 'eu-west-1', text: 'eu-west-1 Ireland' },
{ value: 'eu-west-2', text: 'eu-west-2 London'  },
{ value: 'eu-west-3', text: 'eu-west-3 Paris'  },
{ value: 'il-central-1', text: 'il-central-1 Tel Aviv'  },
{ value: 'me-central-1', text: 'me-central-1 UAE'  },
{ value: 'me-south-1', text: 'me-south-1 Bahrain'  },
{ value: 'mx-central-1', text: 'mx-central-1 Mexico'  },
{ value: 'sa-east-1', text: 'sa-east-1 Sao Paulo' },
{ value: 'us-east-1', text: 'us-east-1 N.Virginia' },
{ value: 'us-east-2', text: 'us-east-2 Ohio'  },
{ value: 'us-gov-east-1', text: 'us-gov-east-1 GovCloud US-East'  },
{ value: 'us-gov-west-1', text: 'us-gov-west-1 GovCloud US-West'  },
{ value: 'us-west-1', text: 'us-west-1 N.California'  },
{ value: 'us-west-2', text: 'us-west-2 Oregon'  }
],
      regionInfo: {region: "us-east-1", lastUpdate: "August 2, 2022"},
      DRregionInfo: {region: "us-west-2", lastUpdate: "August 2, 2022"},
      infrastructure: [],  
      consolidatedServers: [],
      flatInfrastructure: [],
      flatConsolidatedServers: [],
      scenarioCount: 0,
      scenarioName: "base",
      scenarioSelected: "",
      shareMode: false,
      scenarios: [],
      genItems: [{ name: "Retrieving Data..." }],
      currentEmployee: false,
      createBatchMessage: "",
      createBatchID: "",
      showRAC: false,
      showEC2: false,
      showOptCPU: false,
      showODBAWS: true,
      showAsk: true,
      showBeta: false,
      showDBC: false,
      showECfields: false,
      showAurorafields: false,
      showADBSfields: false,
      showRDSfields: false,
      showODBfields: false,
      showRDSConsolidationFields: false,
      databasesCollapsed: false,
      databaseDetailsCollapsed: false,
      addlControlsCollapsed: true,
      algorithmsCollapsed: false,
      scenariosCollapsed: false,
      rdsConsolidationCollapsed: false,
      odbAwsCollapsed: false,
      showec2fsxnfields: false,
      showec2fields: false,
      showAlert: false,
      showAlertNonX86: false,
      showAIX: false,
      totals: [],
      batchAdd: {
        customer: "",
        batchname: "",
        descr: ""
      },
      IS_EXADATA: false,
      IS_PDB: false,
      // showAdjustedIO: false,
      showAlertRecalc: false,
      showAlertPrint: false,
      disableScenarioButton: false,
      triggerFullRecalculateFlag: true,
      // Skip Shape Filter presets; the chosen key is stored in form.rdsSkipShape_preset
      skipShapePresets: get_skip_shape_presets(),
      showPDBalert: false,
      NonX86Platform: "",
      pdb_and_cdb_pairs_in_batch: false,
      duplicate_databases_in_batch: false,
      alertText: "",
      alertTextNonX86: "",
      alertTextRecalc: "",
      alertTextPrint: "",
      alertStyle: "default",
      alertStyleRecalc: "default",
      alertStylePrint: "default",
      standard_form: {},
      form: {},
      comments: {
        General: "",
        DiskSpace: "",
        CPU: "",
        Memory: "",
        IO: "",
        Backup: "",
        EC2: "",
        RDS: "",
        Waits: "",
        Exadata: "",
        Aurora: ""
			},		
      batchItems: [{row: "Loading...", VERSION:"21", PLATFORM_NAME: "Linux_x86_64-bit", frozen_prefs: {smartscan_algo: "ss0"}}],
      batchItemsOrigLength: 0,
      batchItemsHasASVs: 'N',
      flatItems: [{ database: "Please Create a New Scenario first in order to download the CSV ..." } ],
      infraSortBy: "row",
      consolidatedSortBy: "server",
      inputSortBy: "row",
      outputSortBy: "row",
      UseMAZ: "No",
      selected: [],
      rdsSelected: [],
      auroraSelected: [],
      currentInputPage: 1,
      currentRDSConsolidationPage: 1,
      perPage: 10,
      selectedScenarioFilter: "",
      hideDuplicates: false,
      currentOutputPage: 1,
      ask_querytype: "empty",
      infrastructureFields: [
            'dbcsiURL',
            'row',
            'scenarioName',
            'manual',
            'service',
            'model',
            'role',
            'dbservers',
            'storageservers',
            'Usage_units',
            'UsageUnits_target',
            'UsageUnits_billed',
            'UsageUnits_provisioned',
            'UsageUnits_available',
            'VCPU_total',
            'Memory_target',
            'Memory_available',
            'IOPS_target',
            'Throughput_target',
            'storage_target',
            'storage_total_available',
            'storage_data_dg',
            'storage_reco_dg',
            'storage_sparse_dg',
            'storage_style',
            'num_vms',
            'ecpus_per_vm',
            'ecpus_enabled_total',
            'ecpus_reserved_per_vm',
            'ecpus_reserved_total',
            'memory_per_vm_gb',
            'memory_total_gb',
            'vm_filesystem_per_vm_gb',
            'database_storage_gb',
            'additional_flash_cache_gb',
            'DR',
            'licenseType',
            'licenseText',
            'dbserver_cost',
            'storage_cost',
            'Usage_cost',
            'rdma_cost',
            'ecpu_cost',
            'db_storage_cost',
            'vm_fs_cost',
            'flash_cache_cost',
            'monthly_estimate',
            'specificationText',
            'summaryText',
            'Usage_comments',
            'Memory_comments',
            'storage_comments',
            'assumptionsString'
          ],
      infrastructureLabels: {
            'dbcsiURL': 'DBCSI URL',
            'row': 'Scenario Type',
            'scenarioName': 'Scenario Name',
            'manual': 'Manual Configuration',
            'service': 'Service Type',
            'model': 'Model',
            'role': 'Role',
            'dbservers': 'Database Servers',
            'storageservers': 'Storage Servers',
            'Usage_units': 'Usage Unit Type',
            'UsageUnits_target': 'Target Usage Units',
            'UsageUnits_provisioned': 'Provisioned Usage Units',
            'UsageUnits_billed': 'Billed Usage Units',
            'UsageUnits_available': 'Available Usage Units',
            'VCPU_total': 'Total VCPUs',
            'Memory_target': 'Target Memory (GB)',
            'Memory_available': 'Available Memory (GB)',
            'IOPS_target': 'Target IOPS',
            'Throughput_target': 'Target Throughput',
            'storage_target': 'Target Storage (GB)',
            'storage_total_available': 'Total Available Storage (TB)',
            'storage_data_dg': 'Data Diskgroup Size (TB)',
            'storage_reco_dg': 'RECO Diskgroup Size (TB)',
            'storage_sparse_dg': 'Sparse Diskgroup Size (TB)',
            'storage_style': 'Storage Style',
            'num_vms': 'Number of VMs (ExaScale)',
            'ecpus_per_vm': 'Enabled ECPUs per VM (ExaScale)',
            'ecpus_enabled_total': 'Total Enabled ECPUs (ExaScale)',
            'ecpus_reserved_per_vm': 'Reserved ECPUs per VM (ExaScale)',
            'ecpus_reserved_total': 'Total Reserved ECPUs (ExaScale)',
            'memory_per_vm_gb': 'Memory per VM GB (ExaScale)',
            'memory_total_gb': 'Total Memory GB (ExaScale)',
            'vm_filesystem_per_vm_gb': 'VM Filesystem per VM GB (ExaScale)',
            'database_storage_gb': 'Database Storage GB (ExaScale)',
            'additional_flash_cache_gb': 'Additional Flash Cache GB (ExaScale)',
            'DR': 'Disaster Recovery',
            'licenseType': 'License Type',
            'licenseText': 'License Details',
            'dbserver_cost': 'Database Server Cost',
            'storage_cost': 'Storage Cost',
            'Usage_cost': 'Usage Cost',
            'rdma_cost': 'RDMA Compute Cost (ExaScale)',
            'ecpu_cost': 'ECPU Cost (ExaScale)',
            'db_storage_cost': 'Database Storage Cost (ExaScale)',
            'vm_fs_cost': 'VM Filesystem Cost (ExaScale)',
            'flash_cache_cost': 'Flash Cache Cost (ExaScale)',
            'monthly_estimate': 'Monthly Cost Estimate',
            'specificationText': 'Specification Details',
            'summaryText': 'Summary',
            'Usage_comments': 'Usage Comments',
            'Memory_comments': 'Memory Comments',
            'storage_comments': 'Storage Comments',
            'assumptionsString': 'Assumptions'
        },
      consolidatedServerFields: [
            'dbcsiURL',
            'scenarioName',
            'manual',
            'server',
            'UseMAZ',
          'databases',
          'databasesLong',
            'VCPU',
            'Memory',
            'Throughput',
             'IOPS',
            'DiskSpace',
            'COUNT_PDBS',
          'consolidationString',            
          'orig_VCPU_shape',
          'orig_monthly_estimate',
            'targetconfig_rds.shape',
            'targetconfig_rds.Summary',
            "rds_type",
            "RDSbenefits",
            "targetconfig_rds.summaryText",
            "rds_shape",

            "VolumeType",

            "targetconfig_rds.monthly_estimate",
            "targetconfig_rds.shape_cost",
            "targetconfig_rds.ebs_data_cost",
   
            "targetconfig_rds.shape_summaryText",
            "targetconfig_rds.ebs_data_summaryText1",
            "targetconfig_rds.ebs_data_summaryText2",
            "targetconfig_rds.license_summaryText",   

            "targetconfig_rds.shape_max_vcpu",
            "targetconfig_rds.shape_max_vcpu_with_multiAZ",            
            "addlMaxVCPU",


            "targetconfig_rds.cpu_warnings_alert",
            "targetconfig_rds.cpu_warnings_burst",
            "targetconfig_rds.cpu_warnings_info",
            "cpu_target_comments",

            
            "targetconfig_rds.shape_memory",
            "addlMemory",
        
            "targetconfig_rds.InstanceStorage",
            "targetconfig_rds.memory_warnings_alert",
            "memory_target_comments",
            

            
            "targetconfig_rds.shape_throughput","targetconfig_rds.shape_baselinethroughput",
            "targetconfig_rds.ebs_burst_Throughput","targetconfig_rds.ebs_baseline_Throughput",

            "addlThroughput",
            "OrigThroughput", //Exadata original throughput

            "targetconfig_rds.iomb_warnings_alert",
            "targetconfig_rds.iomb_warnings_burst",
            "targetconfig_rds.iomb_warnings_info",
            "iomb_target_comments",
            
            "targetconfig_rds.shape_IOPS","targetconfig_rds.shape_baselineIOPS",
            "targetconfig_rds.ebs_burst_IOPS","targetconfig_rds.ebs_baseline_IOPS",

            "addlBurstIOPS",
            "OrigIOPS",
            "targetconfig_rds.iops_warnings_alert",
            "targetconfig_rds.iops_warnings_burst",
            "targetconfig_rds.iops_warnings_info",
            "iops_target_comments",


            "addlVolumes",
            "targetconfig_rds.AddlStorageVolumes",
            "targetconfig_rds.diskspace_warnings",
            "targetconfig_rds.ebsvol_warnings",

           //  "targetconfig_rds.shape_OD","targetconfig_rds.shape_RI", "targetconfig_rds.shape_RI_SE2", 
            "targetconfig_rds.closeness_string",
            'assumptionsString',
            "ReadReplica",
            "ReadReplicaRegion"
          ],
      consolidatedServerLabels: {
            'dbcsiURL': 'DBCSI URL',
            'row': 'Scenario Type',
            'server': 'Server',
            'databases': 'Databases',
            'databasesLong': 'Databases Details',
            'consolidationString': 'Consolidation Summary',
            'COUNT_PDBS' : 'Total PDBs', 
             'orig_VCPU_shape' : 'Pre-Consolidation VCPU Provisioned',
             'orig_monthly_estimate' : 'Pre-Consolidation Monthly Estimate',
            'scenarioName': 'Scenario Name',
            'manual': 'Manual Configuration',
            'Memory_available': 'Available Memory (GB)',
            'monthly_estimate': 'Monthly Cost Estimate',
            'targetconfig_rds.shape' : 'Server Shape',
            'summaryText': 'Summary',
            "VCPU":"VCPU Target",
            "DiskSpace":"DiskSpace Target",
            "IOPS":"IOPS Target",
            "Throughput":"Throughput Target",
            "Memory":"Memory Target",
            "VolumeType":"Storage Type Used",
            "addlVolumes": "Additional Storage Info",
            "UseMAZ": "Multi-AZ ?",
            "cdb_target_comments": "PDB Comments",
            "cpu_target_comments": "CPU Comments4",
            "targetconfig_rds.cpu_warnings_alert": "CPU Comments",      
            "targetconfig_rds.cpu_warnings_burst": "CPU Comments2",      
            "targetconfig_rds.cpu_warnings_info": "CPU Comments3",      
            "memory_target_comments": "Memory Comments2",
            "targetconfig_rds.memory_warnings_alert": "Memory Comments",      
            
            "targetconfig_rds.ebs_burst_Throughput": "EBS Storage Max Throughput",
            "OrigThroughput": "Throughput on Exadata (if Exadata)",
            "OrigIOPS": "IOPS on Exadata (if Exadata)",
            "targetconfig_rds.diskspace_warnings": "Storage Comments",
            "targetconfig_rds.ebsvol_warnings": "Storage Comments2",
            "rds_shape":"RDS-Oracle Shape",

            "targetconfig_rds.summaryText":"RDS Overall Summary",


            "RDSbenefits":"RDS Managed Database Benefits",
            "targetconfig_rds.monthly_estimate":"RDS Monthly Estimate - Total",
            "targetconfig_rds.shape_OD":"Reference - On-Demand Rate for RDS Shape BYOL singleAZ",
            "targetconfig_rds.shape_RI":"Reference - Hourly Rate for RDS Shape BYOL singleAZ - uses RI if avail",
            "targetconfig_rds.shape_RI_SE2":"Reference - Hourly Rate for RDS Shape SE2-LI singleAZ - uses RI if avail",
            "targetconfig_rds.shape_max_vcpu":"RDS Shape VCPU",
            "targetconfig_rds.shape_optimize_vcpu":"RDS Shape Optimize VCPU (if used)",
            "targetconfig_rds.shape_memory":"RDS Shape Memory",
            "targetconfig_rds.shape_throughput":"RDS Shape Max Throughput",
            "targetconfig_rds.shape_summaryText":"RDS Shape Summary",
            "targetconfig_rds.shape_cost":"RDS Shape Cost",
            "targetconfig_rds.ebs_data_summaryText1":"RDS Storage Summary1",
            "targetconfig_rds.ebs_data_summaryText2":"RDS Storage Summary2",
            "targetconfig_rds.ebs_data_cost":"RDS Storage Cost",
            "targetconfig_rds.license_summaryText":"RDS License Estimation",
            "targetconfig_rds.iomb_warnings_alert":"Throughput Comments",
            "targetconfig_rds.iomb_warnings_burst":"Throughput Comments2",
            "targetconfig_rds.iomb_warnings_info":"Throughput Comments3",
            "iomb_target_comments": "Throughput Comments4",
            "targetconfig_rds.iops_warnings_alert":"IOPS Comments",
            "targetconfig_rds.iops_warnings_burst":"IOPS Comments2",
            "targetconfig_rds.iops_warnings_info":"IOPS Comments3",
            "iops_target_comments": "IOPS Comments4",

            "extraInfo":"Consider PostgreSQL",
            "extraInfo2":"EEtoSE2 Comments",

             "addlMaxVCPU":"Additional VCPU Available","addlOptimVCPU":"Additional Optimize VCPU Provisioned",
             "addlMemory":"Additional Memory Provisioned",
             "targetconfig_rds.InstanceStorage":"RDS Shape Instance Storage",
             "targetconfig_rds.shape_baselinethroughput":"RDS Shape Baseline Throughput if bursting",
             "targetconfig_rds.ebs_baseline_Throughput": "EBS Storage Baseline Throughput if bursting",
             "targetconfig_rds.shape_baselineIOPS":"RDS Shape Baseline IOPS if bursting",
             "targetconfig_rds.shape_IOPS":"RDS Shape Maximum IOPS",
             "addlThroughput":"Additional Throughput","addlBaselineThroughput":"Additional Baseline Throughput",
             "addlBurstIOPS":"Additional IOPS","addlBaselineIOPS":"Additional Baseline IOPS",
             "targetconfig_rds.ebs_burst_IOPS":"EBS Storage Max IOPS","targetconfig_rds.ebs_baseline_IOPS":"EBS Storage Baseline IOPS if bursting",

            "targetconfig_rds.closeness_string": "RDS Next Closest Shape",


            "optimizationGoalSuggestion": "Optimization Goal Suggestion",

            "targetconfig_rds.BareMetalProcessor": "Bare Metal Processor",
            
            'assumptionsString': 'Assumptions',
            "ReadReplica": "RDS-Oracle Replica?",
            "ReadReplicaRegion": "Replica Region",
            "targetconfig_rds.shape_max_vcpu_with_multiAZ": "RDS Shape VCPU with MultiAZ",
            "targetconfig_rds.AddlStorageVolumes": "Additional Storage Volumes"
        },
      csvLabels: {
            "batchID":"Batch",
            "row":"Row",
            "scenarioName": "Scenario",
            "manual": "ManualEdit?",
            "rds_type": "RDS Type",
            "assumptionsString": "Assumptions",
            "database":"Database",
            "CONSOLIDATED":"New Consolidated DB?",
            "description": "Description",
            "url":"DBCSI url",
            "VERSION":"Version",
            "NUM_INSTANCES": "Instances (on-prem)",
            "BANNER": "Banner",
            "DB_UNIQUE_NAME": "DB Unique Name",
            "NUM_CPUS": "NUM_CPUS (on-prem)",
            "NUM_CPU_CORES": "NUM_CPU_CORES (on-prem)",
            "rac_nodes": "Instances (RDS)",
            "hostname":"Hosts",
            "Exadata":"Exadata",
            "VCPU":"VCPU Target",
            "DiskSpace":"DiskSpace Target",
            "IOPS":"IOPS Target",
            "Throughput":"Throughput Target",
            "Memory":"Memory Target",
            "VolumeType":"Storage Type Used",
            "addlVolumes": "Additional Storage Info",
            "UseMAZ": "Multi-AZ ?",
            "cdb_target_comments": "PDB Comments",
            "cpu_target_comments": "CPU Comments4",
            "targetconfig_rds.cpu_warnings_alert": "CPU Comments",      
            "targetconfig_rds.cpu_warnings_burst": "CPU Comments2",      
            "targetconfig_rds.cpu_warnings_info": "CPU Comments3",      
            "memory_target_comments": "Memory Comments2",
            "targetconfig_rds.memory_warnings_alert": "Memory Comments",      
            
            "targetconfig_rds.ebs_burst_Throughput": "EBS Storage Max Throughput",
            "OrigThroughput": "Throughput on Exadata (if Exadata)",
            "OrigIOPS": "IOPS on Exadata (if Exadata)",
            "targetconfig_rds.diskspace_warnings": "Storage Comments",
            "targetconfig_rds.ebsvol_warnings": "Storage Comments2",
            "rds_shape":"RDS-Oracle Shape",
                        "aurora_shape":"Aurora Shape",
                        "targetconfig_aurora.dummy":" ",
            "targetconfig_rds.summaryText":"RDS Overall Summary",
                        "targetconfig_aurora.summaryText":"Aurora Overall Summary",
            "TargetPlatform":"Target Service",
            "RDSbenefits":"RDS Managed Database Benefits",
            "targetconfig_rds.monthly_estimate":"RDS Monthly Estimate - Total",
            "targetconfig_rds.shape_OD":"Reference - On-Demand Rate for RDS Shape BYOL singleAZ",
            "targetconfig_rds.shape_RI":"Reference - Hourly Rate for RDS Shape BYOL singleAZ - uses RI if avail",
            "targetconfig_rds.shape_RI_SE2":"Reference - Hourly Rate for RDS Shape SE2-LI singleAZ - uses RI if avail",
            "targetconfig_rds.shape_max_vcpu":"RDS Shape VCPU",
            "targetconfig_rds.shape_optimize_vcpu":"RDS Shape Optimize VCPU (if used)",
            "targetconfig_rds.shape_memory":"RDS Shape Memory",
            "targetconfig_rds.shape_throughput":"RDS Shape Max Throughput",
            "targetconfig_rds.shape_summaryText":"RDS Shape Summary",
            "targetconfig_rds.shape_cost":"RDS Shape Cost",
            "targetconfig_rds.ebs_data_summaryText1":"RDS Storage Summary1",
            "targetconfig_rds.ebs_data_summaryText2":"RDS Storage Summary2",
            "targetconfig_rds.ebs_data_cost":"RDS Storage Cost",
            "targetconfig_rds.license_summaryText":"RDS License Estimation",
            "targetconfig_rds.iomb_warnings_alert":"Throughput Comments",
            "targetconfig_rds.iomb_warnings_burst":"Throughput Comments2",
            "targetconfig_rds.iomb_warnings_info":"Throughput Comments3",
            "iomb_target_comments": "Throughput Comments4",
            "targetconfig_rds.iops_warnings_alert":"IOPS Comments",
            "targetconfig_rds.iops_warnings_burst":"IOPS Comments2",
            "targetconfig_rds.iops_warnings_info":"IOPS Comments3",
            "iops_target_comments": "IOPS Comments4",
            "COUNT_LINES_PLSQL": "Lines of PLSQL",
            "COUNT_PDBS": "Number of PDBs",
            "extraInfo":"Consider PostgreSQL",
            "extraInfo2":"EEtoSE2 Comments",
            "considerSE2": "Consider SE2",
            "PLATFORM_NAME":"Platform",
            "INSTANCES":"Instances (RAC)",
            "current_hw_consolidation":"Current HW Likely Consolidated?",
            "current_hw_cpu":"Current HW CPU Threads",
            "current_hw_memory":"Current HW Memory",
             "addlMaxVCPU":"Additional VCPU Available","addlOptimVCPU":"Additional Optimize VCPU Provisioned",
             "addlMemory":"Additional Memory Provisioned",
             "targetconfig_rds.InstanceStorage":"RDS Shape Instance Storage",
             "targetconfig_rds.shape_baselinethroughput":"RDS Shape Baseline Throughput if bursting",
             "targetconfig_rds.ebs_baseline_Throughput": "EBS Storage Baseline Throughput if bursting",
             "targetconfig_rds.shape_baselineIOPS":"RDS Shape Baseline IOPS if bursting",
             "targetconfig_rds.shape_IOPS":"RDS Shape Maximum IOPS",
             "addlThroughput":"Additional Throughput","addlBaselineThroughput":"Additional Baseline Throughput",
             "addlBurstIOPS":"Additional IOPS","addlBaselineIOPS":"Additional Baseline IOPS",
             "targetconfig_rds.ebs_burst_IOPS":"EBS Storage Max IOPS","targetconfig_rds.ebs_baseline_IOPS":"EBS Storage Baseline IOPS if bursting",
                         "targetconfig_aurora.monthly_estimate":"Aurora Monthly Estimate - Total",
            "targetconfig_aurora.shape_OD":"Reference - On-Demand Rate for Aurora Shape single instance",
            "targetconfig_aurora.shape_RI":"Reference - Hourly Rate for Aurora Shape single instance - uses RI if avail",
            "targetconfig_aurora.shape_max_vcpu":"Aurora Shape VCPU",
            "targetconfig_aurora.shape_memory":"Aurora Shape Memory",
            "targetconfig_aurora.shape_summaryText":"Aurora Shape Summary",
            "targetconfig_aurora.shape_cost":"Aurora Shape Cost",
            "targetconfig_aurora.ebs_data_summaryText1":"Aurora Storage Summary1",
            "targetconfig_aurora.ebs_data_summaryText2":"Aurora Storage Summary2",
            "targetconfig_aurora.iops_summaryText1":"Aurora IO Summary1",
            "targetconfig_aurora.iops_summaryText2":"Aurora IO Summary2",
            "targetconfig_aurora.ebs_data_cost":"Aurora Storage and IO Cost",
            "targetconfig_rds.closeness_string": "RDS Next Closest Shape",
            "targetconfig_aurora.closeness_string": "Aurora Next Closest Shape",
            "targetconfig_aurora.storage_assumptions": "Aurora Assumptions",
            "targetconfig_elasticache.dummy":" ",
            "targetconfig_elasticache.requested_memory":"ElastiCache Size Target",
            "targetconfig_elasticache.shape":"ElastiCache Shape",
            "targetconfig_elasticache.summaryText":"ElastiCache Summary",
            "targetconfig_elasticache.shape_max_vcpu":"ElastiCache Shape VCPU",
            "targetconfig_elasticache.shape_memory":"ElastiCache Shape Memory",
            "targetconfig_elasticache.shape_summaryText":"ElastiCache Shape Summary",
            "targetconfig_elasticache.monthly_estimate":"ElastiCache Monthly Estimate",
            "targetconfig_elasticache.shape_cost":"ElastiCache Shape Cost",
            "targetconfig_elasticache.closeness_string":"ElastiCache Next Closest Shape",
            "targetconfig_elasticache.elasticache_assumptions": "ElastiCache Assumptions",
            "AdjustedVCPU": "New Target VCPU with Caching",
            "AdjustedMemory": "New Target Memory with Caching",
            "AdjustedIOPS": "New Target IOPS with Caching",
            "AdjustedThroughput": "New Target Throughput with Caching",
            "cachingSavingsText": "Caching Savings Conversation Starter",
            "cachingSavings": "Caching Savings",
            "optimizationGoalSuggestion": "Optimization Goal Suggestion",
            "targetconfig_ec2fsxn.dummy": " ",
            "targetconfig_ec2fsxn.shape": "EC2 + FSxN Shape",
            "targetconfig_ec2fsxn.shape_quantity": "EC2 + FSxN Quantity",
            "targetconfig_ec2fsxn.UseMAZ": "FSxN MAZ",
            "targetconfig_ec2fsxn.summaryText": "EC2 + FSxN Summary",
            "targetconfig_ec2fsxn.shape_max_vcpu": "EC2 + FSxN VCPU",
            "targetconfig_ec2fsxn.shape_memory": "EC2 + FSxN Memory",
            "targetconfig_ec2fsxn.shape_network": "EC2 + FSxN Network",
            "targetconfig_ec2fsxn.Processor": "EC2 + FSxN Processor",
            "targetconfig_ec2fsxn.OracleCoreFactor": "Guess at Core Factor",
            "targetconfig_ec2fsxn.OracleCoreFactorConfidence": "Confidence of Core Factor Guess",
            "targetconfig_ec2fsxn.Geekbench5CoreScoreRounded": "Single Core Benchmark",
            "targetconfig_ec2fsxn.fsxn_throughput": "FSxN Throughput",
            "targetconfig_ec2fsxn.fsxn_iops": "FSxN baseline IOPS rating based on Throughput",
            "targetconfig_ec2fsxn.fsxn_generation": "FSxN Generation",
            "targetconfig_ec2fsxn.fsxn_ha_pairs": "FSxN HA Pairs per File System",
            "targetconfig_ec2fsxn.iomb_warnings_burst": "EC2 + FSxN Throughput Bursting Comments",
            "targetconfig_ec2fsxn.iops_warnings_burst": "EC2 + FSxN IOPS Bursting Comments",
            "targetconfig_ec2fsxn.fsxn_addl_iops": "FSxN Additional Provisioned IOPS per File System",
            "targetconfig_ec2fsxn.fsxn_diskspace": "FSxN Disk Space per File System",
            "targetconfig_ec2fsxn.fsxn_quantity": "Quantity of FSxN File Systems",
            "targetconfig_ec2fsxn.shape_cores_needed": "Suggested Cores Per Instance",
            "targetconfig_ec2fsxn.shape_cores_available": "Total Cores Per Instance",
            "targetconfig_ec2fsxn.shape_vcpus_per_core": "VCPUs Per Core",
            "targetconfig_ec2fsxn.fsxn_data_cost": "FSxN Monthly Estimate",
            "targetconfig_ec2fsxn.fsxn_data_summaryText1": "FSxN Summary",
            "targetconfig_ec2fsxn.total_cores_needed": "Suggested Cores across all Instances",
            "targetconfig_ec2fsxn.shape_summaryText": "EC2 + FSxN Summary",
            "targetconfig_ec2fsxn.monthly_estimate": "Monthly Estimate for EC2 + FSxN",
            "targetconfig_ec2fsxn.shape_cost": "EC2 + FSxN Monthly Estimate",
            "targetconfig_ec2fsxn.shape_OD": "EC2 + FSxN Hourly On-Demand",
            "targetconfig_ec2fsxn.shape_RI": "EC2 + FSxN 1yr NURI",
            "targetconfig_ec2fsxn.closeness_string": "EC2 + FSxN Next Closest Shape",
            "targetconfig_ec2fsxn.match_string": "EC2 + FSxN Specification",
            "targetconfig_ec2fsxn.warnings": "EC2 + FSxN Comments",
            "targetconfig_ec2fsxn.fsxn_warnings": "FSxN Comments",
            "targetconfig_ec2.dummy": " ",
            "targetconfig_ec2.shape": "EC2 Shape",
            "targetconfig_ec2.shape_quantity": "EC2 Quantity",
            "targetconfig_ec2.UseMAZ": "EC2 MAZ",
            "targetconfig_ec2.summaryText": "EC2 Summary",
            "targetconfig_ec2.shape_max_vcpu": "EC2 VCPU",
            "targetconfig_ec2.shape_memory": "EC2 Memory",
            "targetconfig_ec2.shape_network": "EC2 Network",
            "targetconfig_ec2.Processor": "EC2 Processor",
            "targetconfig_ec2.ebs_data_type": "EBS Volume Type",
            "targetconfig_ec2.ebs_data_size": "EBS Volume Size",
            "targetconfig_ec2.ebs_data_iops": "EBS Volume IOPS",
            "targetconfig_ec2.ebs_data_throughput": "EBS Volume Throughput",
            "targetconfig_ec2.ebs_data_cost": "EBS Monthly Estimate",
            "targetconfig_ec2.ebs_data_summaryText1": "EBS Summary",
            "targetconfig_ec2.ebs_data_summaryText2": "EBS Summary2",
            "targetconfig_ec2.monthly_estimate": "Monthly Estimate for EC2 and EBS",
            "targetconfig_ec2.shape_cost": "EC2 Monthly Estimate",
            "targetconfig_ec2.shape_OD": "EC2 Hourly On-Demand",
            "targetconfig_ec2.shape_RI": "EC2 1yr NURI",
            "targetconfig_ec2.closeness_string": "EC2 Next Closest Shape",
            "targetconfig_ec2.match_string": "EC2 Specification",
            "targetconfig_ec2.warnings": "EC2 Comments",
            "targetconfig_ec2.iops_warnings": "EC2 IOPS Comments",
            "SmartScanEligible": "SmartScan Eligible" ,
            "StorageIndexSavings": "Storage Index Savings",
            "additional_datapoints.DB_EXA_COMMITS_P99": "Commits per sec (p99)",
            "additional_datapoints.COUNT_TABLES_HCC": "Count of HCC Tables",
            "OrigVCPU": "VCPU on Exadata (if Exadata)",
            "OrigMemory": "Memory on Exadata (if Exadata)",
            "OrigDiskSpace": "DiskSpace on Exadata (if Exadata)",
            "group": "Group",
            "productionYN": "Production ?",
            "drYN": "DR ?",
            "targetconfig_rds.BareMetalProcessor": "Bare Metal Processor",
            "targetconfig_rds.BareMetalPossibilityComments": "Bare Metal Suggestion",
            "DuplicateMatch": "Duplicate Database?",
            "ReadReplica": "RDS-Oracle Replica?",
            "ReadReplicaRegion": "Replica Region",
            "collectionID": "collectionID",
            "targetconfig_rds.shape_max_vcpu_with_multiAZ": "RDS Shape VCPU with MultiAZ",
            "targetconfig_rds.AddlStorageVolumes": "Additional Storage Volumes",
            "targetconfig_adbs.dummy":" ",
            "targetconfig_adbs.shape": "ADBS Shape",
            "targetconfig_adbs.summaryText": "ADBS Summary",
            "targetconfig_adbs.monthly_estimate": "ADBS Monthly Estimate",
            "targetconfig_adbs.ecpu_requested": "ADBS ECPUs Requested",
            "targetconfig_adbs.ecpu_billed": "ADBS ECPUs Billed",
            "targetconfig_adbs.storage_requested": "ADBS Storage Requested",
            "targetconfig_adbs.storage_billed": "ADBS Storage Billed",
            "targetconfig_adbs.ecpu_cost": "ADBS ECPU Cost",
            "targetconfig_adbs.storage_cost": "ADBS Storage Cost",
            "targetconfig_adbs.ecpu_warnings": "ADBS ECPU Comments",
            "targetconfig_adbs.storage_warnings": "ADBS Storage Comments",
            "targetconfig_adbs.adbs_type": "ADBS Type",
            "targetconfig_adbs.UseMAZ": "ADBS Local Peer?",
            "targetconfig_adbs.license_type": "ADBS License Type"
            
     },

      items: [
        {
          Name: "r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          LinuxOD: 4.256,
          Linux1yrNURI: 2.688,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          InstanceStorage: "EBS only",
          ECUs: 195.0,
          ECU_per_linuxOD: 45.8,
          vCPU_Details: "64 vCPUs",
          ECU_Details: "195 units",
          ECU_per_vCPU: 3.05,
          ECU_per_vCPU_per_linuxOD: 0.7,
          OptimizeCores:
            "2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32",
          OptimizeVCPUs:
            "4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64"
        }
      ],

      auroraItems: [
        {
          Name: "db.r4.16xlarge",
          VCPU: 64,
          Memory: 488.0,
          Throughput: 1750.0,
          AuroraPGOD: 9.28,
          AuroraPG1yrNURI: 6.04,
          Processor: "Intel Xeon E5-2686 v4 (Broadwell)",
          Clockspeed: "2.3 GHz",
          ECUs: 195.0,
          ECU_per_auroraPGOD: 21.0,
          vCPU_Details: "64 vCPUs",
          ECU_Details: "195 units"
        }
      ]
    };
  },
  methods: {
    // Escape HTML metacharacters so user-supplied text (e.g. scenarioName) can be
    // safely interpolated into an html:true BootstrapVue popover/tooltip title without
    // allowing stored XSS.
    escapeHtml(str) {
      if (str === undefined || str === null) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    getCPUChartConfig(item) {
      const chartTag = getChartTag('VCPU', item, false);
      const config = getChartConfig(chartTag, item, { form: this.form });
      // console.log("CPUChart", config);
      return config;
    },
    getThroughputChartConfig(item, adjusted) {
      const chartTag = getChartTag('Throughput', item, adjusted);
      return getChartConfig(chartTag, item);
    },
    getIOPSChartConfig(item, adjusted) {
      const chartTag = getChartTag('IOPS', item, adjusted);
      return getChartConfig(chartTag, item);
    },
    getMemoryChartConfig(item) {
      const chartTag = getChartTag('Memory', item, false);
      return getChartConfig(chartTag, item);
    },
    toggleAllSelection(checked) {
      this.filteredBatchItems.forEach(item => {
        this.$set(item, 'selected', checked);
      });
    },
    toggleItemSelection(item, key, checked) {
      this.$set(item, key, checked);
    },





    //method to match target values to matching configs.  works for the batch_item[groupi]
    runSizingSingle(groupi, myRegionInfo, fullMode) {

      // console.log("Sizing for ", groupi, " using ", myRegionInfo.region);
      
      //var myRegionInfo = JSON.parse(JSON.stringify(this.regionInfo)) ;

      // we start with elasticache because it might adjust the target values
      
      // only calculate elasticache if requested
      this.batchItems[groupi].targetconfig_elasticache=undefined;
      this.batchItems[groupi].AdjustedVCPU=undefined;
      this.batchItems[groupi].AdjustedMemory=undefined;
      this.batchItems[groupi].AdjustedIOPS=undefined;
      this.batchItems[groupi].AdjustedThroughput=undefined;
      var tempAnswerNonEC = null;
      var tempShapeNonEC = null;
      var tempAnswerEC = null;
      var tempShapeEC = null;
      
      let original_volumeType = this.batchItems[groupi].VolumeType;
      
      if (this.batchItems[groupi].UseManualShape== undefined) this.batchItems[groupi].UseManualShape='N';
      
      
      // this calculates Elasticache What-ifs.  We don't do this if we manually edit and pick RDS shape
      if (fullMode && this.batchItems[groupi].frozen_prefs.caching_algo && (this.batchItems[groupi].UseManualShape!="Y") ) {
        // console.log("UseManualShape not Y", this.batchItems[groupi].rds_shape);
        // console.log("calculating elasticache",groupi,this.batchItems[groupi].frozen_prefs);
        //first calculate the RDS shape without caching...
        var save_caching_algo = JSON.parse(JSON.stringify(this.batchItems[groupi].frozen_prefs.caching_algo));
        if (save_caching_algo!='N') {
          this.batchItems[groupi].frozen_prefs.caching_algo = 'N';
        } else {
          this.batchItems[groupi].frozen_prefs.caching_algo = 'ec25';
        }  
        
        // if we are evaluating the what-if we have caching, then we need to calculate EC first.
        if (save_caching_algo=='N') {
          tempShapeEC = pick_elasticache_shape(myRegionInfo, this.batchItems[groupi]);
          // console.log("elasticache_shape", elasticache_shape);
          
          if (tempShapeEC!=null) {
            // console.log("elasticache_shape", elasticache_shape);
            
           
             tempAnswerEC = JSON.parse(JSON.stringify(calculate_elasticache_config(myRegionInfo, tempShapeEC, this.batchItems[groupi])));
            // console.log("targetconfig_elasticache", save_caching_algo, this.batchItems[groupi].targetconfig_elasticache, this.batchItems[groupi].AdjustedMemory);
          }             
        } 
        
        // now calculate RDS
        
        // calculate RDS shape
        if (this.batchItems[groupi].rds_type=="rac") {
          tempShapeNonEC = pick_rac_shape(myRegionInfo, this.batchItems[groupi]);
        } else {
          tempShapeNonEC = pick_rds_shape(myRegionInfo, this.batchItems[groupi]);
        }
        // console.log("ASV-3979 with Elasticache scenario");
        tempAnswerNonEC = JSON.parse(JSON.stringify( calculate_rds_config(myRegionInfo, tempShapeNonEC, this.batchItems[groupi]) ));
        //reset caching algo to what it was
        if (save_caching_algo!='N') {
          this.batchItems[groupi].frozen_prefs.caching_algo = save_caching_algo;
        }  
         
        // now calculate EC if we are doing the real EC example
        if (save_caching_algo!='N') {
          tempShapeEC = pick_elasticache_shape(myRegionInfo, this.batchItems[groupi]);
          // console.log("elasticache_shape", elasticache_shape);
          
          if (tempShapeEC!=null) {
            // console.log("elasticache_shape", elasticache_shape);
            
           
             tempAnswerEC = calculate_elasticache_config(myRegionInfo, tempShapeEC, this.batchItems[groupi]);
            // console.log("targetconfig_elasticache2", save_caching_algo, this.batchItems[groupi].targetconfig_elasticache, this.batchItems[groupi].AdjustedMemory);
             if (save_caching_algo!='N') {
               this.showECfields=true;
               this.batchItems[groupi] = tempAnswerEC;
             } 
          }   
        } else {
          this.batchItems[groupi].frozen_prefs.caching_algo = 'N';
          delete this.batchItems[groupi].targetconfig_elasticache;
          this.batchItems[groupi].AdjustedVCPU=undefined;
          this.batchItems[groupi].AdjustedMemory=undefined;
          this.batchItems[groupi].AdjustedIOPS=undefined;
          this.batchItems[groupi].AdjustedThroughput=undefined;
        }
        
        
        
      }  
      

      if (this.batchItems[groupi].UseManualShape== undefined) this.batchItems[groupi].UseManualShape='N';
      
      
      
      // calculate EC2 (non-bare metal) Configuration
      
      var ec2_shape = null;


      if (this.batchItems[groupi].frozen_prefs.ec2_algo!='N') {

        if (  (this.batchItems[groupi].UseManualShape=="Y") ) {
          // console.log("UseManualShape", this.batchItems[groupi].rds_shape);
  
          //manually pick the shape.
           var foundIt=false;
          for (var ii = 0; ii < myRegionInfo.shapes.length; ii++) {
            if (myRegionInfo.shapes[ii].Name == this.batchItems[groupi].targetconfig_ec2.shape) {
              //now check if price is available and we can offer it in this region
              var okToOffer=false;
              if ( (myRegionInfo.shapes[ii].LinuxOD*1 > 0)) okToOffer=true;
              if (okToOffer) {
                ec2_shape = myRegionInfo.shapes[ii];
                foundIt=true;
                break;
              }  
            }
          }
          
          if (foundIt) {
            var max_storage_throughput = 4*4000;
            ec2_shape.closeness_string="";
            
            ec2_shape.match_string = `${ec2_shape.Name} with ${ec2_shape.VCPU} VCPU${ec2_shape.Name.startsWith('t') ? " (bursting)" :""}${((typeof ec2_shape.OptimizeVCPUs != "undefined")&&(ec2_shape.OptimizeVCPUs != null)&&(ec2_shape.OptimizeVCPUs != "None")&& (ec2_shape.OptimizeVCPUs != "2")&&(this.batchItems[groupi].optgoal_choice=="Y")  ) ? " (OptimizeCPU eligible)" : ""}, ${ec2_shape.Memory} GB, ${ec2_shape.Throughput} MB/s${ec2_shape.BaselineThroughput!=null ? " (bursting)" :""}${(ec2_shape.Throughput*1>max_storage_throughput) ? " but storage maxes out at "+max_storage_throughput+" MB/s" : ""}, ${ec2_shape.IOPS} IOPS${ec2_shape.BaselineIOPS!=null ? " (bursting)" :""}`;
     
            ec2_shape.gap_iops=0;
            ec2_shape.gap_memory=0;
            ec2_shape.gap_throughput=0;
            ec2_shape.gap_vcpu=0;
            
            success = true;
          }  else {
            //could not find manual shape.
            //therefore, take it out of manual mode and let system recalculate
            console.log("could not find manual shape");
            // this.batchItems[groupi].UseManualShape='N';
          }
              
        } else {        
          ec2_shape = pick_ec2_shape(myRegionInfo, this.batchItems[groupi]);
        }  

       this.showec2fields=true;
       this.batchItems[groupi] = calculate_ec2_config(myRegionInfo, ec2_shape, this.batchItems[groupi]);
         

      } else {
        delete this.batchItems[groupi].targetconfig_ec2;
      }
  
      
      
      
      
      
      
      //Now work on RDS
      
      
      let rds_shape = {};
      var success = false;
      let original_rds_type = this.batchItems[groupi].rds_type;



      this.batchItems[groupi].rds_type = original_rds_type;  //not sure this is needed
      this.batchItems[groupi].VolumeType = original_volumeType;  
      // console.log("ASV-4029 VolumeType", this.batchItems[groupi].VolumeType , original_volumeType);
      
      
      

      
      if (  (this.batchItems[groupi].UseManualShape=="Y") ) {
        // console.log("UseManualShape", this.batchItems[groupi].rds_shape);
          var max_storage_throughput = 4*4000;
          if (this.batchItems[groupi].rds_type=="rac") {
            max_storage_throughput = 16*1000;
          } 

        //manually pick the shape.
        // need to set local variable rds_shape based on current value of this.batchItems[groupi].rds_shape
        var foundIt=false;
        for (var ii = 0; ii < myRegionInfo.shapes.length; ii++) {
          if (myRegionInfo.shapes[ii].Name == this.batchItems[groupi].rds_shape) {
            //now check if price is available and we can offer it in this region
            var okToOffer=false;
            if ( (this.batchItems[groupi].rds_type=="ee") && (myRegionInfo.shapes[ii].OracleOD*1 > 0) && !(myRegionInfo.shapes[ii].Name.includes('tpc1')) ) okToOffer=true;
            if ( (this.batchItems[groupi].rds_type=="se") && (myRegionInfo.shapes[ii].OracleLIse2_OD*1 > 0) && !(myRegionInfo.shapes[ii].Name.includes('tpc1')) ) okToOffer=true;
            if ( (this.batchItems[groupi].rds_type=="custom") && (myRegionInfo.shapes[ii].OracleCustomOD*1 > 0) && !(myRegionInfo.shapes[ii].Name.includes('tpc1')) ) okToOffer=true;
            if ( (this.batchItems[groupi].rds_type=="rac") && (myRegionInfo.shapes[ii].OracleOD*1 > 0) && !(myRegionInfo.shapes[ii].Name.includes('tpc')) && 
               ( myRegionInfo.shapes[ii].Name.includes('r5.') || myRegionInfo.shapes[ii].Name.includes('r5b.') || myRegionInfo.shapes[ii].Name.includes('m6i.') || myRegionInfo.shapes[ii].Name.includes('r6i.') || myRegionInfo.shapes[ii].Name.includes('x2iedn.') || myRegionInfo.shapes[ii].Name.includes('r6in.')) ) okToOffer=true;
            if (okToOffer) {
              rds_shape = myRegionInfo.shapes[ii];
              foundIt=true;
              break;
            }  
          }
        }
        
        if (foundIt) {
          rds_shape.closeness_string="";
          rds_shape.match_string = `db.${rds_shape.Name} with ${rds_shape.VCPU} VCPU${rds_shape.Name.startsWith('t') ? " (bursting)" :""}${((typeof rds_shape.OptimizeVCPUs != "undefined")&&(rds_shape.OptimizeVCPUs != null)&&(rds_shape.OptimizeVCPUs != "None")&& (rds_shape.OptimizeVCPUs != "2")&&(this.batchItems[groupi].optgoal_choice=="Y") && (this.batchItems[groupi].rds_type!="se") && (this.batchItems[groupi].rds_type!="custom") && (this.batchItems[groupi].rds_type!="rac") ) ? " (OptimizeCPU eligible)" : ""}, ${rds_shape.Memory} GB, ${rds_shape.Throughput} MB/s${rds_shape.BaselineThroughput!=null ? " (bursting)" :""}${(rds_shape.Throughput*1>max_storage_throughput) ? " but storage maxes out at "+max_storage_throughput+" MB/s" : ""}, ${rds_shape.IOPS} IOPS${rds_shape.BaselineIOPS!=null ? " (bursting)" :""}`;
  
          rds_shape.gap_iops=0;
          rds_shape.gap_memory=0;
          rds_shape.gap_throughput=0;
          rds_shape.gap_vcpu=0;
          rds_shape.rac_nodes=1; //need to fix when we get to RAC
          success = true;
        }  else {
          //could not find manual shape.
          //therefore, take it out of manual mode and let system recalculate
          console.log("could not find manual shape");
          // this.batchItems[groupi].UseManualShape='N';
        }
          
      }
      
      var tempAnswer = null;
      var tempShape = null;
      var checkOtherGoal=false;
      
      delete this.batchItems[groupi].optimizationGoalSuggestion;
      delete this.batchItems[groupi].cachingSavingsText;
      delete this.batchItems[groupi].cachingSavings;
      
      if (!success) {
        //normal mode: pick the right shape
        
        //auto optimization goal suggestion
        //min_license=minimize Licensing
        //N=minimize cost
        
        if (fullMode && this.batchItems[groupi].optgoal_choice=="min_license") {
          //temporary switch prefs
          this.batchItems[groupi].optgoal_choice="min_cost";
          checkOtherGoal=true;
        } else if (fullMode && this.batchItems[groupi].optgoal_choice=="min_cost") {
          this.batchItems[groupi].optgoal_choice="min_license";
          checkOtherGoal=true;
        }    
        
        if (checkOtherGoal) {
          
          // calculate shape
          if (this.batchItems[groupi].rds_type=="rac") {
            tempShape = pick_rac_shape(myRegionInfo, this.batchItems[groupi]);
          } else {
            tempShape = pick_rds_shape(myRegionInfo, this.batchItems[groupi]);
          }
          // console.log("ASV-4112 - check other optimization goal");
          tempAnswer = structuredClone( calculate_rds_config(myRegionInfo, tempShape, this.batchItems[groupi]) );
          
          // switch prefs back
          if (this.batchItems[groupi].optgoal_choice=="min_license") {
            //temporary switch prefs
            this.batchItems[groupi].optgoal_choice="min_cost";
          } else if (this.batchItems[groupi].optgoal_choice=="min_cost") {
            this.batchItems[groupi].optgoal_choice="min_license";
          }
          this.batchItems[groupi].rds_type = original_rds_type;  //not sure this is needed
          this.batchItems[groupi].VolumeType = original_volumeType;  
          // console.log("ASV-4124 VolumeType", this.batchItems[groupi].VolumeType , original_volumeType);
          
 
        }
        
        //now pick shape for real
        if (this.batchItems[groupi].rds_type=="rac") {
          rds_shape = pick_rac_shape(myRegionInfo, this.batchItems[groupi]);
        } else {
          rds_shape = pick_rds_shape(myRegionInfo, this.batchItems[groupi]);
        }
  
      }  
      
      // console.log("ASV-4133 - do real sizing");
      this.batchItems[groupi] = calculate_rds_config(myRegionInfo, rds_shape, this.batchItems[groupi]);

      // compare shapes and answers to see if they differ
      if (fullMode && checkOtherGoal && ( tempShape != rds_shape ) && (tempAnswer.rds_shape!='N/A') && (this.batchItems[groupi].rds_shape!='N/A')) {
        // console.log("checkGoal", tempAnswer.targetconfig_rds.shape, this.batchItems[groupi].targetconfig_rds.shape);
        var VCPUdiff = Math.round( (tempAnswer.targetconfig_rds.shape_max_vcpu * tempAnswer.targetconfig_rds.rac_nodes) - (this.batchItems[groupi].targetconfig_rds.shape_max_vcpu * this.batchItems[groupi].targetconfig_rds.rac_nodes) );
        var VCPUMazString = "";
        var VCPUMazString2 = "";
        var VCPUMazdiff = VCPUdiff;
        
        if ( (this.batchItems[groupi].UseMAZ=="Yes") && (this.batchItems[groupi].rds_type!='rac' ) ) {
          VCPUMazString = "(" + 2*VCPUdiff + " more VCPUs across MultiAZ) ";
          VCPUMazString2 = "(" + (0-2*VCPUdiff) + " less VCPUs across MultiAZ) ";
          VCPUMazdiff = 2*VCPUdiff;
        }
        var Costdiff = Math.round( (tempAnswer.targetconfig_rds.monthly_estimate) - (this.batchItems[groupi].targetconfig_rds.monthly_estimate) );
        
        if (this.batchItems[groupi].optgoal_choice=="min_license") {
        
          if (VCPUdiff>0) {
            this.batchItems[groupi].optimizationGoalSuggestion = "Want to save $" + (0-Costdiff) + " per month?<br/><br/>  If you switch to the minimize AWS Cost goal, we would suggest the " +
              tempAnswer.targetconfig_rds.shape + " which costs $" + (0-Costdiff) + " less per month but does have " +
              VCPUdiff + " more VCPUs "+VCPUMazString + "that may need to be licensed for Oracle.";
          } else {
            this.batchItems[groupi].optimizationGoalSuggestion = "Want to save $" + (0-Costdiff) + " per month?<br/><br/>  If you switch to the minimize AWS Cost goal, we would suggest the " +
              tempAnswer.targetconfig_rds.shape + " which costs $" + (0-Costdiff) + " less per month but may need more licensing for Oracle.";
          }

        } else if (this.batchItems[groupi].optgoal_choice=="min_cost") {
          if (VCPUdiff<0) {
            this.batchItems[groupi].optimizationGoalSuggestion = "Want to use " + (0-VCPUMazdiff) + " fewer VCPUs to potentially reduce your Oracle licensing need?<br/><br/>  If you switch to the minimize Oracle Licensing goal, we would suggest the " +
              tempAnswer.targetconfig_rds.shape + " which has " + (0-VCPUdiff) + " fewer VCPUs "+ VCPUMazString2 + "but does cost $" +
              Costdiff + " more per month.";
          } else {
            // if the diff is possitive, then we must have picked a bare metal shape (I think)
            this.batchItems[groupi].optimizationGoalSuggestion = "Want to possibly use less Oracle licensing?<br/><br/>  If you switch to the minimize Oracle Licensing goal, you could consider the bare metal " +
              tempAnswer.targetconfig_rds.shape + " which may have licensing advantages but does cost $" +
              Costdiff + " more per month.";
          }
        }    
        // console.log("OptimizationGoal Suggestion", groupi, this.batchItems[groupi].optimizationGoalSuggestion );
      }
      
      // now compare EC - scenario is we requested EC
      
      if ( fullMode && this.batchItems[groupi].frozen_prefs.caching_algo && (this.batchItems[groupi].frozen_prefs.caching_algo!='N') && ( tempShapeNonEC != rds_shape ) && (tempAnswerNonEC.rds_shape!='N/A') && (this.batchItems[groupi].rds_shape!='N/A') ) {
        var VCPUdiffEC = Math.round( (tempAnswerNonEC.targetconfig_rds.shape_max_vcpu * tempAnswerNonEC.targetconfig_rds.rac_nodes) - (this.batchItems[groupi].targetconfig_rds.shape_max_vcpu * this.batchItems[groupi].targetconfig_rds.rac_nodes) );
        var VCPUMazStringEC = "";

        
        if ( (this.batchItems[groupi].UseMAZ=="Yes") && (this.batchItems[groupi].rds_type!='rac' ) ) {
          VCPUMazStringEC = "(" + 2*VCPUdiffEC + " fewer VCPUs across MultiAZ)";
        }
        var CostdiffEC = Math.round( (tempAnswerNonEC.targetconfig_rds.monthly_estimate) - (this.batchItems[groupi].targetconfig_rds.monthly_estimate + tempAnswerEC.targetconfig_elasticache.monthly_estimate) );
        
        // console.log("costdiffec", groupi, CostdiffEC);
        
        if (CostdiffEC>0) {
          this.batchItems[groupi].cachingSavingsText = "Your caching assumptions have reduced the Oracle portion of the configuration from a " +
            tempAnswerNonEC.targetconfig_rds.shape + " to a " + this.batchItems[groupi].targetconfig_rds.shape + 
            ", which is a reduction of $" +
            Math.round((tempAnswerNonEC.targetconfig_rds.monthly_estimate) - (this.batchItems[groupi].targetconfig_rds.monthly_estimate)) +
            " per month and " + VCPUdiffEC + " fewer VCPUs" + VCPUMazStringEC +
            ".  The overall cost of the combined ElastiCache ($"+ Math.round((tempAnswerEC.targetconfig_elasticache.monthly_estimate)) + ") and new Oracle configuration is $" + CostdiffEC + " less per month than the non-caching scenario.";
          this.batchItems[groupi].cachingSavings = CostdiffEC;  

        } 
        // console.log("CachingSavings", groupi, this.batchItems[groupi].cachingSavingsText );
        
      }  


      // now compare EC - scenario is we did NOT EC
      
      if ( fullMode && this.batchItems[groupi].frozen_prefs.caching_algo && (this.batchItems[groupi].frozen_prefs.caching_algo=='N') && tempShapeNonEC &&  tempAnswerNonEC && ( tempShapeNonEC != rds_shape ) && (tempAnswerNonEC.rds_shape!='N/A') && (this.batchItems[groupi].rds_shape!='N/A') ) {
        var VCPUdiffEC = Math.round( (this.batchItems[groupi].targetconfig_rds.shape_max_vcpu * this.batchItems[groupi].targetconfig_rds.rac_nodes) - (tempAnswerNonEC.targetconfig_rds.shape_max_vcpu * tempAnswerNonEC.targetconfig_rds.rac_nodes)  );
        var VCPUMazStringEC = "";

        
        if ( (this.batchItems[groupi].UseMAZ=="Yes") && (this.batchItems[groupi].rds_type!='rac' ) ) {
          VCPUMazStringEC = "(" + 2*VCPUdiffEC + " fewer VCPUs across MultiAZ)";
        }
        var CostdiffEC = Math.round( (this.batchItems[groupi].targetconfig_rds.monthly_estimate) - (tempAnswerNonEC.targetconfig_rds.monthly_estimate  + tempAnswerEC.targetconfig_elasticache.monthly_estimate) );
        
        // console.log("costdiffec", groupi, CostdiffEC);
        
        if (CostdiffEC>0) {
          this.batchItems[groupi].cachingSavingsText = "Have you considered if adding a cache can fit with this workload?<br/><br/>  If we assume that a cache can reduce your database requirements by 25%, then we would roughly estimate that the Oracle portion of the configuration may downsize from a " +
            this.batchItems[groupi].targetconfig_rds.shape + " to a " + tempAnswerNonEC.targetconfig_rds.shape + 
            ", which is a reduction of $" +
            Math.round((this.batchItems[groupi].targetconfig_rds.monthly_estimate) - (tempAnswerNonEC.targetconfig_rds.monthly_estimate)) +
            " per month and " + VCPUdiffEC + " fewer VCPUs" + VCPUMazStringEC +
            ".  The estimated overall cost of the combined ElastiCache ($"+ Math.round((tempAnswerEC.targetconfig_elasticache.monthly_estimate)) + ") and new Oracle configuration is $" + CostdiffEC + " less per month than the non-caching scenario.";
          this.batchItems[groupi].cachingSavings = CostdiffEC;  

        } 
        // console.log("CachingSavings", groupi, this.batchItems[groupi].cachingSavingsText );
        
      }  




      // calculate Aurora
      
      
      if (this.batchItems[groupi].frozen_prefs.aurora_algo!='auro1') {
        let aurora_shape = pick_aurora_shape(myRegionInfo, this.batchItems[groupi]);
        // console.log("aurora_shape", aurora_shape);
        
        // if (aurora_shape!=null) {
           this.showAurorafields=true;
           this.batchItems[groupi] = calculate_aurora_config(myRegionInfo, aurora_shape, this.batchItems[groupi]);
        // }   
      }  else {
        delete this.batchItems[groupi].targetconfig_aurora;
      }


      // calculate ADBS
      delete this.batchItems[groupi].odb_shape; //it can get re-added later if needed
      if (this.batchItems[groupi].frozen_prefs.odbAWS_service == 'adbs-tp') {
        
        this.showADBSfields = true;
        this.batchItems[groupi] = calculate_adbs_config(myRegionInfo, this.batchItems[groupi]);
      } else {
        delete this.batchItems[groupi].targetconfig_adbs;
      }


      // calculate EC2 Bare Metal with FSXN
      
      
      if (this.batchItems[groupi].frozen_prefs.ec2fsxn_algo!='N') {
        let ec2fsxn_shape=null;

        if (  (this.batchItems[groupi].UseManualShape=="Y") ) {
          // console.log("UseManualShape", this.batchItems[groupi].rds_shape);
           
  
          //manually pick the shape.
          // need to set local variable ec2fsxn_shape based on current value of this.batchItems[groupi].targetconfig_ec2fsxn.shape
          var foundIt=false;
          for (var ii = 0; ii < myRegionInfo.shapes.length; ii++) {
            if (myRegionInfo.shapes[ii].Name == this.batchItems[groupi].targetconfig_ec2fsxn.shape) {
              //now check if price is available and we can offer it in this region
              var okToOffer=true;
              if (okToOffer) {
                ec2fsxn_shape = myRegionInfo.shapes[ii];
                foundIt=true;
                break;
              }  
            }
          }
          
          if (foundIt) {
            ec2fsxn_shape.closeness_string="";
            ec2fsxn_shape.match_string = `${ec2fsxn_shape.Name} with ${ec2fsxn_shape.VCPU} VCPU, ${ec2fsxn_shape.Memory} GB, ${ ec2fsxn_shape.Network / 8 } MB/s Network Throughput`;
    
            ec2fsxn_shape.gap_iops=0;
            ec2fsxn_shape.gap_memory=0;
            ec2fsxn_shape.gap_throughput=0;
            ec2fsxn_shape.gap_vcpu=0;
            
            success = true;
          }  else {
            //could not find manual shape.
            //therefore, take it out of manual mode and let system recalculate
            console.log("could not find manual shape");
            // this.batchItems[groupi].UseManualShape='N';
          }
            
        } else {        
          ec2fsxn_shape = pick_ec2fsxn_shape(myRegionInfo, this.batchItems[groupi]);
        }  
        // console.log("ec2fsxn_shape", ec2fsxn_shape);
        
        // if (ec2fsxn_shape!=null) {
           this.showec2fsxnfields=true;
           this.batchItems[groupi] = calculate_ec2fsxn_config(myRegionInfo, ec2fsxn_shape, this.batchItems[groupi]);
          // console.log("ec2fsxn", this.batchItems[groupi].targetconfig_ec2fsxn);
        // }   
      }   else {
        delete this.batchItems[groupi].targetconfig_ec2fsxn;
      }
      
      // Enrich with popover text
      this.batchItems[groupi] = enrichBatchItemWithPopoverText(this.batchItems[groupi], this.form);

    },

    addReadReplicaIfNeeded(originalIndex) {
      const originalItem = this.batchItems[originalIndex];
      
      // Check conditions for creating read replica
      const shouldCreateReplica = 
        originalItem.frozen_prefs.readreplica_algo === 'Y' || 
        (originalItem.frozen_prefs.readreplica_algo === 'auto' && originalItem.DATABASE_ROLE === 'PRIMARY');
        
      if (!shouldCreateReplica) return;

      // Check DB name filter if provided
      if (originalItem.frozen_prefs.readreplica_db_name_match_expr && 
          originalItem.frozen_prefs.readreplica_db_name_match_expr.trim() !== '') {
        try {
          let pattern = originalItem.frozen_prefs.readreplica_db_name_match_expr.trim();
          
          // Convert common glob patterns to regex if it looks like a glob pattern
          if (pattern.includes('*') && !pattern.includes('.*')) {
            pattern = pattern.replace(/\*/g, '.*');
          }
          
          const regex = new RegExp(pattern);
          if (!regex.test(originalItem.database)) {
            return; // DB name doesn't match the pattern, skip replica creation
          }
        } catch (e) {
          console.warn('Invalid regex pattern for readreplica_db_name_match_expr:', originalItem.frozen_prefs.readreplica_db_name_match_expr);
          return; // Invalid regex, skip replica creation
        }
      }
      
     // Check if replica already exists to avoid duplicates
      const existingReplica = this.batchItems.find(item => 
        item.ReadReplica === 'Y' && 
        item.originalCollectionID === originalItem.collectionID &&
        item.scenarioName === originalItem.scenarioName
      );
      
      // const existingReplica = (originalItem.ReadReplica==='Y');
      
      if (existingReplica) return;
      
      const duplicateSource = ( (originalItem.DuplicateMatch!=undefined) && (originalItem.DuplicateMatch!='OriginalDatabase') );
      if (duplicateSource) return;
      
      // Create read replica item
      const replicaItem = structuredClone(originalItem);
      
      // Mark as read replica
      replicaItem.ReadReplica = 'Y';
      replicaItem.ReadReplicaRegion = this.DRregionCode;
      replicaItem.originalCollectionID = originalItem.collectionID;
      replicaItem.database = originalItem.database + ' (Replica)';
      replicaItem.row = originalItem.row + "-R";
      
      // Ensure frozen_prefs is copied
//      replicaItem.frozen_prefs = JSON.parse(JSON.stringify(originalItem.frozen_prefs));
      replicaItem.frozen_prefs = structuredClone(originalItem.frozen_prefs);

      // Apply MultiAZ algorithm for replica
      if (originalItem.frozen_prefs.readreplica_maz_algo === 'single') {
        replicaItem.frozen_prefs.multiAZ_algo = 'N';
        replicaItem.UseMAZ='No';
      } else if (originalItem.frozen_prefs.readreplica_maz_algo === 'match') {
        // Keep the same MultiAZ setting as the primary
        replicaItem.frozen_prefs.multiAZ_algo = originalItem.frozen_prefs.multiAZ_algo;
        replicaItem.UseMAZ=originalItem.UseMAZ;
      }
      
      // Adjust VCPU based on sizing algorithm
      if (originalItem.frozen_prefs.readreplica_size_algo === 'rr50') {
        replicaItem.VCPU = Math.ceil(10*originalItem.VCPU * 0.5)/10;
        replicaItem.Memory = Math.ceil(originalItem.Memory * 0.5);
        replicaItem.Throughput = Math.ceil(originalItem.Throughput * 0.5);
        replicaItem.IOPS = Math.ceil(originalItem.IOPS * 0.5);
        replicaItem.OrigThroughput = Math.ceil(originalItem.OrigThroughput * 0.5);
        replicaItem.OrigIOPS = Math.ceil(originalItem.OrigIOPS * 0.5);
      }
      
      if (originalItem.frozen_prefs.readreplica_size_algo === 'rr25') {
        replicaItem.VCPU = Math.ceil(10*originalItem.VCPU * 0.25)/10;
        replicaItem.Memory = Math.ceil(originalItem.Memory * 0.25);
        replicaItem.Throughput = Math.ceil(originalItem.Throughput * 0.25);
        replicaItem.IOPS = Math.ceil(originalItem.IOPS * 0.25);
        replicaItem.OrigThroughput = Math.ceil(originalItem.OrigThroughput * 0.25);
        replicaItem.OrigIOPS = Math.ceil(originalItem.OrigIOPS * 0.25);
      }
      
      // Size the replica
      // await this.changeDRRegion(originalItem.frozen_prefs.readreplica_region);
      
      // Insert replica after original item
      // this.batchItems.splice(originalIndex + 1, 0, replicaItem);
      // this.runSizingSingle(originalIndex + 1, this.DRregionInfo, false);
      
      this.batchItems.push(replicaItem);
      this.runSizingSingle(this.batchItems.length -1 , this.DRregionInfo, false);
    },

    async onCSVModalShow() {
      if (this.csv_format == 'mat') {
        await this.loadMatGenInfo();
      }
    },

    async onCSVFormatChange(value) {
      if (value == 'mat') {
        await this.loadMatGenInfo();
      }
    },

    // The MAT format needs general info (object counts, features, storage) that is not in batchItems.
    // Fetch it once per collection, with bounded concurrency (same approach as buildPPTXScenario).
    async loadMatGenInfo() {
      const collectionIDs = [...new Set(this.batchItems.map(item => item.collectionID))]
        .filter(id => id !== undefined && this.matGenInfo[id] === undefined);
      if (collectionIDs.length == 0) return;

      this.matLoading = true;
      const GENINFO_CONCURRENCY = 6;
      const fetchGenInfo = async (collectionID) => {
        let tries = 2;
        while (tries > 0) {
          try {
            const response = await API.get("dbcsiAPI", `/dbcsi/${collectionID}/ora_v1`);
            const genInfo = {};
            for (const g of response.data) {
              genInfo[g.name] = g.value;
            }
            this.$set(this.matGenInfo, collectionID, genInfo);
            tries = 0;
          } catch (error) {
            console.log("loadMatGenInfo Error for", collectionID, error);
            console.log("Will retry. Attempts Left:", (tries - 1));
          }
          tries -= 1;
        }
      };
      let nextIndex = 0;
      const workers = [];
      for (let w = 0; w < Math.min(GENINFO_CONCURRENCY, collectionIDs.length); w++) {
        workers.push((async () => {
          while (nextIndex < collectionIDs.length) {
            const idx = nextIndex++;
            await fetchGenInfo(collectionIDs[idx]);
          }
        })());
      }
      await Promise.all(workers);
      this.matLoading = false;
    },

    // Convert flatItems rows (any scenario) into MAT rows: one row per collection, disclaimer rows dropped
    buildMatRows(myFlatItems) {
      const rows = [];
      const seen = new Set();
      for (const flatItem of myFlatItems) {
        if (flatItem.collectionID === undefined || seen.has(flatItem.collectionID)) continue;
        seen.add(flatItem.collectionID);
        const item = this.batchItems.find(b => b.collectionID == flatItem.collectionID && b.scenarioName == flatItem.scenarioName) ||
                     this.batchItems.find(b => b.collectionID == flatItem.collectionID);
        if (!item) continue;
        const cdbCollectionId = item.additional_datapoints ? item.additional_datapoints.CDB_collectionId : undefined;
        const cdbItem = cdbCollectionId ? this.batchItems.find(b => b.collectionID == cdbCollectionId) : undefined;
        rows.push(build_mat_row(item, this.matGenInfo[flatItem.collectionID], cdbItem, this.regionCode));
      }
      return rows;
    },

    fixFlatItems(myFlatItems) {
      // this method makes sure that the very first row has a value in all of the needed fields
      // this is because our downloadCSV package inspects only the first row to determine what columns to export, 
      // so we must replace nulls in the first row with empty values
      let tempItems = myFlatItems;
      if (tempItems.length>0) {
        if ( ! (tempItems[0]["optimizationGoalSuggestion"]) ) {
              tempItems[0]["optimizationGoalSuggestion"] = " ";
          }    
        if ( ! (tempItems[0]["targetconfig_rds.BareMetalPossibilityComments"]) ) {
              tempItems[0]["targetconfig_rds.BareMetalPossibilityComments"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.BareMetalProcessor"]) ) {
              tempItems[0]["targetconfig_rds.BareMetalProcessor"] = " ";
        }    
        if ( ! (tempItems[0]["COUNT_PDBS"]) ) {
              tempItems[0]["COUNT_PDBS"] = " ";
        }    
        if ( ! (tempItems[0]["DuplicateMatch"]) ) {
              tempItems[0]["DuplicateMatch"] = " ";
        }    
        if ( ! (tempItems[0]["ReadReplica"]) ) {
              tempItems[0]["ReadReplica"] = " ";
        }    
        if ( ! (tempItems[0]["ReadReplicaRegion"]) ) {
              tempItems[0]["ReadReplicaRegion"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.shape_max_vcpu_with_multiAZ"]) ) {
              tempItems[0]["targetconfig_rds.shape_max_vcpu_with_multiAZ"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.AddlStorageVolumes"]) ) {
              tempItems[0]["targetconfig_rds.AddlStorageVolumes"] = " ";
        }    
         
        if ( ! (tempItems[0]["cachingSavingsText"]) ) {
            tempItems[0]["cachingSavingsText"] = " ";
            tempItems[0]["cachingSavings"] = " ";
        }    
        if ( ! (tempItems[0]["CONSOLIDATED"]) ) {
              tempItems[0]["CONSOLIDATED"] = " ";
        }    
        if ( ! (tempItems[0]["NUM_CPUS"]) ) {
              tempItems[0]["NUM_CPUS"] = " ";
        }    
        if ( ! (tempItems[0]["NUM_CPU_CORES"]) ) {
              tempItems[0]["NUM_CPU_CORES"] = " ";
        }    
        if ( ! (tempItems[0]["current_hw_memory"]) ) {
              tempItems[0]["current_hw_memory"] = " ";
        }    
        if ( ! (tempItems[0]["Exadata"]) ) {
              tempItems[0]["Exadata"] = " ";
        }    
        if ( ! (tempItems[0]["rac_nodes"]) ) {
              tempItems[0]["rac_nodes"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.shape_cost"]) ) {
              tempItems[0]["targetconfig_rds.shape_cost"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.shape_baselinethroughput"]) ) {
              tempItems[0]["targetconfig_rds.shape_baselinethroughput"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.shape_IOPS"]) ) {
              tempItems[0]["targetconfig_rds.shape_IOPS"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.shape_baselineIOPS"]) ) {
              tempItems[0]["targetconfig_rds.shape_baselineIOPS"] = " ";
        }    
        if ( ! (tempItems[0]["targetconfig_rds.InstanceStorage"]) ) {
              tempItems[0]["targetconfig_rds.InstanceStorage"] = " ";
        }    



  
       //these fields might be missing if you used Oracle's version of awr_miner.sql
       //“DB Unique Name”/Banner/“Lines of PLSQL”/Current HW CPU Threads
        if ( ! (tempItems[0]["COUNT_LINES_PLSQL"]) ) {
              tempItems[0]["COUNT_LINES_PLSQL"] = " ";
          }    
        if ( ! (tempItems[0]["BANNER"]) ) {
              tempItems[0]["BANNER"] = " ";
          }    
        if ( ! (tempItems[0]["DB_UNIQUE_NAME"]) ) {
              tempItems[0]["DB_UNIQUE_NAME"] = " ";
          }    
        if ( ! (tempItems[0]["current_hw_cpu"]) ) {
              tempItems[0]["current_hw_cpu"] = " ";
          }    
       
        
        //if showECfields, then row[0] needs to populate values for the EC fields if missing
        if (this.showECfields) {
          if ( ! (tempItems[0]["targetconfig_elasticache.summaryText"]) ) {
              // console.log("fixFlatItems - addEC field to row0")
              tempItems[0]["targetconfig_elasticache.summaryText"] = " ";
              tempItems[0]["targetconfig_elasticache.requested_memory"] = "";
              tempItems[0]["targetconfig_elasticache.shape"] = "";
              tempItems[0]["targetconfig_elasticache.shape_max_vcpu"] = "";
              tempItems[0]["targetconfig_elasticache.shape_memory"] = "";
              tempItems[0]["targetconfig_elasticache.shape_summaryText"] = "";
              tempItems[0]["targetconfig_elasticache.monthly_estimate"] = "";
              tempItems[0]["targetconfig_elasticache.closeness_string"] = "";
              tempItems[0]["targetconfig_elasticache.elasticache_assumptions"] = "";
              tempItems[0]["AdjustedVCPU"] = "";
              tempItems[0]["AdjustedMemory"] = "";
              tempItems[0]["AdjustedIOPS"] = "";
              tempItems[0]["AdjustedThroughput"] = "";
          }   
          
  
          if ( ! (tempItems[0]["targetconfig_elasticache.dummy"]) ) {
              tempItems[0]["targetconfig_elasticache.dummy"] = " ";
          }    
        }
  
        if (this.showAurorafields) {
          if ( ! (tempItems[0]["targetconfig_aurora.summaryText"]) ) {
              // console.log("fixFlatItems - addAurora field to row0", tempItems[0]);
              tempItems[0]["aurora_shape"] = " ";
              tempItems[0]["targetconfig_aurora.summaryText"] = "";
              tempItems[0]["targetconfig_aurora.shape_max_vcpu"] = "";
              tempItems[0]["targetconfig_aurora.shape_memory"] = "";
              tempItems[0]["targetconfig_aurora.shape_summaryText"] = "";
              tempItems[0]["targetconfig_aurora.ebs_data_summaryText1"] = "";
              tempItems[0]["targetconfig_aurora.ebs_data_summaryText2"] = "";
              tempItems[0]["targetconfig_aurora.iops_summaryText1"] = "";
              tempItems[0]["targetconfig_aurora.iops_summaryText2"] = "";
              tempItems[0]["targetconfig_aurora.monthly_estimate"] = "";
              tempItems[0]["targetconfig_aurora.shape_cost"] = "";
              tempItems[0]["targetconfig_aurora.ebs_data_cost"] = "";
              tempItems[0]["targetconfig_aurora.closeness_string"] = "";
              tempItems[0]["targetconfig_aurora.storage_assumptions"] = "";
          }    
          if ( ! (tempItems[0]["targetconfig_aurora.dummy"]) ) {
              tempItems[0]["targetconfig_aurora.dummy"] = " ";
          }    
        }

        if (this.showADBSfields) {
          if ( ! (tempItems[0]["targetconfig_adbs.summaryText"]) ) {
              tempItems[0]["targetconfig_adbs.summaryText"] = "";
              tempItems[0]["targetconfig_adbs.monthly_estimate"] = "";
              tempItems[0]["targetconfig_adbs.ecpu_requested"] = "";
              tempItems[0]["targetconfig_adbs.ecpu_billed"] = "";
              tempItems[0]["targetconfig_adbs.storage_billed"] = "";
              tempItems[0]["targetconfig_adbs.ecpu_cost"] = "";
              tempItems[0]["targetconfig_adbs.storage_cost"] = "";
              tempItems[0]["targetconfig_adbs.ecpu_warnings"] = "";
              tempItems[0]["targetconfig_adbs.storage_warnings"] = "";
              tempItems[0]["targetconfig_adbs.shape"] = "";
              tempItems[0]["targetconfig_adbs.storage_requested"] = "";
              tempItems[0]["targetconfig_adbs.UseMAZ"] = "";
              tempItems[0]["targetconfig_adbs.adbs_type"] = "";
              tempItems[0]["targetconfig_adbs.license_type"] = "";
          }    
          if ( ! (tempItems[0]["targetconfig_adbs.dummy"]) ) {
              tempItems[0]["targetconfig_adbs.dummy"] = " ";
          }    
        }
        
        // console.log("Add showec2fsxnfields to flatItems here");
        if (this.showec2fsxnfields) {
          if ( ! (tempItems[0]["targetconfig_ec2fsxn.summaryText"]) ) {
  
  
              tempItems[0]["targetconfig_ec2fsxn.summaryText"] = " ";
              tempItems[0]["targetconfig_ec2fsxn.monthly_estimate"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape"] = "";
              tempItems[0]["targetconfig_ec2fsxn.match_string"] = "";            
              // "targetconfig_ec2fsxn.shape_summaryText"
              tempItems[0]["targetconfig_ec2fsxn.shape_cost"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_quantity"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_max_vcpu"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_memory"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_network"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_cores_needed"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_cores_available"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_vcpus_per_core"] = "";
              tempItems[0]["targetconfig_ec2fsxn.total_cores_needed"] = "";
              tempItems[0]["targetconfig_ec2fsxn.Processor"] = "";
              tempItems[0]["targetconfig_ec2fsxn.OracleCoreFactor"] = "";
              tempItems[0]["targetconfig_ec2fsxn.OracleCoreFactorConfidence"] = "";
              tempItems[0]["targetconfig_ec2fsxn.Geekbench5CoreScoreRounded"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_OD"] = "";
              tempItems[0]["targetconfig_ec2fsxn.shape_RI"] = "";
              tempItems[0]["targetconfig_ec2fsxn.closeness_string"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_data_summaryText1"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_data_cost"] = "";
              tempItems[0]["targetconfig_ec2fsxn.UseMAZ"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_quantity"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_diskspace"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_throughput"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_addl_iops"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_iops"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_generation"] = "";
              tempItems[0]["targetconfig_ec2fsxn.fsxn_ha_pairs"] = "";
              tempItems[0]["targetconfig_ec2fsxn.iomb_warnings_burst"] = "";
              tempItems[0]["targetconfig_ec2fsxn.iops_warnings_burst"] = "";
              tempItems[0]["targetconfig_ec2fsxn.warnings"] = "";   
              tempItems[0]["targetconfig_ec2fsxn.fsxn_warnings"] = "";            
              
          
          }    
          if ( ! (tempItems[0]["targetconfig_ec2fsxn.dummy"]) ) {
              tempItems[0]["targetconfig_ec2fsxn.dummy"] = " ";
          }    
        }      
        
        // Add showec2fields to flatItems here
        if (this.showec2fields) {
          if ( ! (tempItems[0]["targetconfig_ec2.summaryText"]) ) {
              tempItems[0]["targetconfig_ec2.summaryText"] = " ";
              tempItems[0]["targetconfig_ec2.monthly_estimate"] = "";
              tempItems[0]["targetconfig_ec2.shape"] = "";
              tempItems[0]["targetconfig_ec2.match_string"] = "";            
              tempItems[0]["targetconfig_ec2.shape_cost"] = "";
              tempItems[0]["targetconfig_ec2.shape_quantity"] = "";
              tempItems[0]["targetconfig_ec2.shape_max_vcpu"] = "";
              tempItems[0]["targetconfig_ec2.shape_memory"] = "";
              tempItems[0]["targetconfig_ec2.shape_network"] = "";
              tempItems[0]["targetconfig_ec2.Processor"] = "";
              tempItems[0]["targetconfig_ec2.shape_OD"] = "";
              tempItems[0]["targetconfig_ec2.shape_RI"] = "";
              tempItems[0]["targetconfig_ec2.closeness_string"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_summaryText1"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_summaryText2"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_cost"] = "";
              tempItems[0]["targetconfig_ec2.UseMAZ"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_size"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_type"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_iops"] = "";
              tempItems[0]["targetconfig_ec2.ebs_data_throughput"] = "";
              tempItems[0]["targetconfig_ec2.warnings"] = "";   
              tempItems[0]["targetconfig_ec2.iops_warnings"] = ""; 
          }    
          if ( ! (tempItems[0]["targetconfig_ec2.dummy"]) ) {
              tempItems[0]["targetconfig_ec2.dummy"] = " ";
          }    
        }      
      }  
      return tempItems;
    },
    
    async postBatchSizing() {
    
      // this method does a couple of things:
      // create the flatItems array for the CSV export
      // add the needed disclaimers to the CSV export
      // and for ODB: aggregate total target values and calculate infrastructure sizing
      // and for RDSConsolidation: calculate Consolidated sizing
      
      // hack: set the DRregionInfo upfront once... UPDATE. SHOULD NOT BE NEEDED
      // console.log("hack: setting DRregion upfront to test performance");
      // await this.changeDRRegion(this.form.readreplica_region);
      
      var disclaimer_params = {
        use_se: false,
        use_rac: false,
        optgoal_algo: this.form.optgoal_algo,
        aurora_algo: this.form.aurora_algo,
        caching_algo: this.form.caching_algo,
        odbAWS_service: 'exacs'
      };
      var showECfields = false;

      var showAurorafields = false;
      var showADBSfields = false;
      var showRDSfields = false;
      var showec2fsxnfields = false;
      var showec2fields = false;
      var showODBfields = false;
      var showRDSConsolidationFields = false;
      
      // make a loop through all databases, to do a couple of things
      // identify pdbs with cdbs in the set, and cdbs with pdbs in the set
      // identify how many unique scenarioNames we have (manualEdits mean you can get extras)
      this.pdb_and_cdb_pairs_in_batch = false;
      this.batchItemsHasASVs = 'N';
      var scenarioNames = new Set();
      for (var dbrow=0; dbrow< this.batchItems.length ; dbrow++) {
           // add scenarioName to a set if not already there
           scenarioNames.add(this.batchItems[dbrow].scenarioName);
           
           // set the frozen_prefs.pdb_and_cdb_exclude_algo to the current value (currently, we are not supporting per-scenario different values)
           // this.batchItems[dbrow].frozen_prefs.pdb_and_cdb_exclude_algo = this.form.pdb_and_cdb_exclude_algo;
          
          // see if the PDB has its CDB in the same batch and if so, mark the CDB and PDB
          if ((this.batchItems[dbrow].IS_PDB=='YES') && (this.batchItems[dbrow].CDB_collectionId!=undefined) ) {
             // console.log("found a PDB with a CDB in DB", dbrow, this.batchItems[dbrow].CDB_collectionId);
             //now see if the CDB is part of this batch...
             for (var cdbrow=0; cdbrow< this.batchItems.length ; cdbrow++) {
              if ( (this.batchItems[dbrow].CDB_collectionId - this.batchItems[cdbrow].collectionID) == 0 ) {
                // console.log("found CDB in batch", cdbrow);
                this.batchItems[dbrow].PDBandCDBmatch = "PDBwithParent";
                this.batchItems[cdbrow].PDBandCDBmatch = "CDBwithChild";
                this.pdb_and_cdb_pairs_in_batch = true;
              } else {
                // console.log("No MATCH: PDB, CDB", dbrow, cdbrow, this.batchItems[dbrow].CDB_collectionId, this.batchItems[cdbrow].collectionID, this.batchItems[dbrow], this.batchItems[cdbrow]);
              }
             }
            
          }
          
          if (this.batchItems[dbrow].targetconfig_rds!=undefined && this.batchItems[dbrow].targetconfig_rds.AddlStorageVolumes*1>0) {
            this.batchItemsHasASVs = 'Y';
          }
      }    
      
      // Identify duplicate databases within each scenario
      for (var dbrow1 = 0; dbrow1 < this.batchItems.length; dbrow1++) {
        if (this.batchItems[dbrow1].DuplicateMatch !== undefined) continue; // Skip already processed
        
        var duplicateCount = 0;
        for (var dbrow2 = 0; dbrow2 < this.batchItems.length; dbrow2++) {
          if (dbrow1 === dbrow2) continue; // Skip self
          if (this.batchItems[dbrow1].scenarioName !== this.batchItems[dbrow2].scenarioName) continue; // Only within same scenario
          
          // Skip if one is a read replica of the other (not a true duplicate)
          if ((this.batchItems[dbrow1].ReadReplica === 'Y' && this.batchItems[dbrow1].originalCollectionID === this.batchItems[dbrow2].collectionID) ||
              (this.batchItems[dbrow2].ReadReplica === 'Y' && this.batchItems[dbrow2].originalCollectionID === this.batchItems[dbrow1].collectionID)) {
            continue;
          }
          
          // Check if databases match on DBID, DBNAME, and hostnames and lines of PLSQL
          if (this.batchItems[dbrow1].DBID === this.batchItems[dbrow2].DBID &&
              this.batchItems[dbrow1].DB_NAME === this.batchItems[dbrow2].DB_NAME &&
              this.batchItems[dbrow1].hostname === this.batchItems[dbrow2].hostname &&
              this.batchItems[dbrow1].COUNT_LINES_PLSQL === this.batchItems[dbrow2].COUNT_LINES_PLSQL) {
            
            duplicateCount++;
            if (duplicateCount === 1) {
              // Mark first occurrence as original
              this.batchItems[dbrow1].DuplicateMatch = "OriginalDatabase";
            }
            // Mark subsequent occurrences as duplicates
            this.batchItems[dbrow2].DuplicateMatch = this.batchItems[dbrow1].row;
            this.duplicate_databases_in_batch = true;
          }
        }
      }    
      
      // loop through and add read replicas
      var dbrow0=0;
      const currentItemLength = this.batchItems.length;
      while (dbrow0 < currentItemLength) {
        // Add read replica if needed
        if (this.batchItems[dbrow0].frozen_prefs.readreplica_algo !== 'N') {
          this.alertTextRecalc = "Adding Replicas (please wait) ... " + currentItemLength + " to process";
          // console.log("Add replica", dbrow0);
          this.addReadReplicaIfNeeded(dbrow0);
        }
        dbrow0++;
      }  
      
      this.alertTextRecalc = "Summarizing Results";
      
      var totalScenarioNames = [...scenarioNames].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      
      // make another loop through all databases to identify what kind of disclaimers need to be added
      for (var groupi=0; groupi< this.batchItems.length ; groupi++) {
        // console.log("Aug26 loop", groupi);
      
        // check for disclaimers to add
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.rds_algo!="none") { showRDSfields = true; }
        if (this.batchItems[groupi].rds_type=="rac") disclaimer_params.use_rac = true;
        if (this.batchItems[groupi].rds_type=="se") disclaimer_params.use_se = true;
        if (this.batchItems[groupi].optgoal_choice=="Y") disclaimer_params.optgoal_algo = "Y";
        if (this.batchItems[groupi].targetconfig_elasticache!=undefined) { showECfields = true; disclaimer_params.caching_algo='ec50'; }
        if (this.batchItems[groupi].targetconfig_aurora!=undefined) { showAurorafields = true; disclaimer_params.aurora_algo='auro5'; }
        if (this.batchItems[groupi].targetconfig_adbs!=undefined) { showADBSfields = true; disclaimer_params.odbAWS_service='adbs-tp'; }
        if (this.batchItems[groupi].targetconfig_ec2fsxn!=undefined) { showec2fsxnfields = true; disclaimer_params.ec2fsxn_algo='Y'; }
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.ec2_algo!="N") { showec2fields = true; disclaimer_params.ec2_algo='Y'; }
        
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.odbAWS_algo=="Y") { 
          disclaimer_params.odbAWS_algo='Y';
          if (this.batchItems[groupi].frozen_prefs.odbAWS_service!="adbs-tp") { showODBfields = true;  }
        }
        
        // for now, if any item is adbs-tp, use that as a priority.
        
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.odbAWS_algo=="Y" && this.batchItems[groupi].frozen_prefs.odbAWS_service=="adb" && disclaimer_params.odbAWS_service!='adbs-tp') { disclaimer_params.odbAWS_service='adb'; }
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.odbAWS_algo=="Y" && this.batchItems[groupi].frozen_prefs.odbAWS_service=="adbs-tp") { disclaimer_params.odbAWS_service='adbs-tp'; }
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.odbAWS_algo=="Y" && this.batchItems[groupi].frozen_prefs.odbAWS_service=="exascale") { disclaimer_params.odbAWS_service='exascale'; }
        
        if (this.batchItems[groupi].frozen_prefs && this.batchItems[groupi].frozen_prefs.rdsConsolidation_algo!="N") { showRDSConsolidationFields = true; disclaimer_params.rdsConsolidation_algo='Y'; }
        
        
      }
      
      
      this.showECfields = showECfields;
      this.showAurorafields = showAurorafields;
      this.showADBSfields = showADBSfields;
      this.showec2fsxnfields = showec2fsxnfields;
      this.showec2fields = showec2fields;
      this.showODBfields = showODBfields;
      this.showRDSConsolidationFields = showRDSConsolidationFields;
      this.showRDSfields = showRDSfields;
      

      // aggregate target values for infrastructure calculation
      // console.log("totalScenarioNames", totalScenarioNames);
      // console.log("totalRDSVCPU", totalRDSVCPU);
      
      // if prefs.ExadataSizing
      if (showODBfields) {
        // console.log("postBatchSizing: Sizing for Oracle Database@AWS");
        this.infrastructure = calculate_exadata_config(this.regionInfo, this.batchItems);
        
        // Also calculate ExaScale infrastructure and merge into the same array
        var exascaleInfra = calculate_exascale_config(this.regionInfo, this.batchItems);
        if (exascaleInfra.length > 0) {
          this.infrastructure = this.infrastructure.concat(exascaleInfra);
        }
        // console.log("Temp0310", JSON.stringify(this.infrastructure[0]));

        // loop through infrastructure to aggregate totals
        this.flatInfrastructure = [];
        for (var infrai=0; infrai< this.infrastructure.length ; infrai++) {
          this.flatInfrastructure[infrai] = flatten(this.infrastructure[infrai]);
          this.flatInfrastructure[infrai].dbcsiURL = "https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/batch/"+this.batch_id;
        }


           
        // helper function
        var matchScenario = function (infra) {
           return ( (infra.scenarioName == this) && (infra.role=="Primary") );
        };
        
        // any work we do here won't show up in flatItems, so we should add changes to both batchItems and this.
        // console.log("infrastructure", this.infrastructure);
      
        for (var bi=0; bi<this.batchItems.length; bi++ ) {
        
         
          var infraScenarioMatch = this.infrastructure.find(matchScenario, this.batchItems[bi].scenarioName);
          // can we assume that the find command will always find the primary? TODO- add check for Primary the matchScenario() function
          
          // if we don't find a match for infrastructure, then it might be that we didn't ask for one in the scenario.  so skip this.
          // console.log("infraMatch", infraScenarioMatch, this.batchItems[bi].scenarioName);
          
          if (infraScenarioMatch!=undefined) {

            // console.log("infraMatch2", infraScenarioMatch.scenarioName, this.batchItems[bi].scenarioName);
          
           // console.log("here",infraScenarioMatch, this.batchItems[bi].scenarioName);
            this.batchItems[bi].odb_shape = "See ("+infraScenarioMatch.scenarioName+") in infrastructure table below";
            this.batchItems[bi].odb_specifications = infraScenarioMatch.specificationText;
            if (infraScenarioMatch.multiAZ=="Yes") {
              this.batchItems[bi].odb_specifications += " in 2 AZs (MultiAZ)";
              //TODO: could also say "with DR"
            }
            
            var odb_total_cost = 0;
            var odb_total_Usage_cost = 0;
            var odb_total_dbserver_cost = 0;
            var odb_total_storage_cost = 0;
            
            for (var infrai = 0; infrai < this.infrastructure.length; infrai++) {
              if (this.infrastructure[infrai].scenarioName == this.batchItems[bi].scenarioName) {
                odb_total_cost += this.infrastructure[infrai].monthly_estimate*1;
                odb_total_Usage_cost += this.infrastructure[infrai].Usage_cost *1;
                odb_total_dbserver_cost += this.infrastructure[infrai].dbserver_cost *1;
                odb_total_storage_cost += this.infrastructure[infrai].storage_cost *1;
              }
            }
            
            // do we include/exclude this database from pro-rating?
            
           if ( ( ( this.batchItems[bi].PDBandCDBmatch==undefined ) ||
              ( (this.batchItems[bi].frozen_prefs.pdb_and_cdb_exclude_algo == "none") || 
                ( (this.batchItems[bi].frozen_prefs.pdb_and_cdb_exclude_algo == "excludePDB") && (this.batchItems[bi].PDBandCDBmatch!="PDBwithParent") ) || 
                ( (this.batchItems[bi].frozen_prefs.pdb_and_cdb_exclude_algo == "excludeCDB") && (this.batchItems[bi].PDBandCDBmatch!="CDBwithChild") )
              )
            ) &&
            ( ( this.batchItems[bi].DuplicateMatch==undefined ) ||
              ( (this.batchItems[bi].frozen_prefs.duplicate_database_exclude_algo == "none") || 
                ( (this.batchItems[bi].frozen_prefs.duplicate_database_exclude_algo == "excludeDuplicates") && (this.batchItems[bi].DuplicateMatch=="OriginalDatabase") )
              )
            ) ) {

                var prorated_Usage = Math.round( odb_total_Usage_cost * this.batchItems[bi].VCPU   / infraScenarioMatch.VCPU_total * 100)/ 100;
                if ( (this.batchItems[bi].OrigVCPU != undefined) && (this.batchItems[bi].VCPU != this.batchItems[bi].OrigVCPU) ) {
                  prorated_Usage = Math.round( odb_total_Usage_cost * this.batchItems[bi].OrigVCPU   / infraScenarioMatch.VCPU_total * 100)/ 100;
                }  
                var prorated_dbserver = Math.round( odb_total_dbserver_cost * this.batchItems[bi].Memory  / infraScenarioMatch.Memory_target * 100)/ 100;
                if ((this.batchItems[bi].OrigMemory != undefined) && (this.batchItems[bi].Memory != this.batchItems[bi].OrigMemory)) {
                  prorated_dbserver = Math.round( odb_total_dbserver_cost * this.batchItems[bi].OrigMemory  / infraScenarioMatch.Memory_target * 100)/ 100;
                }
                var prorated_storageserver = Math.round( odb_total_storage_cost * this.batchItems[bi].DiskSpace   / infraScenarioMatch.storage_target * 100)/ 100;
                // console.log("storage prorated", odb_total_storage_cost , this.batchItems[bi].DiskSpace  , infraScenarioMatch.storage_target );
                // console.log("prorated:", prorated_Usage , prorated_dbserver , prorated_storageserver);
    
                this.batchItems[bi].odb_prorated_comments = "Pro-rated breakout attibuted to this database:  Share of DB Server cost=$"+ prorated_dbserver + "   Share of Storage Server cost=$" + prorated_storageserver + "   Share of " + infraScenarioMatch.Usage_units + " Usage cost=$" + prorated_Usage;
                
                this.batchItems[bi].odb_prorated_monthly_estimate =Math.round((prorated_Usage + prorated_dbserver + prorated_storageserver)*100)/100;
                // this.batchItems[bi].odb_prorated_monthly_estimate = Math.round(this.batchItems[bi].VCPU  / infraScenarioMatch.VCPU_total * odb_total_cost * 100) / 100;
                this.batchItems[bi].odb_total_monthly_estimate = Math.round(odb_total_cost * 100) / 100;
              } else {
                this.batchItems[bi].odb_prorated_comments = "Excluding this database because it overlaps with another PDB/CDB and we did not include both in the calculations";
                this.batchItems[bi].odb_prorated_monthly_estimate = 0;
                this.batchItems[bi].odb_total_monthly_estimate = 0;
              }
          }  else {
            // console.log("InfraMatch undefined");
          }
          
         } 
         
        // now do disclaimers
       

        this.infraDisclaimerLists = disclaimers ("ODB", null, disclaimer_params, null) ;
        
               // console.log("postBatchSizing", this.infraDisclaimerLists);
        
        for (var ii=0; ii<this.infraDisclaimerLists.length; ii++)
        {
          this.flatInfrastructure.push (
            {scenarioName:this.infraDisclaimerLists[ii]}
          )  ;
        }

      }  // if showODBfields
      else {
        this.infrastructure = [];
        this.infraDisclaimerLists = [];
      }
      
      
      
      
      // now calculate RDS Consolidated Scenario
      if (showRDSConsolidationFields) {
      
        console.log("postBatchSizing: Sizing for RDS Consolidation");
        const consolidationResults = calculate_consolidated_config(this.regionInfo, this.batchItems, this.DRregionInfo);
        this.consolidatedServers = consolidationResults.servers;
        

        // loop through consolidatedServers to aggregate totals
        this.flatConsolidatedServers = [];
        for (var infrai=0; infrai< this.consolidatedServers.length ; infrai++) {
          this.flatConsolidatedServers[infrai] = flatten(this.consolidatedServers[infrai]);
          this.flatConsolidatedServers[infrai].dbcsiURL = "https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/batch/"+this.batch_id;
        } // for infrai
        
        // now add some fields to batchItems that show the consolidatedServer

        // helper function
        var matchConsolidatedServer = function (server) {
           return ( (server.scenarioName == this.scenarioName) && 
                    (server.databasesArray.some(item => item.collectionID === this.collectionID) ) &&
                    (server.ReadReplica === this.ReadReplica) );
        };
        
        // any work we do here won't show up in flatItems, so we should add changes to both batchItems and this.
      
        for (var bi=0; bi<this.batchItems.length; bi++ ) {
        
         
          var serverScenarioMatch = this.consolidatedServers.find(matchConsolidatedServer, {
            scenarioName: this.batchItems[bi].scenarioName,
            collectionID: this.batchItems[bi].collectionID,
            ReadReplica: this.batchItems[bi].ReadReplica
          });
     
          
          // if we don't find a match for server, then it might be that we didn't ask for one in the scenario.  so skip this.
          
          if (serverScenarioMatch!=undefined) {
          
           // console.log("here",serverScenarioMatch, this.batchItems[bi].scenarioName);
            this.batchItems[bi].consolidation_shape = serverScenarioMatch.targetconfig_rds.shape;
            this.batchItems[bi].consolidation_server = serverScenarioMatch.server;
            this.batchItems[bi].consolidation_summary = serverScenarioMatch.consolidationString;
            this.batchItems[bi].consolidation_databases = serverScenarioMatch.databases;
            this.batchItems[bi].consolidation_databasesLong = serverScenarioMatch.databasesLong;
            this.batchItems[bi].consolidation_monthly_estimate = serverScenarioMatch.targetconfig_rds.monthly_estimate;
            this.batchItems[bi].consolidation_server_summary = serverScenarioMatch.targetconfig_rds.summaryText;
            
          }  
          
         } 
         
        // now do disclaimers
        this.consolidatedServersDisclaimerLists = disclaimers ("RDSConsolidation", null, disclaimer_params, this.regionInfo) ;

       
        // console.log("postBatchSizing", this.consolidationDisclaimerLists);
        
        for (var ii=0; ii<this.consolidatedServersDisclaimerLists.length; ii++)
        {
          this.flatConsolidatedServers.push (
            {scenarioName:this.consolidatedServersDisclaimerLists[ii]}
          )  ;
        }
        
        

      } else {
        this.consolidatedServers=[];
      }
      // if RDS Consolidation
 
      // Calculate totals once at the end with all available data
      const totalsResult = calculateTotals({
        scenarioNames: scenarioNames,
        batchItems: this.batchItems,
        infrastructure: this.infrastructure,
        consolidatedServers: this.consolidatedServers,
        showAlertNonX86: this.showAlertNonX86
      });
      this.totals = totalsResult.totals;
 
      // Enrich all batch items with popover text
      for (let i = 0; i < this.batchItems.length; i++) {
        this.batchItems[i] = enrichBatchItemWithPopoverText(this.batchItems[i], this.form);
      }
 
      
      // now do flatItems
      this.flatItems=[];
      for (var groupi=0; groupi< this.batchItems.length ; groupi++) {
      
        this.flatItems[groupi] = flatten(this.batchItems[groupi]);
        
        // add some extra fields
        this.flatItems[groupi].url = "https://dbcsi.d29q8g3b9hzyur.amplifyapp.com/metrics/"+this.batchItems[groupi].metricsURL+"/ora_v1";
        this.flatItems[groupi].assumptionsString = this.flatItems[groupi].assumptionsString.replace(/<br\/>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"");
        if (  (this.flatItems[groupi]["optimizationGoalSuggestion"]) ) {
          this.flatItems[groupi].optimizationGoalSuggestion = this.flatItems[groupi].optimizationGoalSuggestion.replace(/<br\/>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"");
        }  
        if (  (this.flatItems[groupi]["cachingSavingsText"]) ) {
          this.flatItems[groupi].cachingSavingsText = this.flatItems[groupi].cachingSavingsText.replace(/<br\/>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"");
        }  
        if (  (this.flatItems[groupi]["targetconfig_rds.BareMetalPossibilityComments"]) && (this.flatItems[groupi]["targetconfig_rds.BareMetalPossibilityComments"]!=undefined) ) {
          // console.log("July 25",this.flatItems[groupi]["targetconfig_rds.BareMetalPossibilityComments"]);
          this.flatItems[groupi]["targetconfig_rds.BareMetalPossibilityComments"] = this.flatItems[groupi]["targetconfig_rds.BareMetalPossibilityComments"].replace(/<br\/>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"");
        }  
        
        if (this.flatItems[groupi].addlVolumes==undefined) this.flatItems[groupi].addlVolumes="";
        if (this.flatItems[groupi].rds_type!="rac") {
          //adjust rac_nodes for csv
          if ( (this.flatItems[groupi].UseMAZ=="Yes") && (this.flatItems[groupi].rac_nodes!=undefined) ) {
            this.flatItems[groupi].rac_nodes=2;
          }
        }
        
        // add some fields for ODBCC export
        this.flatItems[groupi].group="Group1";
        this.flatItems[groupi].productionYN="Yes";
        this.flatItems[groupi].drYN="No";
        this.flatItems[groupi].OrigDiskSpace=this.flatItems[groupi].DiskSpace;
        if (this.flatItems[groupi].OrigVCPU==undefined) {
          this.flatItems[groupi].OrigVCPU = this.flatItems[groupi].VCPU;
        }  
        if (this.flatItems[groupi].OrigMemory==undefined) {
          this.flatItems[groupi].OrigMemory = this.flatItems[groupi].Memory;
        } 
       
      }
      //update disclaimers
      this.disclaimerLists = disclaimers("batch","page",disclaimer_params, this.regionInfo);
      
      var theList = disclaimers("batch","xls", disclaimer_params,this.regionInfo);
      
      for (var ii=0; ii<theList.length; ii++)
      {
        this.flatItems.push (
          {database:theList[ii]}
        )  ;
      }
      
      function compare( a, b ) {
        if ( a.row *1 < b.row*1 ){
          return -1;
        }
        if ( a.row*1 > b.row*1 ){
          return 1;
        }
        return 0;
      }
      
      this.flatItems.sort( compare );    
      
      
      // console.log("flatItems", this.flatItems);
      
      
      
      
      this.flatItems = this.fixFlatItems(this.flatItems);

    },
    
    async submitQuestion(theItem) {
      // console.log("submitQuestion", theItem.collectionID);

      var tempContext = JSON.parse(JSON.stringify(theItem));
      var batchParams = {
        body: {
          ask_querytype: this.ask_querytype,
          company: this.company,
          question: this.question,
          region: this.regionCode,
          context: tempContext           
        }
      };
      

      await API.put(
        "dbcsiAPI",
        `/dbcsi/askAdvisor/${theItem.collectionID}`,
        batchParams
      )
        .then(response => {
          // success = true;
          // console.log("Batch- submitQuestion: put success");
            // this.alertText = "Saving Sizing Output to Database... Saved "+groupi+" of "+num_items;
            this.question='';
            this.lastQuestion=theItem.collectionID;
        })
        .catch(error => {
          console.log("Batch- submitQuestion:", error);
            // this.alertText = "Error while saving: "+error;
            // this.alertStyle="danger";
            // success=false;
        });
      
    },
    
    resetBatchModal() {
           this.batchAdd.descr='';
          // this.batchAdd.customer='';
          this.batchAdd.batchname='';
          this.createBatchMessage = "";
          this.createBatchID = "";
    },
    
    async createBatch() {
      let collection_type = "ora_v1";
      
      this.createBatchMessage = "Saving batch definition to database... Please wait... Do not leave this page yet.";

      
      var success = true;
      if (success) {
        // console.log("BatchDefine: I am here4");
        
        // get an array of just the collection_ids that are checked.
        
        var selected_ids = [];
        for (var i of this.batchItems) {
          if (i.selected) {
            // selected_ids.push({collection_id: i.collectionID});
            selected_ids.push(i.collectionID);
          }  
        }  
        // selected_ids = selected_ids.filter((value, index, array) => {
        //       return array.indexOf(value) === index;
        //     }
        //   );
        selected_ids = [...new Set(selected_ids)] ; 
        console.log(selected_ids);
        
        //now expand selected_ids into objects
        var new_selected_ids = [];
        for (var i of selected_ids) {
            new_selected_ids.push({collection_id: i});
            
        }  
        
        //do a put to /collections
        const putParams = {
          body: {
            db_type: "Oracle",
            customer: this.batchAdd.customer,
            batchname: this.batchAdd.batchname,
            descr: this.batchAdd.descr,
            collection_type: collection_type,
            collection_ids: new_selected_ids
          }
        };

        var new_id = null;
        await API.put("dbcsiAPI", `/dbcsi/batch`, putParams)
          .then(response => {
            new_id = response.data.batch_id;
            this.createBatchID = new_id;
            console.log("createBatch API.put: new batch_id=", new_id);
            this.createBatchMessage = "Batch created for "+new_selected_ids.length + " distinct databases.";


          })
          .catch(error => {
            console.log("createBatch API.put Error:", error);
            // alert("API.put error");
              this.createBatchMessage = "Batch not created.  See browser developer tools console for error message.";

          });
          

      }      
    },
    






    initPPTXModal() {
      if (this.totals.length > 0) {
        this.selectedPPTXScenario = this.totals[0].scenarioName;
      }
      this.resetPPTXState();
    },

    // Reset the server-side generation UI state (and stop any active poll).
    resetPPTXState() {
      if (this.pptxPollTimer) {
        clearTimeout(this.pptxPollTimer);
        this.pptxPollTimer = null;
      }
      this.generatingPPTX = false;
      this.pptxStatus = null;
      this.pptxError = null;
      this.pptxDownloadUrl = null;
      this.pptxChartsDisabled = false;
    },

    // Called on modal @hidden so a poll doesn't keep running after close.
    cleanupPPTX() {
      if (this.pptxPollTimer) {
        clearTimeout(this.pptxPollTimer);
        this.pptxPollTimer = null;
      }
    },

    // Build the scenario object sent to both the JSON download (CLI path) and
    // the server-side generator. Fetches per-item genInfo + DBC results.
    async buildPPTXScenario(scenarioName) {
      let scenarioIndex = 0;

      for (let i = 0; i < this.totals.length; i++) {
        if (this.totals[i].scenarioName === scenarioName) {
          scenarioIndex = i;
          break;
        }
      }

      const subsetItems = [];
      for (let groupi = 0; groupi < this.batchItems.length; groupi++) {
        const item = this.batchItems[groupi];

        const includePDBCDB = (item.PDBandCDBmatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.pdb_and_cdb_exclude_algo === "none") ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludePDB") && (item.PDBandCDBmatch !== "PDBwithParent")) ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludeCDB") && (item.PDBandCDBmatch !== "CDBwithChild")));
        
        const includeDuplicate = (item.DuplicateMatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.duplicate_database_exclude_algo === "none") ||
            ((item.frozen_prefs.duplicate_database_exclude_algo === "excludeDuplicates") && (item.DuplicateMatch === "OriginalDatabase")));

        if (includePDBCDB && includeDuplicate && item.scenarioName === scenarioName) {
          subsetItems.push(item);
        }
      }

      // Fetch genInfo for each item, but with BOUNDED concurrency. Firing one
      // request per database at once (Promise.all over every item) could open
      // dozens-to-hundreds of simultaneous requests for large scenarios, which
      // can exhaust Aurora Serverless connections / RDS Data API concurrency and
      // exceed API Gateway's 29s integration timeout -> intermittent 500s. A small
      // worker pool keeps at most GENINFO_CONCURRENCY requests in flight.
      const GENINFO_CONCURRENCY = 6;
      const fetchGenInfo = async (item) => {
        let tries = 2;
        while (tries > 0) {
          try {
            const response = await API.get("dbcsiAPI", `/dbcsi/${item.collectionID}/ora_v1`);
            const genItems = response.data.filter(g => {
              if (g.name === "!CPU_SOCKET_COUNT" || g.name === "GLOBAL_CPU_SOCKET_COUNT" || g.name === "NUM_CPU_SOCKETS") return false;
              // if (g.name.startsWith("DEBUG")) return false;
              if (g.name.startsWith("DB_") && g.name !== "DB_NAME") return false;
              return true;
            });
            const genInfo = {};
            for (const g of genItems) {
              genInfo[g.name] = g.value;
            }
            item.genInfo = genInfo;
            item.features = genItems
              .filter(g => g.name.startsWith("FEATURE_"))
              .map(g => ({ name: g.name.substring(8) }));
            tries = 0;
          } catch (error) {
            console.log("downloadPPTXJSON genInfo Error for", item.collectionID, error);
            console.log("Will retry. Attempts Left:", (tries - 1));
          }
          tries -= 1;
        }
      };
      let genInfoIndex = 0;
      const genInfoWorkers = [];
      for (let w = 0; w < Math.min(GENINFO_CONCURRENCY, subsetItems.length); w++) {
        genInfoWorkers.push((async () => {
          while (genInfoIndex < subsetItems.length) {
            const idx = genInfoIndex++;
            await fetchGenInfo(subsetItems[idx]);
          }
        })());
      }
      await Promise.all(genInfoWorkers);

      const myScenario = {
        scenarioName: this.totals[scenarioIndex].scenarioName,
        totals: this.totals[scenarioIndex],
        items: subsetItems,
        disclaimers: this.disclaimerLists
      };

      const subsetInfraItems = [];
      for (let groupi = 0; groupi < this.infrastructure.length; groupi++) {
        const item = this.infrastructure[groupi];
        if (item.scenarioName === scenarioName) {
          subsetInfraItems.push(item);
        }
      }

      if (this.showODBAWS && (subsetInfraItems.length > 0)) {
        myScenario.infrastructure = subsetInfraItems;
        myScenario.infraDisclaimers = this.infraDisclaimerLists;
      }

      const subsetConsItems = [];
      for (let groupi = 0; groupi < this.consolidatedServers.length; groupi++) {
        const item = this.consolidatedServers[groupi];
        if (item.scenarioName === scenarioName) {
          subsetConsItems.push(item);
        }
      }

      if (this.showRDSConsolidationFields && (subsetConsItems.length > 0)) {
        myScenario.consolidatedServers = subsetConsItems;
        myScenario.consolidatedDisclaimers = this.consolidatedServersDisclaimerLists;
      }

      // Calculate DBC results
      const dbcAdv = {
        total_vcpus: this.totals[scenarioIndex].totalSourceDistinctServerVCPUs,
        annual_growth_percentage: 0,
        business_benefit_amount: 5000 * 5 * this.totals[scenarioIndex].totalRDSCount,
        add_discounts: false,
        discount_percentage: 15,
      };
      const dbcResults = await calculateDBC(API, this.totals[scenarioIndex], dbcAdv);
      if (!dbcResults.error) {
        myScenario.dbc = {
          sourceResult: dbcResults.sourceResult,
          targetResult: dbcResults.targetResult,
          auroraTargetResult: dbcResults.auroraTargetResult,
          consolidatedTargetResult: dbcResults.consolidatedTargetResult,
          odbTargetResult: dbcResults.odbTargetResult,
        };
      }

      return myScenario;
    },

    // AWS Transform (ATX) JSON export: needs the same per-collection general info as the MAT CSV format
    async initATXModal() {
      if (this.totals.length > 0 && !this.totals.some(t => t.scenarioName === this.selectedATXScenario)) {
        this.selectedATXScenario = this.totals[0].scenarioName;
      }
      await this.loadMatGenInfo();
    },

    downloadATXJSON(kind) {
      const records = (kind == 'server') ? this.atxRecords.servers : this.atxRecords.databaseInstances;
      const blob = new Blob([JSON.stringify(records, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const sanitizedScenarioName = String(this.selectedATXScenario).replace(/[^a-zA-Z0-9_-]/g, '_');
      link.href = url;
      link.download = `dbcsi_atx_${kind}_${this.batch_id}_${sanitizedScenarioName}.json`;
      link.click();
      URL.revokeObjectURL(url);
    },

    async downloadPPTXJSON() {
      this.downloadingPPTXJSON = true;
      try {
        const scenarioName = this.selectedPPTXScenario;
        const myScenario = await this.buildPPTXScenario(scenarioName);
        const jsonStr = JSON.stringify(myScenario, null, 2);
        const blob = new Blob([jsonStr], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const sanitizedScenarioName = scenarioName.replace(/[^a-zA-Z0-9_-]/g, '_');
        link.href = url;
        link.download = `dbcsi_pptx_${this.batch_id}_${sanitizedScenarioName}.json`;
        link.click();
        URL.revokeObjectURL(url);
      } finally {
        this.downloadingPPTXJSON = false;
      }
    },

    // Server-side generation: POST scenario -> jobId -> poll status -> auto-download.
    async generatePPTX() {
      this.resetPPTXState();
      this.generatingPPTX = true;
      this.pptxStatus = 'running';
      try {
        const myScenario = await this.buildPPTXScenario(this.selectedPPTXScenario);
        const resp = await API.put("dbcsiAPI", "/dbcsi/pptx/generate", {
          body: { scenario: myScenario, noCharts: this.pptxNoCharts }
        });
        if (!resp || !resp.success) {
          throw new Error((resp && resp.error) || "Failed to submit generation request");
        }
        if (resp.chartsEnabled === false && !this.pptxNoCharts) {
          this.pptxChartsDisabled = true;
        }
        this.pollPPTXStatus(resp.jobId);
      } catch (e) {
        this.pptxStatus = 'failed';
        this.pptxError = (e && e.message) ? e.message : String(e);
        this.generatingPPTX = false;
      }
    },

    // Poll the status endpoint until ready/failed or a ~5 min timeout.
    pollPPTXStatus(jobId) {
      let tries = 0;
      // The worker (dbcsiPPTXlambda) has a 900s / 15-min Lambda timeout, and large
      // scenarios with charts take ~0.25 min per database, so the client must keep
      // polling well past the old 5-min cap or it falsely reports a timeout while
      // the job is still running. ~16 min at 4s intervals covers the worker's max.
      const maxTries = 240;
      const poll = async () => {
        tries += 1;
        try {
          const resp = await API.get("dbcsiAPI", `/dbcsi/pptx/status/${jobId}`);
          if (!resp || !resp.success) {
            throw new Error((resp && resp.error) || "Status check failed");
          }
          if (resp.status === 'ready') {
            this.pptxDownloadUrl = resp.downloadUrl;
            this.pptxStatus = 'ready';
            this.generatingPPTX = false;
            this.triggerPPTXDownload(resp.downloadUrl);
            return;
          }
          if (resp.status === 'failed') {
            this.pptxStatus = 'failed';
            this.pptxError = resp.error || "Generation failed";
            this.generatingPPTX = false;
            return;
          }
          // still running
          if (tries >= maxTries) {
            this.pptxStatus = 'failed';
            this.pptxError = "Timed out waiting for the PowerPoint (still running after ~15 minutes).";
            this.generatingPPTX = false;
            return;
          }
          this.pptxPollTimer = setTimeout(poll, 4000);
        } catch (e) {
          this.pptxStatus = 'failed';
          this.pptxError = (e && e.message) ? e.message : String(e);
          this.generatingPPTX = false;
        }
      };
      this.pptxPollTimer = setTimeout(poll, 4000);
    },

    // The presigned S3 URL already carries Content-Disposition: attachment.
    triggerPPTXDownload(url) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    },

    
    async shareDatabases(theItem) {
      // console.log("shareDatabases", theItem.collectionID);

      this.generatedSharingURL = '';
      

      var batchParams = {
        body: {
          batchID: this.batch_id
        }
      };
      

      await API.put(
        "dbcsiAPI",
        `/dbcsi/shareURL`,
        batchParams
      )
        .then(response => {
          // success = true;
          // console.log("Batch- shareDatabases: put success");
            // this.alertText = "Saving Sizing Output to Database... Saved "+groupi+" of "+num_items;
            this.generatedSharingURL=response.data.generatedSharingURL;
        })
        .catch(error => {
          console.log("Batch- shareDatabases:", error);
            this.generatedSharingURL = "Error while saving: "+error;
            // this.alertStyle="danger";
            // success=false;
        });
      
    },

    async createNewScenarioItem(groupi) {
      var success = true;
      var tries = 4;
      var batchParams = {
        body: {
          outliers: {
            IOPS: 50000,
            IOMB: 12000,
            VCPU: 50
          },
          standard_recommendation_version: this.form.standard_recommendation_version
        }
      };

      //is this a PDB?
      var pdb_response = {};
      if (this.batchItems[groupi].IS_PDB=="YES") {
          tries = 4;
          while (tries > 0) {
            tries -= 1;  
          
            await API.put(
              "dbcsiAPI",
              `/dbcsi/batch/additional_pdb_percentiles/${this.batchItems[groupi].collectionID}`,  
              batchParams
            )
              .then(response => {
                // console.log("additional_pdb_percentiles", response);
                pdb_response = response.data;
                //if we have CDB_IOPS, use those as new outliers
                if (pdb_response.CDB_IOPS != undefined) {
                  
                  batchParams.body.outliers.IOPS = pdb_response.CDB_IOPS;
                  batchParams.body.outliers.IOMB = pdb_response.CDB_IOMB;
                  if (pdb_response.CDB_VCPU != undefined) {
                    batchParams.body.outliers.VCPU = pdb_response.CDB_VCPU;
                  }  
                  console.log("setting new outlier maximums based on parent CDB's metrics (row, IOPS, IOMB, VCPU):", this.batchItems[groupi].row, batchParams.body.outliers.IOPS,batchParams.body.outliers.IOMB, batchParams.body.outliers.VCPU );
                }
                tries=0;
                success=true;
              } 
              )
              .catch(error => {
                console.log("Batch- additional_pdb_percentiles.put Error. Tries:", tries);
                  // this.alertTextRecalc = "Error while additional_datapoints: "+error;
                  // this.alertStyleRecalc="danger";
                  success=false;
              });
          }    
        
      }


      tries = 4;
      while (tries > 0) {
        tries -= 1;  
      
        await API.put(
          "dbcsiAPI",
          `/dbcsi/batch/additional_percentiles/${this.batchItems[groupi].collectionID}`,  
          batchParams
        )
          .then(response => {
            // console.log("additional_percentiles output", response);
            // console.log("additional_percentiles", response.data.standard_recommendation_version, batchParams.body.standard_recommendation_version);
            var main_response=response.data;
            
            //at least acknowledge if there is an error
            if (response.success==false) {
              console.log("Batch- additional_percentiles.put Error", response);
              tries = 0;
              success=false;
            }
            //merge in PDB values
            if (this.batchItems[groupi].IS_PDB=="YES") {
              main_response.DB_PDB2_IOMB_AVERAGE_P99 = pdb_response.DB_PDB2_IOMB_AVERAGE_P99;
              main_response.DB_PDB2_CPU_THREADS_AVERAGE_P99 = pdb_response.DB_PDB2_CPU_THREADS_AVERAGE_P99;
              main_response.DB_PDB2_CPU_THREADS_AVERAGE_P75 = pdb_response.DB_PDB2_CPU_THREADS_AVERAGE_P75;
               // if CDB_IOPS is undefined, then use the outliers
              main_response.CDB_IOPS = pdb_response.CDB_IOPS ?? batchParams.body.outliers.IOPS;
              main_response.CDB_IOMB = pdb_response.CDB_IOMB ?? batchParams.body.outliers.IOMB;
              main_response.CDB_VCPU = pdb_response.CDB_VCPU ?? batchParams.body.outliers.VCPU;
              main_response.CDB_DBID = pdb_response.CDB_DBID;
              main_response.CDB_collectionId = pdb_response.CDB_collectionId;
              main_response.cdb_target_comments = pdb_response.cdb_target_comments;
              if (pdb_response.CDB_IOPS==undefined) {
                main_response.cdb_target_comments += " Using default outliers for (IOPS, IOMB, VCPU).";
                console.log("Default outliers will be used for PDB because CDB not found", batchParams.body.outliers);
              }
             
              
            }
            // look for PDB_COUNT_LINES_PLSQL
            if (main_response.PDB_COUNT_LINES_PLSQL) {
              console.log("CDB missing CONTAINER_DATA adjustments: ", this.batchItems[groupi].collectionID, main_response.PDB_COUNT_LINES_PLSQL, main_response.cdb_target_comments);
              this.batchItems[groupi].COUNT_LINES_PLSQL = main_response.PDB_COUNT_LINES_PLSQL;
            }  
            batchParams.body.inputs = main_response;
            this.batchItems[groupi].additional_datapoints = main_response;
            //Update Exadata - which might not have been detected at first due to FEATURE_Exadata not being reported
            this.batchItems[groupi].Exadata = main_response.Exadata;
            if (main_response.Exadata=="Yes") {
                // ADP and ADW hide the fact that they are exadata!
                // so, we need to also check this after we get additional data points too
                this.IS_EXADATA = true;
            } 

            tries=0;
            success=true;
          } 
          )
          .catch(error => {
            console.log("Batch- additional_percentiles.put Error. Tries:", tries);
              // this.alertTextRecalc = "Error while additional_datapoints: "+error;
              // this.alertStyleRecalc="danger";
              success=false;
          });
      }    
      
      //todo - should do something here if success==false
        
      this.batchItems[groupi].scenario=this.scenarioCount+1;
      this.batchItems[groupi].scenarioName = this.scenarioName;
      if (this.batchItems[groupi].oldRow==undefined) this.batchItems[groupi].oldRow = this.batchItems[groupi].row;
      this.batchItems[groupi].row=Math.round(10*(this.batchItems[groupi].oldRow*1 + 0.1*(this.scenarioCount+1)) ) / 10;
          
          
      // do we calculate a new standard recommendation?
      // Logic:
      // (for now) skip if region is not us-east-1
      // if PDB and no CDB, then calculate a new standard recommendation every time (to protect against case where new CDB data appears)
      // watch out for cpu_threads_ratio.  make sure we explicitly set it to fixed values every time
      if (this.regionCode=='us-east-1') {
        if ( ( (this.batchItems[groupi].IS_PDB == 'YES') && (this.batchItems[groupi].additional_datapoints.CDB_collectionId == undefined) )
           || (this.batchItems[groupi].additional_datapoints.standard_recommendation_version == undefined) || (this.batchItems[groupi].additional_datapoints.standard_recommendation_version != batchParams.body.standard_recommendation_version)  ) {
          console.log("Calculating initial recommendation",this.batchItems[groupi].collectionID);
          
          var original_form=this.form;
          // var original_item=this.batchItems[groupi];
          var original_rds_type = this.batchItems[groupi].rds_type;
          var original_volumeType = this.batchItems[groupi].VolumeType;
          


          
          //do work
          this.form = this.standard_form;
          
          this.batchItems[groupi].rds_type = "ee";
          this.batchItems[groupi].VolumeType = "gp3";
          
          // set cpu_thread_ratio

          this.form.cpu_thread_ratio = 1.0;
          if (this.batchItems[groupi].PLATFORM_NAME=="AIX-Based_Systems_(64-bit)") {
                this.form.cpu_thread_ratio = 2.5;
          }
          if (this.batchItems[groupi].PLATFORM_NAME=="Solaris[tm]_OE_(64-bit)") {
                
                this.form.cpu_thread_ratio = 4.9;
          }
          if (this.batchItems[groupi].PLATFORM_NAME=="HP-UX_IA_(64-bit)") {
               
                this.form.cpu_thread_ratio = 3.4;
          }
        
          this.batchItems[groupi].frozen_prefs = this.form;
          
          await this.recalcSingle(groupi);
          // console.log("rds_shape", this.batchItems[groupi].targetconfig_rds.shape);
          if ((this.batchItems[groupi].rds_shape=='N/A') &&  (this.batchItems[groupi].targetconfig_ec2fsxn==undefined)) {
            //lets try this one as rac
            console.log("try to make a RAC standard recommendation");
            this.batchItems[groupi].rds_type = "rac";
            // this.batchItems[groupi].targetconfig_rds.rds_type ="rac";
            this.batchItems[groupi].TargetPlatform = "";
            this.form.rds_algo="rac";
            this.batchItems[groupi].frozen_prefs = this.form;
            await this.recalcSingle(groupi);
          }
          // console.log("standard recommendation", groupi, JSON.stringify(this.batchItems[groupi]).length );
          // console.log(JSON.stringify(this.batchItems[groupi]));
          
          //save standard_recommendation
          var tempRecommendation = JSON.parse(JSON.stringify(this.batchItems[groupi]));
          batchParams = {
            body: {
              standard_recommendation_version: this.form.standard_recommendation_version,
              recommendation: tempRecommendation           
            }
          };
          
          // now reset values and re-calculate
          // restore original values
          this.form = original_form;
          this.batchItems[groupi].rds_type = original_rds_type;
          this.batchItems[groupi].VolumeType = original_volumeType;
          this.batchItems[groupi].TargetPlatform = "";
          this.batchItems[groupi].frozen_prefs = this.form;
          await this.recalcSingle(groupi);
          
          // now finally do the storing of recommendation (we do this after reset/recalc so that the UI doesn't update showing the internal values)
        
          await API.put(
            "dbcsiAPI",
            `/dbcsi/recommendation/${this.batchItems[groupi].collectionID}`,
            batchParams
          )
            .then(response => {
              // success = true;
              // console.log("Batch- putBatch: put success");
                // this.alertText = "Saving Sizing Output to Database... Saved "+groupi+" of "+num_items;
            })
            .catch(error => {
              console.log("Batch- recommendation:", error);
                // this.alertText = "Error while saving: "+error;
                // this.alertStyle="danger";
                // success=false;
            });
            
            
          
          
        } 
      }
      this.batchItems[groupi].frozen_prefs = JSON.parse(JSON.stringify(this.form));
      await this.recalcSingle(groupi);
      // console.log("recommendation", groupi, JSON.stringify(this.batchItems[groupi]).length );
      // console.log(JSON.stringify(this.batchItems[groupi]));
      
      return success;
    },

    async createNewScenario(evt) {
      evt.preventDefault();
      
        // strip out * from scenarioName
      this.scenarioName = this.scenarioName.replace(/\*/g, '');  
      
      // check that scenarioName is unique
      var uniqueName = true;
      for (var scen=0; scen<this.scenarios.length; scen++) {
        if (this.scenarios[scen].text==this.scenarioName) {
          console.log("createNewScenario - duplicateScenarioName");
          uniqueName = false;
        }  
      }
      if (! uniqueName) {
        this.alertStyleRecalc="danger";
        this.alertTextRecalc = "Error.  Cannot Create Scenario using an existing scenario name.  Please pick a different name.";
      } else {
      
      this.showAlertRecalc = true;
      this.triggerFullRecalculateFlag = false;
      this.alertStyleRecalc="primary";
        this.disableScenarioButton=true;      
        
      

      this.alertTextRecalc = "Creating Scenario... Please wait...";
      this.showAlertRecalc = true;
      // this.scenarioCount++; don't update this till the end as we use it hide the replace scenario button
      this.scenarios.push({ value: this.scenarioCount+1, text: this.scenarioName});
      this.scenarioSelected = this.scenarioCount+1;
      // this.allScenarios.push(this.scenarioName);

      var tries = 10;
      var success = true;


      var batchParams = {
        body: {
          batchID: this.batch_id
        }
      };
      
      if (this.scenarioCount>0) {
        //this is not the first time, so we can just copy the base row (scenario=1)
       
          this.perPage=this.perPage+10;
          
          var num_items=this.batchItems.length;
          var groupi=num_items;
          while (groupi>0 && success) {
            groupi--;
            

            // only copy the base scenario and dont copy readreplicas
            if (  (this.batchItems[groupi].scenario==1) && 
                   (this.batchItems[groupi].manual==undefined || this.batchItems[groupi].manual!='YES') &&
                   (this.batchItems[groupi].ReadReplica==undefined || this.batchItems[groupi].ReadReplica!='Y')
                   ) {

              // let original_algos = JSON.parse(JSON.stringify(this.form));

              
              var newItem = structuredClone(this.batchItems[groupi]);
              newItem.copy="yes"; // some marker that it is a copy
              newItem.scenario=this.scenarioCount+1;
              newItem.row=Math.round(10*(newItem.oldRow*1 + 0.1*(this.scenarioCount+1)) ) / 10;
              
              // newItem.database = newItem.database + " ("+this.scenarioName+")";
              newItem.scenarioName = this.scenarioName;
              // console.log("experiment: ", this.form.rds_algo, newItem.rds_type);
              newItem.rds_type = this.form.rds_algo;
              newItem.TargetPlatform = "";
              
              newItem.frozen_prefs = JSON.parse(JSON.stringify(this.form));

              // add the new row
              this.batchItems.splice(groupi+1,0,newItem);  

              // recalc the newly added row (hence the +1)
              this.recalcSingle(groupi+1);
  
              // this.form = original_algos;


            }
                
            this.alertTextRecalc = "Create Scenario... Processed "+groupi+" of "+num_items;
             
  
          } //end for loop
          
           await this.postBatchSizing();
        
      } // end 2ndtime creation logic (copy versus re-running additional_permissions)
      else
      {
        //this is the first time, so we need to call additional datapoints


        //clear out existing configs
                 
        for (var agroupi=0; agroupi< this.batchItems.length ; agroupi++) {
          this.batchItems[agroupi].targetconfig_rds = {};
          delete this.batchItems[agroupi].targetconfig_aurora ;
          delete this.batchItems[agroupi].targetconfig_elasticache;
          this.batchItems[agroupi].TargetPlatform = "";
          this.batchItems[agroupi].additional_datapoints = null;
          this.batchItems[agroupi].rds_type = this.form.rds_algo;

        }  

        //do a put to /batch/recalc_targets/:batch_id


          var chunk=1;
          var num_items=this.batchItems.length;
          for (var groupi=0; groupi< num_items && success; groupi+=chunk) {
            success = await this.createNewScenarioItem(groupi);
            this.alertTextRecalc = "Create Scenario... Processed "+groupi+" of "+num_items;
          } //end for loop
          
           await this.postBatchSizing();
          
        
      }  //end first-time creation logic
      
      if (success) {
        this.alertTextRecalc = "Create Scenario Finished.";
        this.alertStyleRecalc="success";
      }
      
      // features for the create New Scenario
      let features_params = { body: this.form};
      features_params.body.numDatabases = this.batchItemsOrigLength;
      features_params.body.hasASVs = this.batchItemsHasASVs;
      
      await API.put(
        "dbcsiAPI",
        `/dbcsi/features`,  
        features_params
      )
        .then(response => {
          // console.log("Batch-features", response);
         } 
        )
        .catch(error => {
          console.log("Batch- features Error. ");
            // this.alertTextRecalc = "Error while additional_datapoints: "+error;
            // this.alertStyleRecalc="danger";
            success=false;
        });
    
      
      //now advance scenarioCount
      this.scenarioCount++;
      
      //reset name for next scenario
      this.scenarioName = "Scenario "+(this.scenarioCount+1);
      
      this.disableScenarioButton=false;
      }
    },
    
    async replaceExistingScenario(evt) {
      evt.preventDefault();
      this.triggerFullRecalculateFlag = false;
      this.alertStyleRecalc="primary";
        this.disableScenarioButton=true;      

      this.alertTextRecalc = "Replacing Scenario... Please wait...";
      this.showAlertRecalc = true;


      
      var tries = 10;
      var success = true;


      var num_items=this.batchItems.length;
      var groupi=num_items;
      while (groupi>0 && success) {
        groupi--;
        

        // if this is a match and a read replica, then delete the row
        if (  (this.batchItems[groupi].scenario==this.scenarioSelected) && (this.batchItems[groupi].ReadReplica!=undefined && this.batchItems[groupi].ReadReplica=='Y') ) {
          this.batchItems.splice(groupi,1);
        } else {
          
          // if this is a match (and not a manual edit), then update the prefs and recalculate
          if (  (this.batchItems[groupi].scenario==this.scenarioSelected) && (this.batchItems[groupi].manual==undefined || this.batchItems[groupi].manual!='YES') ) {
  
            this.batchItems[groupi].rds_type = this.form.rds_algo;
            this.batchItems[groupi].TargetPlatform = "";
  
            // recalc the row
            this.batchItems[groupi].frozen_prefs = JSON.parse(JSON.stringify(this.form));
            this.recalcSingle(groupi);
  
          }
          
          // if this is a match and a manual edit, then delete the row
          if (  (this.batchItems[groupi].scenario==this.scenarioSelected) && (this.batchItems[groupi].manual!=undefined && this.batchItems[groupi].manual=='YES') ) {
            this.batchItems.splice(groupi,1);
          }
        }  
            
        this.alertTextRecalc = "Replace Scenario... Processed "+groupi+" of "+num_items;
         

      } //end for loop
      
       await this.postBatchSizing();
        

      if (success) {
        this.alertTextRecalc = "Replace Scenario Finished.";
        this.alertStyleRecalc="success";
      }
      
      // features for the Replace Scenario
      let features_params = { body: this.form};
      features_params.body.numDatabases = this.batchItemsOrigLength;
      features_params.body.hasASVs = this.batchItemsHasASVs;
      
      await API.put(
        "dbcsiAPI",
        `/dbcsi/features`,  
        features_params
      )
        .then(response => {
          // console.log("Batch-features", response);
         } 
        )
        .catch(error => {
          console.log("Batch- features Error. ");
            // this.alertTextRecalc = "Error while additional_datapoints: "+error;
            // this.alertStyleRecalc="danger";
            success=false;
        });
      
        this.disableScenarioButton=false;      
    },


    async manualEditScenario() {

        this.disableScenarioButton=true;
        this.alertStyleRecalc="primary";

        this.alertTextRecalc = "Creating Manual Edit Scenario... Please wait...";
        this.showAlertRecalc = true;
        
        //logic: do we already have a copy of this scenario created?
          var num_items=this.batchItems.length;
          var groupi=num_items;    
          var foundOne=false;
          while ( (groupi>0 ) && !foundOne ) {
            groupi--;
            if ( (this.batchItems[groupi].scenario==this.scenarioSelected) && (this.batchItems[groupi].manual=="YES") ) {
              //found one
              foundOne=true;
            }
          }  

        if (!foundOne) {
        //logic: make a copy of selected scenario...
        // console.log("make a copy of selected scenario for manual editing..");
          this.perPage=this.perPage+10;

          // this.allScenarios.push( this.scenarioSelected+"*");
          // this.allScenarios.sort();
          
          groupi=num_items; 
          while (groupi>0 ) {
            groupi--;
            

            // only copy the selected scenario.
            if (  (this.batchItems[groupi].scenario==this.scenarioSelected) ) {

              // let original_algos = JSON.parse(JSON.stringify(this.form));

              
              var newItem = JSON.parse(JSON.stringify(this.batchItems[groupi]));
              newItem.copy="yes"; // some marker that it is a copy
              newItem.manual="YES";
              // newItem.row=Math.round(10*(newItem.row+0.05) ) / 10; 
              newItem.assumptionsString="Manually edited target values";
              newItem.assumptionsArray=[];
              newItem.frozen_prefs.ec2fsxn_baremetal_showdetail = "";
              
              // newItem.database = newItem.database + " ("+this.scenarioName+")";
              newItem.scenarioName = newItem.scenarioName+"*";
              // console.log("experiment: ", this.form.rds_algo, newItem.rds_type);

              // add the new row
              this.batchItems.splice(groupi+1,0,newItem);  

            }
                
          } //end for loop
          // console.log("finished: make a copy of selected scenario for manual editing..");
          
        } //end make a copy  
        await this.postBatchSizing();
        this.alertTextRecalc = "Manual Edit Scenario Created.";
        this.alertStyleRecalc="success";
        
        this.disableScenarioButton=false;
    },  

    async manualEditReconfig(value) {
        this.disableScenarioButton=true;      
      // console.log('manualEditReconfig',value);
        
        // recalculate only the manual=YES and scenario=this.scenarioSelected rows
          var num_items=this.batchItems.length;
          var groupi=num_items;
          while (groupi>0 ) {
            groupi--;
            
            // only recalc  the manual edit rows
            if (  (this.batchItems[groupi].manual=="YES") ) {
              // console.log("recalculating",groupi,this.batchItems[groupi].rds_type);
              //temp hack: reset target to RDS to recalculate stuff like disk space > 64TB
              this.batchItems[groupi].TargetPlatform='RDS';

            //if we are changing the rds_type, then we need to leave manual pick mode
            // if ( (value=="ee") || (value=="se") || (value=="rac")|| (value=="custom") ) {
            //   if ( (this.batchItems[groupi].UseManualShape=="Y") && (this.batchItems[groupi].rds_type!=value) ) {
            //     console.log("Leaving manual pick shape mode when you change the rds_type.");
            //     this.batchItems[groupi].UseManualShape="N";
            //   }  
            // }

            if ( (this.batchItems[groupi].ReadReplica != undefined) && (this.batchItems[groupi].ReadReplica=='Y') ) {
                 // Size the replica
                // await this.changeDRRegion(this.batchItems[groupi].frozen_prefs.readreplica_region);
                this.runSizingSingle(groupi, this.DRregionInfo, false);
            } else {    
              this.runSizingSingle(groupi, this.regionInfo, true);
            }  
            


            }
            
          }
           await this.postBatchSizing();
        this.disableScenarioButton=false;
    },  

    // this is currently not used
    async manualEditRecalc(value) {
        this.disableScenarioButton=true;      
      // console.log('manualEditReconfig',value);
        // we are leaving
        // recalculate only the manual=YES and scenario=this.scenarioSelected rows
          var num_items=this.batchItems.length;
          var groupi=num_items;
          while (groupi>0 ) {
            groupi--;
            
            // only recalc  the manual edit rows
            if (  (this.batchItems[groupi].manual=="YES") ) {
              // console.log("recalculating",groupi);
              //temp hack: reset target to RDS to recalculate stuff like disk space > 64TB
              this.batchItems[groupi].TargetPlatform='RDS';
            
              this.recalcSingle(groupi);

            }
            
          }
           await this.postBatchSizing();
        this.disableScenarioButton=false;
    },  


    async recalcSingle(groupi) {
      
      // console.log('recalcSingle',groupi);
  
        var batchParams = {
          body: {
            batchRow: this.batchItems[groupi].row,
            prefs: this.form
          }
        };
            
       var response = {
          data: ""
        };
        
        batchParams.body.inputs =  this.batchItems[groupi].additional_datapoints;

        
        //add in AIX_CPU_ADJUSTMENT
        if (this.batchItems[groupi].AIX_CPU_ADJUSTMENT*1>0) {
                batchParams.body.inputs.AIX_CPU_ADJUSTMENT = this.batchItems[groupi].AIX_CPU_ADJUSTMENT;
        }
        
        // console.log("pre calc", batchParams.body.inputs);
        response.data = calculate_target_values(batchParams);
        // console.log("post calc", response.data);
        // console.log("calc A");
            

                
        //console.log("Batch- recalc_targets: put success");
        
        this.batchItems[groupi].VCPU=response.data.VCPU;
        this.batchItems[groupi].OrigVCPU=response.data.OrigVCPU;
        this.batchItems[groupi].Memory=response.data.Memory;
        this.batchItems[groupi].OrigMemory=response.data.OrigMemory;
        this.batchItems[groupi].DiskSpace=response.data.DiskSpace;
        this.batchItems[groupi].IOPS=response.data.IOPS;
        this.batchItems[groupi].Throughput=response.data.Throughput;
        this.batchItems[groupi].OrigThroughput=response.data.OrigThroughput;
        this.batchItems[groupi].OrigIOPS=response.data.OrigIOPS;
        
        // this.batchItems[groupi].TargetPlatform=response.data.TargetPlatform;
        this.batchItems[groupi].UseMAZ=response.data.UseMAZ;
        this.batchItems[groupi].UseRI=response.data.UseRI;
        this.batchItems[groupi].optgoal_choice=response.data.optgoal_choice;
        this.batchItems[groupi].cpu_thread_ratio=response.data.cpu_thread_ratio;
       // this.batchItems[groupi].pdb_algo=response.data.pdb_algo;
       //  this.batchItems[groupi].smartscan_algo=response.data.smartscan_algo;
       // this.batchItems[groupi].smartscan_minimum=response.data.smartscan_minimum;
       // this.batchItems[groupi].nvme_shape_algo=response.data.nvme_shape_algo;
       // this.batchItems[groupi].tshape_algo=response.data.tshape_algo;
      //  this.batchItems[groupi].extMemShape_algo=response.data.extMemShape_algo;
        
        this.batchItems[groupi].Comments='';
        this.batchItems[groupi].cpu_target_comments=response.data.cpu_target_comments;
        this.batchItems[groupi].iomb_target_comments=response.data.iomb_target_comments;
        this.batchItems[groupi].iops_target_comments=response.data.iops_target_comments;
        this.batchItems[groupi].memory_target_comments=response.data.memory_target_comments;
        this.batchItems[groupi].cdb_target_comments=response.data.cdb_target_comments;
        this.batchItems[groupi].diskspace_target_comments=response.data.diskspace_target_comments;
        this.batchItems[groupi].NUM_PDBS=response.data.NUM_PDBS;
        
        this.batchItems[groupi].CDB_IOPS=response.data.CDB_IOPS;
        this.batchItems[groupi].CDB_DBID=response.data.CDB_DBID;
        this.batchItems[groupi].CDB_IOMB=response.data.CDB_IOMB;
        this.batchItems[groupi].CDB_VCPU=response.data.CDB_VCPU;
        this.batchItems[groupi].CDB_collectionId=response.data.CDB_collectionId;
        
        this.batchItems[groupi].VolumeType=response.data.VolumeType;
        this.batchItems[groupi].SmartScanEligible=response.data.DB_EXA_CELL_BYTES_ELIG_MB_P99;
        this.batchItems[groupi].StorageIndexSavings=response.data.DB_EXA_CELL_SI_SAVE_MB_P99;
        this.batchItems[groupi].ThroughputMaxAverage=response.data.DB_IOMB_AVERAGE_P99;
        this.batchItems[groupi].ExadataAdjustmentText=response.data.ExadataAdjustmentText;                
        this.batchItems[groupi].ExadataAdjustment=response.data.ExadataAdjustment;                
        this.batchItems[groupi].ExadataVCPUAdjustmentText=response.data.ExadataVCPUAdjustmentText;     
        
        this.batchItems[groupi].assumptionsString = response.data.assumptionsString;
        this.batchItems[groupi].assumptionsArray = response.data.assumptionsArray;
        
        this.batchItems[groupi].AIX_CPU_ADJUSTMENT_USED = response.data.AIX_CPU_ADJUSTMENT_USED;
        
                  
        this.runSizingSingle(groupi, this.regionInfo, true);

        // if we can't size of RDS-Oracle, automatically try to size for EC2-FSXN
       //if (this.showBeta) {
        // intentional toggle, see line above
        // eslint-disable-next-line no-constant-condition
        if (true) {
          if (this.batchItems[groupi].rds_shape=='N/A') {
            // lets try this one as ec2-fsxn
            // but only if this is not a manual edit and not if they already asked for ec2-fsxn
            if ( !(this.batchItems[groupi].frozen_prefs.ec2fsxn_algo == "Y") && (this.batchItems[groupi].frozen_prefs.rds_algo != "se") && ((this.batchItems[groupi].manual==undefined || this.batchItems[groupi].manual!='YES') ) ) {
              console.log("trying to auto-add a EC2-FSXN recommendation for row:", this.batchItems[groupi].row);
              // copy frozen_prefs to make sure we don't update every database
              this.batchItems[groupi].frozen_prefs = JSON.parse(JSON.stringify(this.batchItems[groupi].frozen_prefs));
              this.batchItems[groupi].frozen_prefs.ec2fsxn_algo = "Y";
              this.batchItems[groupi].frozen_prefs.ec2fsxn_baremetal_ranking = "minimumCost";
              this.batchItems[groupi].frozen_prefs.ec2fsxn_corefactor = "positiveguess";
              this.batchItems[groupi].frozen_prefs.ec2fsxn_baremetal_HA = "single";
              this.batchItems[groupi].frozen_prefs.ec2fsxn_baremetal_showdetail = "ec2only";
  
              this.runSizingSingle(groupi, this.regionInfo, true);
            }  
          } else {
            // unset ec2fsxn_baremetal_showdetail.  it might have been left set before a manual edit resolved it
            this.batchItems[groupi].frozen_prefs.ec2fsxn_baremetal_showdetail = "";
          }
         
        }
        
      
    },


    
    
    async changeODBRecalculate(value) {
       // console.log('show changeODBRecalculate',value, this.form.odbAWS_HA);
       if (value=="adb") {
         // assume x11m and ecpu for ADB for now
         this.form.odbAWS_model="X11M"; 
         this.form.odbAWS_DR="Y"; 

         // if (this.form.odbAWS_DR=="Y20") { this.form.odbAWS_DR="Y"; }
         // if (this.form.odbAWS_DR=="YMA20") { this.form.odbAWS_DR="Y"; }
         // if (this.form.odbAWS_DR=="YMA") { this.form.odbAWS_DR="Y"; }
         
         this.form.odbAWS_HA="Y";
         // if (this.form.odbAWS_HA=="Y20") { this.form.odbAWS_HA="Y"; }
         // if (this.form.odbAWS_HA=="UseMAZ") { this.form.odbAWS_HA="Y"; }
         
         this.form.odbAWS_StorageStyle="default";
         // if (this.form.odbAWS_StorageStyle=="SPARSE") { this.form.odbAWS_StorageStyle="default"; }
         // if (this.form.odbAWS_StorageStyle=="BOTH") { this.form.odbAWS_StorageStyle="BACKUP"; }
       }
       if (value=="adbs-tp") {
         this.form.odbAWS_HA="UseMAZ";
         this.form.odbAWS_DR="N";
       }
       if (value=="exacs") {
         this.form.odbAWS_HA="Y20"; 
         this.form.odbAWS_DR="Y20";
       }
       if (value=="exascale") {
         this.form.odbAWS_HA="Y20"; 
         this.form.odbAWS_DR="Y20";
       }
      this.showAlertRecalc = false;
      this.triggerFullRecalculateFlag = true;
    },  


    async triggerFullRecalculate(value) {
      // console.log('show calculate message',value);
      this.showAlertRecalc = false;
      this.triggerFullRecalculateFlag = true;
    },  




    // async changeAurora(value) {
    //   if (this.scenarioCount>0) {
    //     this.runSizingAll(false);
    //     this.alertTextRecalc = "Aurora preference changed: "+value;
    //   }  
    // },  



    populateShapeLovs(rds_type) {
      //now populate rdsShapesEE_lov
      // console.log("populateShapeLovs",rds_type);
      var myLOV=[];
      var shape_list = JSON.parse(JSON.stringify(this.regionInfo.shapes));
      // filter list
      var max_storage_throughput = 4000;
     if (rds_type=="rac") max_storage_throughput = 16*1000;

      var filter_shape_list = [];
      if (rds_type=="ee") filter_shape_list= shape_list.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (rds_type=="se") filter_shape_list= shape_list.filter(value => (value.OracleLIse2_OD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (rds_type=="custom") filter_shape_list= shape_list.filter(value => (value.OracleCustomOD*1 > 0) && !(value.Name.includes('tpc1')) );
      if (rds_type=="rac") filter_shape_list= shape_list.filter(value => (value.OracleOD*1 > 0) && !(value.Name.includes('tpc')) && 
         ( value.Name.includes('r5.') || value.Name.includes('r5b.') || value.Name.includes('m6i.') || value.Name.includes('r6i.') || value.Name.includes('x2iedn.') || value.Name.includes('r6in.')) );
      if (rds_type=="ec2BM") {
        if (this.form.ec2fsxn_shape_scope=="all") {
          // any EC2 shape (regular or Bare Metal), excluding Graviton (Oracle not supported on ARM)
          filter_shape_list= shape_list.filter(value => (value.LinuxOD*1 > 0) && !(/[0-9]g/.test((value.Name||"").split('.')[0])) );
        } else {
          filter_shape_list= shape_list.filter(value => (value.OracleCoreFactor*1 > 0) && ( value.Name.includes('.metal') ) );
        }
      }
      if (rds_type=="ec2") filter_shape_list= shape_list.filter(value => (value.LinuxOD*1 > 0)    );

      //now sort by VCPU, Memory, Name
       function compareShape(a, b) {
         
         var itemA = 0;
         var itemB = 0;
         
           itemA = a.VCPU * 10000 + a.Memory;
           itemB = b.VCPU * 10000 + b.Memory;

        let comparison = 0;
        
        // sort by family, then by VCPU and Memory
        if (a.Name.split(".")[0] > b.Name.split(".")[0]) {
          comparison = 1;
        } else if (a.Name.split(".")[0] < b.Name.split(".")[0]) {
          comparison = -1;
        } else  {
          
          if (itemA > itemB) {
            comparison = 1;
          } else if (itemA < itemB) {
            comparison = -1;
          }
        }
        
        return comparison;
      }
      
     //sort
     filter_shape_list.sort(compareShape);
      
      
      //build LOV...
      if (filter_shape_list.length==0) {
        myLOV.push({value:"", text: "No available shapes for this region", disabled: true});
      } else {
        
        var last_family=filter_shape_list[0].Name.split(".")[0];
        
        for (var ii = 0; ii < filter_shape_list.length; ii++) {
          var myRow = {value: "", text: ""};
          
          myRow.value=filter_shape_list[ii].Name;
          var cost = filter_shape_list[ii].OracleOD;
          if (rds_type=="se") cost = filter_shape_list[ii].OracleLIse2_OD;
          if (rds_type=="custom") cost = filter_shape_list[ii].OracleCustomOD;
          if (rds_type=="ec2") cost = filter_shape_list[ii].LinuxOD;
  
  
          if (rds_type=="ec2BM") {
            // myRow.text = `${filter_shape_list[ii].Name} --- ${filter_shape_list[ii].VCPU} VCPU${filter_shape_list[ii].Name.startsWith('t') ? " (bursting)" :""}, ${filter_shape_list[ii].Memory} GB, ${ Math.round(filter_shape_list[ii].Network/8) } MB/s Network at $${filter_shape_list[ii].LinuxOD}/hour.  [ benchmark=${filter_shape_list[ii].Geekbench5CoreScoreRounded}, CF=${filter_shape_list[ii].OracleCoreFactor}? ${ (filter_shape_list[ii].OracleCoreFactorConfidence=='maybe') ? 'maybe?' : '' } ]`;
            
            myRow.text = `${filter_shape_list[ii].Name} --- ${filter_shape_list[ii].VCPU} VCPU${filter_shape_list[ii].Name.startsWith('t') ? " (bursting)" :""}, ${filter_shape_list[ii].Memory} GB, ${ Math.round(filter_shape_list[ii].Network/8) } MB/s Network at $${filter_shape_list[ii].LinuxOD}/hour.  [ ${filter_shape_list[ii].Processor} ]`;
          } else if (rds_type=="ec2") {
            myRow.text = `${filter_shape_list[ii].Name} with ${filter_shape_list[ii].VCPU} VCPU${filter_shape_list[ii].Name.startsWith('t') ? " (bursting)" :""}, ${filter_shape_list[ii].Memory} GB, ${filter_shape_list[ii].Throughput} MB/s${filter_shape_list[ii].BaselineThroughput!=null ? " (bursting)" :""}${(filter_shape_list[ii].Throughput*1>max_storage_throughput) ? " but storage maxes out at "+max_storage_throughput+" MB/s" : ""}, ${filter_shape_list[ii].IOPS} IOPS${filter_shape_list[ii].BaselineIOPS!=null ? " (bursting)" :""} at $${cost}/hour`;
          }
          else {
            myRow.text = `db.${filter_shape_list[ii].Name} with ${filter_shape_list[ii].VCPU} VCPU${filter_shape_list[ii].Name.startsWith('t') ? " (bursting)" :""}, ${filter_shape_list[ii].Memory} GB, ${filter_shape_list[ii].Throughput} MB/s${filter_shape_list[ii].BaselineThroughput!=null ? " (bursting)" :""}${(filter_shape_list[ii].Throughput*1>max_storage_throughput) ? " but storage maxes out at "+max_storage_throughput+" MB/s" : ""}, ${filter_shape_list[ii].IOPS} IOPS${filter_shape_list[ii].BaselineIOPS!=null ? " (bursting)" :""} at $${cost}/hour`;
          }
          
           //add a splitter between families
           if ( (rds_type!="ec2BM") && (last_family != filter_shape_list[ii].Name.split(".")[0]) ) {
             myLOV.push({value:"", text: "-------------------------------------------------", disabled: true});
             last_family = filter_shape_list[ii].Name.split(".")[0];
           }
           
           myLOV.push(myRow);
  
        } 
      }

      if (rds_type=="ee") this.rdsShapesEE_lov = myLOV;
      if (rds_type=="se") this.rdsShapesSE_lov = myLOV;
      if (rds_type=="custom") this.rdsShapesCustom_lov = myLOV;
      if (rds_type=="rac") this.rdsShapesRAC_lov = myLOV;
      if (rds_type=="ec2BM") this.ec2BMShapes_lov = myLOV;
      if (rds_type=="ec2") this.ec2Shapes_lov = myLOV;
    },
    
    async changeRegion(value) {
      // console.log('changeRegion',value);
      // this.showAlertRecalc = false;
      // this.triggerFullRecalculateFlag = true;

      this.regionCode=value;
      
      // Disable ODB@AWS if switching to a China region
      if (value === 'cn-north-1' || value === 'cn-northwest-1') {
        this.form.odbAWS_algo = 'N';
      }

    // now load Region info
      await axios
        .get("/db-"+value+".json")
        .then(response => {
          // console.log("I am here4");
          this.regionInfo = response.data;
        
      })
        .catch(error => {
          console.log("Batch-Load regionInfo data Error:", error);
      });
      
      this.populateShapeLovs("ee");
      this.populateShapeLovs("se");
      this.populateShapeLovs("custom");
      this.populateShapeLovs("rac");
      this.populateShapeLovs("ec2BM");
      this.populateShapeLovs("ec2");

          // clear out volumeType when we switch regions because io2 may or may not be there
          for (var bi = 0; bi < this.batchItems.length; bi++) {
            this.batchItems[bi].VolumeType='';
          } //for (var bi=0) loop
      
                  
      if (this.scenarioCount>0) {
        this.runSizingAll(false);
        this.alertTextRecalc = "Region changed to "+this.regionCode;
      }  
    },  

    async changeDRRegionLOV(value) {
      // console.log('changeDRRegionLOV',value);

      // this.showAlertRecalc = false;
      // this.triggerFullRecalculateFlag = true;

     await this.changeDRRegion(value);
      if (this.scenarioCount>0) {
        this.runSizingAll(false);
        this.alertTextRecalc = "DR Region changed to "+this.DRregionCode;
      }  
     
    },  

    async changeDRRegion(value) {
      // console.log('changeDRRegion',value);

      // this.showAlertRecalc = false;
      // this.triggerFullRecalculateFlag = true;

     if ( this.DRregionCode!=value) {
       // console.log('changeDRRegion - loading ',value);  
      // now load Region info
        await axios
          .get("/db-"+value+".json")
          .then(response => {
            // console.log("changeDRRegion - I am here4");
            this.DRregionInfo = response.data;
            this.DRregionCode=value;
          
        })
          .catch(error => {
            console.log("Batch-Load regionInfo data Error:", error);
        });
      }
    },  


    async runSizingAll(checked) {
      // console.log('runSizingAll', checked);
      if (!checked) {
        

        this.alertStyle="primary";
        this.alertText = "Sizing database environments... Please wait...";
        this.showAlert = true;
    
        //   console.log("Submit: I am here1");
        var success = true;
        if (success) {
          // console.log("Submit: I am here2");
    
          // Loop logic
          // for each row in this.batchItems
          

          for (var bi = 0; bi < this.batchItems.length; bi++) {
            // console.log("AutoSizing:" + this.batchItems[bi].database);
            
            //temp hack: reset target to RDS to recalculate stuff like disk space > 64TB
            this.batchItems[bi].TargetPlatform='RDS';
            
            // is this a read replica?
            if ( (this.batchItems[bi].ReadReplica != undefined) && (this.batchItems[bi].ReadReplica=='Y') ) {
                 // Size the replica
                 // reset the readreplica_region to the lastest
                 console.log("RunSizingAll for RR", bi);
                this.batchItems[bi].frozen_prefs.readreplica_region=this.DRregionCode;
                this.batchItems[bi].ReadReplicaRegion=this.DRregionCode;
                this.runSizingSingle(bi, this.DRregionInfo, false);
            } else {    
              this.runSizingSingle(bi, this.regionInfo, true);
            }  
           
    
          } //for (var bi=0) loop
          
           await this.postBatchSizing();
          

    
          this.alertText = "Auto-right-sizing finished.";
          this.alertStyle="success";
    
          // console.log("Auto-right-sizing finished");
        }
      }
    },
    
    onReset(evt) {
      evt.preventDefault();
    }
  },
  
  
  computed: {
    // Drives the Skip Shape Filter dropdown, which stores form.rdsSkipShape_preset ("custom" = use form.rdsSkipShape_expr)
    skipShapePreset: {
      get() {
        if (this.form.rdsSkipShape_preset === "custom") return "custom";
        let skipShape = resolve_skip_shape_filter(this.form);
        if (skipShape.preset) return skipShape.preset.key;
        return (skipShape.expr === "") ? "none" : "custom";
      },
      set(value) {
        // $set because forms saved before rdsSkipShape_preset existed don't have the property
        if (value === "custom") {
          // start the custom pattern from the current preset's regex (same filter, so no recalculation needed)
          let skipShape = resolve_skip_shape_filter(this.form);
          this.$set(this.form, "rdsSkipShape_preset", "custom");
          this.form.rdsSkipShape_expr = skipShape.expr;
        } else {
          this.$set(this.form, "rdsSkipShape_preset", (value === "none") ? "" : value);
          this.form.rdsSkipShape_expr = "";
          this.triggerFullRecalculate(value);
        }
      }
    },
    skipShapePatternError() {
      try {
        get_skip_shape_regex({rdsSkipShape_expr: this.form.rdsSkipShape_expr});
        return "";
      } catch (e) {
        return "Invalid pattern: " + e.message;
      }
    },
    isChinaRegion() {
      return this.regionCode === 'cn-north-1' || this.regionCode === 'cn-northwest-1';
    },
    // Number of databases that will be included in the server-side PowerPoint for
    // the currently selected scenario. Mirrors the include logic in
    // buildPPTXScenario so the time estimate matches what actually gets generated.
    pptxDbCount() {
      if (!this.selectedPPTXScenario) return 0;
      let count = 0;
      for (let groupi = 0; groupi < this.batchItems.length; groupi++) {
        const item = this.batchItems[groupi];
        const includePDBCDB = (item.PDBandCDBmatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.pdb_and_cdb_exclude_algo === "none") ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludePDB") && (item.PDBandCDBmatch !== "PDBwithParent")) ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludeCDB") && (item.PDBandCDBmatch !== "CDBwithChild")));
        const includeDuplicate = (item.DuplicateMatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.duplicate_database_exclude_algo === "none") ||
            ((item.frozen_prefs.duplicate_database_exclude_algo === "excludeDuplicates") && (item.DuplicateMatch === "OriginalDatabase")));
        if (includePDBCDB && includeDuplicate && item.scenarioName === this.selectedPPTXScenario) {
          count++;
        }
      }
      return count;
    },
    // Charts drive the per-database generation time (~0.25 min each); skipping them
    // is fast, so the estimate/warnings below only apply when charts are included.
    pptxIncludeCharts() {
      return !this.pptxNoCharts;
    },
    pptxEstimateMinutes() {
      return Math.ceil(this.pptxDbCount * 0.25);
    },
    pptxShowTimeEstimate() {
      return this.pptxIncludeCharts && this.pptxDbCount > 4;
    },
    pptxTimeoutWarning() {
      return this.pptxIncludeCharts && this.pptxDbCount > 60;
    },
    filteredBatchItems() {
      let filtered = this.batchItems;
      
      // Filter by scenario if one is selected
      if (this.selectedScenarioFilter) {
        filtered = filtered.filter(item => item.scenarioName === this.selectedScenarioFilter);
      }
      
      // Hide duplicates/overlapping databases if checkbox is checked
      if (this.hideDuplicates) {
        filtered = filtered.filter(item => {
        
          
          if ( ( item.PDBandCDBmatch!=undefined ) && (item.frozen_prefs.pdb_and_cdb_exclude_algo == "excludePDB") && (item.PDBandCDBmatch=="PDBwithParent") ) { return false; }
          
          if ( ( item.PDBandCDBmatch!=undefined ) && (item.frozen_prefs.pdb_and_cdb_exclude_algo == "excludeCDB") && (item.PDBandCDBmatch=="CDBwithChild") ) { return false; }
          
          // Hide duplicate databases (keep only original)
          if (item.DuplicateMatch && item.DuplicateMatch !== "OriginalDatabase") return false;
          
          return true;
        });
      }
      
      return filtered;
    },
    
    filteredFlatItems() {
      //filter flatItems based on PDB and CDB selection

      let tempSelectedFlatItems=this.flatItems.filter((item,idx) => (idx<this.batchItems.length &&            
           ( ( this.batchItems[idx].PDBandCDBmatch==undefined ) ||
            ( (this.batchItems[idx].frozen_prefs.pdb_and_cdb_exclude_algo == "none") || 
              ( (this.batchItems[idx].frozen_prefs.pdb_and_cdb_exclude_algo == "excludePDB") && (this.batchItems[idx].PDBandCDBmatch!="PDBwithParent") ) || 
              ( (this.batchItems[idx].frozen_prefs.pdb_and_cdb_exclude_algo == "excludeCDB") && (this.batchItems[idx].PDBandCDBmatch!="CDBwithChild") )
            )
          ) &&
          ( ( this.batchItems[idx].DuplicateMatch==undefined ) ||
            ( (this.batchItems[idx].frozen_prefs.duplicate_database_exclude_algo == "none") || 
              ( (this.batchItems[idx].frozen_prefs.duplicate_database_exclude_algo == "excludeDuplicates") && (this.batchItems[idx].DuplicateMatch=="OriginalDatabase") )
            )
          )  
                  || idx>=this.batchItems.length) );
      tempSelectedFlatItems = this.fixFlatItems(tempSelectedFlatItems);
      return tempSelectedFlatItems;
    },

    selectedFlatItems() {
      //filter flatItems based on batchItems.selected
      let tempSelectedFlatItems=this.flatItems.filter((item,idx) => (idx<this.batchItems.length && this.batchItems[idx].selected) || idx>=this.batchItems.length);
      tempSelectedFlatItems = this.fixFlatItems(tempSelectedFlatItems);
      return tempSelectedFlatItems;
    },
    countSelected() {
      return this.batchItems.filter((item,idx) => (this.batchItems[idx].selected) ).length;
    },
    csvFormatOptions() {
      // the MAT format is only offered to AWS employees
      return this.csv_lov.filter(option => option.value != 'mat' || this.currentEmployee);
    },
    matFlatItems() {
      return this.buildMatRows(this.flatItems);
    },
    atxRecords() {
      if (!this.selectedATXScenario) return { databaseInstances: [], servers: [] };
      const items = this.batchItems.filter(item => {
        if (item.scenarioName !== this.selectedATXScenario) return false;
        if (!this.atxExcludeOverlaps) return true;
        const includePDBCDB = (item.PDBandCDBmatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.pdb_and_cdb_exclude_algo === "none") ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludePDB") && (item.PDBandCDBmatch !== "PDBwithParent")) ||
            ((item.frozen_prefs.pdb_and_cdb_exclude_algo === "excludeCDB") && (item.PDBandCDBmatch !== "CDBwithChild")));
        const includeDuplicate = (item.DuplicateMatch === undefined) ||
          (!item.frozen_prefs || (item.frozen_prefs.duplicate_database_exclude_algo === "none") ||
            ((item.frozen_prefs.duplicate_database_exclude_algo === "excludeDuplicates") && (item.DuplicateMatch === "OriginalDatabase")));
        return includePDBCDB && includeDuplicate;
      });
      return build_atx_records(items, this.matGenInfo);
    },
    matFilteredFlatItems() {
      return this.buildMatRows(this.filteredFlatItems);
    },
    matSelectedFlatItems() {
      return this.buildMatRows(this.selectedFlatItems);
    },
    allSelected() {
      return this.filteredBatchItems.length > 0 && this.filteredBatchItems.every(item => item.selected);
    },
    selectedItems() {
      return this.batchItems.filter((item,idx) => (this.batchItems[idx].selected) );
    },
    csvFields() {
      var myFields= ["batchID","row","scenarioName",
            "database",
            "CONSOLIDATED",
            "DB_UNIQUE_NAME",
            "description",
            "url",
            "VERSION",
            "PLATFORM_NAME",
            "BANNER",
            "NUM_INSTANCES",
            "hostname",
            "NUM_CPUS",
            "NUM_CPU_CORES",
            "cdb_target_comments",
            "considerSE2",
            "extraInfo2",
            "extraInfo", 
            "COUNT_LINES_PLSQL",
            "VCPU",
            "Memory",
            "Throughput",
            "IOPS",
            "DiskSpace",
            "assumptionsString",
            "rds_type",
            "RDSbenefits",
            "targetconfig_rds.summaryText",
            "rds_shape",
            "rac_nodes",
            "UseMAZ",
            "VolumeType",

            "targetconfig_rds.monthly_estimate",
            "targetconfig_rds.shape_cost",
            "targetconfig_rds.ebs_data_cost",
   
            "targetconfig_rds.shape_summaryText",
            "targetconfig_rds.ebs_data_summaryText1",
            "targetconfig_rds.ebs_data_summaryText2",
            "targetconfig_rds.license_summaryText",   

            "targetconfig_rds.shape_max_vcpu",
            "addlMaxVCPU",
            "targetconfig_rds.shape_optimize_vcpu",
            "addlOptimVCPU",
            "current_hw_consolidation",
            "current_hw_cpu",
            "targetconfig_rds.cpu_warnings_alert",
            "targetconfig_rds.cpu_warnings_burst",
            "targetconfig_rds.cpu_warnings_info",
            "cpu_target_comments",

            
            "targetconfig_rds.shape_memory",
            "addlMemory",
             "current_hw_memory",            
            "targetconfig_rds.InstanceStorage",
            "targetconfig_rds.memory_warnings_alert",
            "memory_target_comments",
            

            
            "targetconfig_rds.shape_throughput","targetconfig_rds.shape_baselinethroughput",
            "targetconfig_rds.ebs_burst_Throughput","targetconfig_rds.ebs_baseline_Throughput",

            "addlThroughput",
            "OrigThroughput", //Exadata original throughput

            "targetconfig_rds.iomb_warnings_alert",
            "targetconfig_rds.iomb_warnings_burst",
            "targetconfig_rds.iomb_warnings_info",
            "iomb_target_comments",
            
            "targetconfig_rds.shape_IOPS","targetconfig_rds.shape_baselineIOPS",
            "targetconfig_rds.ebs_burst_IOPS","targetconfig_rds.ebs_baseline_IOPS",

            "addlBurstIOPS",
            "OrigIOPS",
            "targetconfig_rds.iops_warnings_alert",
            "targetconfig_rds.iops_warnings_burst",
            "targetconfig_rds.iops_warnings_info",
            "iops_target_comments",


            "addlVolumes",
            "targetconfig_rds.diskspace_warnings",
            "targetconfig_rds.ebsvol_warnings",

           //  "targetconfig_rds.shape_OD","targetconfig_rds.shape_RI", "targetconfig_rds.shape_RI_SE2", 
            "targetconfig_rds.closeness_string",
            "optimizationGoalSuggestion",
            "Exadata",
      
           // additional Exadata fields added Nov 2024
            "SmartScanEligible",
            "StorageIndexSavings",
            "additional_datapoints.DB_EXA_COMMITS_P99",
            "additional_datapoints.COUNT_TABLES_HCC",
            "OrigVCPU",
            "OrigMemory",
            
            // bare metal fields added July 2025
            "targetconfig_rds.BareMetalProcessor",
            "targetconfig_rds.BareMetalPossibilityComments",
            
            // count_PDBS added August 2025
            "COUNT_PDBS",
            
            // duplicateMatch added Sept 2025
            "DuplicateMatch",
            
            // ReadReplica added Sept 2025
            "ReadReplica",
            "ReadReplicaRegion",
            
            // collectionID, VCPU with MultiAZ added Oct 2025
            "collectionID",
            "targetconfig_rds.shape_max_vcpu_with_multiAZ",
            
            // AdditionalStorageVolumes added Oct 2025
            "targetconfig_rds.AddlStorageVolumes"
            ];
            
      if (!this.showECfields) {
        myFields=myFields.concat([
            "cachingSavingsText",
            "cachingSavings"]);
      }      
      
      if (this.showRDSConsolidationFields) {
        myFields=myFields.concat([
            "consolidation_server",
            "consolidation_summary",
            "consolidation_server_summary",
            "consolidation_shape",
            "consolidation_monthly_estimate",
            "consolidation_databases",
            "consolidation_databasesLong"]);

      }
      

      var myAuroraFields= [
            "targetconfig_aurora.dummy",
            "aurora_shape",
            "targetconfig_aurora.summaryText",
            "targetconfig_aurora.shape_max_vcpu",
            "targetconfig_aurora.shape_memory",
            "targetconfig_aurora.shape_summaryText",
            "targetconfig_aurora.ebs_data_summaryText1","targetconfig_aurora.ebs_data_summaryText2",
            "targetconfig_aurora.iops_summaryText1","targetconfig_aurora.iops_summaryText2",
            "targetconfig_aurora.monthly_estimate",
            "targetconfig_aurora.shape_cost",
            "targetconfig_aurora.ebs_data_cost",
            // "targetconfig_aurora.shape_OD","targetconfig_aurora.shape_RI",
            "targetconfig_aurora.closeness_string",
            "targetconfig_aurora.storage_assumptions"
            ];
      if (this.showAurorafields) {
        myFields=myFields.concat(myAuroraFields);
      }  
      
      var myADBSFields= [
            "targetconfig_adbs.dummy",
            "targetconfig_adbs.shape",
            "targetconfig_adbs.summaryText",
            "targetconfig_adbs.monthly_estimate",
            "targetconfig_adbs.ecpu_requested",
            "targetconfig_adbs.ecpu_billed",
            "targetconfig_adbs.storage_requested",
            "targetconfig_adbs.storage_billed",
            "targetconfig_adbs.ecpu_cost",
            "targetconfig_adbs.storage_cost",
            "targetconfig_adbs.ecpu_warnings",
            "targetconfig_adbs.storage_warnings",
            "targetconfig_adbs.adbs_type",
            "targetconfig_adbs.UseMAZ",
            "targetconfig_adbs.license_type"
            ];
      if (this.showADBSfields) {
        myFields=myFields.concat(myADBSFields);
      }  
      
      var myElasticacheFields= [
            "targetconfig_elasticache.dummy",
            "targetconfig_elasticache.summaryText",
            "cachingSavingsText",
            "cachingSavings",
            "targetconfig_elasticache.requested_memory",
            "targetconfig_elasticache.shape",
            "targetconfig_elasticache.shape_max_vcpu",
            "targetconfig_elasticache.shape_memory",
            "targetconfig_elasticache.shape_summaryText",
            "targetconfig_elasticache.monthly_estimate",
            "targetconfig_elasticache.closeness_string",
            "targetconfig_elasticache.elasticache_assumptions",
            "AdjustedVCPU",
            "AdjustedMemory",
            "AdjustedIOPS",
            "AdjustedThroughput"
            ];
      if (this.showECfields) {
        myFields=myFields.concat(myElasticacheFields);
      }  

      // console.log("add showec2fsxnfields fields to CSV here");
      
      var myEc2fsxnFields= [
            "targetconfig_ec2fsxn.dummy",
            "targetconfig_ec2fsxn.summaryText",
            "targetconfig_ec2fsxn.monthly_estimate",
            "targetconfig_ec2fsxn.shape",
            "targetconfig_ec2fsxn.match_string",            
            // "targetconfig_ec2fsxn.shape_summaryText",
            "targetconfig_ec2fsxn.shape_cost",
            "targetconfig_ec2fsxn.shape_quantity",
            "targetconfig_ec2fsxn.shape_max_vcpu",
            "targetconfig_ec2fsxn.shape_memory",
            "targetconfig_ec2fsxn.shape_network",
            "targetconfig_ec2fsxn.shape_cores_needed",
            "targetconfig_ec2fsxn.shape_cores_available",
            "targetconfig_ec2fsxn.shape_vcpus_per_core",
            "targetconfig_ec2fsxn.total_cores_needed",
            "targetconfig_ec2fsxn.Processor",
            "targetconfig_ec2fsxn.OracleCoreFactor",
            "targetconfig_ec2fsxn.OracleCoreFactorConfidence",
            "targetconfig_ec2fsxn.Geekbench5CoreScoreRounded",
            "targetconfig_ec2fsxn.shape_OD",
            "targetconfig_ec2fsxn.shape_RI",
            "targetconfig_ec2fsxn.closeness_string",
            "targetconfig_ec2fsxn.fsxn_data_summaryText1",
            "targetconfig_ec2fsxn.fsxn_data_cost",
            "targetconfig_ec2fsxn.UseMAZ",
            "targetconfig_ec2fsxn.fsxn_quantity",
            "targetconfig_ec2fsxn.fsxn_diskspace",
            "targetconfig_ec2fsxn.fsxn_throughput",
            "targetconfig_ec2fsxn.fsxn_addl_iops",
            "targetconfig_ec2fsxn.fsxn_iops",
            "targetconfig_ec2fsxn.fsxn_generation",
            "targetconfig_ec2fsxn.fsxn_ha_pairs",
            "targetconfig_ec2fsxn.warnings",
            "targetconfig_ec2fsxn.iomb_warnings_burst",
            "targetconfig_ec2fsxn.iops_warnings_burst",
            "targetconfig_ec2fsxn.fsxn_warnings"
            ];
      if (this.showec2fsxnfields) {
        myFields=myFields.concat(myEc2fsxnFields);
      }  

      var myEc2Fields= [
            "targetconfig_ec2.dummy",
            "targetconfig_ec2.summaryText",
            "targetconfig_ec2.shape",
            "targetconfig_ec2.match_string",
            "targetconfig_ec2.UseMAZ",            
            "targetconfig_ec2.monthly_estimate",
            "targetconfig_ec2.shape_cost",
            "targetconfig_ec2.ebs_data_cost",
            "targetconfig_ec2.shape_max_vcpu",
            "targetconfig_ec2.shape_memory",
            "targetconfig_ec2.shape_network",
            "targetconfig_ec2.Processor",
            "targetconfig_ec2.shape_OD",
            "targetconfig_ec2.shape_RI",
            "targetconfig_ec2.closeness_string",
            "targetconfig_ec2.ebs_data_summaryText1",
            "targetconfig_ec2.ebs_data_summaryText2",
            "targetconfig_ec2.ebs_data_size",
            "targetconfig_ec2.ebs_data_type",
            "targetconfig_ec2.ebs_data_iops",
            "targetconfig_ec2.ebs_data_throughput",
            "targetconfig_ec2.iops_warnings",
            "targetconfig_ec2.warnings"
            ];
      if (this.showec2fields) {
        myFields=myFields.concat(myEc2Fields);
      }  

      // if this is alt-1 format, only use certain fields
      if (this.csv_format == 'alt-1') {
        myFields= [ "row",
            "scenarioName",
            "assumptionsString",
            "url",
            "database",
            "group", 
            "productionYN", 
            "UseMAZ",
            "drYN", 
            "VCPU",
            "Memory",
            "IOPS",
            "Throughput",
            "DiskSpace",
            "OrigVCPU", 
            "OrigMemory", 
            "OrigIOPS",
            "OrigThroughput",
            "OrigDiskSpace"
            ];
      }

      // MAT format uses MAT's own column names and order
      if (this.csv_format == 'mat') {
        myFields = MAT_FIELDS;
      }

      return myFields;
    },  

    infraFields() {
      var myFields= [
        {row: {
          label: "Scenario",
          sortable: true
        }},
        {service: {
          label: "ODB@AWS Offering",
          sortable: true
        }},
        {dbservers: {
          label: "Database Servers",
          sortable: true
        }},
        {storageservers: {
          label: "Storage Servers",
          sortable: true
        }},
        {monthly_estimate: {
          label: "ODB@AWS Monthly Cost",
          sortable: true
        }},
        {UsageUnits_target: {
          label: "Target Usage",
          sortable: true
        }},
        {Memory_target: {
          label: "Target Memory (GB)",
          sortable: true
        }},
        {Throughput_target: {
          label: "Target Throughput (MB/s)",
          sortable: true
        }},
        {IOPS_target: {
          label: "Target IOPS",
          sortable: true
        }},
        {storage_target: {
          label: "Target Storage (Usable GB)",
          sortable: true
        }}
      ];
      return myFields;
    },  

    consolidatedFields() {
      var myFields= [
        {scenarioName: {
          label: "Scenario",
          sortable: true
        }},
        {server: {
          label: "Server",
          sortable: true
        }},
        {databases: {
          label: "Databases",
          sortable: true
        }},
        {"targetconfig_rds.shape": {
          label: "Consolidated Shape",
          sortable: true
        }},
        {"targetconfig_rds.monthly_estimate": {
          label: "RDS Monthly Cost",
          sortable: true
        }},
        {consolidationString: {
          label: "Consolidation Summary",
          sortable: true
        }},
         {VCPU: {
          label: "Target Combined VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Target Combined Memory (GB)",
          sortable: true
        }},
        {Throughput: {
          label: "Target Combined Throughput (MB/s)",
          sortable: true
        }},
        {IOPS: {
          label: "Target Combined IOPS",
          sortable: true
        }},
        {DiskSpace: {
          label: "Target Combined Storage (Usable GB)",
          sortable: true
        }},
        {UseMAZ: {
          label: "MultiAZ",
          sortable: true
        }}
      ];

      return myFields;
    },  
    inputFields() {
      var myFields= [
        {selected: {
          label: ""
        }},
        {row: {
          label: "row",
          sortable: true
        }},
        {database: {
          label: "Database",
          sortable: true
        }}
      ];

      // if (this.showRDSfields) {
        myFields.push( 
        {rds_shape: {
          label: "RDS-Oracle Shape",
          sortable: true
        }},
        {"targetconfig_rds.monthly_estimate": {
          label: "RDS-Oracle Monthly Cost",
          sortable: true
        }}
         );
     // }

      if (this.showRDSConsolidationFields) {
        myFields.push( 
        {consolidation_server: {
          label: "RDS Consolidation Server",
          sortable: true
        }}
         );
      }


      if (this.showODBfields) {
        myFields.push( 
        {odb_shape: {
          label: "ODB@AWS (Dedicated) Configuration",
          sortable: true
        }}
        );
        
        // {"odb_prorated_monthly_estimate": {
        //  label: "ODB@AWS Monthly Cost",
        //  sortable: true
        // }}
  
      }
      
       // console.log("add showec2fsxnfields fields to table here");
      if (this.showec2fsxnfields) {
        myFields.push( 
        {"targetconfig_ec2fsxn.shape": {
          label: "EC2 + FSxN Shape",
          sortable: true
        }},
        {"targetconfig_ec2fsxn.monthly_estimate": {
          label: "EC2 + FSxN Monthly Cost",
          sortable: true
        }}
         );
      }

      if (this.showec2fields) {
        myFields.push( 
        {"targetconfig_ec2.shape": {
          label: "EC2 Shape",
          sortable: true
        }},
        {"targetconfig_ec2.monthly_estimate": {
          label: "EC2 Monthly Cost",
          sortable: true
        }}
         );
      }

      if (this.showAurorafields) {
        myFields.push( 
        {aurora_shape: {
          label: "Aurora Shape",
          sortable: true
        }},
        {"targetconfig_aurora.monthly_estimate": {
          label: "Aurora Monthly Cost",
          sortable: true
        }}
         );
      }

      if (this.showADBSfields) {
        myFields.push( 
        {"targetconfig_adbs.shape": {
          label: "ODB@AWS (ADB-S) Configuration",
          sortable: true
        }},
        {"targetconfig_adbs.monthly_estimate": {
          label: "ODB@AWS (ADB-S) Monthly Cost",
          sortable: true
        }}
         );
      }
     
      
      if (this.showECfields) {
        myFields.push( 
        {"targetconfig_elasticache.shape": {
          label: "Elasticache Shape",
          sortable: true
        }},
        {"targetconfig_elasticache.monthly_estimate": {
          label: "Elasticache Monthly Cost",
          sortable: true
        }}
         );
      }

      if (this.showRDSfields) {
        myFields.push( 
        {show_config: {
          label: "Show Config",
          sortable: false
        }}
         );
      }
      
      myFields.push( 
        {VCPU: {
          label: "Target VCPU",
          sortable: true
        }},
        {Memory: {
          label: "Target Memory (GB)",
          sortable: true
        }},
        {Throughput: {
          label: "Target IO Throughput (MB/s)",
          sortable: true
        }},
        {IOPS: {
          label: "Target IOPS",
          sortable: true
        }},
        {DiskSpace: {
          label: "Target Storage (Usable GB)",
          sortable: true
        }},
        {VolumeType: {
          label: "EBS Volume Type",
          sortable: true
        }},
        // {NUM_INSTANCES: {
        //   label: "Instances (source)",
        //   sortable: true
        // }},
        {UseMAZ: {
          label: "MultiAZ",
          sortable: true
        }},
        {UseSE2: {
          label: "SE2?",
          sortable: true
        }},
        {show_adhoc: {
          label: "Other",
          sortable: false
        }},
        {Comments: {
          label: "Adjustments.....................................",
          sortable: true
        }}
       );
      return myFields;
    }  


  }
};
</script>

<style>
</style>
